export const DEFAULT_PAGE_SIZE = 10;
export const HEADER_X_TOKEN = "X-Token";
export const HEADER_ACCOUNT_API_KEY = "X-Account-ApiKey";
export const HEADER_TEAM_API_KEY = "X-Team-ApiKey";
export const HEADER_MEMBER_API_KEY = "X-Member-ApiKey";
export const LOADING_DATA = "Loading Data...";
export const NO_DATA = "No Data";

export const EMBEDDED_FORM_PROMOTION = 1;
export const EMBEDDED_FORM_SUBSCRIBE = 0;
export const POPUP_FORM_PROMOTION = 1;
export const POPUP_FORM_SUBSCRIBE = 0;

export const PLACEHOLDER_IMAGE = "https://sendx-cdn.s3.us-east-1.amazonaws.com/app/SendXPlaceholder.png";

export const environment = () => {
	const $config = useRuntimeConfig();
	return $config.public.env;
};

export const apiServerUrl = () => {
	const $config = useRuntimeConfig();
	return $config.public.appServer;
};

export const appFrontendUrl = () => {
	const $config = useRuntimeConfig();
	return $config.public.appFrontend;
};

export const stripePublicKey = () => {
	const $config = useRuntimeConfig();
	return $config.public.stripePublicKey;
};

export const defaultJson = {
	type: "doc",
	content: [
		{
			type: "logo",
			attrs: {
				src: "https://maily.to/brand/logo.png",
				alt: null,
				title: null,
				"maily-component": "logo",
				size: "md",
				alignment: "left",
			},
		},
		{ type: "spacer", attrs: { height: "xl" } },
		{
			type: "heading",
			attrs: { textAlign: "left", level: 2 },
			content: [
				{
					type: "text",
					marks: [{ type: "bold" }],
					text: "Discover SendX",
				},
			],
		},
		{
			type: "paragraph",
			attrs: { textAlign: "left" },
			content: [
				{
					type: "text",
					text: "Are you ready to transform your email communication? Introducing SendX, an advanced ESP that helps you craft, automate, and optimize your email campaigns effortlessly.",
				},
			],
		},
		{
			type: "paragraph",
			attrs: { textAlign: "left" },
			content: [
				{
					type: "text",
					text: "Elevate your email marketing with SendX! Click below to try it out:",
				},
			],
		},
		{
			type: "button",
			attrs: {
				text: "Try SendX Now →",
				url: "",
				alignment: "left",
				variant: "filled",
				borderRadius: "round",
				buttonColor: "#000000",
				textColor: "#ffffff",
			},
		},
		{ type: "spacer", attrs: { height: "xl" } },
		{
			type: "paragraph",
			attrs: { textAlign: "left" },
			content: [
				{
					type: "text",
					text: "Join our growing community of users and developers—SendX is continuously evolving, and together, we’re shaping the future of email marketing.",
				},
			],
		},
		{
			type: "paragraph",
			attrs: { textAlign: "left" },
			content: [
				{ type: "text", text: "Regards," },
				{ type: "hardBreak" },
				{ type: "text", text: "The SendX Team" },
			],
		},
	],
};

export const emptySendxEditorTemplate =
	"{\"type\":\"doc\",\"content\":[{\"type\":\"paragraph\",\"attrs\":{\"textAlign\":null,\"showIfKey\":null}}]}"

export const emptySendxEditorHtmlTemplate = `<!DOCTYPE html PUBLIC \"-//W3C//DTD XHTML 1.0 Transitional//EN\" \"http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd\"><html dir=\"ltr\" lang=\"en\"><head><meta charSet=\"utf-8\"/><meta name=\"viewport\" content=\"width=device-width\"/><meta name=\"viewport\" content=\"width=device-width\"/><meta content=\"text/html; charset=UTF-8\" http-equiv=\"Content-Type\"/><meta name=\"x-apple-disable-message-reformatting\"/><link rel=\"preconnect\" href=\"https://fonts.googleapis.com\"/><link rel=\"preconnect\" href=\"https://fonts.gstatic.com\" crossorigin=\"anonymous\"/><meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\"/><meta name=\"x-apple-disable-message-reformatting\"/><meta name=\"format-detection\" content=\"telephone=no,address=no,email=no,date=no,url=no\"/><meta name=\"color-scheme\" content=\"light\"/><meta name=\"supported-color-schemes\" content=\"light\"/><!--$--><style></style><style>\n    @font-face {\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 400;\n      mso-font-alt: 'sans-serif';\n      src: url(https://rsms.me/inter/font-files/Inter-Regular.woff2?v=3.19) format('woff2');\n    }\n\n    * {\n      font-family: 'Inter', sans-serif;\n    }\n  </style><style>blockquote,h1,h2,h3,img,li,ol,p,ul{margin-top:0;margin-bottom:0}@media only screen and (max-width:425px){.tab-row-full{width:100%!important}.tab-col-full{display:block!important;width:100%!important}.tab-pad{padding:0!important}}</style></head><body style=\"margin:0\"><table align=\"center\" width=\"100%\" border=\"0\" cellPadding=\"0\" cellSpacing=\"0\" role=\"presentation\" style=\"max-width:600px;min-width:300px;width:100%;margin-left:auto;margin-right:auto;padding:0.5rem\"><tbody><tr style=\"width:100%\"><td><p style=\"font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151\"> </p></td></tr></tbody></table><!--/$--></body></html>`


export const TIPTAP_TEMPLATES_CODE = {
	"Welcome Email": { "type": "doc", "content": [{ "type": "heading", "attrs": { "textAlign": null, "level": 1, "showIfKey": null }, "content": [{ "type": "text", "text": "Welcome to Our Community!" }] }, { "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "text": "Dear New Member," }] }, { "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "text": "We are thrilled to have you join us! Your membership has been successfully activated, and you are now part of a community that values connection, growth, and learning." }] }, { "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "text": "Here are a few things you can look forward to:" }] }, { "type": "bulletList", "content": [{ "type": "listItem", "attrs": { "color": "" }, "content": [{ "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "text": "Exclusive access to our online forums and discussions" }] }] }, { "type": "listItem", "attrs": { "color": "" }, "content": [{ "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "text": "Invitations to members-only events and webinars" }] }] }, { "type": "listItem", "attrs": { "color": "" }, "content": [{ "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "text": "A monthly newsletter filled with insights, tips, and updates" }] }] }] }, { "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "text": "We encourage you to dive in, participate, and share your experiences and knowledge with fellow members. Your contributions make our community richer and more vibrant." }] }, { "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "text": "If you have any questions or need assistance, please feel free to reach out to us at " }, { "type": "text", "marks": [{ "type": "link", "attrs": { "href": "mailto:support@example.com", "target": "_blank", "rel": "noopener noreferrer nofollow", "class": "mly-no-underline", "isUrlVariable": false } }], "text": "support@example.com" }, { "type": "text", "text": ". We're here to help!" }] }, { "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "text": "Welcome aboard, and we look forward to connecting with you!" }] }, { "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "text": "Best Regards," }] }, { "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "marks": [{ "type": "bold" }], "text": "The Team at [Your Organization]" }] }] },
	"Getting Started": { "type": "doc", "content": [{ "type": "spacer", "attrs": { "height": 64, "showIfKey": null } }, { "type": "image", "attrs": { "src": "https://www.bestregards.me/potion_images/examples/tiktok-header.png", "alt": null, "title": null, "width": 350, "height": 18.166089965397923, "alignment": "center", "externalLink": null, "isExternalLinkVariable": false, "isSrcVariable": false, "showIfKey": null } }, { "type": "image", "attrs": { "src": "https://www.bestregards.me/potion_images/examples/tiktok-icon-logo.png", "alt": null, "title": null, "width": 64, "height": 64, "alignment": "center", "externalLink": null, "isExternalLinkVariable": false, "isSrcVariable": false, "showIfKey": null } }, { "type": "heading", "attrs": { "textAlign": "center", "level": 3, "showIfKey": null }, "content": [{ "type": "text", "text": "🎉 You're Almost In! Let’s Get Started" }] }, { "type": "spacer", "attrs": { "height": 16, "showIfKey": null } }, { "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "text": "Hey there," }] }, { "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "text": "Thanks for signing up! You're just one step away from unlocking exclusive content and personalized experiences on TikTok." }] }, { "type": "button", "attrs": { "text": "Subscribe", "isTextVariable": false, "url": "", "isUrlVariable": false, "alignment": "center", "variant": "filled", "borderRadius": "smooth", "buttonColor": "#FE2C55", "textColor": "#ffffff", "showIfKey": null, "paddingTop": 10, "paddingRight": 32, "paddingBottom": 10, "paddingLeft": 32 } }, { "type": "horizontalRule" }, { "type": "image", "attrs": { "src": "https://www.bestregards.me/potion_images/examples/tiktok-text-logo.png", "alt": null, "title": null, "width": 137, "height": 32.99476439790576, "alignment": "center", "externalLink": null, "isExternalLinkVariable": false, "isSrcVariable": false, "showIfKey": null } }, { "type": "spacer", "attrs": { "height": 16, "showIfKey": null } }, { "type": "spacer", "attrs": { "height": 4, "showIfKey": null } }, { "type": "footer", "attrs": { "textAlign": "center", "maily-component": "footer" }, "content": [{ "type": "text", "marks": [{ "type": "textStyle", "attrs": { "color": "", "fontFamily": null } }], "text": "1234 Example Street, Example, DE 19801, United States" }, { "type": "hardBreak" }, { "type": "text", "marks": [{ "type": "underline" }, { "type": "textStyle", "attrs": { "color": "#64748b", "fontFamily": null } }, { "type": "link", "attrs": { "href": "https://maily.to", "target": "_blank", "rel": "noopener noreferrer nofollow", "class": "mly-no-underline", "isUrlVariable": false } }], "text": "VISIT COMPANY" }, { "type": "text", "marks": [{ "type": "textStyle", "attrs": { "color": "#64748b", "fontFamily": null } }], "text": "  |  " }, { "type": "text", "marks": [{ "type": "underline" }, { "type": "textStyle", "attrs": { "color": "#64748b", "fontFamily": null } }, { "type": "link", "attrs": { "href": "https://maily.to", "target": "_blank", "rel": "noopener noreferrer nofollow", "class": "mly-no-underline", "isUrlVariable": false } }], "text": "VISIT OUR BLOG" }, { "type": "text", "marks": [{ "type": "textStyle", "attrs": { "color": "#64748b", "fontFamily": null } }], "text": "  |  " }, { "type": "text", "marks": [{ "type": "underline" }, { "type": "textStyle", "attrs": { "color": "#64748b", "fontFamily": null } }, { "type": "link", "attrs": { "href": "https://maily.to", "target": "_blank", "rel": "noopener noreferrer nofollow", "class": "mly-no-underline", "isUrlVariable": false } }], "text": "UNSUBSCRIBE" }] }, { "type": "paragraph", "attrs": { "textAlign": "center", "showIfKey": null }, "content": [{ "type": "inlineImage", "attrs": { "height": 20, "width": 20, "src": "https://cdn.usemaily.com/images/icons/linkedin.png", "isSrcVariable": false, "alt": null, "title": null, "externalLink": "https://www.linkedin.com/in/arikchakma/", "isExternalLinkVariable": false } }, { "type": "text", "text": "  " }, { "type": "inlineImage", "attrs": { "height": 20, "width": 20, "src": "https://cdn.usemaily.com/images/icons/youtube.png", "isSrcVariable": false, "alt": null, "title": null, "externalLink": "https://www.youtube.com/arikchakma", "isExternalLinkVariable": false } }, { "type": "text", "text": "  " }, { "type": "inlineImage", "attrs": { "height": 20, "width": 20, "src": "https://cdn.usemaily.com/images/icons/twitter.png", "isSrcVariable": false, "alt": null, "title": null, "externalLink": "https://x.com/imarikchakma", "isExternalLinkVariable": false } }] }] },
	"Launch": { "type": "doc", "content": [{ "type": "section", "attrs": { "borderRadius": 6, "backgroundColor": "#000000", "align": "left", "borderWidth": 0, "borderColor": "#e2e2e2", "paddingTop": 16, "paddingRight": 16, "paddingBottom": 16, "paddingLeft": 16, "marginTop": 0, "marginRight": 0, "marginBottom": 0, "marginLeft": 0, "showIfKey": null }, "content": [{ "type": "image", "attrs": { "src": "https://www.bestregards.me/potion_images/examples/netflix-poster.jpg", "alt": null, "title": null, "width": 456, "height": 684.0000000000001, "alignment": "center", "externalLink": null, "isExternalLinkVariable": false, "isSrcVariable": false, "showIfKey": null } }, { "type": "spacer", "attrs": { "height": 4, "showIfKey": null } }, { "type": "paragraph", "attrs": { "textAlign": "center", "showIfKey": null }, "content": [{ "type": "text", "marks": [{ "type": "textStyle", "attrs": { "color": "#ffffff", "fontFamily": "" } }], "text": "Captivating " }, { "type": "text", "marks": [{ "type": "bold" }, { "type": "textStyle", "attrs": { "color": "#ff0000", "fontFamily": "" } }], "text": "·" }, { "type": "text", "marks": [{ "type": "textStyle", "attrs": { "color": "#ffffff", "fontFamily": "" } }], "text": " Cerebral " }, { "type": "text", "marks": [{ "type": "bold" }, { "type": "textStyle", "attrs": { "color": "#ff0000", "fontFamily": "" } }], "text": "·" }, { "type": "text", "marks": [{ "type": "bold" }, { "type": "textStyle", "attrs": { "color": "#ffffff", "fontFamily": "" } }], "text": " " }, { "type": "text", "marks": [{ "type": "textStyle", "attrs": { "color": "#ffffff", "fontFamily": "" } }], "text": "Docuseries " }, { "type": "text", "marks": [{ "type": "bold" }, { "type": "textStyle", "attrs": { "color": "#d22020", "fontFamily": "" } }], "text": "·" }, { "type": "text", "marks": [{ "type": "bold" }, { "type": "textStyle", "attrs": { "color": "#ffffff", "fontFamily": "" } }], "text": " " }, { "type": "text", "marks": [{ "type": "textStyle", "attrs": { "color": "#ffffff", "fontFamily": "" } }], "text": "Spies   " }] }, { "type": "heading", "attrs": { "textAlign": null, "level": 3, "showIfKey": null }, "content": [{ "type": "text", "marks": [{ "type": "textStyle", "attrs": { "color": "#ffffff", "fontFamily": null } }], "text": "Turning Point: The Bomb and the Cold War" }] }, { "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "marks": [{ "type": "bold" }, { "type": "textStyle", "attrs": { "color": "#ffffff", "fontFamily": null } }], "text": "Coming Tuesday" }] }, { "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "marks": [{ "type": "textStyle", "attrs": { "color": "#ffffff", "fontFamily": null } }], "text": "With firsthand accounts and access to prominent figures around the world, this comprehensive docuseries explores the Cold War and its aftermath. " }, { "type": "text", "marks": [{ "type": "underline" }, { "type": "textStyle", "attrs": { "color": "#ffffff", "fontFamily": null } }, { "type": "link", "attrs": { "href": "https://www.netflix.com/title/81614129?g=f3ee4e31-eda3-4e0a-8a30-cfd18e1f4c22&lkid=URL_PRIMARY_MORE_INFO_0&lnktrk=EVO&trkid=13710079", "target": "_blank", "rel": "noopener noreferrer nofollow", "class": "mly-no-underline", "isUrlVariable": false } }], "text": "Mo" }, { "type": "text", "marks": [{ "type": "underline" }, { "type": "link", "attrs": { "href": "https://www.netflix.com/title/81614129?g=f3ee4e31-eda3-4e0a-8a30-cfd18e1f4c22&lkid=URL_PRIMARY_MORE_INFO_0&lnktrk=EVO&trkid=13710079", "target": "_blank", "rel": "noopener noreferrer nofollow", "class": "mly-no-underline", "isUrlVariable": false } }], "text": "re Info" }] }, { "type": "button", "attrs": { "text": "Remind me", "isTextVariable": false, "url": "", "isUrlVariable": false, "alignment": "left", "variant": "filled", "borderRadius": "smooth", "buttonColor": "#E50914", "textColor": "#ffffff", "showIfKey": null, "paddingTop": 10, "paddingRight": 32, "paddingBottom": 10, "paddingLeft": 32 } }, { "type": "heading", "attrs": { "textAlign": null, "level": 3, "showIfKey": null }, "content": [{ "type": "text", "marks": [{ "type": "textStyle", "attrs": { "color": "#ffffff", "fontFamily": null } }], "text": "Coming Soon" }] }, { "type": "spacer", "attrs": { "height": 4, "showIfKey": null } }, { "type": "columns", "attrs": { "showIfKey": null, "gap": 8 }, "content": [{ "type": "column", "attrs": { "columnId": "1470c5bc-29d5-46f3-88a3-c1608849894a", "width": "auto", "verticalAlign": "top" }, "content": [{ "type": "image", "attrs": { "src": "https://www.bestregards.me/potion_images/examples/netflix-coming-soon-1.jpg", "alt": null, "title": null, "width": 177, "height": 248.0492957746479, "alignment": "center", "externalLink": null, "isExternalLinkVariable": false, "isSrcVariable": false, "showIfKey": null } }] }, { "type": "column", "attrs": { "columnId": "1470c5bc-29d5-46f3-88a3-c1608849894a", "width": "auto", "verticalAlign": "top" }, "content": [{ "type": "image", "attrs": { "src": "https://www.bestregards.me/potion_images/examples/netflix-coming-soon-2.jpg", "alt": null, "title": null, "width": 177, "height": 248.0492957746479, "alignment": "center", "externalLink": null, "isExternalLinkVariable": false, "isSrcVariable": false, "showIfKey": null } }] }, { "type": "column", "attrs": { "columnId": "db7b97c4-1a86-47d7-9de6-982bbdd8cee1", "width": "auto", "verticalAlign": "top" }, "content": [{ "type": "image", "attrs": { "src": "https://www.bestregards.me/potion_images/examples/netflix-coming-soon-3.jpg", "alt": null, "title": null, "width": 177, "height": 248.0492957746479, "alignment": "center", "externalLink": null, "isExternalLinkVariable": false, "isSrcVariable": false, "showIfKey": null } }] }] }, { "type": "spacer", "attrs": { "height": 16, "showIfKey": null } }, { "type": "button", "attrs": { "text": "View All TV Shows & Movies", "isTextVariable": false, "url": "", "isUrlVariable": false, "alignment": "center", "variant": "filled", "borderRadius": "smooth", "buttonColor": "#414141", "textColor": "#ffffff", "showIfKey": null, "paddingTop": 14, "paddingRight": 40, "paddingBottom": 14, "paddingLeft": 40 } }, { "type": "image", "attrs": { "src": "https://www.bestregards.me/potion_images/examples/netflix-logo.png", "alt": null, "title": null, "width": 44, "height": 80.75949367088607, "alignment": "center", "externalLink": null, "isExternalLinkVariable": false, "isSrcVariable": false, "showIfKey": null } }, { "type": "spacer", "attrs": { "height": 16, "showIfKey": null } }, { "type": "heading", "attrs": { "textAlign": "center", "level": 3, "showIfKey": null }, "content": [{ "type": "text", "marks": [{ "type": "textStyle", "attrs": { "color": "rgb(164, 164, 164)", "fontFamily": "" } }], "text": "Questions? Visit the " }, { "type": "text", "marks": [{ "type": "underline" }, { "type": "link", "attrs": { "href": "https://help.netflix.com/help?g=f3ee4e31-eda3-4e0a-8a30-cfd18e1f4c22&lkid=URL_HELP_QUESTIONS&lnktrk=EVO", "target": "_blank", "rel": "noopener noreferrer nofollow", "class": "mly-no-underline", "isUrlVariable": false } }], "text": "Help Center" }, { "type": "hardBreak", "marks": [{ "type": "textStyle", "attrs": { "color": "rgb(164, 164, 164)", "fontFamily": "" } }] }, { "type": "text", "marks": [{ "type": "textStyle", "attrs": { "color": "rgb(164, 164, 164)", "fontFamily": "" } }], "text": "Netflix Services Germany GmbH" }] }, { "type": "paragraph", "attrs": { "textAlign": "center", "showIfKey": null }, "content": [{ "type": "text", "marks": [{ "type": "underline" }, { "type": "textStyle", "attrs": { "color": "#ffffff", "fontFamily": "" } }, { "type": "link", "attrs": { "href": "www.netflix.com", "target": "_blank", "rel": "noopener noreferrer nofollow", "class": "mly-no-underline", "isUrlVariable": false } }], "text": "Unsubscribe" }, { "type": "hardBreak", "marks": [{ "type": "textStyle", "attrs": { "color": "#ffffff", "fontFamily": "" } }] }, { "type": "text", "marks": [{ "type": "underline" }, { "type": "textStyle", "attrs": { "color": "#ffffff", "fontFamily": "" } }, { "type": "link", "attrs": { "href": "https://help.netflix.com/legal/termsofuse", "target": "_blank", "rel": "noopener noreferrer nofollow", "class": "mly-no-underline", "isUrlVariable": false } }], "text": "Terms of Use" }, { "type": "hardBreak", "marks": [{ "type": "textStyle", "attrs": { "color": "#ffffff", "fontFamily": "" } }] }, { "type": "text", "marks": [{ "type": "underline" }, { "type": "textStyle", "attrs": { "color": "#ffffff", "fontFamily": "" } }, { "type": "link", "attrs": { "href": "https://help.netflix.com/legal/privacy", "target": "_blank", "rel": "noopener noreferrer nofollow", "class": "mly-no-underline", "isUrlVariable": false } }], "text": "Privacy" }, { "type": "hardBreak", "marks": [{ "type": "textStyle", "attrs": { "color": "#ffffff", "fontFamily": "" } }] }, { "type": "text", "marks": [{ "type": "underline" }, { "type": "textStyle", "attrs": { "color": "#ffffff", "fontFamily": "" } }], "text": "Help Center" }] }, { "type": "paragraph", "attrs": { "textAlign": "center", "showIfKey": null }, "content": [{ "type": "text", "marks": [{ "type": "textStyle", "attrs": { "color": "#ffffff", "fontFamily": "" } }], "text": "This message was mailed to [" }, { "type": "text", "marks": [{ "type": "textStyle", "attrs": { "color": "#ffffff", "fontFamily": "" } }, { "type": "link", "attrs": { "href": "mailto:ohansemmanuel@gmail.com", "target": "_blank", "rel": "noopener noreferrer nofollow", "class": "mly-no-underline", "isUrlVariable": false } }], "text": "ohansxxxxxxxxxxxx@gmail.com" }, { "type": "text", "marks": [{ "type": "textStyle", "attrs": { "color": "#ffffff", "fontFamily": "" } }], "text": "] by Netflix as part of your Netflix membership" }] }] }, { "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "hardBreak" }] }] },
	"Product": { "type": "doc", "content": [{ "type": "image", "attrs": { "src": "https://www.bestregards.me/potion_images/examples/amazon-logo.jpg", "alt": null, "title": null, "width": 204, "height": 76.83116883116882, "alignment": "left", "externalLink": null, "isExternalLinkVariable": false, "isSrcVariable": false, "showIfKey": null } }, { "type": "spacer", "attrs": { "height": 8, "showIfKey": null } }, { "type": "section", "attrs": { "borderRadius": 6, "backgroundColor": "#ededed", "align": "left", "borderWidth": 2, "borderColor": "#ffffff", "paddingTop": 16, "paddingRight": 16, "paddingBottom": 16, "paddingLeft": 16, "marginTop": 0, "marginRight": 0, "marginBottom": 0, "marginLeft": 0, "showIfKey": null }, "content": [{ "type": "section", "attrs": { "borderRadius": 6, "backgroundColor": "#ffffff", "align": "left", "borderWidth": 0, "borderColor": "#ffffff", "paddingTop": 16, "paddingRight": 16, "paddingBottom": 16, "paddingLeft": 16, "marginTop": 0, "marginRight": 0, "marginBottom": 0, "marginLeft": 0, "showIfKey": null }, "content": [{ "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "text": "We thought you'd like to know about something exciting we just launched." }, { "type": "hardBreak" }, { "type": "text", "text": "A brand new product designed to make your everyday better is finally here — and we think you'll love it." }] }, { "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "text": "Ready to experience smarter living? Explore the all-new " }, { "type": "text", "marks": [{ "type": "bold" }], "text": "Echo Smart Hub" }, { "type": "text", "text": " and take control of your home with your voice." }] }, { "type": "columns", "attrs": { "showIfKey": null, "gap": 8 }, "content": [{ "type": "column", "attrs": { "columnId": "3da631fb-9065-4bef-98ed-584d25dba195", "width": "auto", "verticalAlign": "top" }, "content": [{ "type": "image", "attrs": { "src": "https://aimint.org/ap/wp-content/uploads/sites/18/2016/04/image-placeholder-vertical.jpg", "alt": null, "title": null, "width": "211", "height": "316", "alignment": "center", "externalLink": null, "isExternalLinkVariable": false, "isSrcVariable": false, "showIfKey": null } }] }, { "type": "column", "attrs": { "columnId": "2bf35a4c-2331-4ff5-8a1b-07ab2ccacaf0", "width": "auto", "verticalAlign": "top" }, "content": [{ "type": "image", "attrs": { "src": "https://aimint.org/ap/wp-content/uploads/sites/18/2016/04/image-placeholder-vertical.jpg", "alt": null, "title": null, "width": 211, "height": "316", "alignment": "center", "externalLink": null, "isExternalLinkVariable": false, "isSrcVariable": false, "showIfKey": null } }] }] }] }, { "type": "spacer", "attrs": { "height": 16, "showIfKey": null } }, { "type": "section", "attrs": { "borderRadius": 6, "backgroundColor": "#ffffff", "align": "left", "borderWidth": 0, "borderColor": "#e2e2e2", "paddingTop": 16, "paddingRight": 16, "paddingBottom": 16, "paddingLeft": 16, "marginTop": 0, "marginRight": 0, "marginBottom": 0, "marginLeft": 0, "showIfKey": null }, "content": [{ "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "marks": [{ "type": "bold" }], "text": "Just Released:" }, { "type": "hardBreak" }, { "type": "text", "marks": [{ "type": "bold" }], "text": "Echo Smart Hub" }, { "type": "hardBreak" }, { "type": "text", "marks": [{ "type": "bold" }], "text": "Launch Date:" }, { "type": "text", "text": " Tuesday, 19 March" }] }, { "type": "youtube", "attrs": { "src": "https://www.youtube.com/embed/c21QZnQtGqo", "start": 0, "width": 445, "height": 250.31249999999997, "allowfullscreen": true, "alignment": "center" } }, { "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "text": "Built for seamless integration, the Echo Smart Hub brings your lights, thermostat, music, and more into one effortless voice-controlled experience." }] }, { "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "text": "📦 " }, { "type": "text", "marks": [{ "type": "bold" }], "text": "Shipped from:" }, { "type": "hardBreak" }, { "type": "text", "text": "Amazon Warehouse – Berlin" }] }, { "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "text": "Order now and enjoy " }, { "type": "text", "marks": [{ "type": "bold" }], "text": "exclusive launch pricing" }, { "type": "text", "text": " for a limited time only." }] }, { "type": "button", "attrs": { "text": "Order Now", "isTextVariable": false, "url": "", "isUrlVariable": false, "alignment": "left", "variant": "filled", "borderRadius": "round", "buttonColor": "#fff25f", "textColor": "#000000", "showIfKey": null, "paddingTop": 10, "paddingRight": 32, "paddingBottom": 10, "paddingLeft": 32 } }, { "type": "spacer", "attrs": { "height": 16, "showIfKey": null } }] }, { "type": "spacer", "attrs": { "height": 4, "showIfKey": null } }] }, { "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null } }] },
	"Information": { "type": "doc", "content": [{ "type": "image", "attrs": { "src": "https://cdn.prod.website-files.com/64e6e95f1770b454db7ff6f4/6501d245436969b3397f66d8_Webflow%20(placeholder)%2016-9.png", "alt": null, "title": null, "width": 580, "height": 326.12456747404843, "alignment": "center", "externalLink": null, "isExternalLinkVariable": false, "isSrcVariable": false, "showIfKey": null } }, { "type": "horizontalRule" }, { "type": "heading", "attrs": { "textAlign": null, "level": 1, "showIfKey": null }, "content": [{ "type": "text", "text": "VoltRide crisis, Audionics IPO, Shipzy's acquisition & VRO's $10M funding 💸" }] }, { "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "text": "Too much this week in tech world." }] }, { "type": "horizontalRule" }, { "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "marks": [{ "type": "bold" }], "text": "We are back with our business newsletter edition" }, { "type": "text", "marks": [{ "type": "textStyle", "attrs": { "color": "rgb(54, 55, 55)", "fontFamily": "\"SF Pro Display\", -apple-system, system-ui, \"system-ui\", Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"" } }], "text": ". Today, we’ll cover 4 business topics in one go — let's dive in." }] }, { "type": "columns", "attrs": { "showIfKey": null, "gap": 8 }, "content": [{ "type": "column", "attrs": { "columnId": "440fc964-0d9e-4f72-8139-3a328695b1fe", "width": "auto", "verticalAlign": "top" }, "content": [{ "type": "image", "attrs": { "src": "https://aimint.org/ap/wp-content/uploads/sites/18/2016/04/image-placeholder-vertical.jpg", "alt": null, "title": null, "width": 188, "height": 282.50267379679144, "alignment": "center", "externalLink": null, "isExternalLinkVariable": false, "isSrcVariable": false, "showIfKey": null } }] }, { "type": "column", "attrs": { "columnId": "f3ac67c2-70e7-4f3f-b45a-e85f1be0df03", "width": "auto", "verticalAlign": "top" }, "content": [{ "type": "image", "attrs": { "src": "https://aimint.org/ap/wp-content/uploads/sites/18/2016/04/image-placeholder-vertical.jpg", "alt": null, "title": null, "width": 187, "height": 280.5, "alignment": "center", "externalLink": null, "isExternalLinkVariable": false, "isSrcVariable": false, "showIfKey": null } }] }, { "type": "column", "attrs": { "columnId": "a1bea67f-8fc3-4b9e-900b-8c0a5997f890", "width": "auto", "verticalAlign": "top" }, "content": [{ "type": "image", "attrs": { "src": "https://aimint.org/ap/wp-content/uploads/sites/18/2016/04/image-placeholder-vertical.jpg", "alt": null, "title": null, "width": 187, "height": 280.5, "alignment": "center", "externalLink": null, "isExternalLinkVariable": false, "isSrcVariable": false, "showIfKey": null } }] }] }, { "type": "spacer", "attrs": { "height": 32, "showIfKey": null } }, { "type": "horizontalRule" }, { "type": "heading", "attrs": { "textAlign": null, "level": 2, "showIfKey": null }, "content": [{ "type": "text", "text": "Audionics files for IPO 💰" }] }, { "type": "image", "attrs": { "src": "https://cdn.prod.website-files.com/64e6e95f1770b454db7ff6f4/6501d245436969b3397f66d8_Webflow%20(placeholder)%2016-9.png", "alt": null, "title": null, "width": 578, "height": 325.125, "alignment": "center", "externalLink": null, "isExternalLinkVariable": false, "isSrcVariable": false, "showIfKey": null } }, { "type": "blockquote", "content": [{ "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "marks": [{ "type": "bold" }], "text": "First, some context." }, { "type": "hardBreak" }, { "type": "text", "text": "This is " }, { "type": "text", "marks": [{ "type": "bold" }], "text": "SonicLoop’s" }, { "type": "text", "text": " 2nd attempt at going public. In February 2022, it had filed for a ₹1,800 crore IPO but later pulled the plug, citing volatile market conditions. Instead, it raised $55 million in private capital through convertible preferred stock notes from its existing backer " }, { "type": "text", "marks": [{ "type": "bold" }], "text": "NorthBridge Capital" }, { "type": "text", "text": " and new investor " }, { "type": "text", "marks": [{ "type": "bold" }], "text": "Orion Ventures" }, { "type": "text", "text": ". The round was raised at a minimum valuation cap of approximately " }, { "type": "text", "marks": [{ "type": "bold" }], "text": "$1.1 billion" }, { "type": "text", "text": "." }] }, { "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "marks": [{ "type": "bold" }], "text": "Some quick revenue numbers." }, { "type": "hardBreak" }, { "type": "text", "text": "FY 2021-22 : ₹1,128 crore" }, { "type": "hardBreak" }, { "type": "text", "text": "FY 2022-23 : ₹2,410 crore" }, { "type": "hardBreak" }, { "type": "text", "text": "FY 2023-24 : ₹3,045 crore" }, { "type": "hardBreak" }, { "type": "text", "text": "FY 2024-25 : ₹2,860 crore" }] }, { "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "text": "The slight revenue dip was intentional—aimed at cutting net losses from ₹92 crore to ₹47 crore. The company also reported a " }, { "type": "text", "marks": [{ "type": "bold" }], "text": "positive EBITDA" }, { "type": "text", "text": " for the year." }] }, { "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "marks": [{ "type": "bold" }], "text": "The market has changed." }, { "type": "hardBreak" }, { "type": "text", "text": "In the past 3 years, the global economic slowdown and the recent " }, { "type": "text", "marks": [{ "type": "bold" }], "text": "Tech Tariff standoff" }, { "type": "text", "text": " between major economies have made public markets less attractive from a liquidity standpoint. The new IPO, pegged at a " }, { "type": "text", "marks": [{ "type": "bold" }], "text": "$1.4 billion" }, { "type": "text", "text": " valuation, seems to factor in these broader conditions." }] }, { "type": "paragraph", "attrs": { "textAlign": null, "showIfKey": null }, "content": [{ "type": "text", "marks": [{ "type": "bold" }], "text": "What does this mean for D2C companies?" }, { "type": "hardBreak" }, { "type": "text", "text": "Look, it’s critical for the broader startup ecosystem that large, profitable D2C brands list successfully in public markets. A more predictable IPO environment means more companies will start scaling seriously, raise patient capital, and build real businesses that create jobs. This whole \"ditch D2C, build AI chips\" narrative is fine for chai-break debates, but in the real world, scale still matters" }] }] }, { "type": "button", "attrs": { "text": "Learn more about the program", "isTextVariable": false, "url": "", "isUrlVariable": false, "alignment": "center", "variant": "filled", "borderRadius": "smooth", "buttonColor": "#000000", "textColor": "#ffffff", "showIfKey": null, "paddingTop": 10, "paddingRight": 32, "paddingBottom": 10, "paddingLeft": 32 } }, { "type": "horizontalRule" }, { "type": "image", "attrs": { "src": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Default_pfp.svg/340px-Default_pfp.svg.png", "alt": null, "title": null, "width": 64, "height": 64, "alignment": "center", "externalLink": null, "isExternalLinkVariable": false, "isSrcVariable": false, "showIfKey": null } }, { "type": "spacer", "attrs": { "height": 16, "showIfKey": null } }, { "type": "heading", "attrs": { "textAlign": "center", "level": 3, "showIfKey": null }, "content": [{ "type": "text", "text": "SendX" }] }, { "type": "spacer", "attrs": { "height": 4, "showIfKey": null } }, { "type": "footer", "attrs": { "textAlign": "center", "maily-component": "footer" }, "content": [{ "type": "text", "marks": [{ "type": "textStyle", "attrs": { "color": "", "fontFamily": null } }], "text": "1234 Example Street, Example, DE 19801, United States" }, { "type": "hardBreak" }, { "type": "text", "marks": [{ "type": "underline" }, { "type": "textStyle", "attrs": { "color": "#64748b", "fontFamily": null } }, { "type": "link", "attrs": { "href": "https://maily.to", "target": "_blank", "rel": "noopener noreferrer nofollow", "class": "mly-no-underline", "isUrlVariable": false } }], "text": "VISIT COMPANY" }, { "type": "text", "marks": [{ "type": "textStyle", "attrs": { "color": "#64748b", "fontFamily": null } }], "text": "  |  " }, { "type": "text", "marks": [{ "type": "underline" }, { "type": "textStyle", "attrs": { "color": "#64748b", "fontFamily": null } }, { "type": "link", "attrs": { "href": "https://maily.to", "target": "_blank", "rel": "noopener noreferrer nofollow", "class": "mly-no-underline", "isUrlVariable": false } }], "text": "VISIT OUR BLOG" }, { "type": "text", "marks": [{ "type": "textStyle", "attrs": { "color": "#64748b", "fontFamily": null } }], "text": "  |  " }, { "type": "text", "marks": [{ "type": "underline" }, { "type": "textStyle", "attrs": { "color": "#64748b", "fontFamily": null } }, { "type": "link", "attrs": { "href": "https://maily.to", "target": "_blank", "rel": "noopener noreferrer nofollow", "class": "mly-no-underline", "isUrlVariable": false } }], "text": "UNSUBSCRIBE" }] }, { "type": "paragraph", "attrs": { "textAlign": "center", "showIfKey": null }, "content": [{ "type": "inlineImage", "attrs": { "height": 20, "width": 20, "src": "https://cdn.usemaily.com/images/icons/linkedin.png", "isSrcVariable": false, "alt": null, "title": null, "externalLink": "https://www.linkedin.com/in/arikchakma/", "isExternalLinkVariable": false } }, { "type": "text", "text": "  " }, { "type": "inlineImage", "attrs": { "height": 20, "width": 20, "src": "https://cdn.usemaily.com/images/icons/youtube.png", "isSrcVariable": false, "alt": null, "title": null, "externalLink": "https://www.youtube.com/arikchakma", "isExternalLinkVariable": false } }, { "type": "text", "text": "  " }, { "type": "inlineImage", "attrs": { "height": 20, "width": 20, "src": "https://cdn.usemaily.com/images/icons/twitter.png", "isSrcVariable": false, "alt": null, "title": null, "externalLink": "https://x.com/imarikchakma", "isExternalLinkVariable": false } }] }] },
	"Blank Template": JSON.parse(emptySendxEditorTemplate)
}

export const TIPTAP_TEMPLATES_HTML_CODE = {
	"Welcome Email": `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html dir="ltr" lang="en"><head><meta charSet="utf-8"/><meta name="viewport" content="width=device-width"/><meta name="viewport" content="width=device-width"/><meta content="text/html; charset=UTF-8" http-equiv="Content-Type"/><meta name="x-apple-disable-message-reformatting"/><link rel="preconnect" href="https://fonts.googleapis.com"/><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="anonymous"/><meta http-equiv="X-UA-Compatible" content="IE=edge"/><meta name="x-apple-disable-message-reformatting"/><meta name="format-detection" content="telephone=no,address=no,email=no,date=no,url=no"/><meta name="color-scheme" content="light"/><meta name="supported-color-schemes" content="light"/><!--$--><style></style><style>
    @font-face {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      mso-font-alt: 'sans-serif';
      src: url(https://rsms.me/inter/font-files/Inter-Regular.woff2?v=3.19) format('woff2');
    }

    * {
      font-family: 'Inter', sans-serif;
    }
  </style><style>blockquote,h1,h2,h3,img,li,ol,p,ul{margin-top:0;margin-bottom:0}@media only screen and (max-width:425px){.tab-row-full{width:100%!important}.tab-col-full{display:block!important;width:100%!important}.tab-pad{padding:0!important}}</style></head><body style="margin:0"><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="max-width:600px;min-width:300px;width:100%;margin-left:auto;margin-right:auto;padding:0.5rem;background-color:white"><tbody><tr style="width:100%"><td><h1 style="margin-left:0px;margin-right:0px;margin-top:0px;margin-bottom:12px;text-align:left;color:#111827;font-size:36px;line-height:40px;font-weight:800">Welcome to Our Community!</h1><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151">Dear New Member,</p><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151">We are thrilled to have you join us! Your membership has been successfully activated, and you are now part of a community that values connection, growth, and learning.</p><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151">Here are a few things you can look forward to:</p><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="max-width:100%"><tbody><tr style="width:100%"><td><ul style="margin-top:0px;margin-bottom:20px;padding-left:26px;list-style-type:disc"><li style="margin-bottom:8px;padding-left:6px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale"><p style="font-size:15px;line-height:26.25px;margin:0 0 0px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151">Exclusive access to our online forums and discussions</p></li><li style="margin-bottom:8px;padding-left:6px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale"><p style="font-size:15px;line-height:26.25px;margin:0 0 0px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151">Invitations to members-only events and webinars</p></li><li style="margin-bottom:8px;padding-left:6px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale"><p style="font-size:15px;line-height:26.25px;margin:0 0 0px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151">A monthly newsletter filled with insights, tips, and updates</p></li></ul></td></tr></tbody></table><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151">We encourage you to dive in, participate, and share your experiences and knowledge with fellow members. Your contributions make our community richer and more vibrant.</p><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151">If you have any questions or need assistance, please feel free to reach out to us at <a href="mailto:support@example.com" rel="noopener noreferrer nofollow" style="color:#111827;text-decoration:none;font-weight:500" target="_blank">support@example.com</a>. We&#x27;re here to help!</p><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151">Welcome aboard, and we look forward to connecting with you!</p><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151">Best Regards,</p><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151"><strong>The Team at [Your Organization]</strong></p></td></tr></tbody></table><!--/$--></body></html>`,
	"Getting Started": `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html dir="ltr" lang="en"><head><meta charSet="utf-8"/><meta name="viewport" content="width=device-width"/><meta name="viewport" content="width=device-width"/><link rel="preload" as="image" href="https://www.bestregards.me/potion_images/examples/tiktok-header.png"/><link rel="preload" as="image" href="https://www.bestregards.me/potion_images/examples/tiktok-icon-logo.png"/><link rel="preload" as="image" href="https://www.bestregards.me/potion_images/examples/tiktok-text-logo.png"/><link rel="preload" as="image" href="https://cdn.usemaily.com/images/icons/linkedin.png"/><link rel="preload" as="image" href="https://cdn.usemaily.com/images/icons/youtube.png"/><link rel="preload" as="image" href="https://cdn.usemaily.com/images/icons/twitter.png"/><meta content="text/html; charset=UTF-8" http-equiv="Content-Type"/><meta name="x-apple-disable-message-reformatting"/><link rel="preconnect" href="https://fonts.googleapis.com"/><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="anonymous"/><meta http-equiv="X-UA-Compatible" content="IE=edge"/><meta name="x-apple-disable-message-reformatting"/><meta name="format-detection" content="telephone=no,address=no,email=no,date=no,url=no"/><meta name="color-scheme" content="light"/><meta name="supported-color-schemes" content="light"/><!--$--><style>@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;700&amp;display=swap);</style><style>
    @font-face {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      mso-font-alt: 'sans-serif';
      src: url(https://rsms.me/inter/font-files/Inter-Regular.woff2?v=3.19) format('woff2');
    }

    * {
      font-family: 'Inter', sans-serif;
    }
  </style><style>blockquote,h1,h2,h3,img,li,ol,p,ul{margin-top:0;margin-bottom:0}@media only screen and (max-width:425px){.tab-row-full{width:100%!important}.tab-col-full{display:block!important;width:100%!important}.tab-pad{padding:0!important}}</style></head><body style="margin:0"><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="max-width:600px;min-width:300px;width:100%;margin-left:auto;margin-right:auto;padding:0.5rem;background-color:white"><tbody><tr style="width:100%"><td><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="max-width:37.5em;height:64px"><tbody><tr style="width:100%"><td></td></tr></tbody></table><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin-top:0px;margin-bottom:32px"><tbody style="width:100%"><tr style="width:100%"><td align="center" data-id="__react-email-column"><img title="Image" alt="Image" src="https://www.bestregards.me/potion_images/examples/tiktok-header.png" style="display:block;outline:none;border:none;text-decoration:none;width:350px;max-width:100%"/></td></tr></tbody></table><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin-top:0px;margin-bottom:32px"><tbody style="width:100%"><tr style="width:100%"><td align="center" data-id="__react-email-column"><img title="Image" alt="Image" src="https://www.bestregards.me/potion_images/examples/tiktok-icon-logo.png" style="display:block;outline:none;border:none;text-decoration:none;width:64px;max-width:100%"/></td></tr></tbody></table><h3 style="margin-left:0px;margin-right:0px;margin-top:0px;margin-bottom:0px;text-align:center;color:#111827;font-size:24px;line-height:38px;font-weight:600">🎉 You&#x27;re Almost In! Let’s Get Started</h3><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="max-width:37.5em;height:16px"><tbody><tr style="width:100%"><td></td></tr></tbody></table><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151">Hey there,</p><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151">Thanks for signing up! You&#x27;re just one step away from unlocking exclusive content and personalized experiences on TikTok.</p><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="max-width:100%;text-align:center;margin-bottom:20px"><tbody><tr style="width:100%"><td><a href="" style="line-height:100%;text-decoration:none;display:inline-block;max-width:100%;mso-padding-alt:0px;color:#ffffff;background-color:#FE2C55;border-color:#FE2C55;border-width:2px;border-style:solid;font-size:14px;font-weight:500;border-radius:6px;padding:12px 32px 12px 32px" target="_blank"><span><!--[if mso]><i style="mso-font-width:400%;mso-text-raise:18" hidden>&#8202;&#8202;&#8202;&#8202;</i><![endif]--></span><span style="max-width:100%;display:inline-block;line-height:120%;mso-padding-alt:0px;mso-text-raise:9px">Subscribe</span><span><!--[if mso]><i style="mso-font-width:400%" hidden>&#8202;&#8202;&#8202;&#8202;&#8203;</i><![endif]--></span></a></td></tr></tbody></table><hr style="width:100%;border:none;border-top:1px solid #eaeaea;margin-top:32px;margin-bottom:32px"/><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin-top:0px;margin-bottom:0px"><tbody style="width:100%"><tr style="width:100%"><td align="center" data-id="__react-email-column"><img title="Image" alt="Image" src="https://www.bestregards.me/potion_images/examples/tiktok-text-logo.png" style="display:block;outline:none;border:none;text-decoration:none;width:137px;max-width:100%"/></td></tr></tbody></table><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="max-width:37.5em;height:16px"><tbody><tr style="width:100%"><td></td></tr></tbody></table><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="max-width:37.5em;height:4px"><tbody><tr style="width:100%"><td></td></tr></tbody></table><p style="font-size:14px;line-height:24px;margin:16px 0;color:#64748B;margin-top:0px;margin-bottom:20px;text-align:center;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale"><span>1234 Example Street, Example, DE 19801, United States</span><br/><a href="https://maily.to" rel="noopener noreferrer nofollow" style="color:#111827;text-decoration:none;font-weight:500" target="_blank"><span style="color:#64748b"><u>VISIT COMPANY</u></span></a><span style="color:#64748b">  |  </span><a href="https://maily.to" rel="noopener noreferrer nofollow" style="color:#111827;text-decoration:none;font-weight:500" target="_blank"><span style="color:#64748b"><u>VISIT OUR BLOG</u></span></a><span style="color:#64748b">  |  </span><a href="https://maily.to" rel="noopener noreferrer nofollow" style="color:#111827;text-decoration:none;font-weight:500" target="_blank"><span style="color:#64748b"><u>UNSUBSCRIBE</u></span></a></p><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;text-align:center;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151"><a href="https://www.linkedin.com/in/arikchakma/" rel="noopener noreferrer" style="display:inline;text-decoration:none" target="_blank"><img src="https://cdn.usemaily.com/images/icons/linkedin.png" width="20" height="20" style="display:inline;vertical-align:middle;width:20px;height:20px;outline:none;border:none;text-decoration:none"/></a> <!-- --> <a href="https://www.youtube.com/arikchakma" rel="noopener noreferrer" style="display:inline;text-decoration:none" target="_blank"><img src="https://cdn.usemaily.com/images/icons/youtube.png" width="20" height="20" style="display:inline;vertical-align:middle;width:20px;height:20px;outline:none;border:none;text-decoration:none"/></a> <!-- --> <a href="https://x.com/imarikchakma" rel="noopener noreferrer" style="display:inline;text-decoration:none" target="_blank"><img src="https://cdn.usemaily.com/images/icons/twitter.png" width="20" height="20" style="display:inline;vertical-align:middle;width:20px;height:20px;outline:none;border:none;text-decoration:none"/></a></p></td></tr></tbody></table><!--/$--></body></html>`,
	"Launch": `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html dir="ltr" lang="en"><head><meta charSet="utf-8"/><meta name="viewport" content="width=device-width"/><meta name="viewport" content="width=device-width"/><link rel="preload" as="image" href="https://www.bestregards.me/potion_images/examples/netflix-poster.jpg"/><link rel="preload" as="image" href="https://www.bestregards.me/potion_images/examples/netflix-coming-soon-1.jpg"/><link rel="preload" as="image" href="https://www.bestregards.me/potion_images/examples/netflix-coming-soon-2.jpg"/><link rel="preload" as="image" href="https://www.bestregards.me/potion_images/examples/netflix-coming-soon-3.jpg"/><link rel="preload" as="image" href="https://www.bestregards.me/potion_images/examples/netflix-logo.png"/><meta content="text/html; charset=UTF-8" http-equiv="Content-Type"/><meta name="x-apple-disable-message-reformatting"/><link rel="preconnect" href="https://fonts.googleapis.com"/><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="anonymous"/><meta http-equiv="X-UA-Compatible" content="IE=edge"/><meta name="x-apple-disable-message-reformatting"/><meta name="format-detection" content="telephone=no,address=no,email=no,date=no,url=no"/><meta name="color-scheme" content="light"/><meta name="supported-color-schemes" content="light"/><!--$--><style>@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;700&amp;display=swap);</style><style>
    @font-face {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      mso-font-alt: 'sans-serif';
      src: url(https://rsms.me/inter/font-files/Inter-Regular.woff2?v=3.19) format('woff2');
    }

    * {
      font-family: 'Inter', sans-serif;
    }
  </style><style>blockquote,h1,h2,h3,img,li,ol,p,ul{margin-top:0;margin-bottom:0}@media only screen and (max-width:425px){.tab-row-full{width:100%!important}.tab-col-full{display:block!important;width:100%!important}.tab-pad{padding:0!important}}</style></head><body style="margin:0"><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="max-width:600px;min-width:300px;width:100%;margin-left:auto;margin-right:auto;padding:0.5rem;background-color:white"><tbody><tr style="width:100%"><td><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin-top:0;margin-right:0;margin-bottom:0;margin-left:0"><tbody style="width:100%"><tr style="width:100%"><td align="left" data-id="__react-email-column" style="border-color:#e2e2e2;border-width:0;border-style:solid;background-color:#000000;border-radius:6px;padding-top:16px;padding-right:16px;padding-bottom:16px;padding-left:16px"><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin-top:0px;margin-bottom:0px"><tbody style="width:100%"><tr style="width:100%"><td align="center" data-id="__react-email-column"><img title="Image" alt="Image" src="https://www.bestregards.me/potion_images/examples/netflix-poster.jpg" style="display:block;outline:none;border:none;text-decoration:none;width:456px;max-width:100%"/></td></tr></tbody></table><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="max-width:37.5em;height:4px"><tbody><tr style="width:100%"><td></td></tr></tbody></table><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;text-align:center;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151"><span style="color:#ffffff">Captivating </span><span style="color:#ff0000"><strong>·</strong></span><span style="color:#ffffff"> Cerebral </span><span style="color:#ff0000"><strong>·</strong></span><span style="color:#ffffff"><strong> </strong></span><span style="color:#ffffff">Docuseries </span><span style="color:#d22020"><strong>·</strong></span><span style="color:#ffffff"><strong> </strong></span><span style="color:#ffffff">Spies   </span></p><h3 style="margin-left:0px;margin-right:0px;margin-top:0px;margin-bottom:12px;text-align:left;color:#111827;font-size:24px;line-height:38px;font-weight:600"><span style="color:#ffffff">Turning Point: The Bomb and the Cold War</span></h3><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151"><span style="color:#ffffff"><strong>Coming Tuesday</strong></span></p><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151"><span style="color:#ffffff">With firsthand accounts and access to prominent figures around the world, this comprehensive docuseries explores the Cold War and its aftermath. </span><a href="https://www.netflix.com/title/81614129?g=f3ee4e31-eda3-4e0a-8a30-cfd18e1f4c22&amp;lkid=URL_PRIMARY_MORE_INFO_0&amp;lnktrk=EVO&amp;trkid=13710079" rel="noopener noreferrer nofollow" style="color:#111827;text-decoration:none;font-weight:500" target="_blank"><span style="color:#ffffff"><u>Mo</u></span></a><a href="https://www.netflix.com/title/81614129?g=f3ee4e31-eda3-4e0a-8a30-cfd18e1f4c22&amp;lkid=URL_PRIMARY_MORE_INFO_0&amp;lnktrk=EVO&amp;trkid=13710079" rel="noopener noreferrer nofollow" style="color:#111827;text-decoration:none;font-weight:500" target="_blank"><u>re Info</u></a></p><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="max-width:100%;text-align:left;margin-bottom:20px"><tbody><tr style="width:100%"><td><a href="" style="line-height:100%;text-decoration:none;display:inline-block;max-width:100%;mso-padding-alt:0px;color:#ffffff;background-color:#E50914;border-color:#E50914;border-width:2px;border-style:solid;font-size:14px;font-weight:500;border-radius:6px;padding:12px 32px 12px 32px" target="_blank"><span><!--[if mso]><i style="mso-font-width:400%;mso-text-raise:18" hidden>&#8202;&#8202;&#8202;&#8202;</i><![endif]--></span><span style="max-width:100%;display:inline-block;line-height:120%;mso-padding-alt:0px;mso-text-raise:9px">Remind me</span><span><!--[if mso]><i style="mso-font-width:400%" hidden>&#8202;&#8202;&#8202;&#8202;&#8203;</i><![endif]--></span></a></td></tr></tbody></table><h3 style="margin-left:0px;margin-right:0px;margin-top:0px;margin-bottom:0px;text-align:left;color:#111827;font-size:24px;line-height:38px;font-weight:600"><span style="color:#ffffff">Coming Soon</span></h3><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="max-width:37.5em;height:4px"><tbody><tr style="width:100%"><td></td></tr></tbody></table><table align="center" width="100%" class="tab-row-full" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin:0;padding:0;width:100%"><tbody style="width:100%"><tr style="width:100%"><td width="33%" class="tab-col-full" data-id="__react-email-column" style="width:33%;margin:0;vertical-align:top"><table align="center" width="100%" class="tab-pad" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin:0;padding-left:0;padding-right:6px"><tbody><tr><td><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin-top:0px;margin-bottom:0px"><tbody style="width:100%"><tr style="width:100%"><td align="center" data-id="__react-email-column"><img title="Image" alt="Image" src="https://www.bestregards.me/potion_images/examples/netflix-coming-soon-1.jpg" style="display:block;outline:none;border:none;text-decoration:none;width:177px;max-width:100%"/></td></tr></tbody></table></td></tr></tbody></table></td><td width="33%" class="tab-col-full" data-id="__react-email-column" style="width:33%;margin:0;vertical-align:top"><table align="center" width="100%" class="tab-pad" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin:0;padding-left:3px;padding-right:3px"><tbody><tr><td><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin-top:0px;margin-bottom:0px"><tbody style="width:100%"><tr style="width:100%"><td align="center" data-id="__react-email-column"><img title="Image" alt="Image" src="https://www.bestregards.me/potion_images/examples/netflix-coming-soon-2.jpg" style="display:block;outline:none;border:none;text-decoration:none;width:177px;max-width:100%"/></td></tr></tbody></table></td></tr></tbody></table></td><td width="33%" class="tab-col-full" data-id="__react-email-column" style="width:33%;margin:0;vertical-align:top"><table align="center" width="100%" class="tab-pad" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin:0;padding-left:6px;padding-right:0"><tbody><tr><td><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin-top:0px;margin-bottom:0px"><tbody style="width:100%"><tr style="width:100%"><td align="center" data-id="__react-email-column"><img title="Image" alt="Image" src="https://www.bestregards.me/potion_images/examples/netflix-coming-soon-3.jpg" style="display:block;outline:none;border:none;text-decoration:none;width:177px;max-width:100%"/></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="max-width:37.5em;height:16px"><tbody><tr style="width:100%"><td></td></tr></tbody></table><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="max-width:100%;text-align:center;margin-bottom:20px"><tbody><tr style="width:100%"><td><a href="" style="line-height:100%;text-decoration:none;display:inline-block;max-width:100%;mso-padding-alt:0px;color:#ffffff;background-color:#414141;border-color:#414141;border-width:2px;border-style:solid;font-size:14px;font-weight:500;border-radius:6px;padding:16px 40px 16px 40px" target="_blank"><span><!--[if mso]><i style="mso-font-width:500%;mso-text-raise:24" hidden>&#8202;&#8202;&#8202;&#8202;</i><![endif]--></span><span style="max-width:100%;display:inline-block;line-height:120%;mso-padding-alt:0px;mso-text-raise:12px">View All TV Shows &amp; Movies</span><span><!--[if mso]><i style="mso-font-width:500%" hidden>&#8202;&#8202;&#8202;&#8202;&#8203;</i><![endif]--></span></a></td></tr></tbody></table><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin-top:0px;margin-bottom:0px"><tbody style="width:100%"><tr style="width:100%"><td align="center" data-id="__react-email-column"><img title="Image" alt="Image" src="https://www.bestregards.me/potion_images/examples/netflix-logo.png" style="display:block;outline:none;border:none;text-decoration:none;width:44px;max-width:100%"/></td></tr></tbody></table><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="max-width:37.5em;height:16px"><tbody><tr style="width:100%"><td></td></tr></tbody></table><h3 style="margin-left:0px;margin-right:0px;margin-top:0px;margin-bottom:12px;text-align:center;color:#111827;font-size:24px;line-height:38px;font-weight:600"><span style="color:rgb(164, 164, 164)">Questions? Visit the </span><a href="https://help.netflix.com/help?g=f3ee4e31-eda3-4e0a-8a30-cfd18e1f4c22&amp;lkid=URL_HELP_QUESTIONS&amp;lnktrk=EVO" rel="noopener noreferrer nofollow" style="color:#111827;text-decoration:none;font-weight:500" target="_blank"><u>Help Center</u></a><br/><span style="color:rgb(164, 164, 164)">Netflix Services Germany GmbH</span></h3><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;text-align:center;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151"><a href="www.netflix.com" rel="noopener noreferrer nofollow" style="color:#111827;text-decoration:none;font-weight:500" target="_blank"><span style="color:#ffffff"><u>Unsubscribe</u></span></a><br/><a href="https://help.netflix.com/legal/termsofuse" rel="noopener noreferrer nofollow" style="color:#111827;text-decoration:none;font-weight:500" target="_blank"><span style="color:#ffffff"><u>Terms of Use</u></span></a><br/><a href="https://help.netflix.com/legal/privacy" rel="noopener noreferrer nofollow" style="color:#111827;text-decoration:none;font-weight:500" target="_blank"><span style="color:#ffffff"><u>Privacy</u></span></a><br/><span style="color:#ffffff"><u>Help Center</u></span></p><p style="font-size:15px;line-height:26.25px;margin:0 0 0px 0;text-align:center;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151"><span style="color:#ffffff">This message was mailed to [</span><a href="mailto:ohansemmanuel@gmail.com" rel="noopener noreferrer nofollow" style="color:#111827;text-decoration:none;font-weight:500" target="_blank"><span style="color:#ffffff">ohansxxxxxxxxxxxx@gmail.com</span></a><span style="color:#ffffff">] by Netflix as part of your Netflix membership</span></p></td></tr></tbody></table><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151"><br/></p></td></tr></tbody></table><!--/$--></body></html>`,
	"Product": `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html dir="ltr" lang="en"><head><meta charSet="utf-8"/><meta name="viewport" content="width=device-width"/><meta name="viewport" content="width=device-width"/><link rel="preload" as="image" href="https://www.bestregards.me/potion_images/examples/amazon-logo.jpg"/><link rel="preload" as="image" href="https://aimint.org/ap/wp-content/uploads/sites/18/2016/04/image-placeholder-vertical.jpg"/><link rel="preload" as="image" href="https://cdn4.iconfinder.com/data/icons/logos-and-brands/512/395_Youtube_logo-512.png"/><meta content="text/html; charset=UTF-8" http-equiv="Content-Type"/><meta name="x-apple-disable-message-reformatting"/><link rel="preconnect" href="https://fonts.googleapis.com"/><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="anonymous"/><meta http-equiv="X-UA-Compatible" content="IE=edge"/><meta name="x-apple-disable-message-reformatting"/><meta name="format-detection" content="telephone=no,address=no,email=no,date=no,url=no"/><meta name="color-scheme" content="light"/><meta name="supported-color-schemes" content="light"/><!--$--><style></style><style>
    @font-face {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      mso-font-alt: 'sans-serif';
      src: url(https://rsms.me/inter/font-files/Inter-Regular.woff2?v=3.19) format('woff2');
    }

    * {
      font-family: 'Inter', sans-serif;
    }
  </style><style>blockquote,h1,h2,h3,img,li,ol,p,ul{margin-top:0;margin-bottom:0}@media only screen and (max-width:425px){.tab-row-full{width:100%!important}.tab-col-full{display:block!important;width:100%!important}.tab-pad{padding:0!important}}</style></head><body style="margin:0"><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="max-width:600px;min-width:300px;width:100%;margin-left:auto;margin-right:auto;padding:0.5rem;background-color:white"><tbody><tr style="width:100%"><td><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin-top:0px;margin-bottom:0px"><tbody style="width:100%"><tr style="width:100%"><td align="left" data-id="__react-email-column"><img title="Image" alt="Image" src="https://www.bestregards.me/potion_images/examples/amazon-logo.jpg" style="display:block;outline:none;border:none;text-decoration:none;width:204px;max-width:100%"/></td></tr></tbody></table><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="max-width:37.5em;height:8px"><tbody><tr style="width:100%"><td></td></tr></tbody></table><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin-top:0;margin-right:0;margin-bottom:0;margin-left:0"><tbody style="width:100%"><tr style="width:100%"><td align="left" data-id="__react-email-column" style="border-color:#ffffff;border-width:2px;border-style:solid;background-color:#ededed;border-radius:6px;padding-top:16px;padding-right:16px;padding-bottom:16px;padding-left:16px"><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin-top:0;margin-right:0;margin-bottom:0;margin-left:0"><tbody style="width:100%"><tr style="width:100%"><td align="left" data-id="__react-email-column" style="border-color:#ffffff;border-width:0;border-style:solid;background-color:#ffffff;border-radius:6px;padding-top:16px;padding-right:16px;padding-bottom:16px;padding-left:16px"><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151">We thought you&#x27;d like to know about something exciting we just launched.<br/>A brand new product designed to make your everyday better is finally here — and we think you&#x27;ll love it.</p><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151">Ready to experience smarter living? Explore the all-new <strong>Echo Smart Hub</strong> and take control of your home with your voice.</p><table align="center" width="100%" class="tab-row-full" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin:0;padding:0;width:100%"><tbody style="width:100%"><tr style="width:100%"><td width="50%" class="tab-col-full" data-id="__react-email-column" style="width:50%;margin:0;vertical-align:top"><table align="center" width="100%" class="tab-pad" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin:0;padding-left:0;padding-right:4px"><tbody><tr><td><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin-top:0px;margin-bottom:0px"><tbody style="width:100%"><tr style="width:100%"><td align="center" data-id="__react-email-column"><img title="Image" alt="Image" src="https://aimint.org/ap/wp-content/uploads/sites/18/2016/04/image-placeholder-vertical.jpg" style="display:block;outline:none;border:none;text-decoration:none;width:211px;max-width:100%"/></td></tr></tbody></table></td></tr></tbody></table></td><td width="50%" class="tab-col-full" data-id="__react-email-column" style="width:50%;margin:0;vertical-align:top"><table align="center" width="100%" class="tab-pad" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin:0;padding-left:4px;padding-right:0"><tbody><tr><td><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin-top:0px;margin-bottom:0px"><tbody style="width:100%"><tr style="width:100%"><td align="center" data-id="__react-email-column"><img title="Image" alt="Image" src="https://aimint.org/ap/wp-content/uploads/sites/18/2016/04/image-placeholder-vertical.jpg" style="display:block;outline:none;border:none;text-decoration:none;width:211px;max-width:100%"/></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="max-width:37.5em;height:16px"><tbody><tr style="width:100%"><td></td></tr></tbody></table><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin-top:0;margin-right:0;margin-bottom:0;margin-left:0"><tbody style="width:100%"><tr style="width:100%"><td align="left" data-id="__react-email-column" style="border-color:#e2e2e2;border-width:0;border-style:solid;background-color:#ffffff;border-radius:6px;padding-top:16px;padding-right:16px;padding-bottom:16px;padding-left:16px"><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151"><strong>Just Released:</strong><br/><strong>Echo Smart Hub</strong><br/><strong>Launch Date:</strong> Tuesday, 19 March</p><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin-top:0px;margin-bottom:32px"><tbody style="width:100%"><tr style="width:100%"><td align="center" data-id="__react-email-column"><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="width:fit-content"><tbody style="width:100%"><tr style="width:100%"><td align="center" data-id="__react-email-column" style="width:fit-content"><a href="https://www.youtube.com/embed/c21QZnQtGqo" target="_blank" rel="noopener noreferrer" style="display:block;max-width:100%;margin:0 auto;position:relative"><div style="background-image:url(&#x27;https://img.youtube.com/vi/c21QZnQtGqo/hqdefault.jpg&#x27;);background-position:center center;background-repeat:no-repeat;background-size:cover;width:445px;height:250.31249999999997px;border-radius:8px;line-height:0;font-size:0;display:inline-block"><div style="width:100%;padding-top:25%"><img src="https://cdn4.iconfinder.com/data/icons/logos-and-brands/512/395_Youtube_logo-512.png" alt="Play Icon" style="width:50px;height:50px"/></div></div></a></td></tr></tbody></table></td></tr></tbody></table><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151">Built for seamless integration, the Echo Smart Hub brings your lights, thermostat, music, and more into one effortless voice-controlled experience.</p><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151">📦 <strong>Shipped from:</strong><br/>Amazon Warehouse – Berlin</p><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151">Order now and enjoy <strong>exclusive launch pricing</strong> for a limited time only.</p><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="max-width:100%;text-align:left;margin-bottom:0px"><tbody><tr style="width:100%"><td><a href="" style="line-height:100%;text-decoration:none;display:inline-block;max-width:100%;mso-padding-alt:0px;color:#000000;background-color:#fff25f;border-color:#fff25f;border-width:2px;border-style:solid;font-size:14px;font-weight:500;border-radius:9999px;padding:12px 32px 12px 32px" target="_blank"><span><!--[if mso]><i style="mso-font-width:400%;mso-text-raise:18" hidden>&#8202;&#8202;&#8202;&#8202;</i><![endif]--></span><span style="max-width:100%;display:inline-block;line-height:120%;mso-padding-alt:0px;mso-text-raise:9px">Order Now</span><span><!--[if mso]><i style="mso-font-width:400%" hidden>&#8202;&#8202;&#8202;&#8202;&#8203;</i><![endif]--></span></a></td></tr></tbody></table><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="max-width:37.5em;height:16px"><tbody><tr style="width:100%"><td></td></tr></tbody></table></td></tr></tbody></table><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="max-width:37.5em;height:4px"><tbody><tr style="width:100%"><td></td></tr></tbody></table></td></tr></tbody></table><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151"> </p></td></tr></tbody></table><!--/$--></body></html>`,
	"Information": `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html dir="ltr" lang="en"><head><meta charSet="utf-8"/><meta name="viewport" content="width=device-width"/><meta name="viewport" content="width=device-width"/><link rel="preload" as="image" href="https://cdn.prod.website-files.com/64e6e95f1770b454db7ff6f4/6501d245436969b3397f66d8_Webflow%20(placeholder)%2016-9.png"/><link rel="preload" as="image" href="https://aimint.org/ap/wp-content/uploads/sites/18/2016/04/image-placeholder-vertical.jpg"/><link rel="preload" as="image" href="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Default_pfp.svg/340px-Default_pfp.svg.png"/><link rel="preload" as="image" href="https://cdn.usemaily.com/images/icons/linkedin.png"/><link rel="preload" as="image" href="https://cdn.usemaily.com/images/icons/youtube.png"/><link rel="preload" as="image" href="https://cdn.usemaily.com/images/icons/twitter.png"/><meta content="text/html; charset=UTF-8" http-equiv="Content-Type"/><meta name="x-apple-disable-message-reformatting"/><link rel="preconnect" href="https://fonts.googleapis.com"/><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="anonymous"/><meta http-equiv="X-UA-Compatible" content="IE=edge"/><meta name="x-apple-disable-message-reformatting"/><meta name="format-detection" content="telephone=no,address=no,email=no,date=no,url=no"/><meta name="color-scheme" content="light"/><meta name="supported-color-schemes" content="light"/><!--$--><style>@import url(https://fonts.googleapis.com/css2?family=&quot;SF+Pro+Display&quot;,+-apple-system,+system-ui,+&quot;system-ui&quot;,+Inter,+&quot;Segoe+UI&quot;,+Roboto,+Helvetica,+Arial,+sans-serif,+&quot;Apple+Color+Emoji&quot;,+&quot;Segoe+UI+Emoji&quot;,+&quot;Segoe+UI+Symbol&quot;:wght@400;700&amp;display=swap);
  @import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;700&amp;display=swap);
  @import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;700&amp;display=swap);
  @import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;700&amp;display=swap);
  @import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;700&amp;display=swap);
  @import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;700&amp;display=swap);
  @import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;700&amp;display=swap);</style><style>
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        mso-font-alt: 'sans-serif';
        src: url(https://rsms.me/inter/font-files/Inter-Regular.woff2?v=3.19) format('woff2');
      }
  
      * {
        font-family: 'Inter', sans-serif;
      }
    </style><style>blockquote,h1,h2,h3,img,li,ol,p,ul{margin-top:0;margin-bottom:0}@media only screen and (max-width:425px){.tab-row-full{width:100%!important}.tab-col-full{display:block!important;width:100%!important}.tab-pad{padding:0!important}}</style></head><body style="margin:0"><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="max-width:600px;min-width:300px;width:100%;margin-left:auto;margin-right:auto;padding:0.5rem"><tbody><tr style="width:100%"><td><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin-top:0px;margin-bottom:32px"><tbody style="width:100%"><tr style="width:100%"><td align="center" data-id="__react-email-column"><img title="Image" alt="Image" src="https://cdn.prod.website-files.com/64e6e95f1770b454db7ff6f4/6501d245436969b3397f66d8_Webflow%20(placeholder)%2016-9.png" style="display:block;outline:none;border:none;text-decoration:none;width:580px;max-width:100%"/></td></tr></tbody></table><hr style="width:100%;border:none;border-top:1px solid #eaeaea;margin-top:32px;margin-bottom:32px"/><h1 style="margin-left:0px;margin-right:0px;margin-top:0px;margin-bottom:12px;text-align:left;color:#111827;font-size:36px;line-height:40px;font-weight:800">VoltRide crisis, Audionics IPO, Shipzy&#x27;s acquisition &amp; VRO&#x27;s $10M funding 💸</h1><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151">Too much this week in tech world.</p><hr style="width:100%;border:none;border-top:1px solid #eaeaea;margin-top:32px;margin-bottom:32px"/><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151"><strong>We are back with our business newsletter edition</strong><span style="color:rgb(54, 55, 55);font-family:&quot;SF Pro Display&quot;, -apple-system, system-ui, &quot;system-ui&quot;, Inter, &quot;Segoe UI&quot;, Roboto, Helvetica, Arial, sans-serif, &quot;Apple Color Emoji&quot;, &quot;Segoe UI Emoji&quot;, &quot;Segoe UI Symbol&quot;">. Today, we’ll cover 4 business topics in one go — let&#x27;s dive in.</span></p><table align="center" width="100%" class="tab-row-full" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin:0;padding:0;width:100%"><tbody style="width:100%"><tr style="width:100%"><td width="33%" class="tab-col-full" data-id="__react-email-column" style="width:33%;margin:0;vertical-align:top"><table align="center" width="100%" class="tab-pad" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin:0;padding-left:0;padding-right:6px"><tbody><tr><td><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin-top:0px;margin-bottom:0px"><tbody style="width:100%"><tr style="width:100%"><td align="center" data-id="__react-email-column"><img title="Image" alt="Image" src="https://aimint.org/ap/wp-content/uploads/sites/18/2016/04/image-placeholder-vertical.jpg" style="display:block;outline:none;border:none;text-decoration:none;width:188px;max-width:100%"/></td></tr></tbody></table></td></tr></tbody></table></td><td width="33%" class="tab-col-full" data-id="__react-email-column" style="width:33%;margin:0;vertical-align:top"><table align="center" width="100%" class="tab-pad" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin:0;padding-left:3px;padding-right:3px"><tbody><tr><td><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin-top:0px;margin-bottom:0px"><tbody style="width:100%"><tr style="width:100%"><td align="center" data-id="__react-email-column"><img title="Image" alt="Image" src="https://aimint.org/ap/wp-content/uploads/sites/18/2016/04/image-placeholder-vertical.jpg" style="display:block;outline:none;border:none;text-decoration:none;width:187px;max-width:100%"/></td></tr></tbody></table></td></tr></tbody></table></td><td width="33%" class="tab-col-full" data-id="__react-email-column" style="width:33%;margin:0;vertical-align:top"><table align="center" width="100%" class="tab-pad" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin:0;padding-left:6px;padding-right:0"><tbody><tr><td><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin-top:0px;margin-bottom:0px"><tbody style="width:100%"><tr style="width:100%"><td align="center" data-id="__react-email-column"><img title="Image" alt="Image" src="https://aimint.org/ap/wp-content/uploads/sites/18/2016/04/image-placeholder-vertical.jpg" style="display:block;outline:none;border:none;text-decoration:none;width:187px;max-width:100%"/></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="max-width:37.5em;height:32px"><tbody><tr style="width:100%"><td></td></tr></tbody></table><hr style="width:100%;border:none;border-top:1px solid #eaeaea;margin-top:32px;margin-bottom:32px"/><h2 style="margin-left:0px;margin-right:0px;margin-top:0px;margin-bottom:12px;text-align:left;color:#111827;font-size:30px;line-height:36px;font-weight:700">Audionics files for IPO 💰</h2><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin-top:0px;margin-bottom:32px"><tbody style="width:100%"><tr style="width:100%"><td align="center" data-id="__react-email-column"><img title="Image" alt="Image" src="https://cdn.prod.website-files.com/64e6e95f1770b454db7ff6f4/6501d245436969b3397f66d8_Webflow%20(placeholder)%2016-9.png" style="display:block;outline:none;border:none;text-decoration:none;width:578px;max-width:100%"/></td></tr></tbody></table><blockquote style="border-left-width:4px;border-left-style:solid;border-left-color:#D1D5DB;padding-left:16px;margin-left:0px;margin-right:0px;margin-top:20px;margin-bottom:20px"><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151"><strong>First, some context.</strong><br/>This is <strong>SonicLoop’s</strong> 2nd attempt at going public. In February 2022, it had filed for a ₹1,800 crore IPO but later pulled the plug, citing volatile market conditions. Instead, it raised $55 million in private capital through convertible preferred stock notes from its existing backer <strong>NorthBridge Capital</strong> and new investor <strong>Orion Ventures</strong>. The round was raised at a minimum valuation cap of approximately <strong>$1.1 billion</strong>.</p><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151"><strong>Some quick revenue numbers.</strong><br/>FY 2021-22 : ₹1,128 crore<br/>FY 2022-23 : ₹2,410 crore<br/>FY 2023-24 : ₹3,045 crore<br/>FY 2024-25 : ₹2,860 crore</p><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151">The slight revenue dip was intentional—aimed at cutting net losses from ₹92 crore to ₹47 crore. The company also reported a <strong>positive EBITDA</strong> for the year.</p><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151"><strong>The market has changed.</strong><br/>In the past 3 years, the global economic slowdown and the recent <strong>Tech Tariff standoff</strong> between major economies have made public markets less attractive from a liquidity standpoint. The new IPO, pegged at a <strong>$1.4 billion</strong> valuation, seems to factor in these broader conditions.</p><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151"><strong>What does this mean for D2C companies?</strong><br/>Look, it’s critical for the broader startup ecosystem that large, profitable D2C brands list successfully in public markets. A more predictable IPO environment means more companies will start scaling seriously, raise patient capital, and build real businesses that create jobs. This whole &quot;ditch D2C, build AI chips&quot; narrative is fine for chai-break debates, but in the real world, scale still matters</p></blockquote><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="max-width:100%;text-align:center;margin-bottom:20px"><tbody><tr style="width:100%"><td><a href="" style="line-height:100%;text-decoration:none;display:inline-block;max-width:100%;mso-padding-alt:0px;color:#ffffff;background-color:#000000;border-color:#000000;border-width:2px;border-style:solid;font-size:14px;font-weight:500;border-radius:6px;padding:12px 32px 12px 32px" target="_blank"><span><!--[if mso]><i style="mso-font-width:400%;mso-text-raise:18" hidden>&#8202;&#8202;&#8202;&#8202;</i><![endif]--></span><span style="max-width:100%;display:inline-block;line-height:120%;mso-padding-alt:0px;mso-text-raise:9px">Learn more about the program</span><span><!--[if mso]><i style="mso-font-width:400%" hidden>&#8202;&#8202;&#8202;&#8202;&#8203;</i><![endif]--></span></a></td></tr></tbody></table><hr style="width:100%;border:none;border-top:1px solid #eaeaea;margin-top:32px;margin-bottom:32px"/><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="margin-top:0px;margin-bottom:0px"><tbody style="width:100%"><tr style="width:100%"><td align="center" data-id="__react-email-column"><img title="Image" alt="Image" src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Default_pfp.svg/340px-Default_pfp.svg.png" style="display:block;outline:none;border:none;text-decoration:none;width:64px;max-width:100%"/></td></tr></tbody></table><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="max-width:37.5em;height:16px"><tbody><tr style="width:100%"><td></td></tr></tbody></table><h3 style="margin-left:0px;margin-right:0px;margin-top:0px;margin-bottom:0px;text-align:center;color:#111827;font-size:24px;line-height:38px;font-weight:600">SendX</h3><table align="center" width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style="max-width:37.5em;height:4px"><tbody><tr style="width:100%"><td></td></tr></tbody></table><p style="font-size:14px;line-height:24px;margin:16px 0;color:#64748B;margin-top:0px;margin-bottom:20px;text-align:center;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale"><span>1234 Example Street, Example, DE 19801, United States</span><br/><a href="https://maily.to" rel="noopener noreferrer nofollow" style="color:#111827;text-decoration:none;font-weight:500" target="_blank"><span style="color:#64748b"><u>VISIT COMPANY</u></span></a><span style="color:#64748b">  |  </span><a href="https://maily.to" rel="noopener noreferrer nofollow" style="color:#111827;text-decoration:none;font-weight:500" target="_blank"><span style="color:#64748b"><u>VISIT OUR BLOG</u></span></a><span style="color:#64748b">  |  </span><a href="https://maily.to" rel="noopener noreferrer nofollow" style="color:#111827;text-decoration:none;font-weight:500" target="_blank"><span style="color:#64748b"><u>UNSUBSCRIBE</u></span></a></p><p style="font-size:15px;line-height:26.25px;margin:0 0 20px 0;text-align:center;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#374151"><a href="https://www.linkedin.com/in/arikchakma/" rel="noopener noreferrer" style="display:inline;text-decoration:none" target="_blank"><img src="https://cdn.usemaily.com/images/icons/linkedin.png" width="20" height="20" style="display:inline;vertical-align:middle;width:20px;height:20px;outline:none;border:none;text-decoration:none"/></a> <!-- --> <a href="https://www.youtube.com/arikchakma" rel="noopener noreferrer" style="display:inline;text-decoration:none" target="_blank"><img src="https://cdn.usemaily.com/images/icons/youtube.png" width="20" height="20" style="display:inline;vertical-align:middle;width:20px;height:20px;outline:none;border:none;text-decoration:none"/></a> <!-- --> <a href="https://x.com/imarikchakma" rel="noopener noreferrer" style="display:inline;text-decoration:none" target="_blank"><img src="https://cdn.usemaily.com/images/icons/twitter.png" width="20" height="20" style="display:inline;vertical-align:middle;width:20px;height:20px;outline:none;border:none;text-decoration:none"/></a></p></td></tr></tbody></table><!--/$--></body></html>`,
	"Blank Template": ""
}

export const TIPTAP_TEMPLATES = [
	{
		folder: "Custom",
		usecase: 0,
		is_global: true,
		id: 1,
		title: "Blank Template",
		thumbnail: "",
		usecase: 0,
		templateCode: TIPTAP_TEMPLATES_CODE["Blank Template"],
		htmlCode: TIPTAP_TEMPLATES_HTML_CODE["Blank Template"],
	},
	{
		folder: "Custom",
		usecase: 0,
		is_global: true,
		id: 1,
		title: "Welcome Email",
		thumbnail: "https://cdn.sendx.io/campaign-image/36545_kmcnksq2NwCbKEoT6qGQpd.png",
		usecase: 0,
		templateCode: TIPTAP_TEMPLATES_CODE["Welcome Email"],
		htmlCode: TIPTAP_TEMPLATES_HTML_CODE["Welcome Email"],
	},
	{
		folder: "Custom",
		usecase: 0,
		is_global: true,
		id: 1,
		title: "Getting Started",
		thumbnail: "https://cdn.sendx.io/campaign-image/36545_VAIoe7Tli4NOlQ8qtC1l1e.png",
		usecase: 0,
		templateCode: TIPTAP_TEMPLATES_CODE["Getting Started"],
		htmlCode: TIPTAP_TEMPLATES_HTML_CODE["Getting Started"],
	},
	{
		folder: "Custom",
		usecase: 0,
		is_global: true,
		id: 1,
		title: "Launch",
		thumbnail: "https://cdn.sendx.io/campaign-image/36545_iRha8c201N3zRCX8oScyMh.png",
		usecase: 0,
		templateCode: TIPTAP_TEMPLATES_CODE["Launch"],
		htmlCode: TIPTAP_TEMPLATES_HTML_CODE["Launch"],
	},
	{
		folder: "Custom",
		usecase: 0,
		is_global: true,
		id: 1,
		title: "Product",
		thumbnail: "https://cdn.sendx.io/campaign-image/36545_ZX4GM7LHxYq1aSaG1r0o5u.png",
		usecase: 0,
		templateCode: TIPTAP_TEMPLATES_CODE["Product"],
		htmlCode: TIPTAP_TEMPLATES_HTML_CODE["Product"],
	},
	{
		folder: "Custom",
		usecase: 0,
		is_global: true,
		id: 1,
		title: "Information",
		thumbnail: "https://cdn.sendx.io/campaign-image/36545_705usuIp2APIjvnBePCY2D.png",
		usecase: 0,
		templateCode: TIPTAP_TEMPLATES_CODE["Information"],
		htmlCode: TIPTAP_TEMPLATES_HTML_CODE["Information"],
	},
]


export const DEFAULT_WEBSITE_TEMPLATE = {
	"Data": {
		"LogoUrl": "https://brandlogos.net/wp-content/uploads/2025/04/gate.io_icon-logo_brandlogos.net_806ai.png",
		"Links": [
			{
				"Label": "Home",
				"Url": "https://www.notboring.co"
			},
			{
				"Label": "Archives",
				"Url": "https://www.notboring.co/stories"
			},
			{
				"Label": "About",
				"Url": "https://www.notboring.co/subscribe"
			}
		],
		"Headline": "Infobit Newsletter",
		"CompanyDescription": "🔍 Smart business analysis made fun. ✍️ Writing deep dives on tech, startups, and strategy. 🚀 Read by 250,000+ curious minds weekly.",
		"AuthorName": "Packy McCormick",
		"CompanyName": "Infobit",
		"Campaigns": [
			{
				"Id": 1,
				"Title": "Anthropic secures $4B investment from Amazon to rival OpenAI",
				"CardUrl": "https://www.notboring.co/p/anthropic-funding-amazon",
				"ImageUrl": "https://media.beehiiv.com/cdn-cgi/image/format=auto,width=800,height=421,fit=scale-down,onerror=redirect/uploads/asset/file/bfcfaf22-9523-4687-8b6f-dd7164cf8641/deepseek-r2-thumb.png",
				"ImageAlt": "Anthropic secures $4B investment from Amazon to rival OpenAI",
				"Datetime": "2025-04-29",
				"TimeAgo": "2 hours ago",
				"Count": "125",
				"AuthorUrl": "https://www.notboring.co/about",
				"AuthorName": "Packy McCormick",
				"LogoUrl": "https://brandlogos.net/wp-content/uploads/2025/04/gate.io_icon-logo_brandlogos.net_806ai.png"
			},
			{
				"Title": "Stripe launches new AI-powered financial tools for startups",
				"CardUrl": "https://www.notboring.co/p/stripe-new-ai-tools",
				"ImageUrl": "https://media.beehiiv.com/cdn-cgi/image/format=auto,width=800,height=421,fit=scale-down,onerror=redirect/uploads/asset/file/fe77a9fa-e099-4307-85e1-24fb4e7dc6db/alphabet-q1-2025-thumb.png",
				"ImageAlt": "Stripe launches new AI-powered financial tools for startups",
				"Datetime": "2025-04-29",
				"TimeAgo": "3 hours ago",
				"Count": "98",
				"AuthorUrl": "https://www.notboring.co/about",
				"AuthorName": "Packy McCormick",
				"LogoUrl": "https://brandlogos.net/wp-content/uploads/2025/04/gate.io_icon-logo_brandlogos.net_806ai.png"
			},
			{
				"Title": "NVIDIA unveils Blackwell GPU, crushing AI performance benchmarks",
				"CardUrl": "https://www.notboring.co/p/nvidia-blackwell-gpu",
				"ImageUrl": "https://media.beehiiv.com/cdn-cgi/image/format=auto,width=800,height=421,fit=scale-down,onerror=redirect/uploads/asset/file/3f37c731-0ce1-4a51-8430-3f63ccec2fd0/openai-chrome-chatgpt-thumb.png",
				"ImageAlt": "NVIDIA unveils Blackwell GPU, crushing AI performance benchmarks",
				"Datetime": "2025-04-29",
				"TimeAgo": "5 hours ago",
				"Count": "112",
				"AuthorUrl": "https://www.notboring.co/about",
				"AuthorName": "Packy McCormick",
				"LogoUrl": "https://brandlogos.net/wp-content/uploads/2025/04/gate.io_icon-logo_brandlogos.net_806ai.png"
			},
			{
				"Id": "1",
				"Title": "Figma releases new multiplayer AI design features",
				"CardUrl": "https://www.notboring.co/p/figma-ai-collab",
				"ImageUrl": "https://media.beehiiv.com/cdn-cgi/image/format=auto,width=800,height=421,fit=scale-down,onerror=redirect/uploads/asset/file/ae9dd6e3-09ac-4be2-8977-913320a743e8/1200_athyna_hire_remotely.png",
				"ImageAlt": "Figma releases new multiplayer AI design features",
				"Datetime": "2025-04-29",
				"TimeAgo": "7 hours ago",
				"Count": "87",
				"AuthorUrl": "https://www.notboring.co/about",
				"AuthorName": "Packy McCormick",
				"LogoUrl": "https://brandlogos.net/wp-content/uploads/2025/04/gate.io_icon-logo_brandlogos.net_806ai.png"
			},
			{
				"Title": "OpenAI’s new Voice Engine clones any voice with 15 seconds of audio",
				"CardUrl": "https://www.notboring.co/p/openai-voice-engine",
				"ImageUrl": "https://media.beehiiv.com/cdn-cgi/image/format=auto,width=800,height=421,fit=scale-down,onerror=redirect/uploads/asset/file/f3a6f99e-dd09-41d4-8c63-d5a0f6759a72/siri-thumb.png",
				"ImageAlt": "OpenAI’s new Voice Engine clones any voice with 15 seconds of audio",
				"Datetime": "2025-04-29",
				"TimeAgo": "10 hours ago",
				"Count": "143",
				"AuthorUrl": "https://www.notboring.co/about",
				"AuthorName": "Packy McCormick",
				"LogoUrl": "https://brandlogos.net/wp-content/uploads/2025/04/gate.io_icon-logo_brandlogos.net_806ai.png"
			}
		],
		"PrimaryBackgroundColor": "#fff",
		"SecondaryBackgroundColor": "#f8f9ff",
		"HeaderTextColor": "#FF0000",
		"BodyTextColor": "#222222",
		"ButtonTextColor": "#fff",
		"ButtonBackgroundColor": "#000e4b",
		"LinksColor": "#000e4b",
		"OverlineTextColor": "#6b7280",
		"FooterTextColor": "#111827",
		"ArchiveTitleColor": "#111827",
		"ArchiveTitle": "Archive",
		"HeaderFont": "Inter",
		"BodyFont": "Raleway",
		"FacebookUrl": "https://www.facebook.com/notboringclub",
		"TwitterUrl": "https://twitter.com/packyM",
		"InstagramUrl": "https://www.instagram.com/notboringclub",
		"LinkedinUrl": "https://www.linkedin.com/company/not-boring"
	},
	"NavbarTemplate": "template1.html",
	"FooterTemplate": "template1.html",
	"AuthorTemplate": "template1.html",
	"CampaignsTemplate": "template1.html",
	"SocialLinksTemplate": "template3.html",
	"SubscribeTemplate": "template1.html",
	"HeroTemplate": "template1.html",
	"Template": "template1.html"
}

export const googleFontPickerApiKey = () => {
	const $config = useRuntimeConfig();
	return $config.public.googleFontPickerApiKey;
}

export const Routes = Object.freeze({
	Home: "/",
	NotFound: "/404",
	Error: "/error",
	Dashboard: "/dashboard",
	Profile: "/profile",
	Webhooks: "/webhooks",
	Team: "/team",
	Setting: {
		Billing: "/setting/billing",
		Team: {
			Members: "/setting/team/members",
		},
		Branding: {
			Root: "/setting/branding",
		},
		HomePage: "/setting/home-page",
		Marketplace: {
			Integrations: "/setting/marketplace/integrations",
			AddOns: "/setting/marketplace/addon",
			Partners: "/setting/marketplace/partners",
		},
		ContactProperties: {
			CustomFields: "/setting/custom-properties/custom-fields",
			CustomEvents: "/setting/custom-properties/custom-events",
		},
		Connectors: {
			Api: "/setting/connectors/api",
			Webhook: "/setting/connectors/webhook",
		},
		WebsiteSettings: {
			Design: "/setting/website-settings/design",
		},
		Setup: {
			DomainWhitelisting: "/setting/setup/domain-whitelisting",
			Template: "/setting/setup/template",
			Editor: "/setting/setup/editor",
			Sender: "/setting/setup/sender",
			CompanyInformation: "/setting/setup/company-information",
			Unsubscribe: "/setting/setup/unsubscribe",
		}
	},
	Api: "/api",
	Integration: "/integration",
	Help: "/help",
	Login: "/login",
	Register: "/register",
	Admin: "/admin",
	ResetPassword: "/resetpassword",
	Onboarding: "/onboarding",
	Form: {
		Root: "/form",
		Popup: "/form/table/popup",
		Embed: "/form/table/embed",
		LandingPage: "/form/table/landing-page",
		New: {
			Type: "/form/new/type",
			Basic: "/form/new/basic",
			Design: "/form/new/design",
			Content: "/form/new/content",
			SuccessPage: "/form/new/success-page",
			Targeting: "/form/new/targeting",
			Behaviour: "/form/new/behaviour",
			Success: "/form/new/success",
		},
		Edit: {
			Popup: "/form/popup/edit",
			Embed: "/form/embedded/edit",
			LandingPage: "/form/landing-page/edit",
		},
		Details: {
			Overview: "/form/details/overview",
			Performance: "/form/details/overview/performance",
			Submission: "/form/details/overview/submission",
		},
	},
	Integration: {
		Root: "/integration",
	},
  	AddOn: {
		Root: "/addon",
	},
	Template: {
		Root: "/template",
		New: "/template/new",
    Type: "/template/new/type",
	},
	Audience: {
		List: {
			Home: "/audience/list/table", // all lists
			New: {
				Import: {
					SelectFile: "/audience/list/new/import/select-file",
					MatchFields: "/audience/list/new/import/match-fields",
				},
			},
		},
		Contact: {
			Home: "/audience/contact/table", // all contacts
			Unsubscribed: "/audience/contact/table/unsubscribed",
			Bounced: "/audience/contact/table/bounced",
			MarkedSpam: "/audience/contact/table/markedspam",
			New: "/audience/contact/new",
			Info: {
				Home: "/audience/contact/info",
				Timeline: "/audience/contact/info/timeline",
			},
			Edit: {
				Home: "/audience/contact/edit",
				Timeline: "/audience/contact/edit/timeline",
			},
		},
		Tag: {
			Home: "/audience/tag/table",
		},
		Segment: {
			Root: "/audience/segment",
			Home: "/audience/segment/table",
			New: "/audience/segment/new",
		},
	},
	Campaign: {
		Root: "/campaign",
		Newsletter: {
			Root: "/campaign/newsletter",
			Home: "/campaign/newsletter/table", // all newsletters
			Draft: "/campaign/newsletter/table/draft",
			Scheduled: "/campaign/newsletter/table/scheduled",
			Sending: "/campaign/newsletter/table/sending",
			Sent: "/campaign/newsletter/table/sent",
			Quarantined: "/campaign/newsletter/table/quarantined",
			New: {
				Sender: "/campaign/newsletter/new/sender", // Subject and Sender details
				Type: "/campaign/newsletter/new/type", // Subject and Sender details
				Design: "/campaign/newsletter/new/design",
				Content: "/campaign/newsletter/new/content",
				Recipient: "/campaign/newsletter/new/recipient",
				ReviewAndConfirm: "/campaign/newsletter/new/review",
				Schedule: "/campaign/newsletter/new/schedule",
			},
			Edit: "/campaign/newsletter/edit",
		},
		ABTest: {
			Root: "/campaign/abtest",
			Home: "/campaign/abtest/table", // all newsletters
			Draft: "/campaign/abtest/table/draft",
			Scheduled: "/campaign/abtest/table/scheduled",
			Testing: "/campaign/abtest/table/testing",
			Tested: "/campaign/abtest/table/tested",
			WinnerScheduled: "/campaign/abtest/table/winnerScheduled",
			WinnerSending: "/campaign/abtest/table/winnerSending",
			Finished: "/campaign/abtest/table/finished",
			New: {
				Sender: "/campaign/abtest/new/sender", // Subject and Sender details
				Type: "/campaign/abtest/new/type",
				Subject: "/campaign/abtest/new/sender",
				Design: "/campaign/abtest/new/design",
				Content: "/campaign/abtest/new/content",
				Recipient: "/campaign/abtest/new/recipient",
				ReviewAndConfirm: "/campaign/abtest/new/review",
				Schedule: "/campaign/abtest/new/schedule",
			},
			Edit: "/campaign/abtest/edit",
		},
		Drip: {
			Root: "/campaign/drip",
			Home: "/campaign/drip/table",
			Active: "/campaign/drip/table/active",
			Paused: "/campaign/drip/table/paused",
			New: {
				Sender: "/campaign/drip/new/sender", // Subject and Sender details
				Type: "/campaign/drip/new/type",
				Content: "/campaign/drip/new/content",
				Schedule: "/campaign/drip/new/schedule",
				TriggerCondition: "/campaign/drip/new/trigger-condition",
			},
			Edit: "/campaign/drip/edit",
		},
		AutoTrigger: {
			Root: "/campaign/autotrigger",
			Home: "/campaign/autotrigger/table", // all autotriggers
			Draft: "/campaign/autotrigger/table/draft",
			Active: "/campaign/autotrigger/table/active",
			New: {
				Sender: "/campaign/autotrigger/new/sender", // Subject and Sender details
				Type: "/campaign/autotrigger/new/type",
				Design: "/campaign/autotrigger/new/design",
				Content: "/campaign/autotrigger/new/content",
				ReviewAndConfirm: "/campaign/autotrigger/new/review",
				Trigger: "/campaign/autotrigger/new/trigger",
			},
			Edit: "/campaign/autotrigger/edit",
		},
		RSS: {
			Root: "/campaign/rss",
			Home: "/campaign/rss/table",
			Draft: "/campaign/rss/table/draft",
			Active: "/campaign/rss/table/active",
			Paused: "/campaign/rss/table/paused",
			New: {
				Basic: "/campaign/rss/new/basic",
				Content: "/campaign/rss/new/content",
				Recipient: "/campaign/rss/new/recipient",
				Schedule: "/campaign/rss/new/schedule",
				ReviewAndConfirm: "/campaign/rss/new/review",
			},
			Edit: "/campaign/rss/edit",
		},
		Report: {
			Home: "/campaign/report",
		},
		Details: {
			Overview: "/campaign/details/overview",
			Performance: "/campaign/details/overview/performance",
		},
	},
	Automate: {
		Root: "/automate",
		Workflow: {
			Root: "/automate/workflow",
			Home: "/automate/workflow/table", // all automations
			Draft: "/automate/workflow/table/draft",
			Active: "/automate/workflow/table/active",
			Paused: "/automate/workflow/table/paused",
			Template: "/automate/workflow/table/template",
			New: {
				Home: "/automate/workflow/new",
				Template: "/automate/workflow/new/template",
				Edit: "/automate/workflow/new/edit",
				Timeline: "/automate/workflow/new/timeline",
				Goal: "/automate/workflow/new/goal",
			},
		},
		Automation: {
			New: {
				Name: "/automate/automations/new/name",
				Configure: "/automate/automations/new/configure",
			},
			Info: "/automate/automations/info",
			Edit: "/automate/automations/edit",
			Home: "/automate/automations/table",
		},
		BulkAction: {
			Root: "/automate/bulk-action",
			Home: "/automate/bulk-action/table",
		}
	},
	Tickets: {
		Home: "/tickets/table",
		New: "/tickets/new",
		Root: "/tickets",
	},
	Post: {
		Root: "/post",
		Home: "/post/table",
		Published: "/post/table/published",
		Draft: "/post/table/draft",
		New: {
			Basic: "/post/new/basic",
			Design: "/post/new/design",
			Content: "/post/new/content",
			ReviewAndConfirm: "/post/new/review",
			Type: "/post/new/type",
			Details: "/post/new/details"
		},
		Edit: "/post/edit",
	}
});

export const AccountState = Object.freeze({
	PaidSubscribed: "paid_subscribed",
	WithinFreeUsage: "within_free_usage",
	FreeEmailsLimitExceeded: "free_emails_limit_exceeded",
	FreeContactLimitExceeded: "free_contact_limit_exceeded",
	CardInvalid: "card_invalid",
	TrialEnded: "trial_ended",
});



export const AccountLockReason = Object.freeze({
	LockedBasedOnRisk: 0,
	LockedManually: 1,
	LockedExceededContactLimit: 2,
	LockedPaymentFailed: 3,
});

export const FieldTypes = Object.freeze({
	Empty: "",
	Info: "is-info",
	Danger: "is-danger",
	Success: "is-success",
});

export const RssScheduleType = Object.freeze({
	ScheduleNow: 0,
	ScheduleDaily: 1,
	ScheduleWeekly: 2,
	ScheduleMonthly: 3,
});

export const CampaignScheduleType = Object.freeze({
	ScheduleLater: 0,
	SendNow: 1,
	TriggerViaAutomation: 2,
	Recurring: 3,
});

export const CampaignType = Object.freeze({
	BroadcastCampaign: 0,
	RSSCampaign: 1,
	ABTestCampaign: 2,
});

export const CampaignStatus = Object.freeze({
	Draft: 0,
	Scheduled: 1,
	Sending: 2,
	Sent: 3,
});

export const ABTestCampaignStatus = Object.freeze({
	ABTestDraft: 0,
	ABTestScheduled: 1,
	ABTestTesting: 2,
	ABTestTested: 3,
	ABTestWinnerScheduled: 4,
	ABTestWinnerSending: 5,
	ABTestFinished: 6,
	ABTestQuarantined: 7,
});

export const BeePlugin = Object.freeze({
	ClientId: "840f4477-2071-4b5b-a7c9-79cd553fea12",
	ClientSecret: "S6n6Vl2JvshvZ0nUNnqgRYqJyNuLK8E1b4UHGkKG6FZlOvpCbgj",
});

export const BeePageBuilderPlugin = Object.freeze({
	ClientId: "6d8e7b81-4c69-4707-a148-6c0deebeaab8",
	ClientSecret: "sZxUeOqpK02J9o66jCpLr8WSnqdT5n1XD4NCpvH5vYobBWwsWxtd",
});

export const Integrations = Object.freeze([
	{ name: "Zapier", component: `LogoZapier` },
	{ name: "Intercom", component: `LogoIntercom` },
	{ name: "Click Funnels", component: `LogoClickFunnels` },
	{ name: "Stripe", component: `LogoStripe` },
	{ name: "PayPal", component: `LogoPayPal` },
	{ name: "Woo Commerce", component: `LogoWooCommerce` },
	{ name: "Teachable", component: `LogoTeachable` },
	{ name: "Pipedrive", component: `LogoPipedrive` },
]);

export const SidebarTab = Object.freeze({
	Actions: 0,
	Integrations: 1,
	SelectActionValue: 2,
	TriggerOrActionCompleteAndSave: 3,
});

// 0 WorkflowActionListSubscribe ActionType = iota
// 1 WorkflowActionListUnsubscribe
// 2 WorkflowActionListConfirm
// 3 WorkflowActionContactRemovedFromList
// 4 WorkflowActionTagAddedToContact
// 5 WorkflowActionTagDeletedFromContact
// 6 WorkflowActionContactAddedViaEmailCollectPopup
// 7 WorkflowActionContactAddedViaEmailCollectForm
// 8 WorkflowActionContactAddedViaLandingPage
// 9 WorkflowActionContactAddedToSegment
//10 WorkflowActionContactRemovedFromSegment
//11 WorkflowActionSendCampaign
//12 WorkflowActionSendEmail

// 0 WorkflowSendImmediately ActionDelay = iota
// 1 WorkflowAfterMinutes
// 2 WorkflowAfterHours
// 3 WorkflowAfterDays

export const radioItemsInteger = [
	{
		label: "Yes",
		value: "1",
	},
	{
		label: "No",
		value: "0",
	},
];

export const radioItemsBoolean = [
	{
		label: "True",
		value: "true",
	},
	{
		label: "False",
		value: "false",
	},
];

export const contactSourceItems = [
	{ value: "0", label: "unknown" },
	{ value: "1", label: "via file import" },
	{ value: "2", label: "JS API" },
	{ value: "3", label: "REST API" },
	{ value: "4", label: "Manual addition" },
	{ value: "5", label: "Via Popups" },
	{ value: "6", label: "Via Forms" },
	{ value: "7", label: "Via Landing Pages" },
	{ value: "8", label: "Via InstaPages" },
	{ value: "9", label: "Via SamCart" },
	{ value: "10", label: "Via Woo-Commerce" },
];

export const WaitDurationType = Object.freeze({
	Hours: 0,
	Days: 1,
});

export const popupThemeNames = {
	0: "Modal",
	1: "Page Takeover",
	2: "Bar",
	3: "Slider",
	4: "Modal Newsletter",
	5: "Page Takeover Side",
	6: "Intro Bar",
	7: "Modal Background",
	8: "Modal Left Image",
	9: "Modal Right Image",
	10: "Modal Background Classic",
	11: "Modal Background Modern",
	12: "Modal Background Retro",
	13: "Modal Left Image Modern",
	14: "Modal Right Image Modern",
	15: "Modal Left Image Equal",
	16: "Modal Right Image Equal",
	17: "Modal Left Image Equal Retro",
	18: "Modal Right Image Equal Retro",
	19: "Modal Left Image Modern Retro",
	20: "Modal Right Image Modern Retro",
	21: "Modal Background Minimal",
	22: "Modal Background Muse",
	23: "Bar Modern",
	24: "Bar Minimal",
	25: "Page Takeover Modern Retro",
	26: "Page Takeover Left Image Equal",
	27: "Page Takeover Right Image Equal",
};

export const EntityNames = Object.freeze({
	EntityCampaign: 0,
	EntityABTest: 1,
	EntityPopup: 2,
	EntityLandingPage: 3,
	EntityEmbeddedForm: 4,
});

export const AutomationTriggers = Object.freeze({
	subscribes_to_list: "Subscribed to a list",
	unsubscribes_from_list: "Unsubscribed from a list",
	confirms_list: "Confirmed to a list",
	tag_added: "Tag added",
	tag_removed: "Tag removed",
	opens_campaign: "Opened newsletter campaign",
	clicks_link: "Clicked a link in newsletter or auto-trigger campaign",
	subscribes_to_drip: "Added to a drip campaign",
	unsubscribes_from_drip: "Removed from a drip campaign",
	send_push_campaign: "Send webpush campaign",
	send_contact_activity_email_notification: "Send activity notification email",
	call_webhook: "Call Webhook",
	pipedrive_send_contact: "Send contact to PipeDrive",
	salesforce_send_contact: "Send contact to SalesForce",
	closeio_send_contact: "Send contact to Close.Io",
	demio_send_contact: "Send contact to Demio",
	demio_register_contact: "Register contact on Demio",
	facebook_add_to_custom_audience: "Add contact to Facebook Custom Audience",
	facebook_remove_from_custom_audience:
		"Remove contact from Facebook Custom Audience",
	opens_drip: "Opened drip campaign",
	clicks_drip_link: "Clicked a link in drip campaign",
	completes_drip: "Completed a drip campaign",
	campaign_replied_to: "Replied to a newsletter campaign",
	dripstep_replied_to: "Replied to a drip campaign",
	removed_from_list: "Removed from a list",
	contact_added_via_popup: "Contact added via popup form",
	contact_added_via_form: "Contact added via embedded form",
	contact_added_to_segment: "Added to a segment",
	contact_removed_from_segment: "Removed from a segment",
	contact_added_via_landing_page: "Contact added via landing page form",
	contact_clicks_push_campaign: "Clicked webpush campaign",
	contact_visited_page: "Contact visited page",
	global_subscribe: "Global Subscribe",
	global_unsubscribe: "Unsubscribe Contact",
	instapage_contact_added: "Contact added via InstaPage",
	samcart_order_placed: "Order placed via SamCart",
	woocommerce_order_placed: "Order placed via WooCommerce",
	woocommerce_customer_created: "Customer created via WooCommerce",
	samcart_customer_created: "Customer created via SamCart",
	stripe_customer_created: "Customer created via Stripe",
	stripe_customer_charge_succeeded: "Customer charged succeeded via Stripe",
	stripe_customer_charge_failed: "Customer charged failed via Stripe",
	stripe_customer_charge_refunded: "Customer charged refunded via Stripe",
	paypal_customer_charge_succeeded: "Customer charged succeeded via Paypal",
	paypal_customer_charge_failed: "Customer charged failed via Paypal",
	paypal_customer_charge_refunded: "Customer charged refunded via Paypal",
	paypal_customer_charge_declined: "Customer charged declined via Paypal",
	intercom_lead_created: "Lead created via Intercom",
	intercom_user_created: "User created via Intercom",
	shopify_checkout_started: "Shopify cart abandoned",
	shopify_customer_created: "Shopify customer created",
	shopify_customer_deleted: "Shopify customer deleted",
	shopify_order_cancelled: "Shopify order cancelled",
	shopify_order_created: "Shopify order created",
	shopify_order_fulfilled: "Shopify order fulfilled",
	submitted_via_form: "Submitted via form",
	send_campaign: "Send auto-trigger campaign",
});

export const TriggerOptionsData = Object.freeze({
	1: [
		{ id: -1, text: "-- Choose a Trigger --" },
		{ id: 0, text: "Subscribed to a list", type: "list" },
		{ id: 2, text: "Confirmed to a list", type: "list" },
		{ id: 13, text: "Removed from list", type: "list" },
		{ id: 3, text: "Tag added", type: "tag" },
		{ id: 4, text: "Tag removed", type: "tag" },
		{ id: 5, text: "Opened newsletter campaign", type: "campaign" },
		{
			id: 6,
			text: "Clicked a link in newsletter or auto-trigger campaign",
			type: "text",
		},
		{ id: 7, text: "Added to a drip campaign", type: "drip" },
		{ id: 8, text: "Opened a drip campaign", type: "drip" },
		{ id: 9, text: "Clicked a link in drip", type: "text" },
		{ id: 10, text: "Completed a drip campaign", type: "drip" },
		{ id: 12, text: "Replied to a drip campaign", type: "drip" },
		{ id: 14, text: "Contact added via popup form", type: "popup" },
		{ id: 15, text: "Contact added via embedded form", type: "embed" },
		{ id: 18, text: "Contact added via landing page form", type: "landing" },
		{ id: 16, text: "Added to a segment", type: "segment" },
		{ id: 17, text: "Removed from a segment", type: "segment" },
		{ id: 20, text: "Contact visited page", type: "text" },
		{ id: 21, text: "Unsubscribe Contact" },
	],
	2: [
		{ id: -1, text: "-- Choose a Trigger --" },
		{ id: 25, text: "New customer created" },
		{ id: 24, text: "Placed order" },
	],
	3: [
		{ id: -1, text: "-- Choose a Trigger --" },
		{ id: 23, text: "Placed order" },
	],
	4: [
		{ id: -1, text: "-- Choose a Trigger --" },
		{ id: 27, text: "New customer created" },
		{ id: 28, text: "Customer charge succeeded" },
		{ id: 29, text: "Customer charge failed" },
		{ id: 30, text: "Customer charge refunded" },
	],
	5: [
		{ id: -1, text: "-- Choose a Trigger --" },
		{ id: 31, text: "Customer charge succeeded" },
		{ id: 32, text: "Customer charge failed" },
		{ id: 33, text: "Customer charge declined" },
		{ id: 34, text: "Customer charge refunded" },
	],
	6: [
		{ id: -1, text: "-- Choose a Trigger --" },
		{ id: 22, text: "Submitted via landing page" },
	],
	7: [
		{ id: -1, text: "-- Choose a Trigger --" },
		{ id: 35, text: "Intercom lead created" },
		{ id: 36, text: "Intercom user created" },
	],
	9: [
		{ id: -1, text: "-- Choose a Trigger --" },
		{ id: 44, text: "Submitted via form" },
	],
	12: [
		{ id: -1, text: "-- Choose a Trigger --" },
		{ id: 37, text: "Cart abandoned" },
		{ id: 38, text: "New customer" },
		{ id: 41, text: "Placed order" },
		{ id: 40, text: "Cancelled order" },
		{ id: 42, text: "Fulfilled order" },
	],
});

export const ActionOptionsData = Object.freeze({
	1: [
		{ id: -1, text: "-- Choose an Action --" },
		{ id: 0, text: "Subscribes to a list", type: "list" },
		{ id: 2, text: "Confirmed to a list", type: "list" },
		{ id: 8, text: "Removed from a list", type: "list" },
		{ id: 3, text: "Tag added", type: "tag" },
		{ id: 4, text: "Tag removed", type: "tag" },
		{ id: 5, text: "Send auto-trigger campaign", type: "autotrigger" },
		{ id: 6, text: "Added to a drip campaign", type: "drip" },
		{ id: 7, text: "Removed from a drip", type: "drip" },
		{ id: 10, text: "Send activity notification email", type: "member" },
		{ id: 11, text: "Unsubscribe contact" },
		{ id: 12, text: "Global subscribe" },
		{ id: 13, text: "Call webhook", type: "text" },
		{ id: 21, text: "Delete Contact" },
	],
	7: [
		{ id: -1, text: "-- Choose an Action --" },
		{ id: 14, text: "Send contact" },
	],
	10: [
		{ id: -1, text: "-- Choose an Action --" },
		{ id: 18, text: "Register contact", type: "demio" },
	],
});

export const AppEntities = Object.freeze({
	Contact: 0,
	Campaign: 1,
	Billing: 2,
	Form: 3,
	Automation: 4,
	Team: 5,
	Member: 6,
	Setting: 7,
	Import: 8,
	BulkAction: 9,
	Templates: 10,
	CustomField: 11,
	RssFeed: 12,
	Domain: 13,
	ApiKey: 14,
	Audience: 15,
	TeamPreferences: 16,
	CustomEvent: 17,
	AddOns: 18,
	WebSettings: 19,
  Notification: 20,
});

export const AddOns = Object.freeze({
	FRANCHISE_SUPPORT: 1,
	CUSTOM_REPLY: 2,
	BOT_OPEN_CLICK: 3,
	READ_SKIMMED_GLANCED: 4,
	SHORTCUTS: 5,
  	DYNAMIC_SENDER: 6,
	MX_BASED_ROUTING: 7,
	TRANSACTIONAL_EMAIL: 8,
	LIST_CLEANING: 9,
  	BLOGS: 10,
});

export const AddOnsDetail = Object.freeze({
	[AddOns.FRANCHISE_SUPPORT]: {
    routeName: "franchise-support",
		title: "What All Can You Do With Franchise Support In SendX",
		settingTitle: "Configure your addOn settings",
		reportTitle: "Analytics and performance insights",
		description:
			"Enable seamless sharing of resources like templates, tags, custom fields, and segments across teams, with full editing capabilities.",
		detail:
			"<p class='text-gray-600 mb-4'>The Franchise Support addon enables efficient collaboration across multiple teams or franchise locations by allowing shared access to key resources such as email templates, tags, custom fields, and segments. Team members can create, edit, and manage these resources with full permissions, ensuring consistency in branding and messaging across your organization. <br> This addon streamlines workflows by centralizing resource management, reducing duplication of efforts, and enabling real-time updates across all connected accounts.</p>",
		keyFeatures:
			"Shared resource management for templates, tags, and segments<br>Full editing permissions for team members<br>Real-time synchronization across accounts<br>Centralized branding control<br>Streamlined workflows and reduced duplication",
		tags: ["workflow", "personalization", "event data", "SendX"],
		src: "https://video.sendworks.com/share/1w1rkDjxyH41oZoyIArOFw",
		categories: "Workflows",
		imageSrc:
			"https://sendx-cdn.s3.us-east-1.amazonaws.com/add-on-images/franchise_support.png",
		hasSetting: false,
    hasReport: false,
    hasBilling: false,
	},
	[AddOns.CUSTOM_REPLY]: {
    routeName: "custom-reply",
		title: "Setting Up Custom Reply Email Addresses for Campaigns",
		settingTitle: "Configure your addOn settings",
		reportTitle: "Analytics and performance insights",
		description:
			"Ability to set a custom reply-to email address for each campaign, ensuring responses are directed to the desired inbox for better communication and tracking.",
		detail:
			"<p class='text-gray-600 mb-4'>The Custom Reply addon allows you to set a unique reply-to email address for each email campaign, ensuring that recipient responses are routed to the appropriate inbox. This feature enhances communication by enabling personalized follow-ups and better tracking of campaign replies. You can configure reply-to addresses to align with specific teams, departments, or campaigns, improving response management and customer engagement.</p>",
		keyFeatures:
			"Custom reply-to email per campaign<br>Improved response tracking<br>Department or team-specific reply routing<br>Enhanced customer engagement",
		tags: ["workflow", "personalization", "event data", "SendX"],
		src: "https://video.sendworks.com/share/VYRARXE1C61bCK7ijKkKGg",
		categories: "Workflows",
		imageSrc:
			"https://sendx-cdn.s3.us-east-1.amazonaws.com/add-on-images/custom_reply.png",
    hasSetting: false,
    hasReport: false,
    hasBilling: false,
	},
	[AddOns.BOT_OPEN_CLICK]: {
    routeName: "bot-tracker",
		title: "Detecting Bot Opens and Clicks",
		settingTitle: "Configure your addOn settings",
		reportTitle: "Analytics and performance insights",
		description:
			"Ability to identify and filter out bot-generated opens and clicks for more accurate campaign performance tracking.",
		detail:
			"<p class='text-gray-600 mb-4'>The Bot Open & Click Detection addon enhances the accuracy of your email campaign analytics by identifying and filtering out opens and clicks generated by bots. This ensures your performance metrics reflect genuine user interactions, allowing for more reliable data-driven decisions. The addon uses advanced algorithms to detect bot activity, such as automated scans or crawlers, and excludes these from your reports. You can view detailed analytics on bot activity and export filtered results for further analysis.</p>",
		keyFeatures:
			"Bot activity detection and filtering<br>Accurate campaign performance metrics<br>Advanced bot identification algorithms<br>Detailed bot activity reports<br>Exportable analytics data",
		categories: "Workflows",
		imageSrc:
			"https://sendx-cdn.s3.us-east-1.amazonaws.com/add-on-images/bot_open_click.png",
		src: "https://video.sendworks.com/share/hdhBHKLw7SawHRZb6R3tXw",
    hasSetting: false,
    hasReport: false,
    hasBilling: false,
	},
	[AddOns.READ_SKIMMED_GLANCED]: {
    routeName: "read-skim-glance",
		title: "Tracking Email Engagement Duration",
		settingTitle: "Configure your addOn settings",
		reportTitle: "Analytics and performance insights",
		description:
			"Ability to measure how long a recipient engages with an email and classify it as Read, Skimmed, or Glanced.",
		detail:
			"<p class='text-gray-600 mb-4'>The Read, Skimmed, Glanced addon provides deep insights into recipient engagement by tracking how long each recipient spends interacting with your emails. Emails are categorized as 'Read' (long engagement), 'Skimmed' (moderate engagement), or 'Glanced' (brief engagement), allowing you to understand audience behavior better. This data helps optimize email content and design for higher engagement. The addon includes detailed analytics dashboards and exportable reports to track engagement trends over time.</p>",
		keyFeatures:
			"Engagement duration tracking<br>Read, Skimmed, Glanced categorization<br>Detailed engagement analytics<br>Customizable engagement thresholds<br>Exportable engagement reports",
		categories: "Workflows",
		imageSrc:
			"https://sendx-cdn.s3.us-east-1.amazonaws.com/add-on-images/read_skimmed_glanced.png",
		src: "https://video.sendworks.com/share/1jfU5QHf62iRQUuFfbYkTw",
    hasSetting: false,
    hasReport: false,
    hasBilling: false,
	},
	[AddOns.SHORTCUTS]: {
    routeName: "shortcuts",
		title: "Using Keyboard Shortcuts in SendX",
		settingTitle: "Configure your addOn settings",
		reportTitle: "Analytics and performance insights",
		description:
			"Boost your productivity with keyboard shortcuts, allowing you to navigate and perform actions quickly within SendX.",
		detail:
			"<p class='text-gray-600 mb-4'>The Keyboard Shortcuts addon enhances your workflow efficiency by providing a set of customizable keyboard shortcuts for navigating and performing actions within the SendX platform. From creating campaigns to managing contacts, shortcuts reduce the time spent on repetitive tasks, allowing you to focus on strategy. The addon includes a reference guide for all available shortcuts and supports customization to suit your preferences. </p>",
		keyFeatures:
			"Customizable keyboard shortcuts<br>Faster navigation and task execution<br>Comprehensive shortcut reference guide<br>Shortcut usage analytics<br>Support for multiple user roles",
		categories: "Workflows",
		imageSrc:
			"https://sendx-cdn.s3.us-east-1.amazonaws.com/add-on-images/read_skimmed_glanced.png",
		src: "https://video.sendworks.com/share/1jfU5QHf62iRQUuFfbYkTw",
    hasSetting: false,
    hasReport: false,
    hasBilling: false,
	},
	[AddOns.DYNAMIC_SENDER]: {
    routeName: "dynamic-sender",
		title: "Dynamic Sender Profiles for Campaigns",
		settingTitle: "Configure your addOn settings",
		reportTitle: "Analytics and performance insights",
		description:
			"Personalize your campaigns by dynamically changing the sender name and email address based on recipient data or campaign goals.",
		detail:
			"<p class='text-gray-600 mb-4'>The Dynamic Sender addon allows you to personalize your email campaigns by dynamically adjusting the sender name and email address based on recipient attributes, such as location, segment, or preferences. This creates a more personalized experience, increasing open rates and engagement. You can set rules to select sender profiles automatically and test different configurations to optimize performance. Analytics provide insights into which sender profiles drive the best results.</p>",
		keyFeatures:
			"Dynamic sender name and email selection<br>Recipient-based personalization rules<br>A/B testing for sender profiles<br>Engagement analytics by sender<br>Automated sender profile management",
		categories: "Workflows",
		imageSrc:
			"https://sendx-cdn.s3.us-east-1.amazonaws.com/add-on-images/read_skimmed_glanced.png",
		src: "https://video.sendworks.com/share/1jfU5QHf62iRQUuFfbYkTw",
    hasSetting: false,
    hasReport: false,
    hasBilling: false,
	},
	[AddOns.MX_BASED_ROUTING]: {
   routeName: "mx-routing",
		title: "MX-Based Email Routing",
		settingTitle: "Configure your addOn settings",
		reportTitle: "Analytics and performance insights",
		description:
			"Optimize email delivery by routing emails through specific mail servers based on recipient domain MX records.",
		detail:
			"<p class='text-gray-600 mb-4'>The MX-Based Routing addon improves email deliverability by intelligently routing emails through optimal mail servers based on the recipient's domain MX records. This ensures faster delivery and reduces the likelihood of emails being marked as spam. The addon automatically analyzes MX records and selects the best server for each recipient, with options to customize routing rules. Detailed analytics track delivery success rates and server performance.</p>",
		keyFeatures:
			"Intelligent MX-based email routing<br>Optimized email deliverability<br>Customizable routing rules<br>Delivery success analytics<br>Real-time server performance monitoring",
		categories: "Workflows",
		imageSrc:
			"https://sendx-cdn.s3.us-east-1.amazonaws.com/add-on-images/read_skimmed_glanced.png",
		src: "https://video.sendworks.com/share/1jfU5QHf62iRQUuFfbYkTw",
    hasSetting: false,
    hasReport: false,
    hasBilling: false,
	},
	[AddOns.TRANSACTIONAL_EMAIL]: {
    routeName: "transactional-email",
		title: "Transactional Email Management",
		settingTitle: "Configure your addOn settings",
		reportTitle: "Analytics and performance insights",
		description:
			"Send and manage transactional emails like order confirmations, password resets, and notifications directly from SendX.",
		detail:
			"<p class='text-gray-600 mb-4'>The Transactional Email addon enables you to send and manage transactional emails, such as order confirmations, password resets, and account notifications, directly within the SendX platform. This streamlines your email operations by centralizing both marketing and transactional emails. You can customize templates and track delivery and engagement metrics. The addon ensures high deliverability and provides detailed analytics for transactional email performance.</p>",
		keyFeatures:
			"Centralized transactional email management. Customizable email templates. High deliverability rates. Detailed performance analytics",
		categories: "Workflows",
		imageSrc:
			"https://sendx-cdn.s3.us-east-1.amazonaws.com/add-on-images/read_skimmed_glanced.png",
		src: "https://video.sendworks.com/share/1jfU5QHf62iRQUuFfbYkTw",
    hasSetting: false,
    hasReport: false,
    hasBilling: false,
	},
	[AddOns.LIST_CLEANING]: {
    routeName: "list-cleaning",
		title: "Verify and clean your email contacts",
		settingTitle: "Configure your email verification settings",
		reportTitle: "Analytics and performance insights",
		description:
			"Boost your productivity with keyboard shortcuts, allowing you to navigate and perform actions quickly within SendX.",
		detail:
			"<p class='text-gray-600 mb-4'>The List Cleaning addon helps you maintain a healthy email list by verifying the validity of your contacts' email addresses. It checks for syntax errors, domain validity, and mailbox existence without sending actual emails to your contacts. <br><br> Clean email lists improve your sender reputation, reduce bounce rates, and increase your email deliverability. With this addon, you can automatically clean new contacts as they're added or run cleaning jobs on your existing contacts. <br><br>Each email verification costs 1 credit. You can purchase additional credits in the billing section.</p>",
		keyFeatures:
			"<ul class='space-y-4'> <li class='flex'> <span class='ml-3 text-gray-600'>Automatic cleaning of new contacts</span> </li> <li class='flex'> <span class='ml-3 text-gray-600'>Bulk cleaning of existing contacts</span></li> <li class='flex'> <span class='ml-3 text-gray-600'>Detailed analytics and reporting</span> </li> <li class='flex'> <span class='ml-3 text-gray-600'>Export functionality for verification results</span> </li> </ul>",
		categories: "Workflows",
		imageSrc:
			"https://sendx-cdn.s3.us-east-1.amazonaws.com/add-on-images/read_skimmed_glanced.png",
		src: "https://video.sendworks.com/share/1jfU5QHf62iRQUuFfbYkTw",
    hasSetting: true,
    hasReport: true,
    hasBilling: true,
	},
  [AddOns.BLOGS]: {
    routeName: "blogs",
    title: "Publish Blogs & Newsletters",
    settingTitle: "Configure your addOn settings",
    reportTitle: "Analytics and performance insights",
    description:
      "Create and publish blogs and newsletters to your custom-branded site directly from SendX, unifying your content and email strategies.",
    detail:
      "<p>The Blogs addon empowers you to build and publish blog content and newsletters under your own brand. Easily convert your email campaigns into blog posts, or compose new articles directly in the editor. Customize your blog’s appearance with templates, custom domains, and branding settings. This feature enables seamless integration of content marketing and email outreach.</p><br><p>You can track a blog's performance with detailed analytics, configure SEO settings, and manage all your content in one place. Ideal for marketers who want to maximize content reach and reuse newsletters as evergreen content.</p>",
    keyFeatures:
      "<ul><li>Convert newsletters to blogs</li><li>Custom-branded blog and domain support</li><li>SEO-friendly editor and settings</li><li>Blog scheduling and drafts</li><li>Performance analytics</li></ul>",
    tags: ["content marketing", "newsletter", "blog", "branding", "SendX"],
    src: "https://video.sendworks.com/share/sample-posts-addon-video-link", // Replace with actual video
    categories: "Content",
    imageSrc:
			"https://sendx-cdn.s3.us-east-1.amazonaws.com/add-on-images/read_skimmed_glanced.png",
		src: "https://video.sendworks.com/share/1jfU5QHf62iRQUuFfbYkTw",
    hasSetting: true,
    hasReport: false,
    hasBilling: false,
  },
});

export const DomainSetupVideos = Object.freeze({
	"cloudflare": {
		title: "Cloudflare Setup",
		src: "https://video.sendworks.com/share/D0iGws6QJUJEDFQPryiI1Q",
		imageSrc: "https://sendx-cdn.s3.us-east-1.amazonaws.com/dns-setup-images/cloudflare.png",
	},
	"godaddy": {
		title: "Go Daddy Setup",
		src: "https://video.sendworks.com/share/e1R8HexxI8nBWHGNFzcbJw",
		imageSrc: "https://sendx-cdn.s3.us-east-1.amazonaws.com/dns-setup-images/godaddy.png",
	},
	"namecheap": {
		title: "NameCheap Setup",
		src: "https://video.sendworks.com/share/2OpBW2s8UJqWRTmAYkUBUA",
		imageSrc: "https://sendx-cdn.s3.us-east-1.amazonaws.com/dns-setup-images/namecheap.png",
	},
	"google": {
		title: "Google Domains Setup",
		src: "https://video.sendworks.com/share/ytbVB592OqcQy2UI38YgKA",
		imageSrc: "https://sendx-cdn.s3.us-east-1.amazonaws.com/dns-setup-images/google.png",
	},
});

export const MemberRole = Object.freeze({
	RoleOwner: 0,
	RoleAdmin: 1,
	RoleContributor: 2,
	RoleViewer: 3,
});

export const MemberExclusions = Object.freeze({
	[MemberRole.RoleOwner]: [],
	[MemberRole.RoleAdmin]: [AppEntities.Team],
	[MemberRole.RoleContributor]: [
		AppEntities.Contact,
		AppEntities.Team,
		AppEntities.Member,
		AppEntities.Billing,
		AppEntities.TeamPreferences,
		AppEntities.WebSettings,
    AppEntities.Notification,
	], //segments?, team prefrences?
	[MemberRole.RoleViewer]: [
		AppEntities.Contact,
		AppEntities.Team,
		AppEntities.Member,
		AppEntities.Setting,
		AppEntities.Billing,
		AppEntities.Automation,
		AppEntities.Campaign,
		AppEntities.Form,
		AppEntities.BulkAction,
		AppEntities.Templates,
		AppEntities.CustomField,
		AppEntities.CustomEvent,
		AppEntities.RssFeed,
		AppEntities.Domain,
		AppEntities.ApiKey,
		AppEntities.Audience,
		AppEntities.TeamPreferences,
		AppEntities.AddOns,
		AppEntities.WebSettings,
    AppEntities.Notification,
	],
});

export const EditorType = {
	PLAIN_TEXT_EDITOR: 0,
	DRAG_DROP_EDITOR: 1,
	SENDX_EDITOR: 2,
}

export const thankyouMailDefaultTemplate = JSON.stringify({
	page: {
		body: {
			container: {
				style: {
					"background-color": "#FFFFFF",
				},
			},
			content: {
				computedStyle: {
					linkColor: "#0000FF",
					messageBackgroundColor: "transparent",
					messageWidth: "600px",
				},
				style: {
					color: "#000000",
					"font-family": "Arial, 'Helvetica Neue', Helvetica, sans-serif",
				},
			},
			type: "mailup-bee-page-properties",
			webFonts: [],
		},
		description: "",
		rows: [
			{
				columns: [
					{
						"grid-columns": 12,
						modules: [
							{
								descriptor: {
									computedStyle: {
										class: "center autowidth",
										hideContentOnMobile: false,
										width: "310px",
									},
									image: {
										alt: "",
										href: "",
										prefix: "",
										src: "https://imagecdn.sendpost.io/images/c824aabd-1b4f-4718-b8ee-fc6864950b9e/dragdrop-dev/SendX.png",
										target: "_blank",
									},
									style: {
										"padding-bottom": "0px",
										"padding-left": "0px",
										"padding-right": "0px",
										"padding-top": "0px",
										width: "100%",
									},
								},
								locked: false,
								type: "mailup-bee-newsletter-modules-image",
								uuid: "31a94252-ce85-4b00-afd0-356babc245c6",
							},
							{
								descriptor: {
									computedStyle: {
										hideContentOnMobile: false,
									},
									style: {
										"padding-bottom": "10px",
										"padding-left": "10px",
										"padding-right": "10px",
										"padding-top": "10px",
									},
									text: {
										computedStyle: {
											linkColor: "#0000FF",
										},
										html: '<div class="txtTinyMce-wrapper" style="font-size:14px;line-height:16px;font-family:inherit;" data-mce-style="font-size:14px;line-height:16px;font-family:inherit;"><p style="line-height:14px;word-break:break-word;" data-mce-style="line-height:14px;word-break:break-word;">Hi {{.FirstName}},</p><p style="line-height:14px;word-break:break-word;" data-mce-style="line-height:14px;word-break:break-word;">&nbsp;</p><p style="line-height:14px;word-break:break-word;" data-mce-style="line-height:14px;word-break:break-word;">Thanks for subscribing to SendX ! We are really happy to have you onboard :)</p><p style="line-height:14px;word-break:break-word;" data-mce-style="line-height:14px;word-break:break-word;">Cheers,</p><p style="line-height:14px;word-break:break-word;" data-mce-style="line-height:14px;word-break:break-word;"><br/><a href="http://sendx.io/" style="text-decoration: underline;">Team SendX</a></p></div>',
										style: {
											color: "#555555",
											"font-family": "inherit",
											"line-height": "120%",
										},
									},
								},
								locked: false,
								type: "mailup-bee-newsletter-modules-text",
								uuid: "ec36f7f1-1a1a-4a35-9cc1-7787183c2464",
							},
							{
								type: "mailup-bee-newsletter-modules-text",
								descriptor: {
									text: {
										html: '<div class="txtTinyMce-wrapper" style="font-size: 14px; line-height: 16px;" data-mce-style="font-size: 14px; line-height: 16px;"><p style="font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;" data-mce-style="font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;"><span style="color: #c4c4c4; line-height: 14px;" data-mce-style="color: #c4c4c4; line-height: 14px;">Powered by SendX</span></p></div>',
										style: {
											color: "#555555",
											"line-height": "200%",
											"font-family": "inherit",
										},
										computedStyle: {
											linkColor: "#0000FF",
										},
									},
									style: {
										"padding-top": "40px",
										"padding-right": "10px",
										"padding-bottom": "10px",
										"padding-left": "10px",
									},
									computedStyle: {
										hideContentOnMobile: false,
									},
									mobileStyle: {},
								},
								uuid: "4c4ccf21-6a8d-44e9-b56f-3d16137ededc",
								locked: false,
							},
						],
						style: {
							"background-color": "transparent",
							"border-bottom": "0px solid transparent",
							"border-left": "0px solid transparent",
							"border-right": "0px solid transparent",
							"border-top": "0px solid transparent",
							"padding-bottom": "5px",
							"padding-left": "0px",
							"padding-right": "0px",
							"padding-top": "5px",
						},
						uuid: "49979d87-12fc-470a-9387-11dd026e95a5",
					},
				],
				container: {
					style: {
						"background-color": "transparent",
						"background-image": "none",
						"background-position": "top left",
						"background-repeat": "no-repeat",
					},
				},
				content: {
					computedStyle: {
						hideContentOnDesktop: false,
						hideContentOnMobile: false,
						rowColStackOnMobile: true,
						rowReverseColStackOnMobile: false,
						verticalAlign: "top",
					},
					style: {
						"background-color": "transparent",
						"background-image": "none",
						"background-position": "top left",
						"background-repeat": "no-repeat",
						"border-bottom": "0px solid transparent",
						"border-left": "0px solid transparent",
						"border-radius": "0px",
						"border-right": "0px solid transparent",
						"border-top": "0px solid transparent",
						color: "#000000",
						width: "600px",
					},
				},
				empty: false,
				locked: false,
				synced: false,
				type: "",
				uuid: "a684de38-c3d3-4908-8213-9e321cf88d42",
			},
		],
		template: {
			name: "template-base",
			type: "basic",
			version: "2.0.0",
		},
		title: "",
	},
	comments: {},
});

export const thankyouMailDefaultHtmlCode = `<!DOCTYPE html><html xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office" lang="en"><head><title></title><meta http-equiv="Content-Type" content="text/html; charset=utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch><o:AllowPNG/></o:OfficeDocumentSettings></xml><![endif]--><style>
*{box-sizing:border-box}body{margin:0;padding:0}a[x-apple-data-detectors]{color:inherit!important;text-decoration:inherit!important}#MessageViewBody a{color:inherit;text-decoration:none}p{line-height:inherit}.desktop_hide,.desktop_hide table{mso-hide:all;display:none;max-height:0;overflow:hidden}.image_block img+div{display:none} @media (max-width:620px){.mobile_hide{display:none}.row-content{width:100%!important}.stack .column{width:100%;display:block}.mobile_hide{min-height:0;max-height:0;max-width:0;overflow:hidden;font-size:0}.desktop_hide,.desktop_hide table{display:table!important;max-height:none!important}}
</style></head><body style="background-color:#fff;margin:0;padding:0;-webkit-text-size-adjust:none;text-size-adjust:none"><table class="nl-container" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#fff"><tbody><tr><td><table class="row row-1" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"><tbody><tr><td><table 
class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;border-radius:0;color:#000;width:600px;margin:0 auto" width="600"><tbody><tr><td class="column column-1" width="100%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:5px;padding-top:5px;vertical-align:top;border-top:0;border-right:0;border-bottom:0;border-left:0"><table class="image_block block-1" 
width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"><tr><td class="pad" style="width:100%"><div class="alignment" align="center" style="line-height:10px"><div style="max-width:310px"><img src="https://imagecdn.sendpost.io/images/c824aabd-1b4f-4718-b8ee-fc6864950b9e/dragdrop-dev/SendX.png" style="display:block;height:auto;border:0;width:100%" width="310" height="auto"></div></div></td></tr></table><table 
class="text_block block-2" width="100%" border="0" cellpadding="10" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"><tr><td class="pad"><div style="font-family:sans-serif"><div class style="font-size:14px;font-family:Arial,'Helvetica Neue',Helvetica,sans-serif;mso-line-height-alt:16.8px;color:#555;line-height:1.2"><p style="margin:0;mso-line-height-alt:16.8px">Hi {{.FirstName}},</p><p style="margin:0;mso-line-height-alt:16.8px">&nbsp;</p><p
 style="margin:0;mso-line-height-alt:16.8px">Thanks for subscribing to SendX ! We are really happy to have you onboard :)</p><p style="margin:0;mso-line-height-alt:16.8px">Cheers,</p><p style="margin:0;mso-line-height-alt:16.8px"><br><a href="http://sendx.io/" style="text-decoration: underline; color: #0000FF;">Team SendX</a></p></div></div></td></tr></table><table class="text_block block-3" width="100%" border="0" cellpadding="0" cellspacing="0" 
role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"><tr><td class="pad" style="padding-bottom:10px;padding-left:10px;padding-right:10px;padding-top:40px"><div style="font-family:sans-serif"><div class style="font-size:14px;font-family:Arial,'Helvetica Neue',Helvetica,sans-serif;mso-line-height-alt:28px;color:#555;line-height:2"><p style="margin:0;font-size:14px;text-align:center;mso-line-height-alt:28px"><span style="color:#c4c4c4;">Powered by SendX</span></p>
</div></div></td></tr></table></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table><!-- End --></body></html>`;

export const successPageDefaultTemplateCode = JSON.stringify({
	page: {
		body: {
			container: {
				style: {
					"background-color": "#FFFFFF",
				},
			},
			content: {
				computedStyle: {
					linkColor: "#0000FF",
					messageBackgroundColor: "transparent",
					messageWidth: "775px",
				},
				style: {
					color: "#000000",
					"font-family": "Arial, 'Helvetica Neue', Helvetica, sans-serif",
				},
			},
			type: "mailup-bee-page-properties",
			webFonts: [],
		},
		description: "",
		rows: [
			{
				columns: [
					{
						"grid-columns": 12,
						modules: [
							{
								descriptor: {
									computedStyle: {
										hideContentOnMobile: false,
									},
									style: {
										"padding-bottom": "10px",
										"padding-left": "10px",
										"padding-right": "10px",
										"padding-top": "10px",
									},
									text: {
										computedStyle: {
											linkColor: "#0000FF",
										},
										html: '<div class="txtTinyMce-wrapper" style="font-size: 14px; line-height: 16px; font-family: inherit;" data-mce-style="font-size: 14px; line-height: 16px; font-family: inherit;"><p style="font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;" data-mce-style="font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;"><span style="font-size: 16px; line-height: 19px;" data-mce-style="font-size: 16px; line-height: 19px;">Thank You!</span></p></div>',
										style: {
											color: "#555555",
											"font-family": "inherit",
											"line-height": "120%",
										},
									},
								},
								locked: false,
								type: "mailup-bee-newsletter-modules-text",
								uuid: "fd2e503a-0b60-4d9d-af63-f73e5036823f",
							},
							{
								descriptor: {
									computedStyle: {
										hideContentOnDesktop: false,
										hideContentOnMobile: false,
									},
									heading: {
										style: {
											color: "#000000",
											direction: "ltr",
											"font-family": "inherit",
											"font-size": "30px",
											"font-weight": "700",
											"letter-spacing": "0px",
											"line-height": "120%",
											"link-color": "#E01253",
											"text-align": "center",
										},
										text: "You'll hear from us soon.",
										title: "h1",
									},
									style: {
										"padding-bottom": "0px",
										"padding-left": "0px",
										"padding-right": "0px",
										"padding-top": "0px",
										"text-align": "center",
										width: "100%",
									},
								},
								locked: false,
								type: "mailup-bee-newsletter-modules-heading",
								uuid: "337fc7d2-3912-418f-a14d-72890f574a89",
							},
						],
						style: {
							"background-color": "transparent",
							"border-bottom": "0px solid transparent",
							"border-left": "0px solid transparent",
							"border-right": "0px solid transparent",
							"border-top": "0px solid transparent",
							"padding-bottom": "60px",
							"padding-left": "0px",
							"padding-right": "0px",
							"padding-top": "60px",
						},
						uuid: "ab1fc74c-e025-444a-b2d1-e2ab1fca5422",
					},
				],
				container: {
					style: {
						"background-color": "transparent",
						"background-image": "none",
						"background-position": "top left",
						"background-repeat": "no-repeat",
					},
				},
				content: {
					computedStyle: {
						hideContentOnDesktop: false,
						hideContentOnMobile: false,
						rowColStackOnMobile: true,
						rowReverseColStackOnMobile: false,
						verticalAlign: "top",
					},
					style: {
						"background-color": "transparent",
						"background-image": "none",
						"background-position": "top left",
						"background-repeat": "no-repeat",
						"border-bottom": "0px solid transparent",
						"border-left": "0px solid transparent",
						"border-radius": "0px",
						"border-right": "0px solid transparent",
						"border-top": "0px solid transparent",
						color: "#000000",
						width: "775px",
					},
				},
				empty: false,
				locked: false,
				synced: false,
				type: "",
				uuid: "d4fcefb3-a833-4638-a897-bdb9f54890f1",
			},
		],
		template: {
			name: "template-base",
			type: "basic",
			version: "2.0.0",
		},
		title: "",
	},
	comments: {},
});

export const successPageDefaultHtmlCode = `<!DOCTYPE html>
<html lang="">

<head>
	<title></title>
	<meta charset="UTF-8">
	<meta name="viewport" content="width=device-width">
	<style>
		.bee-row,
		.bee-row-content {
			position: relative
		}

		.bee-row-1,
		.bee-row-1 .bee-row-content {
			background-repeat: no-repeat
		}

		body {
			background-color: #FFFFFF;
			color: #000000;
			font-family: Arial, "Helvetica Neue", Helvetica, sans-serif
		}

		* {
			box-sizing: border-box
		}

		body,
		h1,
		p {
			margin: 0
		}

		.bee-row-content {
			max-width: 775px;
			margin: 0 auto;
			display: flex
		}

		.bee-row-content .bee-col-w12 {
			flex-basis: 100%
		}

		.bee-text {
			overflow-wrap: anywhere
		}

		@media (max-width:768px) {
			.bee-row-content:not(.no_stack) {
				display: block
			}
		}

		.bee-row-1 .bee-row-content {
			border-radius: 0;
			color: #000000
		}

		.bee-row-1 .bee-col-1 {
			padding-bottom: 60px;
			padding-top: 60px
		}

		.bee-row-1 .bee-col-1 .bee-block-1 {
			padding: 10px
		}

		.bee-row-1 .bee-col-1 .bee-block-2 {
			text-align: center;
			width: 100%
		}
	</style>
</head>

<body>
	<div class="bee-page-container">
		<div class="bee-row bee-row-1">
			<div class="bee-row-content">
				<div class="bee-col bee-col-1 bee-col-w12">
					<div class="bee-block bee-block-1 bee-text">
						<div style="font-size: 14px; line-height: 120%; font-family: inherit; color: #555555;" class="bee-text-content">
							<p style="font-size: 14px; line-height: 16px; text-align: center;"><span style="font-size: 16px; line-height: 19px;">Thank You!</span></p>
						</div>
					</div>
					<div class="bee-block bee-block-2 bee-heading">
						<h1 style="color:#000000;direction:ltr;font-family:Arial, 'Helvetica Neue', Helvetica, sans-serif;font-size:30px;font-weight:700;letter-spacing:normal;line-height:120%;text-align:center;margin-top:0;margin-bottom:0;">You'll hear from us soon. </h1>
					</div>
				</div>
			</div>
		</div>
	</div>
</body>

</html>`;

export const confirmationMailDefaultTemplate = JSON.stringify({
	page: {
		body: {
			container: {
				style: {
					"background-color": "#FFFFFF",
				},
			},
			content: {
				computedStyle: {
					linkColor: "#0000FF",
					messageBackgroundColor: "transparent",
					messageWidth: "600px",
				},
				style: {
					color: "#000000",
					"font-family": "Arial, 'Helvetica Neue', Helvetica, sans-serif",
				},
			},
			type: "mailup-bee-page-properties",
			webFonts: [],
		},
		description: "",
		rows: [
			{
				columns: [
					{
						"grid-columns": 12,
						modules: [
							{
								descriptor: {
									computedStyle: {
										class: "center autowidth",
										hideContentOnMobile: false,
										width: "310px",
									},
									image: {
										alt: "",
										href: "",
										prefix: "",
										src: "https://imagecdn.sendpost.io/images/c824aabd-1b4f-4718-b8ee-fc6864950b9e/dragdrop-dev/SendX.png",
										target: "_blank",
									},
									style: {
										"padding-bottom": "0px",
										"padding-left": "0px",
										"padding-right": "0px",
										"padding-top": "0px",
										width: "100%",
									},
								},
								locked: false,
								type: "mailup-bee-newsletter-modules-image",
								uuid: "31a94252-ce85-4b00-afd0-356babc245c6",
							},
							{
								descriptor: {
									computedStyle: {
										hideContentOnMobile: false,
									},
									style: {
										"padding-bottom": "10px",
										"padding-left": "10px",
										"padding-right": "10px",
										"padding-top": "10px",
									},
									text: {
										computedStyle: {
											linkColor: "#0000FF",
										},
										html: '<div class="txtTinyMce-wrapper" style="font-size: 14px; line-height: 16px; font-family: inherit;" data-mce-style="font-size: 14px; line-height: 16px; font-family: inherit;"><p style="line-height: 14px; word-break: break-word;" data-mce-style="line-height: 14px;">Hi {{.FirstName}},</p><p style="line-height: 14px; word-break: break-word;" data-mce-style="line-height: 14px;">&nbsp;</p><p style="line-height: 14px; word-break: break-word;" data-mce-style="line-height: 14px;">Kindly click on the below button to be a part of SendX.</p></div>',
										style: {
											color: "#555555",
											"font-family": "inherit",
											"line-height": "120%",
										},
									},
								},
								locked: false,
								type: "mailup-bee-newsletter-modules-text",
								uuid: "ec36f7f1-1a1a-4a35-9cc1-7787183c2464",
							},
							{
								type: "mailup-bee-newsletter-modules-button",
								descriptor: {
									button: {
										label: '<div class="txtTinyMce-wrapper" style="font-family: inherit;" data-mce-style="font-family: inherit;"><p dir="ltr" style="word-break: break-word;" data-mce-style="word-break: break-word;">Confirm Here</p></div>',
										href: "{{.ConfirmationUrl}}",
										target: "_blank",
										style: {
											"font-family": "inherit",
											"font-size": "26px",
											"font-weight": "400",
											"background-color": "#19a350",
											"border-radius": "12px",
											"border-top": "0px solid transparent",
											"border-right": "0px solid transparent",
											"border-bottom": "0px solid transparent",
											"border-left": "0px solid transparent",
											color: "#ffffff",
											"line-height": "200%",
											"padding-top": "10px",
											"padding-right": "35px",
											"padding-bottom": "10px",
											"padding-left": "35px",
											width: "auto",
											"max-width": "100%",
											direction: "ltr",
										},
									},
									style: {
										"text-align": "center",
										"padding-top": "10px",
										"padding-right": "10px",
										"padding-bottom": "10px",
										"padding-left": "10px",
									},
									mobileStyle: {},
									computedStyle: {
										width: 224,
										height: 72,
										hideContentOnMobile: false,
									},
								},
								uuid: "32306062-5246-45ae-a0d6-a8d894e4623a",
								locked: false,
							},
							{
								type: "mailup-bee-newsletter-modules-text",
								descriptor: {
									text: {
										html: '<div class="txtTinyMce-wrapper" style="font-size: 14px; line-height: 16px;" data-mce-style="font-size: 14px; line-height: 16px;"><p style="font-size: 14px; line-height: 16px; word-break: break-word;" data-mce-style="font-size: 14px; line-height: 16px;">Cheers,<br><a href="https://sendx.io/" style="text-decoration: underline;">Team SendX</a></p></div>',
										style: {
											color: "#555555",
											"line-height": "120%",
											"font-family": "inherit",
										},
										computedStyle: {
											linkColor: "#0000FF",
										},
									},
									style: {
										"padding-top": "10px",
										"padding-right": "10px",
										"padding-bottom": "10px",
										"padding-left": "10px",
									},
									computedStyle: {
										hideContentOnMobile: false,
									},
									mobileStyle: {},
								},
								uuid: "e7b775b3-ffb1-4a41-99b8-101e6b5366e8",
								locked: false,
							},
							{
								descriptor: {
									computedStyle: {
										hideContentOnMobile: false,
									},
									style: {
										"padding-bottom": "10px",
										"padding-left": "10px",
										"padding-right": "10px",
										"padding-top": "10px",
									},
									text: {
										computedStyle: {
											linkColor: "#0000FF",
										},
										html: '<div class="txtTinyMce-wrapper" style="font-size:14px;line-height:28px;font-family:inherit;" data-mce-style="font-size:14px;line-height:28px;font-family:inherit;"><p style="font-size:14px;line-height:28px;word-break:break-word;text-align:center;" data-mce-style="font-size:14px;line-height:28px;word-break:break-word;text-align:center;"><span style="color:#c4c4c4;line-height:24px;" data-mce-style="color:#c4c4c4;line-height:24px;">Powered by SendX</span></p></div>',
										style: {
											color: "#555555",
											"font-family": "inherit",
											"line-height": "200%",
										},
									},
								},
								locked: false,
								type: "mailup-bee-newsletter-modules-text",
								uuid: "4c4ccf21-6a8d-44e9-b56f-3d16137ededc",
							},
						],
						style: {
							"background-color": "transparent",
							"border-bottom": "0px solid transparent",
							"border-left": "0px solid transparent",
							"border-right": "0px solid transparent",
							"border-top": "0px solid transparent",
							"padding-bottom": "5px",
							"padding-left": "0px",
							"padding-right": "0px",
							"padding-top": "5px",
						},
						uuid: "49979d87-12fc-470a-9387-11dd026e95a5",
					},
				],
				container: {
					style: {
						"background-color": "transparent",
						"background-image": "none",
						"background-position": "top left",
						"background-repeat": "no-repeat",
					},
				},
				content: {
					computedStyle: {
						hideContentOnDesktop: false,
						hideContentOnMobile: false,
						rowColStackOnMobile: true,
						rowReverseColStackOnMobile: false,
						verticalAlign: "top",
					},
					style: {
						"background-color": "transparent",
						"background-image": "none",
						"background-position": "top left",
						"background-repeat": "no-repeat",
						"border-bottom": "0px solid transparent",
						"border-left": "0px solid transparent",
						"border-radius": "0px",
						"border-right": "0px solid transparent",
						"border-top": "0px solid transparent",
						color: "#000000",
						width: "600px",
					},
				},
				empty: false,
				locked: false,
				synced: false,
				type: "",
				uuid: "a684de38-c3d3-4908-8213-9e321cf88d42",
			},
		],
		template: {
			name: "template-base",
			type: "basic",
			version: "2.0.0",
		},
		title: "",
	},
	comments: {},
});

export const confirmationMailDefaultHtmlCode = `<!DOCTYPE html><html xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office" lang="en"><head><title></title><meta http-equiv="Content-Type" content="text/html; charset=utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch><o:AllowPNG/></o:OfficeDocumentSettings></xml><![endif]--><style>
*{box-sizing:border-box}body{margin:0;padding:0}a[x-apple-data-detectors]{color:inherit!important;text-decoration:inherit!important}#MessageViewBody a{color:inherit;text-decoration:none}p{line-height:inherit}.desktop_hide,.desktop_hide table{mso-hide:all;display:none;max-height:0;overflow:hidden}.image_block img+div{display:none} @media (max-width:620px){.mobile_hide{display:none}.row-content{width:100%!important}.stack .column{width:100%;display:block}.mobile_hide{min-height:0;max-height:0;max-width:0;overflow:hidden;font-size:0}.desktop_hide,.desktop_hide table{display:table!important;max-height:none!important}}
</style></head><body style="background-color:#fff;margin:0;padding:0;-webkit-text-size-adjust:none;text-size-adjust:none"><table class="nl-container" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#fff"><tbody><tr><td><table class="row row-1" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"><tbody><tr><td><table 
class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;border-radius:0;color:#000;width:600px;margin:0 auto" width="600"><tbody><tr><td class="column column-1" width="100%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:5px;padding-top:5px;vertical-align:top;border-top:0;border-right:0;border-bottom:0;border-left:0"><table class="image_block block-1" 
width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"><tr><td class="pad" style="width:100%"><div class="alignment" align="center" style="line-height:10px"><div style="max-width:310px"><img src="https://imagecdn.sendpost.io/images/c824aabd-1b4f-4718-b8ee-fc6864950b9e/dragdrop-dev/SendX.png" style="display:block;height:auto;border:0;width:100%" width="310" height="auto"></div></div></td></tr></table><table 
class="text_block block-2" width="100%" border="0" cellpadding="10" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"><tr><td class="pad"><div style="font-family:sans-serif"><div class style="font-size:14px;font-family:Arial,'Helvetica Neue',Helvetica,sans-serif;mso-line-height-alt:16.8px;color:#555;line-height:1.2"><p style="margin:0;mso-line-height-alt:16.8px">Hi {{.FirstName}},</p><p style="margin:0;mso-line-height-alt:16.8px">&nbsp;</p><p
 style="margin:0;mso-line-height-alt:16.8px">Kindly click on the below button to be a part of SendX.</p></div></div></td></tr></table><table class="button_block block-3" width="100%" border="0" cellpadding="10" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"><tr><td class="pad"><div class="alignment" align="center"><!--[if mso]>
<v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" style="height:72px;width:224px;v-text-anchor:middle;" arcsize="17%" stroke="false" fillcolor="#19a350">
<w:anchorlock/>
<v:textbox inset="0px,0px,0px,0px">
<center style="color:#ffffff; font-family:Arial, sans-serif; font-size:26px">
<![endif]--><div style="text-decoration:none;display:inline-block;color:#fff;background-color:#19a350;border-radius:12px;width:auto;border-top:0 solid transparent;font-weight:400;border-right:0 solid transparent;border-bottom:0 solid transparent;border-left:0 solid transparent;padding-top:10px;padding-bottom:10px;font-family:Arial,'Helvetica Neue',Helvetica,sans-serif;font-size:26px;text-align:center;mso-border-alt:none;word-break:keep-all">
<span style="padding-left:35px;padding-right:35px;font-size:26px;display:inline-block;letter-spacing:normal;"><a href="{{.ConfirmationUrl}}" style="text-decoration:none;color:#ffffff;" target="_blank"><span style="word-break: break-word; line-height: 52px;">Confirm Here</span></a></span></div><!--[if mso]></center></v:textbox></v:roundrect><![endif]--></div></td></tr></table><table class="text_block block-4" width="100%" border="0" cellpadding="10" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"><tr><td class="pad"><div 
style="font-family:sans-serif"><div class style="font-size:14px;font-family:Arial,'Helvetica Neue',Helvetica,sans-serif;mso-line-height-alt:16.8px;color:#555;line-height:1.2"><p style="margin:0;font-size:14px;mso-line-height-alt:16.8px">Cheers,<br><a href="https://sendx.io/" style="text-decoration: underline; color: #0000FF;">Team SendX</a></p></div></div></td></tr></table><table class="text_block block-5" width="100%" border="0" cellpadding="10" 
cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"><tr><td class="pad"><div style="font-family:sans-serif"><div class style="font-size:14px;font-family:Arial,'Helvetica Neue',Helvetica,sans-serif;mso-line-height-alt:28px;color:#555;line-height:2"><p style="margin:0;font-size:14px;text-align:center;mso-line-height-alt:28px"><span style="color:#c4c4c4;">Powered by SendX</span></p></div></div></td></tr></table></td></tr></tbody></table></td></tr>
</tbody></table></td></tr></tbody></table><!-- End --></body></html>`;

export const confirmationPageDefaultTemplate = JSON.stringify({
	page: {
		body: {
			container: {
				style: {
					"background-color": "#FFFFFF",
				},
			},
			content: {
				computedStyle: {
					linkColor: "#0000FF",
					messageBackgroundColor: "transparent",
					messageWidth: "600px",
				},
				style: {
					color: "#000000",
					"font-family": "Arial, 'Helvetica Neue', Helvetica, sans-serif",
				},
			},
			type: "mailup-bee-page-properties",
			webFonts: [],
		},
		description: "",
		rows: [
			{
				columns: [
					{
						"grid-columns": 12,
						modules: [
							{
								descriptor: {
									computedStyle: {
										hideContentOnMobile: false,
									},
									style: {
										"padding-bottom": "10px",
										"padding-left": "10px",
										"padding-right": "10px",
										"padding-top": "10px",
									},
									text: {
										computedStyle: {
											linkColor: "#0000FF",
										},
										html: '<div class="txtTinyMce-wrapper" style="font-size:14px;line-height:16px;font-family:inherit;" data-mce-style="font-size:14px;line-height:16px;font-family:inherit;"><p style="line-height:14px;word-break:break-word;" data-mce-style="line-height:14px;word-break:break-word;">Hi&nbsp;,<br/><br/>You have been successfully confirmed subscription to the list. Great to have you onboard :)<br/><br/></p><p style="line-height:14px;word-break:break-word;" data-mce-style="line-height:14px;word-break:break-word;">Love,<br/>Your awesome company.</p></div>',
										style: {
											color: "#555555",
											"font-family": "inherit",
											"line-height": "120%",
										},
									},
								},
								locked: false,
								type: "mailup-bee-newsletter-modules-text",
								uuid: "ec36f7f1-1a1a-4a35-9cc1-7787183c2464",
							},
							{
								descriptor: {
									computedStyle: {
										class: "center autowidth",
										hideContentOnMobile: false,
										width: "310px",
									},
									image: {
										alt: "",
										href: "",
										prefix: "",
										src: "https://imagecdn.sendpost.io/images/c824aabd-1b4f-4718-b8ee-fc6864950b9e/dragdrop-dev/SendX.png",
										target: "_blank",
									},
									style: {
										"padding-bottom": "0px",
										"padding-left": "0px",
										"padding-right": "0px",
										"padding-top": "0px",
										width: "100%",
									},
								},
								locked: false,
								type: "mailup-bee-newsletter-modules-image",
								uuid: "31a94252-ce85-4b00-afd0-356babc245c6",
							},
						],
						style: {
							"background-color": "transparent",
							"border-bottom": "0px solid transparent",
							"border-left": "0px solid transparent",
							"border-right": "0px solid transparent",
							"border-top": "0px solid transparent",
							"padding-bottom": "5px",
							"padding-left": "0px",
							"padding-right": "0px",
							"padding-top": "5px",
						},
						uuid: "49979d87-12fc-470a-9387-11dd026e95a5",
					},
				],
				container: {
					style: {
						"background-color": "transparent",
						"background-image": "none",
						"background-position": "top left",
						"background-repeat": "no-repeat",
					},
				},
				content: {
					computedStyle: {
						hideContentOnDesktop: false,
						hideContentOnMobile: false,
						rowColStackOnMobile: true,
						rowReverseColStackOnMobile: false,
						verticalAlign: "top",
					},
					style: {
						"background-color": "transparent",
						"background-image": "none",
						"background-position": "top left",
						"background-repeat": "no-repeat",
						"border-bottom": "0px solid transparent",
						"border-left": "0px solid transparent",
						"border-radius": "0px",
						"border-right": "0px solid transparent",
						"border-top": "0px solid transparent",
						color: "#000000",
						width: "600px",
					},
				},
				empty: false,
				locked: false,
				synced: false,
				type: "",
				uuid: "a684de38-c3d3-4908-8213-9e321cf88d42",
			},
		],
		template: {
			name: "template-base",
			type: "basic",
			version: "2.0.0",
		},
		title: "",
	},
	comments: {},
});

export const confirmationPageDefaultHtmlCode = `<!DOCTYPE html><html xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office" lang="en"><head><title></title><meta http-equiv="Content-Type" content="text/html; charset=utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch><o:AllowPNG/></o:OfficeDocumentSettings></xml><![endif]--><style>
*{box-sizing:border-box}body{margin:0;padding:0}a[x-apple-data-detectors]{color:inherit!important;text-decoration:inherit!important}#MessageViewBody a{color:inherit;text-decoration:none}p{line-height:inherit}.desktop_hide,.desktop_hide table{mso-hide:all;display:none;max-height:0;overflow:hidden}.image_block img+div{display:none} @media (max-width:620px){.mobile_hide{display:none}.row-content{width:100%!important}.stack .column{width:100%;display:block}.mobile_hide{min-height:0;max-height:0;max-width:0;overflow:hidden;font-size:0}.desktop_hide,.desktop_hide table{display:table!important;max-height:none!important}}
</style></head><body style="background-color:#fff;margin:0;padding:0;-webkit-text-size-adjust:none;text-size-adjust:none"><table class="nl-container" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#fff"><tbody><tr><td><table class="row row-1" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"><tbody><tr><td><table 
class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;border-radius:0;color:#000;width:600px;margin:0 auto" width="600"><tbody><tr><td class="column column-1" width="100%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:5px;padding-top:5px;vertical-align:top;border-top:0;border-right:0;border-bottom:0;border-left:0"><table class="text_block block-1" 
width="100%" border="0" cellpadding="10" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"><tr><td class="pad"><div style="font-family:sans-serif"><div class style="font-size:14px;font-family:Arial,'Helvetica Neue',Helvetica,sans-serif;mso-line-height-alt:16.8px;color:#555;line-height:1.2"><p style="margin:0;mso-line-height-alt:16.8px">Hi&nbsp;,<br><br>You have been successfully confirmed subscription to the list. Great to have you onboard :)
<br><br></p><p style="margin:0;mso-line-height-alt:16.8px">Love,<br>Your awesome company.</p></div></div></td></tr></table><table class="image_block block-2" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"><tr><td class="pad" style="width:100%"><div class="alignment" align="center" style="line-height:10px"><div style="max-width:310px"><img 
src="https://imagecdn.sendpost.io/images/c824aabd-1b4f-4718-b8ee-fc6864950b9e/dragdrop-dev/SendX.png" style="display:block;height:auto;border:0;width:100%" width="310" height="auto"></div></div></td></tr></table></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table><!-- End --></body></html> `;

export const DefaultEditorValues = Object.freeze({
	DragDropTemplateCode:
		'{"page":{"body":{"container":{"style":{"background-color":"#FFFFFF"}},"content":{"computedStyle":{"linkColor":"#0068A5","messageBackgroundColor":"transparent","messageWidth":"500px"},"style":{"color":"#000000","font-family":"Arial, \'Helvetica Neue\', Helvetica, sans-serif"}},"type":"mailup-bee-page-properties","webFonts":[{"fontFamily":"Arial, \'Helvetica Neue\', Helvetica, sans-serif","name":"Arial","url":""},{"fontFamily":"\'Helvetica Neue\', Helvetica, Arial, sans-serif","name":"Helvetica","url":""}]},"description":"Test template for BEE","rows":[{"columns":[{"grid-columns":12,"modules":[{"descriptor":{"computedStyle":{"hideContentOnDesktop":false,"hideContentOnMobile":false},"style":{"padding-bottom":"10px","padding-left":"10px","padding-right":"10px","padding-top":"10px"},"text":{"computedStyle":{"linkColor":"#0068A5"},"html":"\u003cdiv class=\\"txtTinyMce-wrapper\\" style=\\"font-size:12px;line-height:14px;font-family:inherit;\\" data-mce-style=\\"font-size:12px;line-height:14px;font-family:inherit;\\"\u003e\u003cp style=\\"font-size:12px;line-height:14px;word-break:break-word;\\" data-mce-style=\\"font-size:12px;line-height:14px;word-break:break-word;\\"\u003e\u003cspan style=\\"font-size:14px;line-height:16px;\\" data-mce-style=\\"font-size:14px;line-height:16px;\\"\u003eHi {{.FirstName}},\u003c/span\u003e\u003c/p\u003e\u003cp style=\\"font-size:12px;line-height:14px;word-break:break-word;\\" data-mce-style=\\"font-size:12px;line-height:14px;word-break:break-word;\\"\u003e\u0026nbsp;\u003c/p\u003e\u003cp style=\\"font-size:12px;line-height:14px;word-break:break-word;\\" data-mce-style=\\"font-size:12px;line-height:14px;word-break:break-word;\\"\u003e\u003cspan style=\\"font-size:14px;line-height:16px;\\" data-mce-style=\\"font-size:14px;line-height:16px;\\"\u003eThe Awesome Inc. is introducing a newsletter series which is bound to pull your socks off. These newsletter will contain a series of very engaging content including the recipes we\u0026#39;ve used so far to woo clients for ourselves.\u003c/span\u003e\u003c/p\u003e\u003cp style=\\"font-size:12px;line-height:14px;word-break:break-word;\\" data-mce-style=\\"font-size:12px;line-height:14px;word-break:break-word;\\"\u003e\u003cspan style=\\"font-size:14px;line-height:16px;\\" data-mce-style=\\"font-size:14px;line-height:16px;\\"\u003eBe sure to subscribe to this email content by simply replying \u0026#34;Yes\u0026#34; to this email. We\u0026#39;ll add you to our subscribers list and stay tuned every Friday to read interesting news as well as our marketing mantra.\u003c/span\u003e\u003c/p\u003e\u003cp style=\\"font-size:12px;line-height:14px;word-break:break-word;\\" data-mce-style=\\"font-size:12px;line-height:14px;word-break:break-word;\\"\u003e\u003cspan style=\\"font-size:14px;line-height:16px;\\" data-mce-style=\\"font-size:14px;line-height:16px;\\"\u003eRegards\u003c/span\u003e\u003c/p\u003e\u003cp style=\\"font-size:12px;line-height:14px;word-break:break-word;\\" data-mce-style=\\"font-size:12px;line-height:14px;word-break:break-word;\\"\u003e\u003cspan style=\\"font-size:14px;line-height:16px;\\" data-mce-style=\\"font-size:14px;line-height:16px;\\"\u003eYour faithful marketers\u003c/span\u003e\u003c/p\u003e\u003cp style=\\"font-size:12px;line-height:14px;word-break:break-word;\\" data-mce-style=\\"font-size:12px;line-height:14px;word-break:break-word;\\"\u003e\u003cspan style=\\"font-size:14px;line-height:16px;\\" data-mce-style=\\"font-size:14px;line-height:16px;\\"\u003eAwesome Inc.\u003c/span\u003e\u003c/p\u003e\u003c/div\u003e","style":{"color":"#555555","font-family":"inherit","line-height":"120%"}}},"locked":false,"type":"mailup-bee-newsletter-modules-text","uuid":"1969b432-b8ed-43a6-82e3-16877e0aee3c"}],"style":{"background-color":"transparent","border-bottom":"0px solid transparent","border-left":"0px solid transparent","border-right":"0px solid transparent","border-top":"0px solid transparent","padding-bottom":"5px","padding-left":"0px","padding-right":"0px","padding-top":"5px"},"uuid":"7ef91825-0e96-43ce-8084-6d7c4e20affb"}],"container":{"style":{"background-color":"transparent","background-image":"none","background-position":"top left","background-repeat":"no-repeat"}},"content":{"computedStyle":{"hideContentOnDesktop":false,"hideContentOnMobile":false,"rowColStackOnMobile":true,"rowReverseColStackOnMobile":false,"verticalAlign":"top"},"style":{"background-color":"transparent","background-image":"none","background-position":"top left","background-repeat":"no-repeat","color":"#000000","width":"500px"}},"empty":false,"locked":false,"synced":false,"type":"one-column-empty","uuid":"638f028b-c7d3-4cd6-ab75-6ad8e2b301e7"},{"columns":[{"grid-columns":12,"modules":[{"descriptor":{"computedStyle":{"hideContentOnDesktop":false,"hideContentOnMobile":false},"style":{"padding-bottom":"10px","padding-left":"10px","padding-right":"10px","padding-top":"10px"},"text":{"computedStyle":{"linkColor":"#0068A5"},"html":"\u003cdiv class=\\"txtTinyMce-wrapper\\" style=\\"font-size:12px;line-height:14px;font-family:inherit;\\" data-mce-style=\\"font-size:12px;line-height:14px;font-family:inherit;\\"\u003e\u003cp style=\\"font-size:14px;line-height:16px;word-break:break-word;\\" data-mce-style=\\"font-size:14px;line-height:16px;word-break:break-word;\\"\u003eP.S: If you aren’t the right person to contact about this, please let me know. If you would rather, I not follow up, you can let me know that too!\u003c/p\u003e\u003c/div\u003e","style":{"color":"#555555","font-family":"inherit","line-height":"120%"}}},"locked":false,"type":"mailup-bee-newsletter-modules-text","uuid":"77bfe3f2-1947-408a-be5b-db5f3dc54c74"}],"style":{"background-color":"transparent","border-bottom":"0px solid transparent","border-left":"0px solid transparent","border-right":"0px solid transparent","border-top":"0px solid transparent","padding-bottom":"5px","padding-left":"0px","padding-right":"0px","padding-top":"5px"},"uuid":"c9854fff-f520-4e53-b098-9379ab45ca69"}],"container":{"style":{"background-color":"transparent","background-image":"none","background-position":"top left","background-repeat":"no-repeat"}},"content":{"computedStyle":{"hideContentOnDesktop":false,"hideContentOnMobile":false,"rowColStackOnMobile":true,"rowReverseColStackOnMobile":false,"verticalAlign":"top"},"style":{"background-color":"transparent","background-image":"none","background-position":"top left","background-repeat":"no-repeat","color":"#000000","width":"500px"}},"empty":false,"locked":false,"synced":false,"type":"one-column-empty","uuid":"3cde9a1f-a22c-4b9a-9f36-6ff3ce9ef525"}],"template":{"name":"template-base","type":"basic","version":"2.0.0"},"title":"Template Base"},"comments":{}}',

	DragDropHtmlCode: `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
	<html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
	
	<head>
			   <!--[if gte mso 9]><xml><o:OfficeDocumentSettings><o:AllowPNG/><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
			   <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
			   <meta name="viewport" content="width=device-width">
			   <!--[if !mso]><!-->
			   <meta http-equiv="X-UA-Compatible" content="IE=edge">
			   <!--<![endif]-->
			   <title></title>
			   <!--[if !mso]><!-->
			   <!--<![endif]-->
			   <style type="text/css">
				   body {
					   margin: 0;
					   padding: 0;
				   }
	
				   table,
				   td,
				   tr {
					   vertical-align: top;
					   border-collapse: collapse;
				   }
	
				   * {
					   line-height: inherit;
				   }
	
				   a[x-apple-data-detectors=true] {
					   color: inherit !important;
					   text-decoration: none !important;
				   }
			   </style>
			   <style type="text/css" id="media-query">
				   @media (max-width: 520px) {
	
					   .block-grid,
					   .col {
						   min-width: 320px !important;
						   max-width: 100% !important;
						   display: block !important;
					   }
	
					   .block-grid {
						   width: 100% !important;
					   }
	
					   .col {
						   width: 100% !important;
					   }
	
					   .col>div {
						   margin: 0 auto;
					   }
	
					   img.fullwidth,
					   img.fullwidthOnMobile {
						   max-width: 100% !important;
					   }
	
					   .no-stack .col {
						   min-width: 0 !important;
						   display: table-cell !important;
					   }
	
					   .no-stack.two-up .col {
						   width: 50% !important;
					   }
	
					   .no-stack .col.num4 {
						   width: 33% !important;
					   }
	
					   .no-stack .col.num8 {
						   width: 66% !important;
					   }
	
					   .no-stack .col.num4 {
						   width: 33% !important;
					   }
	
					   .no-stack .col.num3 {
						   width: 25% !important;
					   }
	
					   .no-stack .col.num6 {
						   width: 50% !important;
					   }
	
					   .no-stack .col.num9 {
						   width: 75% !important;
					   }
	
					   .video-block {
						   max-width: none !important;
					   }
	
					   .mobile_hide {
						   min-height: 0px;
						   max-height: 0px;
						   max-width: 0px;
						   display: none;
						   overflow: hidden;
						   font-size: 0px;
					   }
	
					   .desktop_hide {
						   display: block !important;
						   max-height: none !important;
					   }
				   }
			   </style>
	</head>
	
	<body class="clean-body" style="margin: 0; padding: 0; -webkit-text-size-adjust: 100%; background-color: #FFFFFF;">
			   <!--[if IE]><div class="ie-browser"><![endif]-->
			   <table class="nl-container" style="table-layout: fixed; vertical-align: top; min-width: 320px; Margin: 0 auto; border-spacing: 0; border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-color: #FFFFFF; width: 100%;" cellpadding="0" cellspacing="0" role="presentation" width="100%" bgcolor="#FFFFFF" valign="top">
				   <tbody>
					   <tr style="vertical-align: top;" valign="top">
						   <td style="word-break: break-word; vertical-align: top;" valign="top">
							   <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="background-color:#FFFFFF"><![endif]-->
							   <div style="background-color:transparent;">
								   <div class="block-grid " style="Margin: 0 auto; min-width: 320px; max-width: 500px; overflow-wrap: break-word; word-wrap: break-word; word-break: break-word; background-color: transparent;">
									   <div style="border-collapse: collapse;display: table;width: 100%;background-color:transparent;">
										   <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:transparent;"><tr><td align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:500px"><tr class="layout-full-width" style="background-color:transparent"><![endif]-->
										   <!--[if (mso)|(IE)]><td align="center" width="500" style="background-color:transparent;width:500px; border-top: 0px solid transparent; border-left: 0px solid transparent; border-bottom: 0px solid transparent; border-right: 0px solid transparent;" valign="top"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 0px; padding-left: 0px; padding-top:5px; padding-bottom:5px;"><![endif]-->
										   <div class="col num12" style="min-width: 320px; max-width: 500px; display: table-cell; vertical-align: top; width: 500px;">
											   <div style="width:100% !important;">
												   <!--[if (!mso)&(!IE)]><!-->
												   <div style="border-top:0px solid transparent; border-left:0px solid transparent; border-bottom:0px solid transparent; border-right:0px solid transparent; padding-top:5px; padding-bottom:5px; padding-right: 0px; padding-left: 0px;">
													   <!--<![endif]-->
													   <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 10px; padding-left: 10px; padding-top: 10px; padding-bottom: 10px; font-family: Arial, sans-serif"><![endif]-->
													   <div style="color:#555555;font-family:Arial, 'Helvetica Neue', Helvetica, sans-serif;line-height:1.2;padding-top:10px;padding-right:10px;padding-bottom:10px;padding-left:10px;">
														   <div style="font-size: 12px; line-height: 1.2; font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif; color: #555555; mso-line-height-alt: 14px;">
															   <p style="font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px; margin: 0;"><span style="font-size: 14px;">Hi {{.FirstName}},</span></p>
															   <p style="font-size: 12px; line-height: 1.2; mso-line-height-alt: 14px; margin: 0;">&nbsp;</p>
															   <p style="font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px; margin: 0;"><span style="font-size: 14px;">The Awesome Inc. is introducing a newsletter series which is bound to pull your socks off. These newsletter will contain a series of very engaging content including the recipes we've used so far to woo clients for ourselves.</span></p>
															   <p style="font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px; margin: 0;"><span style="font-size: 14px;">Be sure to subscribe to this email content by simply replying "Yes" to this email. We'll add you to our subscribers list and stay tuned every Friday to read interesting news as well as our marketing mantra.</span></p>
															   <p style="font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px; margin: 0;"><span style="font-size: 14px;">Regards</span></p>
															   <p style="font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px; margin: 0;"><span style="font-size: 14px;">Your faithful marketers</span></p>
															   <p style="font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px; margin: 0;"><span style="font-size: 14px;">Awesome Inc.</span></p>
														   </div>
													   </div>
													   <!--[if mso]></td></tr></table><![endif]-->
													   <!--[if (!mso)&(!IE)]><!-->
												   </div>
												   <!--<![endif]-->
											   </div>
										   </div>
										   <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
										   <!--[if (mso)|(IE)]></td></tr></table></td></tr></table><![endif]-->
									   </div>
								   </div>
							   </div>
							   <div style="background-color:transparent;">
								   <div class="block-grid " style="Margin: 0 auto; min-width: 320px; max-width: 500px; overflow-wrap: break-word; word-wrap: break-word; word-break: break-word; background-color: transparent;">
									   <div style="border-collapse: collapse;display: table;width: 100%;background-color:transparent;">
										   <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:transparent;"><tr><td align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:500px"><tr class="layout-full-width" style="background-color:transparent"><![endif]-->
										   <!--[if (mso)|(IE)]><td align="center" width="500" style="background-color:transparent;width:500px; border-top: 0px solid transparent; border-left: 0px solid transparent; border-bottom: 0px solid transparent; border-right: 0px solid transparent;" valign="top"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 0px; padding-left: 0px; padding-top:5px; padding-bottom:5px;"><![endif]-->
										   <div class="col num12" style="min-width: 320px; max-width: 500px; display: table-cell; vertical-align: top; width: 500px;">
											   <div style="width:100% !important;">
												   <!--[if (!mso)&(!IE)]><!-->
												   <div style="border-top:0px solid transparent; border-left:0px solid transparent; border-bottom:0px solid transparent; border-right:0px solid transparent; padding-top:5px; padding-bottom:5px; padding-right: 0px; padding-left: 0px;">
													   <!--<![endif]-->
													   <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 10px; padding-left: 10px; padding-top: 10px; padding-bottom: 10px; font-family: Arial, sans-serif"><![endif]-->
													   <div style="color:#555555;font-family:Arial, 'Helvetica Neue', Helvetica, sans-serif;line-height:1.2;padding-top:10px;padding-right:10px;padding-bottom:10px;padding-left:10px;">
														   <div style="font-size: 12px; line-height: 1.2; font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif; color: #555555; mso-line-height-alt: 14px;">
															   <p style="font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px; margin: 0;">P.S: If you aren’t the right person to contact about this, please let me know. If you would rather, I not follow up, you can let me know that too!</p>
														   </div>
													   </div>
													   <!--[if mso]></td></tr></table><![endif]-->
													   <!--[if (!mso)&(!IE)]><!-->
												   </div>
												   <!--<![endif]-->
											   </div>
										   </div>
										   <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
										   <!--[if (mso)|(IE)]></td></tr></table></td></tr></table><![endif]-->
									   </div>
								   </div>
							   </div>
							   <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
						   </td>
					   </tr>
				   </tbody>
			   </table>
			   <!--[if (IE)]></div><![endif]-->
	</body>
	
	</html>`,

	PlainTextHtmlCode: `<!DOCTYPE html>
  <html>
    <head>
      <title></title>
    </head>
    <body>
      <div style="background-color:#fff;font-family:&quot;HelveticaNeue&quot;,&quot;Helvetica Neue&quot;,Helvetica,Arial,sans-serif;margin:0;padding:0">
        <table align="center" border="0" cellpadding="0" cellspacing="0" width="533px">
    <tbody>
      <tr>
        <td style="text-align:center;padding:30px 0 20px 0"><img alt="SendX" class="CToWUd" height="87px" src="https://cdn.sendx.io/prod/upload/img/20/11/11/27/11336/full.png" style="margin:0;padding:0" width="193px" /></td>
      </tr>
      <tr>
        <td>
          <table border="0" cellpadding="0" cellspacing="0" style="background:#ffffff;border-radius:4px;margin:0;padding:0" width="100%">
      <tbody>
        <tr>
          <td style="padding:30px;font-family:&quot;Open Sans&quot;,&quot;HelveticaNeue&quot;,&quot;Helvetica Neue&quot;,Helvetica,Arial,sans-serif">
            <p style="margin:0 0 16px;line-height:20px;color:#555555;font-size:14px">Hi {{.FirstName}},</p>
  
            <p style="margin:16px 0;line-height:20px;color:#555555;font-size:14px">I am Matt, one of the co-founders of Awesome Inc. Really appreciate you joining Awesome Inc. and we hope you'll fall in love with it once you start exploring it further.
        <br>
        <br>
  
        If you wouldn't mind can I ask you a quick question: <br> Why did you sign-up ?
        <br>
        <br>
        The reason I ask this is because knowing what made you sign-up is really helpful for us in delivering the product and experience our customers want. Just hit 'reply' and let me know.
        <br>
        <br>
        Over the next few weeks, I will be sending you interesting growth tips which you can apply to grow your web business with Awesome Inc.
        <br>
        <br>
  
  
        Best,<br>
        Matt.<br>
        Founder @ Awesome Inc.<br>
  
            </p>
          </td>
        </tr>
      </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td style="color:#aaaaaa;font-size:12px;text-align:center;padding:20px 0">Powered by <a href="https://sendx.io" style="color:#aaaaaa" target="_blank">SendX</a></td>
      </tr>
    </tbody>
        </table>
        <div class="yj6qo">&nbsp;</div>
  
        <div class="adL">&nbsp;</div>
      </div>
    </body>
  </html>`,

	LandingPageTemplateCode:
		'{"page":{"body":{"content":{"style":{"color":"#000000","font-family":"Arial, \'Helvetica Neue\', Helvetica, sans-serif"},"computedStyle":{"messageBackgroundColor":"transparent","linkColor":"#0000FF","messageWidth":"775px"}},"container":{"style":{"background-color":"#FFFFFF"}},"webFonts":[{"name":"Lato","fontFamily":"\'Lato\', Tahoma, Verdana, Segoe, sans-serif","url":"https://fonts.googleapis.com/css?family=Lato"}],"type":"mailup-bee-page-properties"},"rows":[{"content":{"style":{"background-image":"none","background-repeat":"no-repeat","color":"#000000","width":"775px","background-position":"top left","background-color":"#EEF0EC"},"computedStyle":{"rowColStackOnMobile":true}},"locked":false,"container":{"style":{"background-image":"none","background-position":"top left","background-repeat":"no-repeat","background-color":"#EEF0EC"}},"columns":[{"grid-columns":12,"modules":[{"locked":false,"type":"mailup-bee-newsletter-modules-image","descriptor":{"image":{"src":"https://d1oco4z2z1fhwp.cloudfront.net/templates/default/72/yourlogo_dark(2).png","alt":"Image","href":""},"style":{"width":"100%","padding-top":"25px","padding-right":"25px","padding-bottom":"25px","padding-left":"25px"},"computedStyle":{"width":100,"class":"center  autowidth "}}},{"locked":false,"type":"mailup-bee-newsletter-modules-text","descriptor":{"text":{"style":{"color":"#642B2B","font-family":"\'Anton\', sans-serif","line-height":"120%"},"html":"<div class=\\"txtTinyMce-wrapper\\" style=\\"font-size: 12px; line-height: 14px; font-family: Anton, sans-serif;\\" data-mce-style=\\"font-size: 12px; line-height: 14px; font-family: Anton, sans-serif;\\">\\n<p style=\\"text-align: center; font-size: 12px; line-height: 14px;\\" data-mce-style=\\"text-align: center; font-size: 12px; line-height: 14px;\\"><span style=\\"font-size: 38px; line-height: 45px;\\" data-mce-style=\\"font-size: 38px; line-height: 45px;\\"><strong><span style=\\"line-height: 45px; font-size: 38px;\\" data-mce-style=\\"line-height: 45px; font-size: 38px;\\"><span style=\\"line-height: 45px; font-size: 38px;\\" data-mce-style=\\"line-height: 45px; font-size: 38px;\\">FORGET THE FUNNEL</span></span></strong></span></p>\\n</div>","computedStyle":{"linkColor":"#0000FF"}},"style":{"padding-top":"20px","padding-right":"20px","padding-bottom":"20px","padding-left":"20px"},"computedStyle":{"hideContentOnMobile":false}}},{"descriptor":{"style":{"width":"100%","padding-top":"0px","padding-right":"0px","padding-bottom":"0px","padding-left":"0px"},"video":{"src":"https://www.youtube.com/watch?v=hcMZxpDJcvk","iconSize":"65","thumbSrc":"https://img.youtube.com/vi/hcMZxpDJcvk/maxresdefault.jpg","thumbRatio":"16-9","iconColor2":"#000000","iconColor1":"#FFFFFF","iconSrc":"https://app-rsrc.getbee.io/public/resources/components/widgetBar/video-content-icon-sets/light/type-01.png","iconType":"1"},"computedStyle":{"width":"100%","hideContentOnMobile":false,"class":"center"}},"type":"mailup-bee-newsletter-modules-video","locked":false},{"locked":false,"type":"mailup-bee-newsletter-modules-text","descriptor":{"text":{"style":{"color":"#24213d","font-family":"\'Lato\', Tahoma, Verdana, Segoe, sans-serif","line-height":"150%"},"html":"<div class=\\"txtTinyMce-wrapper\\" style=\\"font-size: 12px; line-height: 18px; font-family: Lato, Tahoma, Verdana, Segoe, sans-serif;\\" data-mce-style=\\"font-size: 12px; line-height: 18px; font-family: Lato, Tahoma, Verdana, Segoe, sans-serif;\\">\\n<p style=\\"font-size: 12px; line-height: 18px;\\" data-mce-style=\\"font-size: 12px; line-height: 18px;\\">&nbsp;</p>\\n<p style=\\"font-size: 12px; line-height: 18px;\\" data-mce-style=\\"font-size: 12px; line-height: 18px;\\">&nbsp;</p>\\n<p style=\\"font-size: 12px; line-height: 18px;\\" data-mce-style=\\"font-size: 12px; line-height: 18px;\\"><span style=\\"font-size: 16px; line-height: 24px;\\" data-mce-style=\\"font-size: 16px; line-height: 24px;\\">In this video, you\'ll learn tips and strategies for better user onboarding, activation and retention from none other than Claire Suellentrop, the Co-Founder of Userlist.io and Forget the Funnel.</span></p>\\n<p style=\\"font-size: 12px; line-height: 18px;\\" data-mce-style=\\"font-size: 12px; line-height: 18px;\\">&nbsp;</p>\\n<p style=\\"font-size: 12px; line-height: 18px;\\" data-mce-style=\\"font-size: 12px; line-height: 18px;\\"><span style=\\"font-size: 16px; line-height: 24px;\\" data-mce-style=\\"font-size: 16px; line-height: 24px;\\">In fact, not only will you learn about Claire\'s experiences from when she was at Calendly plus what she\'s doing now, but she also breaks down her exact process for improving customer retention for her clients.</span></p>\\n<p style=\\"font-size: 12px; line-height: 18px;\\" data-mce-style=\\"font-size: 12px; line-height: 18px;\\"><span style=\\"font-size: 16px; line-height: 24px;\\" data-mce-style=\\"font-size: 16px; line-height: 24px;\\">On top of that, Claire gives us a high-level view of exactly how to identify which segments are important for your business, and even takes it one step further by helping you figure out which questions to ask those users.</span></p>\\n<p style=\\"font-size: 12px; line-height: 18px;\\" data-mce-style=\\"font-size: 12px; line-height: 18px;\\">&nbsp;</p>\\n<p style=\\"font-size: 12px; line-height: 18px;\\" data-mce-style=\\"font-size: 12px; line-height: 18px;\\"><span style=\\"font-size: 16px; line-height: 24px;\\" data-mce-style=\\"font-size: 16px; line-height: 24px;\\">In short, this video will provide you with actionable ways to improve your marketing funnel with expert advice!</span></p>\\n<p style=\\"font-size: 12px; line-height: 18px;\\" data-mce-style=\\"font-size: 12px; line-height: 18px;\\"><span style=\\"font-size: 16px; line-height: 24px;\\" data-mce-style=\\"font-size: 16px; line-height: 24px;\\">Please note there is use of strong language and a lot of alcohol consumption in this video. Drunk Entrepreneurs does not condone dangerous drinking in any way! So please drink safe.</span></p>\\n<p style=\\"font-size: 12px; line-height: 18px;\\" data-mce-style=\\"font-size: 12px; line-height: 18px;\\">&nbsp;</p>\\n<p style=\\"font-size: 12px; line-height: 18px;\\" data-mce-style=\\"font-size: 12px; line-height: 18px;\\"><span style=\\"font-size: 16px; line-height: 24px;\\" data-mce-style=\\"font-size: 16px; line-height: 24px;\\">Be sure to SUBSCRIBE to get access to some of the most \\"intoxicating\\" marketing and business tips from the best entrepreneurs out there: </span></p>\\n</div>","computedStyle":{"linkColor":"#24213d"}},"style":{"padding-top":"0px","padding-right":"0px","padding-bottom":"0px","padding-left":"0px"},"computedStyle":{"hideContentOnMobile":false}}},{"descriptor":{"style":{"padding-top":"0px","padding-right":"0px","padding-left":"0px","padding-bottom":"0px"},"html":{"html":"<div class=\\"sendx-submit-form-dragDropEditor\\" id=\\"sendx-submit-form-25pQ1\\" data-id=\\"25pQ1\\"><input data-placeholder=\\"Your Name\\" id=\\"SubscriberForm-First Name-25pQ1\\" class=\\"sendx-field-25pQ1\\" data-attr-type=\\"0\\" style=\\"font-size: 18px; margin-top: 10px !important;margin-left: 2.5% !important;margin-right: 2.5% !important;padding: 15px !important;height: 45px !important;width: 95% !important;color: #333 !important;background-color: #fff !important;border: 1px solid #c4c4c4 !important;-webkit-box-shadow: inset 0 0 3px rgba(0,0,0,0.18) !important;-moz-box-shadow: inset 0 0 3px rgba(0,0,0,0.18) !important;box-shadow: inset 0 0 3px rgba(0,0,0,0.18) !important;-webkit-border-radius: 4px !important;-moz-border-radius: 4px !important;border-radius: 4px !important;-webkit-box-sizing: border-box !important;-moz-box-sizing: border-box !important;-ms-box-sizing: border-box !important;box-sizing: border-box !important;background-image: none !important;min-width: 0 !important;min-height: 0 !important;\\" /><input data-placeholder=\\"Your Email\\" id=\\"SubscriberForm-Email-25pQ1\\" class=\\"sendx-field-25pQ1\\" data-attr-type=\\"0\\" style=\\"font-size: 18px; margin-top: 10px !important;margin-left: 2.5% !important;margin-right: 2.5% !important;padding: 15px !important;height: 45px !important;width: 95% !important;color: #333 !important;background-color: #fff !important;border: 1px solid #c4c4c4 !important;-webkit-box-shadow: inset 0 0 3px rgba(0,0,0,0.18) !important;-moz-box-shadow: inset 0 0 3px rgba(0,0,0,0.18) !important;box-shadow: inset 0 0 3px rgba(0,0,0,0.18) !important;-webkit-border-radius: 4px !important;-moz-border-radius: 4px !important;border-radius: 4px !important;-webkit-box-sizing: border-box !important;-moz-box-sizing: border-box !important;-ms-box-sizing: border-box !important;box-sizing: border-box !important;background-image: none !important;min-width: 0 !important;min-height: 0 !important;\\" /></div><div class=\\"sendx-submit-button-dragDropEditor\\" id=\\"sendx-submit-button-25pQ1\\" style=\\"background-color: rgb(13, 109, 184); color: #fff; margin-top: 25px; font-size: 22px; background: #642b2b; text-align: center; line-height:50px; -moz-border-radius: 3px; -webkit-border-radius: 3px; border-radius: 3px; border: none; text-shadow: none; width: 70%; margin-left: 15%; margin-right: 15%; height: 50px;\\" data-submitting-text=\\"Your details are being submitted\\" data-post-submit-text=\\"You are in ...\\">JOIN UPCOMING WORKSHOPS</div>\\n"},"computedStyle":{"hideContentOnMobile":false}},"type":"mailup-bee-newsletter-modules-html","locked":false}],"style":{"padding-bottom":"60px","border-left":"0px solid transparent","border-bottom":"0px solid transparent","border-top":"0px solid transparent","padding-right":"0px","border-right":"0px solid transparent","padding-top":"0px","background-color":"transparent","padding-left":"0px"}}],"type":"one-column-empty"},{"content":{"style":{"background-image":"none","background-repeat":"no-repeat","color":"#333","width":"775px","background-position":"top left","background-color":"transparent"},"computedStyle":{"rowColStackOnMobile":true}},"locked":false,"container":{"style":{"background-image":"none","background-position":"top left","background-repeat":"no-repeat","background-color":"#EEF0EC"}},"columns":[{"grid-columns":6,"modules":[{"locked":false,"type":"mailup-bee-newsletter-modules-image","descriptor":{"image":{"src":"https://d1oco4z2z1fhwp.cloudfront.net/templates/default/72/TM_01.jpg","alt":"Image","href":""},"style":{"width":"100%","padding-top":"0px","padding-right":"0px","padding-bottom":"0px","padding-left":"0px"},"computedStyle":{"width":272,"class":"center  autowidth "}}},{"locked":false,"type":"mailup-bee-newsletter-modules-text","descriptor":{"text":{"style":{"color":"#642B2B","font-family":"\'Lato\', Tahoma, Verdana, Segoe, sans-serif","line-height":"120%"},"html":"<div class=\\"txtTinyMce-wrapper\\" style=\\"font-size: 12px; line-height: 14px; font-family: Lato, Tahoma, Verdana, Segoe, sans-serif;\\" data-mce-style=\\"font-size: 12px; line-height: 14px; font-family: Lato, Tahoma, Verdana, Segoe, sans-serif;\\">\\n<p style=\\"font-size: 14px; line-height: 16px; text-align: center;\\" data-mce-style=\\"font-size: 14px; line-height: 16px; text-align: center;\\"><span style=\\"font-size: 16px; line-height: 19px;\\" data-mce-style=\\"font-size: 16px; line-height: 19px;\\"><strong><span style=\\"line-height: 19px; font-size: 16px;\\" data-mce-style=\\"line-height: 19px; font-size: 16px;\\">Georgiana Laudi</span></strong></span></p>\\n</div>","computedStyle":{"linkColor":"#0000FF"}},"style":{"padding-top":"20px","padding-right":"0px","padding-bottom":"20px","padding-left":"0px"},"computedStyle":{"hideContentOnMobile":false}}},{"locked":false,"type":"mailup-bee-newsletter-modules-text","descriptor":{"text":{"style":{"color":"#24213d","font-family":"inherit","line-height":"150%"},"html":"<div class=\\"txtTinyMce-wrapper\\" style=\\"font-size: 12px; line-height: 18px;\\" data-mce-style=\\"font-size: 12px; line-height: 18px;\\">\\n<p style=\\"font-size: 14px; line-height: 21px;\\" data-mce-style=\\"font-size: 14px; line-height: 21px;\\">Gia has been bringing brands, products and campaigns to life for nearly 20 years. As an early employee &amp; VP of Marketing at Unbounce, she helped grow revenue by 900% in her first 3 years and go from under $1M to $15.6M in ARR.</p>\\n<p style=\\"font-size: 14px; line-height: 21px;\\" data-mce-style=\\"font-size: 14px; line-height: 21px;\\">&nbsp;</p>\\n<p style=\\"font-size: 14px; line-height: 21px;\\" data-mce-style=\\"font-size: 14px; line-height: 21px;\\">As a strategic advisor at her company A Better CX, she helps high-growth SaaS companies scale their marketing and drive serious business results.</p>\\n</div>","computedStyle":{"linkColor":"#0000FF"}},"style":{"padding-top":"0px","padding-right":"0px","padding-bottom":"0px","padding-left":"0px"},"computedStyle":{"hideContentOnMobile":false}}}],"style":{"padding-bottom":"0px","border-left":"10px solid transparent","border-bottom":"10px solid transparent","border-top":"10px solid transparent","padding-right":"0px","border-right":"10px solid transparent","padding-top":"0px","background-color":"transparent","padding-left":"0px"}},{"grid-columns":6,"modules":[{"locked":false,"type":"mailup-bee-newsletter-modules-image","descriptor":{"image":{"src":"https://d1oco4z2z1fhwp.cloudfront.net/templates/default/72/TM_02.jpg","alt":"Image","href":""},"style":{"width":"100%","padding-top":"0px","padding-right":"0px","padding-bottom":"0px","padding-left":"0px"},"computedStyle":{"width":272,"class":"center  autowidth "}}},{"locked":false,"type":"mailup-bee-newsletter-modules-text","descriptor":{"text":{"style":{"color":"#642B2B","font-family":"\'Lato\', Tahoma, Verdana, Segoe, sans-serif","line-height":"120%"},"html":"<div class=\\"txtTinyMce-wrapper\\" style=\\"font-size: 12px; line-height: 14px; font-family: Lato, Tahoma, Verdana, Segoe, sans-serif;\\" data-mce-style=\\"font-size: 12px; line-height: 14px; font-family: Lato, Tahoma, Verdana, Segoe, sans-serif;\\">\\n<p style=\\"font-size: 14px; line-height: 16px; text-align: center;\\" data-mce-style=\\"font-size: 14px; line-height: 16px; text-align: center;\\"><span style=\\"font-size: 16px; line-height: 19px;\\" data-mce-style=\\"font-size: 16px; line-height: 19px;\\"><strong>Claire Suellentrop</strong></span></p>\\n</div>","computedStyle":{"linkColor":"#0000FF"}},"style":{"padding-top":"20px","padding-right":"0px","padding-bottom":"20px","padding-left":"0px"},"computedStyle":{"hideContentOnMobile":false}}},{"locked":false,"type":"mailup-bee-newsletter-modules-text","descriptor":{"text":{"style":{"color":"#24213d","font-family":"inherit","line-height":"150%"},"html":"<div class=\\"txtTinyMce-wrapper\\" style=\\"font-size: 12px; line-height: 18px;\\" data-mce-style=\\"font-size: 12px; line-height: 18px;\\">\\n<p style=\\"font-size: 14px; line-height: 21px;\\" data-mce-style=\\"font-size: 14px; line-height: 21px;\\">While serving as Director of Marketing and employee #2 at Calendly, Claire helped the product grow from a few thousand users to over 400k monthly users, with revenue climbing to millions in ARR.</p>\\n<p style=\\"font-size: 14px; line-height: 21px;\\" data-mce-style=\\"font-size: 14px; line-height: 21px;\\">&nbsp;</p>\\n<p style=\\"font-size: 14px; line-height: 21px;\\" data-mce-style=\\"font-size: 14px; line-height: 21px;\\">She now runs Love Your Customers, where she helps high-growth SaaS companies get inside their customers\' heads and increase conversions along their sales, marketing, and onboarding funnels.</p>\\n</div>","computedStyle":{"linkColor":"#0000FF"}},"style":{"padding-top":"0px","padding-right":"0px","padding-bottom":"0px","padding-left":"0px"},"computedStyle":{"hideContentOnMobile":false}}}],"style":{"padding-bottom":"0px","border-left":"10px solid transparent","border-bottom":"10px solid transparent","border-top":"10px solid transparent","padding-right":"0px","border-right":"10px solid transparent","padding-top":"0px","background-color":"transparent","padding-left":"0px"}}],"type":"two-columns-empty"},{"content":{"style":{"background-image":"none","background-repeat":"no-repeat","color":"#000000","width":"775px","background-position":"top left","background-color":"transparent"},"computedStyle":{"rowColStackOnMobile":true}},"locked":false,"container":{"style":{"background-image":"none","background-position":"top left","background-repeat":"no-repeat","background-color":"#EEF0EC"}},"columns":[{"grid-columns":12,"modules":[{"descriptor":{"text":{"style":{"color":"#555555","font-family":"inherit","line-height":"120%"},"html":"<div class=\\"txtTinyMce-wrapper\\" style=\\"font-size: 12px; line-height: 14px;\\" data-mce-style=\\"font-size: 12px; line-height: 14px;\\">\\n<p style=\\"font-size: 14px; line-height: 16px; text-align: center;\\" data-mce-style=\\"font-size: 14px; line-height: 16px; text-align: center;\\"><span style=\\"color: rgb(0, 0, 0); font-size: 26px; line-height: 31px;\\" data-mce-style=\\"color: rgb(0, 0, 0); font-size: 26px; line-height: 31px;\\"><strong>Gia and Claire have helped build marketing strategies for awesome SaaS brands including:</strong></span></p>\\n</div>","computedStyle":{"linkColor":"#0000FF"}},"style":{"padding-top":"60px","padding-right":"10px","padding-left":"10px","padding-bottom":"45px"},"computedStyle":{"hideContentOnMobile":false}},"type":"mailup-bee-newsletter-modules-text","locked":false},{"descriptor":{"image":{"src":"https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/840f4477-2071-4b5b-a7c9-79cd553fea12/dragdrop-dev/Screen%20Shot%202019-05-17%20at%203.05.31%20am.png","alt":"Image","href":""},"style":{"width":"100%","padding-top":"0px","padding-right":"0px","padding-bottom":"0px","padding-left":"0px"},"computedStyle":{"width":723,"class":"center  autowidth ","hideContentOnMobile":false}},"type":"mailup-bee-newsletter-modules-image","locked":false}],"style":{"padding-bottom":"55px","border-left":"0px solid transparent","border-bottom":"0px solid transparent","border-top":"0px solid transparent","padding-right":"0px","border-right":"0px solid transparent","padding-top":"5px","background-color":"transparent","padding-left":"0px"}}],"type":"one-column-empty"},{"content":{"style":{"background-image":"none","background-repeat":"no-repeat","color":"#000000","width":"775px","background-position":"top left","background-color":"transparent"},"computedStyle":{"rowColStackOnMobile":true}},"locked":false,"container":{"style":{"background-image":"none","background-position":"top left","background-repeat":"no-repeat","background-color":"#EEF0EC"}},"columns":[{"grid-columns":12,"modules":[{"descriptor":{"text":{"style":{"color":"#555555","font-family":"inherit","line-height":"180%"},"html":"<div class=\\"txtTinyMce-wrapper\\" style=\\"font-size: 12px; line-height: 21px;\\" data-mce-style=\\"font-size: 12px; line-height: 21px;\\">\\n<p style=\\"font-size: 14px; line-height: 25px;\\" data-mce-style=\\"font-size: 14px; line-height: 25px;\\"><span style=\\"color: rgb(255, 255, 255); font-size: 18px; line-height: 32px;\\" data-mce-style=\\"color: rgb(255, 255, 255); font-size: 18px; line-height: 32px;\\">I just watched the replay from yesterday\'s workshop, and I\'ll urge my CEO to watch it, too. It will help him understand exactly what I\'ve been struggling to communicate for so long. I can\'t overstate how much I appreciate you sharing all of this.</span></p>\\n</div>","computedStyle":{"linkColor":"#0000FF"}},"style":{"padding-top":"45px","padding-right":"45px","padding-bottom":"45px","padding-left":"45px"},"computedStyle":{"hideContentOnMobile":false}},"type":"mailup-bee-newsletter-modules-text","locked":false}],"style":{"padding-bottom":"5px","border-left":"0px solid #642B2B","border-bottom":"0px solid #642B2B","border-top":"0px solid #642B2B","padding-right":"0px","border-right":"0px solid #642B2B","padding-top":"5px","background-color":"#656A60","padding-left":"0px"}}],"type":"one-column-empty"},{"content":{"style":{"background-image":"none","background-repeat":"no-repeat","color":"#333","width":"775px","background-position":"top left","background-color":"transparent"},"computedStyle":{"rowColStackOnMobile":true}},"locked":false,"container":{"style":{"background-image":"none","background-position":"top left","background-repeat":"no-repeat","background-color":"#EEF0EC"}},"columns":[{"grid-columns":6,"modules":[{"descriptor":{"image":{"src":"https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/840f4477-2071-4b5b-a7c9-79cd553fea12/dragdrop-dev/rally-workshop-testimonial.png","alt":"Image","href":""},"style":{"width":"100%","padding-top":"0px","padding-right":"0px","padding-bottom":"0px","padding-left":"0px"},"computedStyle":{"width":97,"class":"right fixedwidth","hideContentOnMobile":false}},"type":"mailup-bee-newsletter-modules-image","locked":false}],"style":{"padding-bottom":"5px","border-left":"0px solid transparent","border-bottom":"0px solid transparent","border-top":"0px solid transparent","padding-right":"0px","border-right":"0px solid transparent","padding-top":"5px","background-color":"transparent","padding-left":"0px"}},{"grid-columns":6,"modules":[{"descriptor":{"text":{"style":{"color":"#555555","font-family":"inherit","line-height":"120%"},"html":"<div class=\\"txtTinyMce-wrapper\\" data-mce-style=\\"font-size: 12px; line-height: 14px;\\" style=\\"font-size: 12px; line-height: 14px;\\"><p style=\\"font-size: 12px; line-height: 14px;\\" data-mce-style=\\"font-size: 12px; line-height: 14px;\\">&nbsp;</p>\\n<p style=\\"font-size: 12px; line-height: 14px;\\" data-mce-style=\\"font-size: 12px; line-height: 14px;\\"><span style=\\"font-size: 16px; line-height: 19px;\\" data-mce-style=\\"font-size: 16px; line-height: 19px;\\"><strong>Rally Stanoeva</strong></span></p>\\n<p style=\\"font-size: 12px; line-height: 14px;\\" data-mce-style=\\"font-size: 12px; line-height: 14px;\\"><span style=\\"font-size: 16px; line-height: 19px;\\" data-mce-style=\\"font-size: 16px; line-height: 19px;\\"><span style=\\"font-size: 13px; line-height: 15px;\\" data-mce-style=\\"font-size: 13px; line-height: 15px;\\">Marketing Manager</span><br></span></p>\\n<p style=\\"font-size: 12px; line-height: 14px;\\" data-mce-style=\\"font-size: 12px; line-height: 14px;\\"><span class=\\"elementor-testimonial__name\\" style=\\"font-weight: 800; color: rgb(46, 41, 37); font-family: Roboto, sans-serif; font-size: 14px; line-height: 16px;\\" data-mce-style=\\"font-weight: 800; color: rgb(46, 41, 37); font-family: Roboto, sans-serif; font-size: 14px; line-height: 16px;\\">&nbsp;</span></p></div>","computedStyle":{"linkColor":"#0000FF"}},"style":{"padding-top":"10px","padding-right":"10px","padding-bottom":"10px","padding-left":"10px"},"computedStyle":{"hideContentOnMobile":false}},"type":"mailup-bee-newsletter-modules-text","locked":false}],"style":{"padding-bottom":"5px","border-left":"0px solid transparent","border-bottom":"0px solid transparent","border-top":"0px solid transparent","padding-right":"0px","border-right":"0px solid transparent","padding-top":"5px","background-color":"transparent","padding-left":"0px"}}],"type":"two-columns-empty"},{"content":{"style":{"background-image":"none","background-repeat":"no-repeat","color":"#000000","width":"775px","background-position":"top left","background-color":"transparent"},"computedStyle":{"rowColStackOnMobile":true}},"locked":false,"container":{"style":{"background-image":"none","background-position":"top left","background-repeat":"no-repeat","background-color":"#EEF0EC"}},"columns":[{"grid-columns":12,"modules":[{"descriptor":{"style":{"padding-top":"0px","padding-right":"0px","padding-bottom":"0px","padding-left":"0px"},"html":{"html":"<div class=\\"sendx-submit-form-dragDropEditor\\" id=\\"sendx-submit-form-AE76F\\" data-id=\\"AE76F\\"><input data-placeholder=\\"Your Name\\" id=\\"SubscriberForm-First Name-AE76F\\" class=\\"sendx-field-AE76F\\" data-attr-type=\\"0\\" style=\\"font-size: 18px; margin-top: 10px !important;margin-left: 2.5% !important;margin-right: 2.5% !important;padding: 15px !important;height: 45px !important;width: 95% !important;color: #333 !important;background-color: #fff !important;border: 1px solid #c4c4c4 !important;-webkit-box-shadow: inset 0 0 3px rgba(0,0,0,0.18) !important;-moz-box-shadow: inset 0 0 3px rgba(0,0,0,0.18) !important;box-shadow: inset 0 0 3px rgba(0,0,0,0.18) !important;-webkit-border-radius: 4px !important;-moz-border-radius: 4px !important;border-radius: 4px !important;-webkit-box-sizing: border-box !important;-moz-box-sizing: border-box !important;-ms-box-sizing: border-box !important;box-sizing: border-box !important;background-image: none !important;min-width: 0 !important;min-height: 0 !important;\\" /><input data-placeholder=\\"Your Email\\" id=\\"SubscriberForm-Email-AE76F\\" class=\\"sendx-field-AE76F\\" data-attr-type=\\"0\\" style=\\"font-size: 18px; margin-top: 10px !important;margin-left: 2.5% !important;margin-right: 2.5% !important;padding: 15px !important;height: 45px !important;width: 95% !important;color: #333 !important;background-color: #fff !important;border: 1px solid #c4c4c4 !important;-webkit-box-shadow: inset 0 0 3px rgba(0,0,0,0.18) !important;-moz-box-shadow: inset 0 0 3px rgba(0,0,0,0.18) !important;box-shadow: inset 0 0 3px rgba(0,0,0,0.18) !important;-webkit-border-radius: 4px !important;-moz-border-radius: 4px !important;border-radius: 4px !important;-webkit-box-sizing: border-box !important;-moz-box-sizing: border-box !important;-ms-box-sizing: border-box !important;box-sizing: border-box !important;background-image: none !important;min-width: 0 !important;min-height: 0 !important;\\" /></div><div class=\\"sendx-submit-button-dragDropEditor\\" id=\\"sendx-submit-button-AE76F\\" style=\\"background-color: rgb(13, 109, 184); color: #fff; margin-top: 25px; font-size: 22px; background: #642b2b; text-align: center; line-height:50px; -moz-border-radius: 3px; -webkit-border-radius: 3px; border-radius: 3px; border: none; text-shadow: none; width: 70%; margin-left: 15%; margin-right: 15%; height: 50px;\\" data-submitting-text=\\"Your details are being submitted\\" data-post-submit-text=\\"You are in ...\\">JOIN UPCOMING WORKSHOPS</div>\\n"},"computedStyle":{"hideContentOnMobile":false}},"type":"mailup-bee-newsletter-modules-html","locked":false},{"descriptor":{"style":{"padding-left":"60px","padding-top":"60px","padding-right":"60px","padding-bottom":"60px","text-align":"center"},"computedStyle":{"hideContentOnMobile":false,"iconsDefaultHeight":32,"height":157,"padding":"0 5px 5px 0","width":288,"iconsDefaultWidth":32},"iconsList":{"icons":[{"text":"","image":{"src":"https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-circle-dark-gray/facebook@2x.png","prefix":"https://www.facebook.com/","href":"https://www.facebook.com/","alt":"Facebook","title":"Facebook"},"type":"follow","name":"facebook"},{"text":"","image":{"src":"https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-circle-dark-gray/twitter@2x.png","prefix":"https://twitter.com/","href":"https://twitter.com/","alt":"Twitter","title":"Twitter"},"type":"follow","name":"twitter"},{"text":"","image":{"src":"https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-circle-dark-gray/instagram@2x.png","prefix":"https://instagram.com/","href":"https://instagram.com/","alt":"Instagram","title":"Instagram"},"type":"follow","name":"instagram"},{"text":"","image":{"src":"https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-circle-dark-gray/linkedin@2x.png","prefix":"https://www.linkedin.com/","href":"https://www.linkedin.com/","alt":"LinkedIn","title":"LinkedIn"},"type":"follow","name":"linkedin"}]}},"type":"mailup-bee-newsletter-modules-social","locked":false}],"style":{"padding-bottom":"5px","border-left":"0px solid transparent","border-bottom":"0px solid transparent","border-top":"0px solid transparent","padding-right":"0px","border-right":"0px solid transparent","padding-top":"60px","background-color":"transparent","padding-left":"0px"}}],"type":"one-column-empty"}],"description":"","template":{"version":"2.0.0","type":"basic","name":"template-base"},"title":""}}',

	EmptyBeeEditorHtml: `<!DOCTYPE html><html xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office" lang="en"><head><title></title><meta http-equiv="Content-Type" content="text/html; charset=utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch><o:AllowPNG/></o:OfficeDocumentSettings></xml><![endif]--><style> *{box-sizing:border-box}body{margin:0;padding:0}a[x-apple-data-detectors]{color:inherit!important;text-decoration:inherit!important}#MessageViewBody a{color:inherit;text-decoration:none}p{line-height:inherit}.desktop_hide,.desktop_hide table{mso-hide:all;display:none;max-height:0;overflow:hidden}.image_block img+div{display:none} @media (max-width:520px){.mobile_hide{display:none}.row-content{width:100%!important}.stack .column{width:100%;display:block}.mobile_hide{min-height:0;max-height:0;max-width:0;overflow:hidden;font-size:0}.desktop_hide,.desktop_hide table{display:table!important;max-height:none!important}} </style></head><body class="body" style="background-color:#fff;margin:0;padding:0;-webkit-text-size-adjust:none;text-size-adjust:none"><table class="nl-container" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#fff"><tbody><tr><td><table class="row row-1" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"><tbody><tr><td> <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;border-radius:0;color:#000;width:500px;margin:0 auto" width="500"><tbody><tr><td class="column column-1" width="100%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:5px;padding-top:5px;vertical-align:top;border-top:0;border-right:0;border-bottom:0;border-left:0"><table class="empty_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"><tr><td class="pad"><div></div></td></tr></table></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table><!-- End --></body></html>`,

	DragDropRssTemplateCode:
		'{"page":{"body":{"container":{"style":{"background-color":"#FFFFFF"}},"content":{"computedStyle":{"align":"center","linkColor":"#0068A5","messageBackgroundColor":"transparent","messageWidth":"720px"},"style":{"color":"#000000","font-family":"\'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif"}},"type":"mailup-bee-page-properties","webFonts":[{"fontFamily":"Arial, \'Helvetica Neue\', Helvetica, sans-serif","name":"Arial","url":""},{"fontFamily":"\'Helvetica Neue\', Helvetica, Arial, sans-serif","name":"Helvetica","url":""},{"fontFamily":"\'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif","name":"Open Sans","url":"https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700\u0026display=swap"}]},"description":"Test template for BEE","rows":[{"columns":[{"grid-columns":12,"modules":[{"descriptor":{"computedStyle":{"class":"center autowidth","hideContentOnMobile":false,"width":"100px"},"image":{"alt":"","href":"","prefix":"","src":"https://d1oco4z2z1fhwp.cloudfront.net/templates/default/72/yourlogo_dark(2).png","target":"_blank"},"style":{"border-radius":"0px","padding-bottom":"0px","padding-left":"0px","padding-right":"0px","padding-top":"0px","width":"100%"}},"locked":false,"type":"mailup-bee-newsletter-modules-image","uuid":"3b0d3fcc-294e-4cc8-834e-6c891de85d33"},{"descriptor":{"computedStyle":{"hideContentOnMobile":false},"spacer":{"style":{"height":"35px"}}},"locked":false,"type":"mailup-bee-newsletter-modules-spacer","uuid":"d04d4467-6859-4ec9-864f-e24317b77f9c"}],"style":{"background-color":"transparent","border-bottom":"0px solid transparent","border-left":"0px solid transparent","border-right":"0px solid transparent","border-top":"0px solid transparent","padding-bottom":"5px","padding-left":"0px","padding-right":"0px","padding-top":"5px"},"uuid":"87ca9c41-19e1-4ce5-b7c1-fce3eeb9a9e1"}],"container":{"style":{"background-color":"#ffffff","background-image":"none","background-position":"top left","background-repeat":"no-repeat"}},"content":{"computedStyle":{"hideContentOnDesktop":false,"hideContentOnMobile":false,"rowColStackOnMobile":true,"rowReverseColStackOnMobile":false,"verticalAlign":"top"},"style":{"background-color":"#ffffff","background-image":"none","background-position":"top left","background-repeat":"no-repeat","border-bottom":"0px solid transparent","border-left":"0px solid transparent","border-radius":"0px","border-right":"0px solid transparent","border-top":"0px solid transparent","color":"#000000","width":"720px"}},"empty":false,"locked":false,"synced":false,"type":"","uuid":"67e58adc-b7d8-43fb-b79a-48974926085d"},{"columns":[{"grid-columns":12,"modules":[{"descriptor":{"computedStyle":{"hideContentOnDesktop":false,"hideContentOnMobile":false},"heading":{"style":{"color":"#555555","direction":"ltr","font-family":"\'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif","font-size":"24px","font-weight":"700","letter-spacing":"0px","line-height":"150%","link-color":"#0068a5","text-align":"left"},"text":"\u003cspan class=\\"tinyMce-placeholder\\"\u003e\u003ca href=\\"{{ .PostLink }}\\" target=\\"_blank\\" style=\\"text-decoration: underline;\\" rel=\\"noopener\\"\u003e\u003cspan class=\\"mce-content-body mce-edit-focus\\" style=\\"position: relative;\\" id=\\"1a28b471-83bc-41f3-aa46-ef90f9772844\\" data-position=\\"20-0-0\\" data-qa=\\"tinyeditor-root-element\\"\u003e\u003cspan class=\\"tinyMce-placeholder\\"\u003e\u0026nbsp;{{ .PostTitle }}\u003c/span\u003e\u003c/span\u003e\u003c/a\u003e\u003c/span\u003e","title":"h2"},"style":{"padding-bottom":"0px","padding-left":"5px","padding-right":"0px","padding-top":"0px","text-align":"center","width":"100%"}},"locked":false,"type":"mailup-bee-newsletter-modules-heading","uuid":"c6c2ee62-eb4f-416e-bc83-ad14836992d9"},{"descriptor":{"computedStyle":{"hideContentOnAmp":false,"hideContentOnDesktop":false,"hideContentOnHtml":false,"hideContentOnMobile":false},"paragraph":{"computedStyle":{"linkColor":"#0068A5","paragraphSpacing":"16px"},"html":"\u003cp\u003ePublished on {{ .PostDate }}\u003c/p\u003e","style":{"color":"#000000","direction":"ltr","font-family":"\'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif","font-size":"16px","font-weight":"400","letter-spacing":"0px","line-height":"120%","text-align":"left"}},"style":{"padding-bottom":"10px","padding-left":"10px","padding-right":"10px","padding-top":"10px"}},"locked":false,"type":"mailup-bee-newsletter-modules-paragraph","uuid":"a6e46785-80cc-4984-ba46-0f43a0de4a99"},{"descriptor":{"computedStyle":{"hideContentOnDesktop":false,"hideContentOnMobile":false,"rowColStackOnMobile":true,"rowReverseColStackOnMobile":false,"verticalAlign":"top"},"heading":{"style":{"color":"#555555","direction":"ltr","font-family":"inherit","font-size":"16px","font-weight":"700","letter-spacing":"0px","line-height":"120%","link-color":"#E01253","text-align":"center"},"text":"\u003cspan class=\\"tinyMce-placeholder\\"\u003e\u003c/span\u003e","title":"h1"},"style":{"padding-bottom":"0px","padding-left":"0px","padding-right":"0px","padding-top":"0px","text-align":"center","width":"100%"}},"locked":false,"type":"mailup-bee-newsletter-modules-heading","uuid":"62829076-7333-413b-8a58-471dbdc778b9"},{"descriptor":{"computedStyle":{"hideContentOnAmp":false,"hideContentOnDesktop":false,"hideContentOnHtml":false,"hideContentOnMobile":false},"paragraph":{"computedStyle":{"linkColor":"#0068a5","paragraphSpacing":"16px"},"html":"\u003cp\u003e{{ .PostDescriptionOrContent }}\u003c/p\u003e","style":{"color":"#000000","direction":"ltr","font-family":"\'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif","font-size":"16px","font-weight":"400","letter-spacing":"0px","line-height":"150%","text-align":"left"}},"style":{"padding-bottom":"0px","padding-left":"10px","padding-right":"10px","padding-top":"10px"}},"locked":false,"type":"mailup-bee-newsletter-modules-paragraph","uuid":"a428ba2d-3adc-4816-be91-26dde0d2fd1b"},{"descriptor":{"computedStyle":{"hideContentOnAmp":false,"hideContentOnDesktop":false,"hideContentOnHtml":false,"hideContentOnMobile":false},"paragraph":{"computedStyle":{"linkColor":"#0068A5","paragraphSpacing":"12px"},"html":"\u003cp\u003e\u003ca href=\\"{{ .PostLink }}\\" target=\\"_blank\\" style=\\"text-decoration: underline;\\" rel=\\"noopener\\"\u003eRead more...\u003c/a\u003e\u003c/p\u003e","style":{"color":"#0068a5","direction":"ltr","font-family":"\'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif","font-size":"14px","font-weight":"400","letter-spacing":"0px","line-height":"120%","text-align":"left"}},"style":{"padding-bottom":"5px","padding-left":"10px","padding-right":"5px","padding-top":"0px"}},"locked":false,"type":"mailup-bee-newsletter-modules-paragraph","uuid":"21056998-9547-4d54-abea-47b266cddf81"},{"descriptor":{"computedStyle":{"hideContentOnMobile":false},"spacer":{"style":{"height":"35px"}}},"locked":false,"type":"mailup-bee-newsletter-modules-spacer","uuid":"ce7c6fc9-d68e-4b26-8967-b84ed428004d"}],"style":{"background-color":"transparent","border-bottom":"0px solid transparent","border-left":"0px solid transparent","border-right":"0px solid transparent","border-top":"0px solid transparent","padding-bottom":"5px","padding-left":"0px","padding-right":"0px","padding-top":"5px"},"uuid":"a9f39b93-9b7e-426c-b3d9-48ff87eee65a"}],"container":{"displayCondition":{"after":"{{end}}","before":"{{range .Posts}}","description":"Iterate Posts","label":"Iterate Posts","type":"BEE_CUSTOM_DISPLAY_CONDITION"},"style":{"background-color":"#ffffff","background-image":"none","background-position":"top left","background-repeat":"no-repeat"}},"content":{"computedStyle":{"columnsSpacing":"0px","hideContentOnDesktop":false,"hideContentOnMobile":false,"rowColStackOnMobile":true,"rowReverseColStackOnMobile":false,"verticalAlign":"top"},"style":{"background-color":"#ffffff","background-image":"none","background-position":"top left","background-repeat":"no-repeat","border-bottom":"0px solid #573737","border-left":"0px solid #573737","border-radius":"0px","border-right":"0px solid #573737","border-top":"0px solid #573737","color":"#000000","width":"720px"}},"empty":false,"locked":false,"synced":false,"type":"one-column-12-empty","uuid":"0237df5b-aa59-4c13-8550-9a6749977155"},{"columns":[{"grid-columns":12,"modules":[{"descriptor":{"computedStyle":{"height":57,"hideContentOnMobile":false,"iconsDefaultWidth":32,"padding":"0 2.5px 0 2.5px","width":151},"iconsList":{"icons":[{"id":"facebook","image":{"alt":"Facebook","href":"https://www.facebook.com/","prefix":"https://www.facebook.com/","src":"https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/circle-color/facebook@2x.png","target":"_blank","title":"Facebook"},"name":"Facebook","text":"","type":"follow"},{"id":"x","image":{"alt":"X","href":"https://twitter.com/","prefix":"https://twitter.com/","src":"https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/circle-color/twitter@2x.png","target":"_blank","title":"X"},"name":"X","text":"","type":"follow"},{"id":"instagram","image":{"alt":"Instagram","href":"https://instagram.com/","prefix":"https://instagram.com/","src":"https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/circle-color/instagram@2x.png","target":"_blank","title":"Instagram"},"name":"Instagram","text":"","type":"follow"},{"id":"linkedin","image":{"alt":"LinkedIn","href":"https://www.linkedin.com/","prefix":"https://www.linkedin.com/","src":"https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/circle-color/linkedin@2x.png","target":"_blank","title":"LinkedIn"},"name":"LinkedIn","text":"","type":"follow"}]},"style":{"padding-bottom":"10px","padding-left":"10px","padding-right":"10px","padding-top":"10px","text-align":"center"}},"locked":false,"type":"mailup-bee-newsletter-modules-social","uuid":"7c11a6c7-d8be-4411-aa82-28d527122c93"}],"style":{"background-color":"transparent","border-bottom":"0px solid transparent","border-left":"0px solid transparent","border-right":"0px solid transparent","border-top":"0px solid transparent","padding-bottom":"5px","padding-left":"0px","padding-right":"0px","padding-top":"5px"},"uuid":"22afc435-0231-44de-9d08-91011d181c8c"}],"container":{"style":{"background-color":"#ffffff","background-image":"none","background-position":"top left","background-repeat":"no-repeat"}},"content":{"computedStyle":{"hideContentOnDesktop":false,"hideContentOnMobile":false,"rowColStackOnMobile":true,"rowReverseColStackOnMobile":false,"verticalAlign":"top"},"style":{"background-color":"#ffffff","background-image":"none","background-position":"top left","background-repeat":"no-repeat","border-bottom":"0px solid transparent","border-left":"0px solid transparent","border-radius":"0px","border-right":"0px solid transparent","border-top":"0px solid transparent","color":"#000000","width":"720px"}},"empty":false,"locked":false,"synced":false,"type":"one-column-12-empty","uuid":"1f24de04-6e37-4d6a-9794-347b526b596a"}],"template":{"name":"template-base","type":"basic","version":"2.0.0"},"title":"Template Base"},"comments":{}}',

	DragDropRssHtmlCode: `<!DOCTYPE html>
<html xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office" lang="en">
   <head>
      <title></title>
      <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
      <meta name="viewport" content="width=device-width,initial-scale=1">
      <!--[if mso]>
      <xml>
         <o:OfficeDocumentSettings>
            <o:PixelsPerInch>96</o:PixelsPerInch>
            <o:AllowPNG/>
         </o:OfficeDocumentSettings>
      </xml>
      <![endif]--><!--[if !mso]><!-->
      <link 
         href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&amp;display=swap" rel="stylesheet" type="text/css">
      <!--<![endif]-->
      <style>
         *{box-sizing:border-box}body{margin:0;padding:0}a[x-apple-data-detectors]{color:inherit!important;text-decoration:inherit!important}#MessageViewBody a{color:inherit;text-decoration:none}p{line-height:inherit}.desktop_hide,.desktop_hide table{mso-hide:all;display:none;max-height:0;overflow:hidden}.image_block img+div{display:none}sub,sup{line-height:0;font-size:75%} @media (max-width:740px){.social_block.desktop_hide .social-table{display:inline-block!important}.mobile_hide{display:none}.row-content{width:100%!important}.stack .column{width:100%;display:block}.mobile_hide{min-height:0;max-height:0;max-width:0;overflow:hidden;font-size:0}.desktop_hide,.desktop_hide table{display:table!important;max-height:none!important}}
      </style>
      <!--[if mso ]>
      <style>sup, sub { font-size: 100% !important; } sup { mso-text-raise:10% } sub { mso-text-raise:-10% }</style>
      <![endif]-->
   </head>
   <body class="body" style="background-color:#fff;margin:0;padding:0;-webkit-text-size-adjust:none;text-size-adjust:none">
      <table class="nl-container" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#fff">
         <tbody>
            <tr>
               <td>
                  <table class="row row-1" align="center" 
                     width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#fff">
                     <tbody>
                        <tr>
                           <td>
                              <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#fff;border-radius:0;color:#000;width:720px;margin:0 auto" width="720">
                                 <tbody>
                                    <tr>
                                       <td class="column column-1" width="100%" 
                                          style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:5px;padding-top:5px;vertical-align:top;border-top:0;border-right:0;border-bottom:0;border-left:0">
                                          <table class="image_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0">
                                             <tr>
                                                <td class="pad" style="width:100%">
                                                   <div class="alignment" align="center" style="line-height:10px">
                                                      <div style="max-width:100px"><img 
                                                         src="https://d1oco4z2z1fhwp.cloudfront.net/templates/default/72/yourlogo_dark(2).png" style="display:block;height:auto;border:0;width:100%" width="100" height="auto"></div>
                                                   </div>
                                                </td>
                                             </tr>
                                          </table>
                                          <div class="spacer_block block-2" style="height:35px;line-height:35px;font-size:1px">&#8202;</div>
                                       </td>
                                    </tr>
                                 </tbody>
                              </table>
                           </td>
                        </tr>
                     </tbody>
                  </table>
                  {{range .Posts}}
                  <table class="row row-2" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" 
                     style="mso-table-lspace:0;mso-table-rspace:0;background-color:#fff">
                     <tbody>
                        <tr>
                           <td>
                              <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#fff;border-radius:0;color:#000;width:720px;margin:0 auto" width="720">
                                 <tbody>
                                    <tr>
                                       <td class="column column-1" width="100%" 
                                          style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:5px;padding-top:5px;vertical-align:top;border-top:0;border-right:0;border-bottom:0;border-left:0">
                                          <table class="heading_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0">
                                             <tr>
                                                <td class="pad" style="padding-left:5px;text-align:center;width:100%">
                                                   <h2 
                                                      style="margin:0;color:#555;direction:ltr;font-family:'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif;font-size:24px;font-weight:700;letter-spacing:normal;line-height:150%;text-align:left;margin-top:0;margin-bottom:0;mso-line-height-alt:36px">
                                                      <span class="tinyMce-placeholder" style="word-break: break-word;"><a href="{{ .PostLink }}" target="_blank" style="text-decoration: underline; color: #0068a5;" rel="noopener"><span class="mce-content-body mce-edit-focus" style="word-break: break-word; position: relative;" id="1a28b471-83bc-41f3-aa46-ef90f9772844" data-position="20-0-0" data-qa="tinyeditor-root-element"><span class="tinyMce-placeholder" style="word-break: break-word;">&nbsp;{{ .PostTitle }}</span></span></a></span>
                                                   </h2>
                                                </td>
                                             </tr>
                                          </table>
                                          <table class="paragraph_block block-2" width="100%" border="0" cellpadding="10" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word">
                                             <tr>
                                                <td class="pad">
                                                   <div style="color:#000;direction:ltr;font-family:'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;letter-spacing:0;line-height:120%;text-align:left;mso-line-height-alt:19.2px">
                                                      <p style="margin:0">Published on {{ .PostDate }}</p>
                                                   </div>
                                                </td>
                                             </tr>
                                          </table>
                                          <table class="heading_block block-3" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0">
                                             <tr>
                                                <td class="pad" style="text-align:center;width:100%">
                                                   <h1 style="margin:0;color:#555;direction:ltr;font-family:'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif;font-size:16px;font-weight:700;letter-spacing:normal;line-height:120%;text-align:center;margin-top:0;margin-bottom:0;mso-line-height-alt:19.2px">
                                                      <span class="tinyMce-placeholder" style="word-break: break-word;"></span>
                                                   </h1>
                                                </td>
                                             </tr>
                                          </table>
                                          <table class="paragraph_block block-4" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word">
                                             <tr>
                                                <td class="pad" style="padding-left:10px;padding-right:10px;padding-top:10px">
                                                   <div 
                                                      style="color:#000;direction:ltr;font-family:'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;letter-spacing:0;line-height:150%;text-align:left;mso-line-height-alt:24px">
                                                      <p style="margin:0">{{ .PostDescriptionOrContent }}</p>
                                                   </div>
                                                </td>
                                             </tr>
                                          </table>
                                          <table class="paragraph_block block-5" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word">
                                             <tr>
                                                <td class="pad" 
                                                   style="padding-bottom:5px;padding-left:10px;padding-right:5px">
                                                   <div style="color:#0068a5;direction:ltr;font-family:'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif;font-size:14px;font-weight:400;letter-spacing:0;line-height:120%;text-align:left;mso-line-height-alt:16.8px">
                                                      <p style="margin:0"><a href="{{ .PostLink }}" target="_blank" style="text-decoration: underline; color: #0068A5;" rel="noopener">Read more...</a></p>
                                                   </div>
                                                </td>
                                             </tr>
                                          </table>
                                          <div 
                                             class="spacer_block block-6" style="height:35px;line-height:35px;font-size:1px">&#8202;</div>
                                       </td>
                                    </tr>
                                 </tbody>
                              </table>
                           </td>
                        </tr>
                     </tbody>
                  </table>
                  {{end}}
                  <table class="row row-3" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#fff">
                     <tbody>
                        <tr>
                           <td>
                              <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" 
                                 style="mso-table-lspace:0;mso-table-rspace:0;background-color:#fff;border-radius:0;color:#000;width:720px;margin:0 auto" width="720">
                                 <tbody>
                                    <tr>
                                       <td class="column column-1" width="100%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:5px;padding-top:5px;vertical-align:top;border-top:0;border-right:0;border-bottom:0;border-left:0">
                                          <table class="social_block block-1" width="100%" border="0" cellpadding="10" cellspacing="0" role="presentation" 
                                             style="mso-table-lspace:0;mso-table-rspace:0">
                                             <tr>
                                                <td class="pad">
                                                   <div class="alignment" align="center">
                                                      <table class="social-table" width="144px" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;display:inline-block">
                                                         <tr>
                                                            <td style="padding:0 2px 0 2px"><a href="https://www.facebook.com/" target="_blank"><img 
                                                               src="https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/circle-color/facebook@2x.png" width="32" height="auto" alt="Facebook" title="Facebook" style="display:block;height:auto;border:0"></a></td>
                                                            <td style="padding:0 2px 0 2px"><a href="https://twitter.com/" target="_blank"><img src="https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/circle-color/twitter@2x.png" width="32" height="auto" alt="X" title="X" 
                                                               style="display:block;height:auto;border:0"></a></td>
                                                            <td style="padding:0 2px 0 2px"><a href="https://instagram.com/" target="_blank"><img src="https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/circle-color/instagram@2x.png" width="32" height="auto" alt="Instagram" title="Instagram" style="display:block;height:auto;border:0"></a></td>
                                                            <td style="padding:0 2px 0 2px"><a href="https://www.linkedin.com/" target="_blank"><img
                                                               src="https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/circle-color/linkedin@2x.png" width="32" height="auto" alt="LinkedIn" title="LinkedIn" style="display:block;height:auto;border:0"></a></td>
                                                         </tr>
                                                      </table>
                                                   </div>
                                                </td>
                                             </tr>
                                          </table>
                                       </td>
                                    </tr>
                                 </tbody>
                              </table>
                           </td>
                        </tr>
                     </tbody>
                  </table>
               </td>
            </tr>
         </tbody>
      </table>
      <!-- End -->
   </body>
</html>`,
});

export const EmptyStateDetails = Object.freeze({
	campaign: {
		newsletter: {
			all: {
				topic: "Create your first newsletter",
				description:
					"Design, schedule and track localised email newsletter campaigns.",
				detailsInList: [
					"Unlock the power of targeted email campaigns with localised newsletters that drive results.",
					"Get excellent deliverability with one-click resend and smart send technology.",
					"Design professional-looking emails with ease using our intuitive drag-and-drop editor.",
					"Benefit from access to over 500,000 royalty-free stock photos.",
					"Measure success with detailed analytics, and click heatmap reports to optimise your campaigns.",
				],
				buttonName: "Create Newsletter",
				imageName: "newsletter.png",
				redirectPage: Routes.Campaign.Newsletter.New.Sender,
			},
			draft: {
				topic: "No draft newsletters",
				description: "Once a draft newsletter is created, it will appear here.",
			},
			scheduled: {
				topic: "No scheduled newsletters",
				description: "Once a newsletter is scheduled, it will be appear here.",
			},
			sending: {
				topic: "No newsletters currently being sent.",
				description: "Once a newsletter is sending, it will be appear here.",
			},
			sent: {
				topic: "No newsletters sent.",
				description: "Once a newsletter is sent, it will appear here.",
			},
			quarantined: {
				topic: "No newsletters quarantined.",
				description: "Once a newsletter is quarantined, it will appear here.",
			},
		},
		rss: {
			all: {
				topic: "Create your first RSS campaign",
				description:
					"Automate your email marketing with our powerful email rss campaign builder.",
				detailsInList: [
					"Unlock the power of targeted RSS campaigns that drive results.",
					"Design professional-looking emails with ease using our intuitive drag-and-drop editor.",
					"Benefit from access to over 500,000 royalty-free stock photos.",
					"Measure success with detailed analytics, and click heatmap reports to optimise your campaigns.",
				],
				buttonName: "Create RSS campaigns",
				imageName: "newsletter.png",
				redirectPage: Routes.Campaign.RSS.New.Basic,
			},
			active: {
				topic: "No active RSS campaigns",
				description: "Once a rss execution is active, it will appear here.",
			},
			paused: {
				topic: "No paused RSS campaigns",
				description: "Once a rss execution is paused, it will appear here.",
			},
			draft: {
				topic: "No draft RSS campaigns",
				description: "Once a rss execution is saved as draft, it will appear here.",
			},
		},
		drip: {
			all: {
				topic: "Create your first drip campaign",
				description:
					"Automate your email marketing with our powerful email drip campaign builder.",
				detailsInList: [
					"Build custom email drip sequences.",
					"Segment your subscribers based on your specific requirements.",
					"Automatically tag subscribers based on their email engagement and website activity.",
					"Automate email campaigns based on subscriber actions and custom workflows.",
				],
				buttonName: "Create Drip",
				imageName: "drip.png",
				redirectPage: Routes.Campaign.Drip.New.Sender,
			},
			active: {
				topic: "No active drips",
				description: "Once a drip sequence is enabled, it will appear here.",
			},
			paused: {
				topic: "No paused drips",
				description: "Once a drip sequence is paused, it will appear here.",
			},
		},
		abSplit: {
			all: {
				topic: "Create your A/B split test",
				description:
					"Optimise your email strategy with A/B testing for newsletter campaigns.",
				detailsInList: [
					"Test different email subject lines, CTAs, and send times to find the most effective campaign.",
					"Find our what drives engagement faster by testing multiple elements simultaneously.",
					"View detailed reports with open rate, click rate, and heatmaps showing subscriber interactions.",
				],
				buttonName: "Create A/B split test",
				imageName: "absplit.png",
				redirectPage: Routes.Campaign.ABTest.New.Sender,
			},
			draft: {
				topic: "No draft split tests",
				description: "Once a draft split test is created, it will appear here.",
			},
			scheduled: {
				topic: "No scheduled split tests",
				description: "Once a split test is scheduled, it will be appear here.",
			},
			testing: {
				topic: "No split tests are currently underway.",
				description: "Once a split test is underway, it will be appear here.",
			},
			tested: {
				topic: "No split tests are tested.",
				description: "Once a split test is tested, it will be appear here.",
			},
			winnerScheduled: {
				topic: "No winners scheduled",
				description:
					"Once a winner has been identified and scheduled, it will appear here.",
			},
			winnerSending: {
				topic: "No winners currently being sent.",
				description: "Once a winner is sending, it will appear here.",
			},
			finished: {
				topic: "No winners sent.",
				description: "Once a winner is sent, it will appear here.",
			},
		},
		autoTrigger: {
			all: {
				topic: "Create your first auto trigger campaign",
				description:
					"Automate your marketing efforts with our robust auto-trigger campaign feature.",
				detailsInList: [
					"Create personalized email sequences triggered by user actions or events.",
					"Segment your audience based on behavior, demographics, or other criteria.",
					"Automatically engage subscribers based on their interactions with your website or emails.",
				],
				buttonName: "Create Auto Trigger",
				imageName: "autotrigger.png",
				redirectPage: Routes.Campaign.AutoTrigger.New.Sender,
			},
			active: {
				topic: "No active auto-triggers",
				description: "Once an auto-trigger is enabled, it will appear here.",
			},
			draft: {
				topic: "No draft auto-triggers",
				description:
					"Once a draft auto-trigger is created, it will appear here.",
			},
		},
	},
	audience: {
		contact: {
			all: {
				topic: "Create your first contact",
				description: "Group your contacts using lists, tags and segments",
				detailsInList: [
					"Add contacts manually, import them to lists or tags or use our API",
					"Use custom fields to your contacts",
					"Auto-merging of contacts based on email",
					"Auto-suppression of unsubscribed, bounced and marked spam contacts",
				],
				buttonName: "Create Contact",
				imageName: "contact.png",
			},
			unsubscribed: {
				topic: "No unsubscribed contacts",
				description: "Once a contact has unsubscribed, they will appear here.",
			},
			bounced: {
				topic: "No bounced contacts",
				description: "Once a contact has bounced, they will be appear here.",
			},
			markedSpam: {
				topic: "No contacts marked as spam",
				description: "Once a contact is marked as spam, they will appear here.",
			},
		},
		list: {
			all: {
				topic: "Create your first list",
				description: "Better manage your contacts using lists",
				detailsInList: [
					"Import contacts easily via CSV file to your lists",
					"Setup automated thankyou emails to go on list subscription",
					"Use double-optin lists to reduce bot subscription and spammers",
					"Trigger automations when contacts subscribe to a list",
				],
				buttonName: "Create List",
				imageName: "list.png",
			},
			contact: {
				topic: "No contacts found for this list",
				description:
					"This list is currently empty. Once contacts are added, they will appear here.",
			},
		},
		tag: {
			all: {
				topic: "Create your first tag",
				description:
					"Group your contacts based on activity or behaviour using tags",
				detailsInList: [
					"Import contacts easily via CSV file to your tags",
					"Use our API to add or remove tags to a contact",
					"Trigger automations when tags are being added or removed from a contact",
				],
				buttonName: "Create Tag",
				imageName: "tag.png",
			},
			contact: {
				topic: "No contacts found for this tag",
				description:
					"This tag is currently empty. Once contacts are added, they will appear here.",
			},
		},
		segment: {
			all: {
				topic: "Create your first segment",
				description:
					"Set of conditions to group contacts based on attributes or behaviour",
				detailsInList: [
					"Group your contacts based on email activity, custom field, tags or list membership & more ",
					"Better targeted groups for your campaigns",
					"Easily segregate active & inactive subscribers for better email performance",
				],
				buttonName: "Create Segment",
				imageName: "segment.png",
				redirectPage: Routes.Audience.Segment.New,
			},
		},
	},
	forms: {
		formData: {
			popup: {
				topic: "No popups found",
				description: "Once a popup is created, it will appear here.",
			},
			embedded: {
				topic: "No embedded forms found",
				description: "Once an embedded form is created, it will appear here.",
			},
			landing: {
				topic: "No landing pages",
				description: "Once a landing page is created, it will appear here.",
			},
		},
	},
	automation: {
		automationData: {
			all: {
				topic: "No automations found",
				description: "Once an automation is created, it will appear here.",
			},
		},
	},
	workflow: {
		workflowData: {
			all: {
				topic: "No workflows found",
				description: "Once a workflow is created, it will appear here.",
			},
		},
	},
	setting: {
		bulkAction: {
			all: {
				topic: "No bulk actions found",
				description: "Once a bulk action is created, it will appear here.",
			},
		},
		customField: {
			all: {
				topic: "No custom fields found",
				description: "Once a custom field is created, it will appear here.",
			},
		},
		customEvent: {
			all: {
				topic: "No custom events found",
				description: "Once a custom event is created, it will appear here.",
			},
		},
		customEventProperty: {
			all: {
				topic: "No property found",
				description: "Once a property is created, it will appear here.",
			},
		},
		senders: {
			all: {
				topic: "No senders found",
				description: "Once a sender is created, it will appear here.",
			},
		},
		members: {
			all: {
				topic: "No members found",
				description: "Once a member is added, it will appear here.",
			},
		},
		domains: {
			all: {
				topic: "No domains found",
				description: "Once a domain is added, it will appear here.",
			},
		},
		domainWhitelisting: {
			all: {
				topic: "No whitelisted domains found",
				description: "Once a domain is whitelisted, it will appear here.",
			},
		},
		emailTemplate: {
			all: {
				topic: "No email template found",
				description: "Once a email template is created, it will appear here.",
			},
		},
		landingPageTemplate: {
			all: {
				topic: "No landing page template found",
				description:
					"Once a landing page template is created, it will appear here.",
			},
		},
		feed: {
			all: {
				topic: "No feeds found",
				description: "Once a feed is created, it will appear here.",
			},
		},
	},
	tickets: {
		ticketsData: {
			all: {
				topic: "No tickets found",
				description: "Once a ticket is created, it will appear here.",
			},
		}
	},
	posts: {
		postsData: {
			all: {
				topic: "No blogs found",
				description: "Once a blog is created, it will appear here.",
			},
		},
	},
});

export const PopupFormDesign = {
	Title: [
		{
			label: "Text",
			type: "text",
			resource: "title",
		},
		{
			label: "Font Size",
			type: "range",
			unit: "px",
			resource: "TitleFontSize",
		},
		{
			label: "Font",
			type: "font-picker",
			resource: "TitleFont",
		},
		{
			label: "Font Color",
			type: "color-picker",
			resource: "HeaderTextColor",
		},
		{
			label: "Alignment",
			type: "alignment",
			resource: "TitleAlignment",
		},
	],
	Description: [
		{
			label: "Text",
			type: "text",
			resource: "description",
		},
		{
			label: "Font Size",
			type: "range",
			unit: "px",
			resource: "DescriptionFontSize",
		},
		{
			label: "Font",
			type: "font-picker",
			resource: "DescriptionFont",
		},
		{
			label: "Font Color",
			type: "color-picker",
			resource: "TextColor",
		},
		{
			label: "Alignment",
			type: "alignment",
			resource: "DescriptionAlignment",
		},
	],
	Button: [
		{
			label: "Text",
			type: "text",
			resource: "buttonText",
		},
		{
			label: "Font Size",
			type: "range",
			unit: "px",
			resource: "ButtonFontSize",
		},
		{
			label: "Font Color",
			type: "color-picker",
			resource: "ButtonTextColor",
		},
		{
			label: "Font",
			type: "font-picker",
			resource: "ButtonFont",
		},
		{
			label: "Button Color",
			type: "color-picker",
			resource: "ButtonColor",
		},
		{
			label: "Button Radius",
			type: "range",
			unit: "px",
			resource: "ButtonRadius",
		},
		{
			label: "Border Color",
			type: "color-picker",
			resource: "ButtonBorderColor",
		},
		{
			label: "Border Width",
			type: "range",
			unit: "px",
			resource: "ButtonBorderSize",
		},
		{
			label: "Top Bottom Padding",
			type: "range",
			unit: "px",
			resource: "ButtonPaddingTopBottom",
		},
		{
			label: "Left Right Padding",
			type: "range",
			unit: "px",
			resource: "ButtonPaddingLeftRight",
		},
		{
			label: "Alignment",
			type: "alignment",
			resource: "ButtonTextAlignment",
		},
	],
	"Close Text": [
		{
			label: "Text",
			type: "text",
			resource: "closeText",
		},
		{
			label: "Font Size",
			type: "range",
			unit: "px",
			resource: "CloseTextFontSize",
		},
		{
			label: "Font Color",
			type: "color-picker",
			resource: "CloseTextFontColor",
		},
		{
			label: "Font",
			type: "font-picker",
			resource: "CloseTextFont",
		},
	],
	"Post Action Title": [
		{
			label: "Text",
			type: "text",
			resource: "postActionTitle",
		},
		{
			label: "Title Color",
			type: "color-picker",
			resource: "PostActionTitleColor",
		},
		{
			label: "Font Size",
			type: "range",
			unit: "px",
			resource: "PostActionTitleFontSize",
		},
		{
			label: "Font",
			type: "font-picker",
			resource: "PostActionTitleFont",
		},
		{
			label: "Alignment",
			type: "alignment",
			resource: "PostActionTitleAlignment",
		},
	],
	"Post Action Description": [
		{
			label: "Text",
			type: "text",
			resource: "postActionDescription",
		},
		{
			label: "Description Color",
			type: "color-picker",
			resource: "PostActionDescriptionColor",
		},
		{
			label: "Font Size",
			type: "range",
			unit: "px",
			resource: "PostActionDescriptionFontSize",
		},
		{
			label: "Font",
			type: "font-picker",
			resource: "PostActionDescriptionFont",
		},
		{
			label: "Alignment",
			type: "alignment",
			resource: "PostActionDescriptionAlignment",
		},
	],
	Background: [
		{
			label: "Background Color",
			type: "color-picker",
			resource: "BackgroundColor",
		},
		{
			label: "Overlay Color",
			type: "color-picker",
			resource: "OverlayColor",
		},
		{
			label: "Opacity",
			type: "range",
			unit: "none",
			resource: "BackgroundOpacity",
			min: 0,
			max: 1,
			step: 0.01,
		},
	],
	"GDPR Checkbox": [
		{
			type: "gdpr-checkbox",
			label: "Enable GDPR Checkbox",
		},
		{
			label: "Font Size",
			type: "range",
			unit: "px",
			resource: "GdprFontSize",
		},
		{
			label: "Font Color",
			type: "color-picker",
			resource: "GdprTextColor",
		},
		{
			label: "Font",
			type: "font-picker",
			resource: "GdprFont",
		},
		{
			label: "Alignment",
			type: "alignment",
			resource: "GdprContentAlignment",
		},
	],
	Recaptcha: [
		{
			type: "recaptcha-checkbox",
			label: "Enable Recaptcha",
		},
	],
	"Add Image": [
		{
			type: "add-image",
			label: "Add Image",
		},
	],
	Fields: [
		{
			label: "Font Size",
			type: "range",
			unit: "px",
			resource: "FieldFontSize",
		},
		{
			label: "Font Color",
			type: "color-picker",
			resource: "FieldTextColor",
		},
		{
			label: "Field Color",
			type: "color-picker",
			resource: "FieldColor",
		},
		{
			label: "Field Radius",
			type: "range",
			unit: "px",
			resource: "FieldRadius",
		},
		{
			label: "Border Color",
			type: "color-picker",
			resource: "FieldBorderColor",
		},
		{
			label: "Border Width",
			type: "range",
			unit: "px",
			resource: "FieldBorderSize",
		},
		{
			label: "Top Bottom Padding",
			type: "range",
			unit: "px",
			resource: "FieldPaddingTopBottom",
		},
		{
			label: "Left Right Padding",
			type: "range",
			unit: "px",
			resource: "FieldPaddingLeftRight",
		},
		{
			label: "Alignment",
			type: "alignment",
			resource: "FieldTextAlignment",
		},
	],
	"Add Fields": [
		{
			type: "add-fields",
		},
	],
	"Add Custom CSS": [
		{
			label: "Add Custom CSS",
			type: "text",
			resource: "customCss",
		},
	],
};

export const fonts = [
	"ABeeZee",
	"Abel",
	"Abril Fatface",
	"Aclonica",
	"Acme",
	"Actor",
	"Adamina",
	"Advent Pro",
	"Aguafina Script",
	"Akronim",
	"Aladin",
	"Aldrich",
	"Alegreya",
	"Alegreya SC",
	"Alex Brush",
	"Alfa Slab One",
	"Alice",
	"Alike",
	"Alike Angular",
	"Allan",
	"Allerta",
	"Allerta Stencil",
	"Allura",
	"Almendra",
	"Almendra Display",
	"Almendra SC",
	"Amarante",
	"Amaranth",
	"Amatic SC",
	"Amethysta",
	"Anaheim",
	"Andada",
	"Andika",
	"Angkor",
	"Annie Use Your Telescope",
	"Anonymous Pro",
	"Antic",
	"Antic Didone",
	"Antic Slab",
	"Anton",
	"Arapey",
	"Arbutus",
	"Arbutus Slab",
	"Architects Daughter",
	"Archivo Black",
	"Archivo Narrow",
	"Arimo",
	"Arizonia",
	"Armata",
	"Artifika",
	"Arvo",
	"Asap",
	"Asset",
	"Astloch",
	"Asul",
	"Atomic Age",
	"Aubrey",
	"Audiowide",
	"Autour One",
	"Average",
	"Average Sans",
	"Averia Gruesa Libre",
	"Averia Libre",
	"Averia Sans Libre",
	"Averia Serif Libre",
	"Bad Script",
	"Balthazar",
	"Bangers",
	"Basic",
	"Battambang",
	"Baumans",
	"Bayon",
	"Belgrano",
	"Belleza",
	"BenchNine",
	"Bentham",
	"Berkshire Swash",
	"Bevan",
	"Bigelow Rules",
	"Bigshot One",
	"Bilbo",
	"Bilbo Swash Caps",
	"Bitter",
	"Black Ops One",
	"Bokor",
	"Bonbon",
	"Boogaloo",
	"Bowlby One",
	"Bowlby One SC",
	"Brawler",
	"Bree Serif",
	"Bubblegum Sans",
	"Bubbler One",
	"Buda",
	"Buenard",
	"Butcherman",
	"Butterfly Kids",
	"Cabin",
	"Cabin Condensed",
	"Cabin Sketch",
	"Caesar Dressing",
	"Cagliostro",
	"Calligraffitti",
	"Cambo",
	"Candal",
	"Cantarell",
	"Cantata One",
	"Cantora One",
	"Capriola",
	"Cardo",
	"Carme",
	"Carrois Gothic",
	"Carrois Gothic SC",
	"Carter One",
	"Caudex",
	"Cedarville Cursive",
	"Ceviche One",
	"Changa One",
	"Chango",
	"Chau Philomene One",
	"Chela One",
	"Chelsea Market",
	"Chenla",
	"Cherry Cream Soda",
	"Cherry Swash",
	"Chewy",
	"Chicle",
	"Chivo",
	"Cinzel",
	"Cinzel Decorative",
	"Clicker Script",
	"Coda",
	"Coda Caption",
	"Codystar",
	"Combo",
	"Comfortaa",
	"Coming Soon",
	"Concert One",
	"Condiment",
	"Content",
	"Contrail One",
	"Convergence",
	"Cookie",
	"Copse",
	"Corben",
	"Courgette",
	"Cousine",
	"Coustard",
	"Covered By Your Grace",
	"Crafty Girls",
	"Creepster",
	"Crete Round",
	"Crimson Text",
	"Croissant One",
	"Crushed",
	"Cuprum",
	"Cutive",
	"Cutive Mono",
	"Damion",
	"Dancing Script",
	"Dangrek",
	"Dawning of a New Day",
	"Days One",
	"Delius",
	"Delius Swash Caps",
	"Delius Unicase",
	"Della Respira",
	"Devonshire",
	"Didact Gothic",
	"Diplomata",
	"Diplomata SC",
	"Doppio One",
	"Dorsa",
	"Dosis",
	"Dr Sugiyama",
	"Droid Sans",
	"Droid Sans Mono",
	"Droid Serif",
	"Duru Sans",
	"Dynalight",
	"EB Garamond",
	"Eagle Lake",
	"Eater",
	"Economica",
	"Electrolize",
	"Emblema One",
	"Emilys Candy",
	"Engagement",
	"Englebert",
	"Enriqueta",
	"Erica One",
	"Esteban",
	"Euphoria Script",
	"Ewert",
	"Exo",
	"Expletus Sans",
	"Fanwood Text",
	"Fascinate",
	"Fascinate Inline",
	"Faster One",
	"Fasthand",
	"Federant",
	"Federo",
	"Felipa",
	"Fenix",
	"Finger Paint",
	"Fjord One",
	"Flamenco",
	"Flavors",
	"Fondamento",
	"Fontdiner Swanky",
	"Forum",
	"Francois One",
	"Freckle Face",
	"Fredericka the Great",
	"Fredoka One",
	"Freehand",
	"Fresca",
	"Frijole",
	"Fugaz One",
	"GFS Didot",
	"GFS Neohellenic",
	"Gafata",
	"Galdeano",
	"Galindo",
	"Gentium Basic",
	"Gentium Book Basic",
	"Geo",
	"Geostar",
	"Geostar Fill",
	"Germania One",
	"Gilda Display",
	"Give You Glory",
	"Glass Antiqua",
	"Glegoo",
	"Gloria Hallelujah",
	"Goblin One",
	"Gochi Hand",
	"Gorditas",
	"Goudy Bookletter 1911",
	"Graduate",
	"Gravitas One",
	"Great Vibes",
	"Griffy",
	"Gruppo",
	"Gudea",
	"Habibi",
	"Hammersmith One",
	"Hanalei",
	"Hanalei Fill",
	"Handlee",
	"Hanuman",
	"Happy Monkey",
	"Headland One",
	"Henny Penny",
	"Herr Von Muellerhoff",
	"Holtwood One SC",
	"Homemade Apple",
	"Homenaje",
	"IM Fell DW Pica",
	"IM Fell DW Pica SC",
	"IM Fell Double Pica",
	"IM Fell Double Pica SC",
	"IM Fell English",
	"IM Fell English SC",
	"IM Fell French Canon",
	"IM Fell French Canon SC",
	"IM Fell Great Primer",
	"IM Fell Great Primer SC",
	"Iceberg",
	"Iceland",
	"Imprima",
	"Inconsolata",
	"Inder",
	"Indie Flower",
	"Inika",
	"Irish Grover",
	"Istok Web",
	"Italiana",
	"Italianno",
	"Jacques Francois",
	"Jacques Francois Shadow",
	"Jim Nightshade",
	"Jockey One",
	"Jolly Lodger",
	"Josefin Sans",
	"Josefin Slab",
	"Joti One",
	"Judson",
	"Julee",
	"Julius Sans One",
	"Junge",
	"Jura",
	"Just Another Hand",
	"Just Me Again Down Here",
	"Kameron",
	"Karla",
	"Kaushan Script",
	"Keania One",
	"Kelly Slab",
	"Kenia",
	"Khmer",
	"Kite One",
	"Knewave",
	"Kotta One",
	"Koulen",
	"Kranky",
	"Kreon",
	"Kristi",
	"Krona One",
	"La Belle Aurore",
	"Lancelot",
	"Lato",
	"League Script",
	"Leckerli One",
	"Ledger",
	"Lekton",
	"Lemon",
	"Life Savers",
	"Lilita One",
	"Limelight",
	"Linden Hill",
	"Lobster",
	"Lobster Two",
	"Londrina Outline",
	"Londrina Shadow",
	"Londrina Sketch",
	"Londrina Solid",
	"Lora",
	"Love Ya Like A Sister",
	"Loved by the King",
	"Lovers Quarrel",
	"Luckiest Guy",
	"Lusitana",
	"Lustria",
	"Macondo",
	"Macondo Swash Caps",
	"Magra",
	"Maiden Orange",
	"Mako",
	"Marcellus",
	"Marcellus SC",
	"Marck Script",
	"Margarine",
	"Marko One",
	"Marmelad",
	"Marvel",
	"Mate",
	"Mate SC",
	"Maven Pro",
	"McLaren",
	"Meddon",
	"MedievalSharp",
	"Medula One",
	"Megrim",
	"Meie Script",
	"Merienda",
	"Merienda One",
	"Merriweather",
	"Metal",
	"Metal Mania",
	"Metamorphous",
	"Metrophobic",
	"Michroma",
	"Miltonian",
	"Miltonian Tattoo",
	"Miniver",
	"Miss Fajardose",
	"Modern Antiqua",
	"Molengo",
	"Molle",
	"Monofett",
	"Monoton",
	"Monsieur La Doulaise",
	"Montaga",
	"Montez",
	"Montserrat",
	"Montserrat Alternates",
	"Montserrat Subrayada",
	"Moul",
	"Moulpali",
	"Mountains of Christmas",
	"Mouse Memoirs",
	"Mr Bedfort",
	"Mr Dafoe",
	"Mr De Haviland",
	"Mrs Saint Delafield",
	"Mrs Sheppards",
	"Muli",
	"Mystery Quest",
	"Neucha",
	"Neuton",
	"News Cycle",
	"Niconne",
	"Nixie One",
	"Nobile",
	"Nokora",
	"Norican",
	"Nosifer",
	"Nothing You Could Do",
	"Noticia Text",
	"Nova Cut",
	"Nova Flat",
	"Nova Mono",
	"Nova Oval",
	"Nova Round",
	"Nova Script",
	"Nova Slim",
	"Nova Square",
	"Numans",
	"Nunito",
	"Odor Mean Chey",
	"Offside",
	"Old Standard TT",
	"Oldenburg",
	"Oleo Script",
	"Oleo Script Swash Caps",
	"Open Sans",
	"Open Sans Condensed",
	"Oranienbaum",
	"Orbitron",
	"Oregano",
	"Orienta",
	"Original Surfer",
	"Oswald",
	"Over the Rainbow",
	"Overlock",
	"Overlock SC",
	"Ovo",
	"Oxygen",
	"Oxygen Mono",
	"PT Mono",
	"PT Sans",
	"PT Sans Caption",
	"PT Sans Narrow",
	"PT Serif",
	"PT Serif Caption",
	"Pacifico",
	"Paprika",
	"Parisienne",
	"Passero One",
	"Passion One",
	"Patrick Hand",
	"Patua One",
	"Paytone One",
	"Peralta",
	"Permanent Marker",
	"Petit Formal Script",
	"Petrona",
	"Philosopher",
	"Piedra",
	"Pinyon Script",
	"Pirata One",
	"Plaster",
	"Play",
	"Playball",
	"Playfair Display",
	"Playfair Display SC",
	"Podkova",
	"Poiret One",
	"Poller One",
	"Poly",
	"Pompiere",
	"Pontano Sans",
	"Port Lligat Sans",
	"Port Lligat Slab",
	"Prata",
	"Preahvihear",
	"Press Start 2P",
	"Princess Sofia",
	"Prociono",
	"Prosto One",
	"Puritan",
	"Purple Purse",
	"Quando",
	"Quantico",
	"Quattrocento",
	"Quattrocento Sans",
	"Questrial",
	"Quicksand",
	"Quintessential",
	"Qwigley",
	"Racing Sans One",
	"Radley",
	"Raleway",
	"Raleway Dots",
	"Rambla",
	"Rammetto One",
	"Ranchers",
	"Rancho",
	"Rationale",
	"Redressed",
	"Reenie Beanie",
	"Revalia",
	"Ribeye",
	"Ribeye Marrow",
	"Righteous",
	"Risque",
	"Rochester",
	"Rock Salt",
	"Rokkitt",
	"Romanesco",
	"Ropa Sans",
	"Rosario",
	"Rosarivo",
	"Rouge Script",
	"Ruda",
	"Rufina",
	"Ruge Boogie",
	"Ruluko",
	"Rum Raisin",
	"Ruslan Display",
	"Russo One",
	"Ruthie",
	"Rye",
	"Sacramento",
	"Sail",
	"Salsa",
	"Sanchez",
	"Sancreek",
	"Sansita One",
	"Sarina",
	"Satisfy",
	"Scada",
	"Schoolbell",
	"Seaweed Script",
	"Sevillana",
	"Seymour One",
	"Shadows Into Light",
	"Shadows Into Light Two",
	"Shanti",
	"Share",
	"Share Tech",
	"Share Tech Mono",
	"Shojumaru",
	"Short Stack",
	"Siemreap",
	"Sigmar One",
	"Signika",
	"Signika Negative",
	"Simonetta",
	"Sirin Stencil",
	"Six Caps",
	"Skranji",
	"Slackey",
	"Smokum",
	"Smythe",
	"Sniglet",
	"Snippet",
	"Snowburst One",
	"Sofadi One",
	"Sofia",
	"Sonsie One",
	"Sorts Mill Goudy",
	"Source Code Pro",
	"Source Sans Pro",
	"Special Elite",
	"Spicy Rice",
	"Spinnaker",
	"Spirax",
	"Squada One",
	"Stalemate",
	"Stalinist One",
	"Stardos Stencil",
	"Stint Ultra Condensed",
	"Stint Ultra Expanded",
	"Stoke",
	"Strait",
	"Sue Ellen Francisco",
	"Sunshiney",
	"Supermercado One",
	"Suwannaphum",
	"Swanky and Moo Moo",
	"Syncopate",
	"Tangerine",
	"Taprom",
	"Telex",
	"Tenor Sans",
	"Text Me One",
	"The Girl Next Door",
	"Tienne",
	"Tinos",
	"Titan One",
	"Titillium Web",
	"Trade Winds",
	"Trocchi",
	"Trochut",
	"Trykker",
	"Tulpen One",
	"Ubuntu",
	"Ubuntu Condensed",
	"Ubuntu Mono",
	"Ultra",
	"Uncial Antiqua",
	"Underdog",
	"Unica One",
	"UnifrakturCook",
	"UnifrakturMaguntia",
	"Unkempt",
	"Unlock",
	"Unna",
	"VT323",
	"Vampiro One",
	"Varela",
	"Varela Round",
	"Vast Shadow",
	"Vibur",
	"Vidaloka",
	"Viga",
	"Voces",
	"Volkhov",
	"Vollkorn",
	"Voltaire",
	"Waiting for the Sunrise",
	"Wallpoet",
	"Walter Turncoat",
	"Warnes",
	"Wellfleet",
	"Wire One",
	"Yanone Kaffeesatz",
	"Yellowtail",
	"Yeseva One",
	"Yesteryear",
	"Zeyada",
];

export const Segment = Object.freeze({
	//options
	Option: {
		LISTS: -1,
		TAGS: -2,
		CAMPAIGNS: -3,
		DRIPSTEP: -4,
		DRIP: -5,
		SHOPIFY_PRODUCT: -6,
		SHOPIFY_COUPON: -7,
		SHOPIFY_SMART_COLLECTION: -8,
		SHOPIFY_CUSTOM_COLLECTION: -9,
		EMAIL: -10,
		WORKFLOWS: -11,
	},

	// input
	Input: {
		TEXT: -1,
		CHECKBOX: -2,
		SELECT: -3,
		RADIO: -4,
	},

	// type
	Type: {
		INTEGER: -1,
		STRING: -2,
		BOOLEAN: -3,
		DATE: -4,
		DOUBLE: -5,
	},
});

export const CUSTOM_FIELD_DEFAULT_TYPES = {
	EMAIL: -1,
	FIRST_NAME: -2,
	LAST_NAME: -3,
	COMPANY: -5,
};

export const FORM_FIELD_TYPES = {
	INPUT: 0,
	DROPDOWN: 2,
	CHECKBOX: 3,
};

export const PLACEHOLDER_VALUE_FOR_CHECKBOX = -6;

export const PLACEHOLDER_VALUE_FOR_DROPDOWN = -7;

export const RSSTags = [
	{ key: "{{ .PostTitle }}", value: "title" },
	{ key: "{{ .PostAuthor }}", value: "author" },
	{ key: "{{ .PostDate }}", value: "published, pubDate" },
	{ key: "{{ .PostLink }}", value: "link" },
	{ key: "{{ .PostDescription }}", value: "description" },
	{ key: "{{ .PostContent }}", value: "content" },
	{
		key: "{{ .PostDescriptionOrContent }}",
		value: ".PostDescription or .PostContent, whichever is present, description first",
	},
	{
		key: "{{ .PostContentOrDescription }}",
		value: ".PostContent or .PostDescription, whichever is present, content first",
	},
];
export const CAMPAIGN_TABLE_HEADERS = [
	{
		label: "Name",
		key: "name",
	},
	{
		label: "Sent",
		key: "sent",
	},
	{
		label: "Opened",
		key: "opened",
	},
	{
		label: "% Opened",
		key: "percent_opened",
	},
	{
		label: "Clicked",
		key: "clicked",
	},
	{
		label: "% Clicked",
		key: "percent_clicked",
	},
];

export const TICKET_TABLE_HEADERS = [
	{
		label: "Name",
		key: "name",
	},
	{
		label: "Status",
		key: "status",
	},
	{
		label: "Created",
		key: "created",
	},
	{
		label: "Updated",
		key: "updated",
	},
];

export const DRIP_TABLE_HEADERS = [
	{
		label: "Name",
		key: "name",
	},
	{
		label: "Active",
		key: "active",
	},
	{
		label: "Drip Steps",
		key: "steps",
	},
	{
		label: "Starts on Automation Trigger",
		key: "automation_trigger",
	},

	{
		label: "Date Created (UTC)",
		key: "created",
	},
	{
		label: "Date Updated (UTC)",
		key: "updated",
	},
];

export const ABTEST_TABLE_HEADERS = [
	{
		label: "Name",
		key: "name",
	},
	{
		label: "Sent",
		key: "sent",
	},
	{
		label: "Opened",
		key: "opened",
	},
	{
		label: "% Opened",
		key: "percent_opened",
	},
	{
		label: "Clicked",
		key: "clicked",
	},
	{
		label: "% Clicked",
		key: "percent_clicked",
	},
];

export const AUTO_TRIGGER_TABLE_HEADERS = [
	{
		label: "Name",
		key: "name",
	},
	{
		label: "Starts on Automation Trigger",
		key: "automation_trigger",
	},
	{
		label: "Sent",
		key: "sent",
	},
	{
		label: "Opened",
		key: "opened",
	},
	{
		label: "% Opened",
		key: "percent_opened",
	},
	{
		label: "Clicked",
		key: "clicked",
	},
	{
		label: "% Clicked",
		key: "percent_clicked",
	},
	{
		label: "Revenue Attributed",
		key: "revenue_attributed",
	},
	{
		label: "Revenue Per Recipient",
		key: "revenue_per_recipient",
	},
];

export const TAGS_TABLE_HEADERS = [
	{
		label: "Name",
		key: "name",
	},
	{
		label: "Size",
		key: "size",
	},
	{
		label: "Revenue",
		key: "totalRevenue",
	},
	{
		label: "Revenue Per Contact",
		key: "revenuePerContact",
	},
	{
		label: "Date Created",
		key: "created",
	},
	{
		label: "Date Updated",
		key: "updated",
	},
];

export const LISTS_TABLE_HEADERS = [
	{
		label: "Name",
		key: "name",
	},
	{
		label: "Opt In Type",
		key: "type",
	},
	{
		label: "Size",
		key: "size",
	},

	{
		label: "Date Created",
		key: "created",
	},
	{
		label: "Date Updated",
		key: "updated",
	},
];

export const CONTACT_TABLE_HEADERS = [
	{
		label: "Name",
		key: "name",
	},
	{
		label: "Email",
		key: "email",
	},
	{
		label: "Date Created",
		key: "created",
	},
	{
		label: "Date Updated",
		key: "updated",
	},
];

export const SEGMENT_INFO_TABLE_HEADERS = [
	{
		label: "Name",
		key: "name",
	},
	{
		label: "Email",
		key: "email",
	},
	{
		label: "Created",
		key: "created",
	},
	{
		label: "Updated",
		key: "updated",
	},
];

export const POPUP_TABLE_HEADER = [
	{
		label: "Name",
		key: "name",
	},
	{
		label: "Views",
		key: "impressions",
	},
	{
		label: "Action Completed",
		key: "action_completed",
	},
	{
		label: "Conversion Rate",
		key: "conversion_rate",
	},
	{
		label: "Status",
		key: "status",
	},
];


export const POST_TABLE_HEADER = [
	{
		label: "Name",
		key: "name",
	},
	{
		label: "Created",
		key: "created",
	},
	{
		label: "Updated",
		key: "updated",
	},
	{
		label: "Status",
		key: "status",
	},
];

export const EMBED_TABLE_HEADER = [
	{
		label: "Name",
		key: "name",
	},
	{
		label: "Views",
		key: "impressions",
	},
	{
		label: "Action Completed",
		key: "action_completed",
	},
	{
		label: "Conversion Rate",
		key: "conversion_rate",
	},
	{
		label: "Status",
		key: "status",
	},
];

export const LANDING_PAGE_TABLE_HEADERS = [
	{
		label: "Name",
		key: "name",
	},
	{
		label: "Views",
		key: "impressions",
	},
	{
		label: "Submissions",
		key: "action_completed",
	},
	{
		label: "Submission Rate",
		key: "submission_rate",
	},
];

export const WORKFLOWS_TABLE_HEADERS = [
	{
		label: "Name",
		key: "name",
	},
	{
		label: "Active",
		key: "status",
	},
	{
		label: "Enrolled",
		key: "enrolled",
	},
	{
		label: "Active",
		key: "active",
	},
	{
		label: "Exited",
		key: "exited",
	},
	{
		label: "Completed",
		key: "completed",
	},
	{
		label: "Date Created",
		key: "created",
	},
	{
		label: "Date Updated",
		key: "updated",
	},
];

export const WorkflowsTriggerOptionsData = {
	1: [
		{
			id: 0,
			name: "Subscribed to a list",
			type: "list",
			message: "When a contact is subscribed to a list",
		},
		{
			id: 2,
			name: "Confirmed to a list",
			type: "list",
			message: "When a contact is confirmed to a list",
		},
		{
			id: 13,
			name: "Removed from list",
			type: "list",
			message: "When a contact is removed from a list",
		},
		{
			id: 3,
			name: "Tag added",
			type: "tag",
			message: "When a contact is added to a tag",
		},
		{
			id: 4,
			name: "Tag removed",
			type: "tag",
			message: "When a contact is removed form a tag",
		},
		{
			id: 47,
			name: "Custom event added",
			type: "customEvent",
			message: "When a contact is added, a custom event : ",
		},
		{
			id: 5,
			name: "Opened newsletter campaign",
			type: "campaign",
			message: "When a contact opens a newsletter campaign",
		},
		{
			id: 6,
			name: "Clicked a link in newsletter or auto-trigger campaign",
			type: "text",
			message:
				"When a contact clicks a link in a newsletter or auto-trigger campaign",
		},
		{
			id: 7,
			name: "Added to a drip campaign",
			type: "drip",
			message: "When a contact is added to a drip campaign",
		},
		{
			id: 8,
			name: "Opened a drip campaign",
			type: "drip",
			message: "When a contact opens a drip campaign",
		},
		{
			id: 9,
			name: "Clicked a link in drip",
			type: "text",
			message: "When a contact clicks a link in a drip campaign",
		},
		{
			id: 10,
			name: "Completed a drip campaign",
			type: "drip",
			message: "When a contact completes a drip campaign",
		},
		{
			id: 12,
			name: "Replied to a drip campaign",
			type: "drip",
			message: "When a contact replies to a drip campaign",
		},
		{
			id: 14,
			name: "Contact added via popup form",
			type: "popup",
			message: "When a contact is added via popup form",
		},
		{
			id: 15,
			name: "Contact added via embedded form",
			type: "embed",
			message: "When a contact is added via embedded form",
		},
		{
			id: 18,
			name: "Contact added via landing page form",
			type: "landing",
			message: "When a contact is added via landing page form",
		},
		{
			id: 16,
			name: "Added to a segment",
			type: "segment",
			message: "When a contact is added to a segment",
		},
		{
			id: 17,
			name: "Removed from a segment",
			type: "segment",
			message: "When a contact is removed from a segment",
		},
		{
			id: 20,
			name: "Contact visited page",
			type: "text",
			message: "When a contact visits a page",
		},
		{
			id: 21,
			name: "Unsubscribe Contact",
			message: "When a contact unsubscribes",
		},
	],
	2: [
		{
			id: 25,
			name: "New customer created",
			type: "customer",
			message: "When a new customer is created via WooCommerce",
		},
		{
			id: 24,
			name: "Placed order",
			type: "order",
			message: "When an order is placed via WooCommerce",
		},
	],
	3: [
		{
			id: 23,
			name: "Placed order",
			type: "order",
			message: "When an order is placed via SamCart",
		},
	],
	4: [
		{
			id: 27,
			name: "New customer created",
			type: "customer",
			message: "When a Stripe charge is refunded for a customer",
		},
		{
			id: 28,
			name: "Customer charge succeeded",
			type: "charge",
			message: "When a Stripe charge succeeds for a customer",
		},
		{
			id: 29,
			name: "Customer charge failed",
			type: "charge",
			message: "When a Stripe charge fails for a customer",
		},
		{
			id: 30,
			name: "Customer charge refunded",
			type: "charge",
			message: "When a Stripe charge is refunded for a customer",
		},
	],
	5: [
		{
			id: 31,
			name: "Customer charge succeeded",
			type: "charge",
			message: "When a Paypal charge is refunded for a customer",
		},
		{
			id: 32,
			name: "Customer charge failed",
			type: "charge",
			message: "When a Paypal charge succeeds for a customer",
		},
		{
			id: 33,
			name: "Customer charge declined",
			type: "charge",
			message: "When a Paypal charge declined for a customer",
		},
		{
			id: 34,
			name: "Customer charge refunded",
			type: "charge",
			message: "When a Paypal charge is refunded for a customer",
		},
	],
	6: [
		{
			id: 22,
			name: "Submitted via landing page",
			type: "form",
			message: "When a form is submitted via Instapage landing page",
		},
	],
	7: [
		{
			id: 35,
			name: "Intercom lead created",
			type: "lead",
			message: "When a lead is created via Intercom",
		},
		{
			id: 36,
			name: "Intercom user created",
			type: "user",
			message: "When a user is created via Intercom",
		},
	],
	9: [
		{
			id: 44,
			name: "Submitted via form",
			type: "form",
			message: "When a form is submitted via Convert Box form",
		},
	],
	12: [
		{
			id: 37,
			name: "Cart abandoned",
			type: "cart",
			message: "When a Shopify cart is abandoned",
		},
		{
			id: 38,
			name: "New customer",
			type: "customer",
			message: "When a Shopify customer is created",
		},
		{
			id: 41,
			name: "Placed order",
			type: "order",
			message: "When a Shopify order is placed",
		},
		{
			id: 40,
			name: "Cancelled order",
			type: "order",
			message: "When a Shopify order is cancelled",
		},
		{
			id: 42,
			name: "Fulfilled order",
			type: "order",
			message: "When a Shopify order is fulfilled",
		},
	],
};

export const WorkflowsExitTriggerOptionData = {
	1: [
		{
			id: 0,
			name: "Subscribed to a list",
			type: "list",
			message: "When a contact is subscribed to a list",
		},
		{
			id: 2,
			name: "Confirmed to a list",
			type: "list",
			message: "When a contact is confirmed to a list",
		},
		{
			id: 13,
			name: "Removed from list",
			type: "list",
			message: "When a contact is removed from a list",
		},
		{
			id: 3,
			name: "Tag added",
			type: "tag",
			message: "When a contact is added to a tag",
		},
		{
			id: 4,
			name: "Tag removed",
			type: "tag",
			message: "When a contact is removed form a tag",
		},
		{
			id: 5,
			name: "Opened newsletter campaign",
			type: "campaign",
			message: "When a contact opens a newsletter campaign",
		},
		{
			id: 6,
			name: "Clicked a link in newsletter or auto-trigger campaign",
			type: "text",
			message:
				"When a contact clicks a link in a newsletter or auto-trigger campaign",
		},
		{
			id: 7,
			name: "Added to a drip campaign",
			type: "drip",
			message: "When a contact is added to a drip campaign",
		},
		{
			id: 8,
			name: "Opened a drip campaign",
			type: "drip",
			message: "When a contact opens a drip campaign",
		},
		{
			id: 9,
			name: "Clicked a link in drip",
			type: "text",
			message: "When a contact clicks a link in a drip campaign",
		},
		{
			id: 10,
			name: "Completed a drip campaign",
			type: "drip",
			message: "When a contact completes a drip campaign",
		},
		{
			id: 12,
			name: "Replied to a drip campaign",
			type: "drip",
			message: "When a contact replies to a drip campaign",
		},
		{
			id: 14,
			name: "Contact added via popup form",
			type: "popup",
			message: "When a contact is added via popup form",
		},
		{
			id: 15,
			name: "Contact added via embedded form",
			type: "embed",
			message: "When a contact is added via embedded form",
		},
		{
			id: 18,
			name: "Contact added via landing page form",
			type: "landing",
			message: "When a contact is added via landing page form",
		},
		// {
		//   id: 16,
		//   name: "Added to a segment",
		//   type: "segment",
		//   message: "When a contact is added to a segment",
		// },
		// {
		//   id: 17,
		//   name: "Removed from a segment",
		//   type: "segment",
		//   message: "When a contact is removed from a segment",
		// },
		{
			id: 20,
			name: "Contact visited page",
			type: "text",
			message: "When a contact visits a page",
		},
		{
			id: 21,
			name: "Unsubscribe Contact",
			message: "When a contact unsubscribes",
		},
	],
	2: [
		{
			id: 25,
			name: "New customer created",
			type: "customer",
			message: "When a new customer is created via WooCommerce",
		},
		{
			id: 24,
			name: "Placed order",
			type: "order",
			message: "When an order is placed via WooCommerce",
		},
	],
	3: [
		{
			id: 23,
			name: "Placed order",
			type: "order",
			message: "When an order is placed via SamCart",
		},
	],
	4: [
		{
			id: 27,
			name: "New customer created",
			type: "customer",
			message: "When a Stripe charge is refunded for a customer",
		},
		{
			id: 28,
			name: "Customer charge succeeded",
			type: "charge",
			message: "When a Stripe charge succeeds for a customer",
		},
		{
			id: 29,
			name: "Customer charge failed",
			type: "charge",
			message: "When a Stripe charge fails for a customer",
		},
		{
			id: 30,
			name: "Customer charge refunded",
			type: "charge",
			message: "When a Stripe charge is refunded for a customer",
		},
	],
	5: [
		{
			id: 31,
			name: "Customer charge succeeded",
			type: "charge",
			message: "When a Paypal charge is refunded for a customer",
		},
		{
			id: 32,
			name: "Customer charge failed",
			type: "charge",
			message: "When a Paypal charge succeeds for a customer",
		},
		{
			id: 33,
			name: "Customer charge declined",
			type: "charge",
			message: "When a Paypal charge declined for a customer",
		},
		{
			id: 34,
			name: "Customer charge refunded",
			type: "charge",
			message: "When a Paypal charge is refunded for a customer",
		},
	],
	6: [
		{
			id: 22,
			name: "Submitted via landing page",
			type: "form",
			message: "When a form is submitted via Instapage landing page",
		},
	],
	7: [
		{
			id: 35,
			name: "Intercom lead created",
			type: "lead",
			message: "When a lead is created via Intercom",
		},
		{
			id: 36,
			name: "Intercom user created",
			type: "user",
			message: "When a user is created via Intercom",
		},
	],
	12: [
		{
			id: 37,
			name: "Cart abandoned",
			type: "cart",
			message: "When a Shopify cart is abandoned",
		},
		{
			id: 38,
			name: "New customer",
			type: "customer",
			message: "When a Shopify customer is created",
		},
		{
			id: 41,
			name: "Placed order",
			type: "order",
			message: "When a Shopify order is placed",
		},
		{
			id: 40,
			name: "Cancelled order",
			type: "order",
			message: "When a Shopify order is cancelled",
		},
		{
			id: 42,
			name: "Fulfilled order",
			type: "order",
			message: "When a Shopify order is fulfilled",
		},
	],
	9: [
		{
			id: 44,
			name: "Submitted via form",
			type: "form",
			message: "When a form is submitted via Convert Box form",
		},
	],
};

export const WorkflowsTriggerFiltersOptionData = {
	1: [
		{
			id: 0,
			name: "Subscribed to a list",
			type: "list",
			message: "When a contact is subscribed to a list",
		},
		{
			id: 2,
			name: "Confirmed to a list",
			type: "list",
			message: "When a contact is confirmed to a list",
		},
		{
			id: 13,
			name: "Removed from list",
			type: "list",
			message: "When a contact is removed from a list",
		},
		{
			id: 3,
			name: "Tag added",
			type: "tag",
			message: "When a contact is added to a tag",
		},
		{
			id: 4,
			name: "Tag removed",
			type: "tag",
			message: "When a contact is removed form a tag",
		},
		{
			id: 5,
			name: "Opened newsletter campaign",
			type: "campaign",
			message: "When a contact opens a newsletter campaign",
		},
		{
			id: 6,
			name: "Clicked a link in newsletter or auto-trigger campaign",
			type: "text",
			message:
				"When a contact clicks a link in a newsletter or auto-trigger campaign",
		},
		{
			id: 7,
			name: "Added to a drip campaign",
			type: "drip",
			message: "When a contact is added to a drip campaign",
		},
		{
			id: 8,
			name: "Opened a drip campaign",
			type: "drip",
			message: "When a contact opens a drip campaign",
		},
		{
			id: 9,
			name: "Clicked a link in drip",
			type: "text",
			message: "When a contact clicks a link in a drip campaign",
		},
		{
			id: 10,
			name: "Completed a drip campaign",
			type: "drip",
			message: "When a contact completes a drip campaign",
		},
		{
			id: 12,
			name: "Replied to a drip campaign",
			type: "drip",
			message: "When a contact replies to a drip campaign",
		},
		{
			id: 14,
			name: "Contact added via popup form",
			type: "popup",
			message: "When a contact is added via popup form",
		},
		{
			id: 15,
			name: "Contact added via embedded form",
			type: "form",
			message: "When a contact is added via embedded form",
		},
		{
			id: 18,
			name: "Contact added via landing page form",
			type: "landing_page",
			message: "When a contact is added via landing page form",
		},
		// {
		//   id: 16,
		//   name: "Added to a segment",
		//   type: "segment",
		//   message: "When a contact is added to a segment",
		// },
		// {
		//   id: 17,
		//   name: "Removed from a segment",
		//   type: "segment",
		//   message: "When a contact is removed from a segment",
		// },
		{
			id: 20,
			name: "Contact visited page",
			type: "text",
			message: "When a contact visits a page",
		},
		{
			id: 21,
			name: "Unsubscribe Contact",
			message: "When a contact unsubscribes",
		},
	],
	2: [
		{
			id: 25,
			name: "New customer created",
			type: "customer",
			message: "When a new customer is created via WooCommerce",
		},
		{
			id: 24,
			name: "Placed order",
			type: "order",
			message: "When an order is placed via WooCommerce",
		},
	],
	3: [
		{
			id: 23,
			name: "Placed order",
			type: "order",
			message: "When an order is placed via SamCart",
		},
	],
	4: [
		{
			id: 27,
			name: "New customer created",
			type: "customer",
			message: "When a Stripe charge is refunded for a customer",
		},
		{
			id: 28,
			name: "Customer charge succeeded",
			type: "charge",
			message: "When a Stripe charge succeeds for a customer",
		},
		{
			id: 29,
			name: "Customer charge failed",
			type: "charge",
			message: "When a Stripe charge fails for a customer",
		},
		{
			id: 30,
			name: "Customer charge refunded",
			type: "charge",
			message: "When a Stripe charge is refunded for a customer",
		},
	],
	5: [
		{
			id: 31,
			name: "Customer charge succeeded",
			type: "charge",
			message: "When a Paypal charge is refunded for a customer",
		},
		{
			id: 32,
			name: "Customer charge failed",
			type: "charge",
			message: "When a Paypal charge succeeds for a customer",
		},
		{
			id: 33,
			name: "Customer charge declined",
			type: "charge",
			message: "When a Paypal charge declined for a customer",
		},
		{
			id: 34,
			name: "Customer charge refunded",
			type: "charge",
			message: "When a Paypal charge is refunded for a customer",
		},
	],
	6: [
		{
			id: 22,
			name: "Submitted via landing page",
			type: "form",
			message: "When a form is submitted via Instapage landing page",
		},
	],
	7: [
		{
			id: 35,
			name: "Intercom lead created",
			type: "lead",
			message: "When a lead is created via Intercom",
		},
		{
			id: 36,
			name: "Intercom user created",
			type: "user",
			message: "When a user is created via Intercom",
		},
	],
	12: [
		{
			id: 37,
			name: "Cart abandoned",
			type: "cart",
			message: "When a Shopify cart is abandoned",
		},
		{
			id: 38,
			name: "New customer",
			type: "customer",
			message: "When a Shopify customer is created",
		},
		{
			id: 41,
			name: "Placed order",
			type: "order",
			message: "When a Shopify order is placed",
		},
		{
			id: 40,
			name: "Cancelled order",
			type: "order",
			message: "When a Shopify order is cancelled",
		},
		{
			id: 42,
			name: "Fulfilled order",
			type: "order",
			message: "When a Shopify order is fulfilled",
		},
	],
	9: [
		{
			id: 44,
			name: "Submitted via form",
			type: "form",
			message: "When a form is submitted via Convert Box form",
		},
	],
};

export const WorkflowsActionOptionsData = Object.freeze({
	1: [
		{
			id: 0,
			name: "Subscribes to a list",
			type: "list",
			message: "Subscribes to a list",
		},
		{
			id: 2,
			name: "Confirmed to a list",
			type: "list",
			message: "Confirmed to a list",
		},
		{
			id: 8,
			name: "Removed from a list",
			type: "list",
			message: "Removed from a list",
		},
		{ id: 3, name: "Tag added", type: "tag", message: "Tag added" },
		{ id: 4, name: "Tag removed", type: "tag", message: "Tag removed" },
		// {
		//   id: 5,
		//   name: "Send auto-trigger campaign",
		//   type: "autotrigger",
		//   message: "Send auto-trigger campaign",
		// },
		{
			id: 6,
			name: "Added to a drip campaign",
			type: "drip",
			message: "Added to a drip campaign",
		},
		{
			id: 7,
			name: "Removed from a drip",
			type: "drip",
			message: "Removed from a drip",
		},
		// {
		//   id: 10,
		//   name: "Send activity notification email",
		//   type: "member",
		//   message: "Send activity notification email",
		// },
		{ id: 11, name: "Unsubscribe contact", message: "Unsubscribe contact" },
		{ id: 12, name: "Global subscribe", message: "Global subscribe" },
		{ id: 13, name: "Call webhook", type: "text", message: "Call webhook" },
		{ id: 21, name: "Delete Contact", message: "Delete Contact" },
		{
			id: 22,
			name: "Update Custom field",
			type: "customfield",
			message: "Update Custom field",
		},
	],
	7: [{ id: 14, name: "Send contact", message: "Send contact to Pipedrive" }],
	10: [
		{
			id: 18,
			name: "Register contact",
			type: "demio",
			message: "Register contact on Demio",
		},
	],
	15: [
		{
			id: 23,
			name: "Send SMS",
			type: "twilio",
			message: "Send SMS",
		},
	],
});

export const WorkflowsAudienceFiltersOptions = [
	{
		label: "Contacts",
		items: [
			{
				entity: "Contacts",
				id: "unsubscribed",
				label: "Unsubscribed from all email communication",
				conditions: [
					{
						label: "equal",
						value: "equal",
					},
				],
				input: Segment.Input.RADIO,
				type: Segment.Type.INTEGER,
			},
			{
				entity: "Contacts",
				id: "bounced",
				label: "Email address bounced",
				conditions: [
					{
						label: "equal",
						value: "equal",
					},
				],
				input: Segment.Input.RADIO,
				type: Segment.Type.INTEGER,
			},
			{
				entity: "Contacts",
				id: "marked-spam",
				label: "Marked spam",
				conditions: [
					{
						label: "equal",
						value: "equal",
					},
				],
				input: Segment.Input.RADIO,
				type: Segment.Type.INTEGER,
			},
			//     {
			//       entity: 'Contacts',
			//       id: "lists",
			//       label: "Lists",
			//       conditions: [
			//         { label: "Any of", value: "in" },
			//         { label: "None of", value: "not_in" },
			//       ],
			//       input: Segment.Input.CHECKBOX,
			//       type: Segment.Type.INTEGER,
			//       options: Segment.Option.LISTS,
			//     },
			//     {
			//       entity: 'Contacts',
			//       id: "tags",
			//       label: "Tags",
			//       conditions: [
			//         { label: "Any of", value: "in" },
			//         { label: "None of", value: "not_in" },
			//       ],
			//       input: Segment.Input.CHECKBOX,
			//       type: Segment.Type.INTEGER,
			//       options: Segment.Option.TAGS,
			//     },

			//     {
			//       entity: 'Contacts',
			//       id: "email",
			//       label: "Email",
			//       conditions: [
			//         { label: "contains", value: "contains" },
			//         { label: "doesn't contain", value: "not_contains" },
			//         { label: "equal", value: "equal" },
			//         { label: "not equal", value: "not_equal" },
			//         { label: "begins with", value: "begins_with" },
			//         { label: "ends with", value: "ends_with" },
			//       ],
			//       input: Segment.Input.TEXT,
			//       type: Segment.Type.STRING,
			//     },
			//     {
			//       entity: 'Contacts',
			//       id: "first-name",
			//       label: "First Name",
			//       conditions: [
			//         { label: "is empty", value: "is_empty" },
			//         { label: "is not empty", value: "is_not_empty" },
			//         { label: "contains", value: "contains" },
			//         { label: "doesn't contain", value: "not_contains" },
			//         { label: "equal", value: "equal" },
			//         { label: "not equal", value: "not_equal" },
			//         { label: "begins with", value: "begins_with" },
			//         { label: "ends with", value: "ends_with" },
			//       ],
			//       input: Segment.Input.TEXT,
			//       type: Segment.Type.STRING,
			//     },
			//     {
			//       entity: 'Contacts',
			//       id: "last-name",
			//       label: "Last Name",
			//       conditions: [
			//         { label: "is empty", value: "is_empty" },
			//         { label: "is not empty", value: "is_not_empty" },
			//         { label: "contains", value: "contains" },
			//         { label: "doesn't contain", value: "not_contains" },
			//         { label: "equal", value: "equal" },
			//         { label: "not equal", value: "not_equal" },
			//         { label: "begins with", value: "begins_with" },
			//         { label: "ends with", value: "ends_with" },
			//       ],
			//       input: Segment.Input.TEXT,
			//       type: Segment.Type.STRING,
			//     },
			//     {
			//       entity: 'Contacts',
			//       id: "company",
			//       label: "Company",
			//       conditions: [
			//         { label: "is empty", value: "is_empty" },
			//         { label: "is not empty", value: "is_not_empty" },
			//         { label: "contains", value: "contains" },
			//         { label: "doesn't contain", value: "not_contains" },
			//         { label: "equal", value: "equal" },
			//         { label: "not equal", value: "not_equal" },
			//         { label: "begins with", value: "begins_with" },
			//         { label: "ends with", value: "ends_with" },
			//       ],
			//       input: Segment.Input.TEXT,
			//       type: Segment.Type.STRING,
			//     },
			//     {
			//       entity: 'Contacts',
			//       id: "active",
			//       label: "Last email opened or submitted form (in days)",
			//       conditions: [
			//         { label: "less", value: "less" },
			//         { label: "greater", value: "greater" },
			//       ],
			//       input: Segment.Input.TEXT,
			//       type: Segment.Type.INTEGER,
			//     },
			//     {
			//       entity: 'Contacts',
			//       id: "email-opened",
			//       label : "Last email opened (in days)",
			//       conditions: [
			//         {label : "less", value: "less"},
			//         {label : "greater", value: "greater"},
			//       ],
			//       input: Segment.Input.TEXT,
			//       type: Segment.Type.INTEGER,
			//     },
			//     {
			//       entity: 'Contacts',
			//       id: "email-clicked",
			//       label : "Last email clicked (in days)",
			//       conditions: [
			//         {label : "less", value: "less"},
			//         {label : "greater", value: "greater"},
			//       ],
			//       input: Segment.Input.TEXT,
			//       type: Segment.Type.INTEGER,
			//     },
			//     {
			//       entity: 'Contacts',
			//       id: "location",
			//       label: "Location",
			//       conditions: [
			//         { label: "equal", value: "equal" },
			//         { label: "not equal", value: "not_equal" },
			//       ],
			//       input: Segment.Input.SELECT,
			//       type: Segment.Type.STRING,
			//     },
			//     {
			//       entity: 'Contacts',
			//       id: "ltv",
			//       label: "Lifetime Value",
			//       conditions: [{ label: "between", value: "between" }],
			//       input: Segment.Input.TEXT,
			//       type: Segment.Type.INTEGER,
			//     },
			//     {
			//       entity: 'Contacts',
			//       id: "contact-source",
			//       label: "Contact added via source",
			//       conditions: [{ label: "equal", value: "equal" }],
			//       input: Segment.Input.SELECT,
			//       type: Segment.Type.INTEGER,
			//     },
			//     {
			//       entity: 'Contacts',
			//       id: "contact-created",
			//       label: "Contact Created",
			//       conditions: [
			//         { label: "equal", value: "equal" },
			//         { label: "less", value: "less" },
			//         { label: "greater", value: "greater" },
			//       ],
			//       input: Segment.Input.TEXT,
			//       type: Segment.Type.DATE,
			//     },
		],
	},
	{
		label: "Lists",
		items: [
			{
				entity: "Lists",
				id: "lists-confirmed",
				label: "Subscribed and confirmed to lists",
				conditions: [{ label: "Any of", value: "in" }],
				input: Segment.Input.CHECKBOX,
				type: Segment.Type.INTEGER,
				options: Segment.Option.LISTS,
			},
			{
				entity: "Lists",
				id: "lists-notconfirmed",
				label: "Subscribed and not confirmed to lists",
				type: "DP with list option",
				conditions: [{ label: "None of", value: "not_in" }],
				input: Segment.Input.CHECKBOX,
				type: Segment.Type.INTEGER,
				options: Segment.Option.LISTS,
			},
		],
	},
	{
		label: "Tags",
		items: [
			{
				entity: "Tags",
				id: "tags",
				label: "Has Tags",
				conditions: [
					{ label: "Any of", value: "in" },
					{ label: "None of", value: "not_in" },
				],
				input: Segment.Input.CHECKBOX,
				type: Segment.Type.INTEGER,
				options: Segment.Option.TAGS,
			},
		],
	},
	{
		label: "Custom Fields",
		items: [],
	},
];

export const WorkflowsConditionOptions = [
	// {
	//   label: "Contacts",
	//   items: [
	//     {
	//       entity: "Contacts",
	//       id: "unsubscribed",
	//       label: "Unsubscribed from all email communication",
	//       conditions: [
	//         {
	//           label: "equal",
	//           value: "equal",
	//         },
	//       ],
	//       input: Segment.Input.RADIO,
	//       type: Segment.Type.INTEGER,
	//     },
	//     {
	//       entity: "Contacts",
	//       id: "bounced",
	//       label: "Email address bounced",
	//       conditions: [
	//         {
	//           label: "equal",
	//           value: "equal",
	//         },
	//       ],
	//       input: Segment.Input.RADIO,
	//       type: Segment.Type.INTEGER,
	//     },
	//     {
	//       entity: "Contacts",
	//       id: "marked-spam",
	//       label: "Marked spam",
	//       conditions: [
	//         {
	//           label: "equal",
	//           value: "equal",
	//         },
	//       ],
	//       input: Segment.Input.RADIO,
	//       type: Segment.Type.INTEGER,
	//     },

	//     {
	//       entity: "Contacts",
	//       id: "lists",
	//       label: "Lists",
	//       conditions: [
	//         { label: "Any of", value: "in" },
	//         { label: "None of", value: "not_in" },
	//       ],
	//       input: Segment.Input.CHECKBOX,
	//       type: Segment.Type.INTEGER,
	//       options: Segment.Option.LISTS,
	//     },
	//     {
	//       entity: "Contacts",
	//       id: "tags",
	//       label: "Tags",
	//       conditions: [
	//         { label: "Any of", value: "in" },
	//         { label: "None of", value: "not_in" },
	//       ],
	//       input: Segment.Input.CHECKBOX,
	//       type: Segment.Type.INTEGER,
	//       options: Segment.Option.TAGS,
	//     },

	//     {
	//       entity: "Contacts",
	//       id: "email",
	//       label: "Email",
	//       conditions: [
	//         { label: "contains", value: "contains" },
	//         { label: "doesn't contain", value: "not_contains" },
	//         { label: "equal", value: "equal" },
	//         { label: "not equal", value: "not_equal" },
	//         { label: "begins with", value: "begins_with" },
	//         { label: "ends with", value: "ends_with" },
	//       ],
	//       input: Segment.Input.TEXT,
	//       type: Segment.Type.STRING,
	//     },
	//     {
	//       entity: "Contacts",
	//       id: "first-name",
	//       label: "First Name",
	//       conditions: [
	//         { label: "is empty", value: "is_empty" },
	//         { label: "is not empty", value: "is_not_empty" },
	//         { label: "contains", value: "contains" },
	//         { label: "doesn't contain", value: "not_contains" },
	//         { label: "equal", value: "equal" },
	//         { label: "not equal", value: "not_equal" },
	//         { label: "begins with", value: "begins_with" },
	//         { label: "ends with", value: "ends_with" },
	//       ],
	//       input: Segment.Input.TEXT,
	//       type: Segment.Type.STRING,
	//     },
	//     {
	//       entity: "Contacts",
	//       id: "last-name",
	//       label: "Last Name",
	//       conditions: [
	//         { label: "is empty", value: "is_empty" },
	//         { label: "is not empty", value: "is_not_empty" },
	//         { label: "contains", value: "contains" },
	//         { label: "doesn't contain", value: "not_contains" },
	//         { label: "equal", value: "equal" },
	//         { label: "not equal", value: "not_equal" },
	//         { label: "begins with", value: "begins_with" },
	//         { label: "ends with", value: "ends_with" },
	//       ],
	//       input: Segment.Input.TEXT,
	//       type: Segment.Type.STRING,
	//     },
	//     {
	//       entity: "Contacts",
	//       id: "company",
	//       label: "Company",
	//       conditions: [
	//         { label: "is empty", value: "is_empty" },
	//         { label: "is not empty", value: "is_not_empty" },
	//         { label: "contains", value: "contains" },
	//         { label: "doesn't contain", value: "not_contains" },
	//         { label: "equal", value: "equal" },
	//         { label: "not equal", value: "not_equal" },
	//         { label: "begins with", value: "begins_with" },
	//         { label: "ends with", value: "ends_with" },
	//       ],
	//       input: Segment.Input.TEXT,
	//       type: Segment.Type.STRING,
	//     },
	//     {
	//       entity: "Contacts",
	//       id: "active",
	//       label: "Last email opened or submitted form (in days)",
	//       conditions: [
	//         { label: "less", value: "less" },
	//         { label: "greater", value: "greater" },
	//       ],
	//       input: Segment.Input.TEXT,
	//       type: Segment.Type.INTEGER,
	//     },
	//     {
	//       entity: "Contacts",
	//       id: "email-opened",
	//       label: "Last email opened (in days)",
	//       conditions: [
	//         { label: "less", value: "less" },
	//         { label: "greater", value: "greater" },
	//       ],
	//       input: Segment.Input.TEXT,
	//       type: Segment.Type.INTEGER,
	//     },
	//     {
	//       entity: "Contacts",
	//       id: "email-clicked",
	//       label: "Last email clicked (in days)",
	//       conditions: [
	//         { label: "less", value: "less" },
	//         { label: "greater", value: "greater" },
	//       ],
	//       input: Segment.Input.TEXT,
	//       type: Segment.Type.INTEGER,
	//     },
	//     {
	//       entity: "Contacts",
	//       id: "location",
	//       label: "Location",
	//       conditions: [
	//         { label: "equal", value: "equal" },
	//         { label: "not equal", value: "not_equal" },
	//       ],
	//       input: Segment.Input.SELECT,
	//       type: Segment.Type.STRING,
	//     },
	//     {
	//       entity: "Contacts",
	//       id: "ltv",
	//       label: "Lifetime Value",
	//       conditions: [{ label: "between", value: "between" }],
	//       input: Segment.Input.TEXT,
	//       type: Segment.Type.INTEGER,
	//     },
	//     {
	//       entity: "Contacts",
	//       id: "contact-source",
	//       label: "Contact added via source",
	//       conditions: [{ label: "equal", value: "equal" }],
	//       input: Segment.Input.SELECT,
	//       type: Segment.Type.INTEGER,
	//     },
	//     {
	//       entity: "Contacts",
	//       id: "contact-created",
	//       label: "Contact Created",
	//       conditions: [
	//         { label: "equal", value: "equal" },
	//         { label: "less", value: "less" },
	//         { label: "greater", value: "greater" },
	//       ],
	//       input: Segment.Input.TEXT,
	//       type: Segment.Type.DATE,
	//     },
	//   ],
	// },
	{
		label: "Lists",
		items: [
			{
				entity: "Lists",
				id: "lists-confirmed",
				label: "Subscribed and confirmed to lists",
				conditions: [{ label: "Any of", value: "in" }],
				input: Segment.Input.CHECKBOX,
				type: Segment.Type.INTEGER,
				options: Segment.Option.LISTS,
			},
			{
				entity: "Lists",
				id: "lists-notconfirmed",
				label: "Subscribed and not confirmed to lists",
				type: "DP with list option",
				conditions: [{ label: "None of", value: "not_in" }],
				input: Segment.Input.CHECKBOX,
				type: Segment.Type.INTEGER,
				options: Segment.Option.LISTS,
			},
		],
	},
	// {
	//   label: "Newsletter or Auto-Trigger Campaigns",
	//   items: [
	//     {
	//       entity: "Newsletter or Auto-Trigger Campaigns",
	//       id: "campaigns",
	//       label: "Sent these campaigns",
	//       conditions: [
	//         { label: "Any of", value: "in" },
	//         { label: "None of", value: "not_in" },
	//       ],
	//       options: Segment.Option.CAMPAIGNS,
	//       input: Segment.Input.CHECKBOX,
	//       type: Segment.Type.INTEGER,
	//     },
	//     {
	//       entity: "Newsletter or Auto-Trigger Campaigns",
	//       id: "campaigns-opened",
	//       label: "Campaigns sent and opened them",
	//       conditions: [{ label: "Any of", value: "in" }],
	//       options: Segment.Option.CAMPAIGNS,
	//       input: Segment.Input.CHECKBOX,
	//       type: Segment.Type.INTEGER,
	//     },
	//     {
	//       entity: "Newsletter or Auto-Trigger Campaigns",
	//       id: "campaigns-unopened",
	//       label: "Campaigns sent but didn't open them",
	//       conditions: [{ label: "None of", value: "not_in" }],
	//       options: Segment.Option.CAMPAIGNS,
	//       input: Segment.Input.CHECKBOX,
	//       type: Segment.Type.INTEGER,
	//     },
	//     {
	//       entity: "Newsletter or Auto-Trigger Campaigns",
	//       id: "campaigns-clicked",
	//       label: "Campaigns sent and clicked links in them",
	//       conditions: [{ label: "Any of", value: "in" }],
	//       options: Segment.Option.CAMPAIGNS,
	//       input: Segment.Input.CHECKBOX,
	//       type: Segment.Type.INTEGER,
	//     },
	//     {
	//       entity: "Newsletter or Auto-Trigger Campaigns",
	//       id: "campaigns-link-clicked",
	//       label: "Clicked this link in campaign",
	//       conditions: [
	//         { label: "contains", value: "contains" },
	//         { label: "equal", value: "equal" },
	//       ],
	//       input: Segment.Input.TEXT,
	//       type: Segment.Type.STRING,
	//     },
	//     {
	//       entity: "Newsletter or Auto-Trigger Campaigns",
	//       id: "campaigns-unclicked",
	//       label: "Campaigns sent but didn't click links in them",
	//       // type: Segment.Type."DP with campaigns options",
	//       conditions: [{ label: "None of", value: "not_in" }],
	//       options: Segment.Option.CAMPAIGNS,
	//       input: Segment.Input.CHECKBOX,
	//       type: Segment.Type.INTEGER,
	//     },
	//   ],
	// },
	// {
	//   label: "Drip Campaigns",
	//   items: [
	//     {
	//       entity: "Drip Campaigns",
	//       id: "drip-steps-sent",
	//       label:
	//         "Added to drip campaigns and the below drip steps are already sent.",
	//       conditions: [{ label: "Any of", value: "in" }],
	//       options: Segment.Option.DRIPSTEP,
	//       input: Segment.Input.CHECKBOX,
	//       type: Segment.Type.INTEGER,
	//     },
	//     {
	//       entity: "Drip Campaigns",
	//       id: "drip-steps-notsent",
	//       label: "Added to drip campaigns but the below drip steps are not sent",
	//       conditions: [{ label: "None of", value: "not_in" }],
	//       options: Segment.Option.DRIPSTEP,
	//       input: Segment.Input.CHECKBOX,
	//       type: Segment.Type.INTEGER,
	//     },
	//     {
	//       entity: "Drip Campaigns",
	//       id: "drip-steps-opened",
	//       label: "Drip steps sent and opened",
	//       conditions: [{ label: "Any of", value: "in" }],
	//       options: Segment.Option.DRIPSTEP,
	//       input: Segment.Input.CHECKBOX,
	//       type: Segment.Type.INTEGER,
	//     },
	//     {
	//       entity: "Drip Campaigns",
	//       id: "drip-steps-unopened",
	//       label: "Drip steps sent but not opened",
	//       conditions: [{ label: "None of", value: "not_in" }],
	//       options: Segment.Option.DRIPSTEP,
	//       input: Segment.Input.CHECKBOX,
	//       type: Segment.Type.INTEGER,
	//     },
	//     {
	//       entity: "Drip Campaigns",
	//       id: "drip-steps-clicked",
	//       label: "Drip steps sent and links clicked",
	//       conditions: [{ label: "Any of", value: "in" }],
	//       options: Segment.Option.DRIPSTEP,
	//       input: Segment.Input.CHECKBOX,
	//       type: Segment.Type.INTEGER,
	//     },
	//     {
	//       entity: "Drip Campaigns",
	//       id: "drip-steps-link-clicked",
	//       label: "Clicked this link in drip steps",
	//       conditions: [
	//         { label: "contains", value: "contains" },
	//         { label: "equal", value: "equal" },
	//       ],
	//       input: Segment.Input.TEXT,
	//       type: Segment.Type.STRING,
	//     },
	//     {
	//       entity: "Drip Campaigns",
	//       id: "drip-steps-unclicked",
	//       label: "Drip steps sent but links not clicked",
	//       conditions: [{ label: "None of", value: "not_in" }],
	//       options: Segment.Option.DRIPSTEP,
	//       input: Segment.Input.CHECKBOX,
	//       type: Segment.Type.INTEGER,
	//     },
	//     {
	//       entity: "Drip Campaigns",
	//       id: "drip_sequences_started",
	//       label: "Drip started but not completed",
	//       conditions: [{ label: "None of", value: "not_in" }],
	//       options: Segment.Option.DRIP,
	//       input: Segment.Input.CHECKBOX,
	//       type: Segment.Type.INTEGER,
	//     },
	//     {
	//       entity: "Drip Campaigns",
	//       id: "drip_sequences_completed",
	//       label: "Drip completed",
	//       conditions: [{ label: "Any of", value: "in" }],
	//       options: Segment.Option.DRIP,
	//       input: Segment.Input.CHECKBOX,
	//       type: Segment.Type.INTEGER,
	//     },
	//   ],
	// },
	{
		label: "Tags",
		items: [
			{
				entity: "Tags",
				id: "tags-added",
				label: "Has Tags",
				conditions: [{ label: "Any of", value: "in" }],
				input: Segment.Input.CHECKBOX,
				type: Segment.Type.INTEGER,
				options: Segment.Option.TAGS,
			},
			{
				entity: "Tags",
				id: "tags-notadded",
				label: "Dosen't have tags",
				conditions: [{ label: "None of", value: "not_in" }],
				input: Segment.Input.CHECKBOX,
				type: Segment.Type.INTEGER,
				options: Segment.Option.TAGS,
			},
		],
	},
	{
		label: "Custom Fields",
		items: [],
	},
	{
		label: "Workflow Email",
		items: [],
	},
];

export const DEFAULT_FROM_TRIGGER_OPTION_DATA = {
	provider: 1,
	type: -1,
	pageSourceType: 0,
	pageSourceValue: "",
	metadata: "",
	metadataElementWrapper: {
		id: "-1",
		name: "Select",
	},
	integrationMetadata: "",
	integrationMetadataElementWrapper: {
		id: "-1",
		name: "Select",
	},
	filterData: JSON.stringify({}),
};

export const DEFAULT_TRIGGER_OPTION_DATA = {
	id: -1,
	name: "Choose a trigger",
};

export const DEFAULT_PROPERTY_OPTION_DATA = {
	id: -1,
	name: "Choose a custom event property",
};

export const DEFAULT_ACTION_OPTION_DATA = {
	id: -1,
	name: "Choose an action",
};

export const DEFAULT_TRIGGER_ENTITY = {
	id: "-1",
	name: "Choose an entity",
	type: "0",
};

export const DEFAULT_FROM_ACTION_OPTION_DATA = {
	provider: 1,
	type: -1,
	metadata: "",
	metadataElementWrapper: {
		id: "-1",
		name: "Select",
	},
	integrationMetadata: "",
	integrationMetadataElementWrapper: {
		id: "-1",
		name: "Select",
	},
	pageSourceValue: "",
	durationType: 0,
	durationValue: 0,
	operator: 0,
	customFieldValue: "",
};

export const WORKFLOWS_ERROR_MESSAGE = {
	TRIGGER_PLEASE_SELECT_TYPE: "Please select a trigger to proceed!",
	TRIGGER_PLEASE_SELECT_ENTITY: "Please select an entity to proceed!",
	TRIGGER_PLEASE_ENTER_URL: "Please enter a link to proceed!",
	TRIGGER_PLEASE_ENTER_VALID_URL: "Please enter a valid URL!",
	TRIGGER_PLEASE_ADD_PAGE_VALUE: "Please enter a value!",
	TRIGGER_PLEASE_CHECK_CUSTOM_EVENT_PROPERTY:
		"Please setup custom event property check!",
	TRIGGER_SELECT_FILTER_TRIGGER: "Please select a filter trigger to proceed",
	TRIGGER_SELECT_FILTER_ENTITY: "Please select a filter entity to proceed",
	TRIGGER_SELECT_FILTER_URL: "Please enter a filter link to proceed",
	TRIGGER_SELECT_FILTER_VALID_URL:
		"PLease enter a valid filter link to proceed",
	TRIGGER_SELECT_FILTER_PLEASE_ADD_PAGE_VALUE: "Please enter a value!",
	TRIGGER_AUDIENCE_FILTER_OPTION:
		"Please select an audience filter option to proceed",
	TRIGGER_AUDIENCE_FILTER_SUB_OPTION:
		"Please select an audience filter sub option to proceed",
	TRIGGER_AUDIENCE_FILTER_VALUE:
		"Please enter a audience filter value to proceed",
	EXIT_TRIGGER_PLEASE_SELECT_TYPE: "Please select an exit trigger to proceed!",
	EXIT_TRIGGER_PLEASE_SELECT_ENTITY:
		"Please select an exit trigger entity to proceed!",
	EXIT_TRIGGER_PLEASE_ENTER_URL:
		"Please enter a exit trigger link to proceed!",
	EXIT_TRIGGER_PLEASE_ENTER_VALID_URL:
		"Please enter a valid exit trigger URL!",
	EXIT_TRIGGER_PLEASE_ADD_PAGE_VALUE: "Please enter a exit trigger value!",
	ACTION_PLEASE_SELECT_TYPE: "Please select an action to proceed!",
	ACTION_PLEASE_ENTER_WEBHOOK: "Please enter a webhook!",
	ACTION_PLEASE_ENTER_VALID_WEBHOOK: "Please enter valid webhook!",
	ACTION_PLEASE_ENTER_TWILIO_SENDER:
		"Please select a twilio sender phone number!",
	EMAIL: {
		name: "Please enter email name",
		subject: "Please enter email subject",
		previewText: "Please enter email preview text",
		sender: "Please enter email sender",
		templateCode: "Please design email",
		senderObject: "Please select email sender",
		htmlCode: "Please design email",
	},
	GOAL_PLEASE_SELECT_TYPE: "Please  select a goal type",
	GOAL_PLEASE_SELECT_ENTITY: "Please select a goal entity",
	GOAL_ENTER_URL: "Please enter a URL",
	GOAL_ENTER_VALID_URL: "Please enter a valid URL",
	GOAL_PLEASE_ADD_PAGE_VALUE: "Please enter a value!",
	CONDITION_OPTION: "Please select an condition option to proceed",
	CONDITION_SUB_OPTION: "Please select an condition sub option to proceed",
	CONDITION_VALUE: "Please enter a condition value to proceed",
};

export const NodeTypes = {
	enrollment_trigger: 0,
	action_node: 1,
	decision_node: 2,
	A: 3,
	B: 4,
	dot: 5,
	drip_node: 6,
	exit_node: 7,
	ab_split_node: 8,
	email_node: 9,
	delay_node: 10,
	garbage_node: 11,
};

export const NodeTypesMap = {
	0: "enrollment_trigger",
	1: "action_node",
	2: "decision_node",
	3: "A",
	4: "B",
	5: "dot",
	6: "drip_node",
	7: "exit_node",
	8: "ab_split_node",
	9: "email_node",
	10: "delay_node",
	11: "garbage_node",
};

export const isDragDropTemplateEmpty = (templateCode) => {
	const jsonData = JSON.parse(templateCode);
	if (!jsonData || !jsonData.page || !jsonData.page.rows) {
		return true;
	}

	const rows = jsonData.page.rows;

	for (let i = 0; i < rows.length; i++) {
		const columns = rows[i].columns;

		for (let j = 0; j < columns.length; j++) {
			const modules = columns[j].modules;
			if (modules.length !== 0) {
				return false;
			}
		}
	}

	return true;
};

export const isSendxEditorTemplateEmpty = (templateCode) => {
	const template = typeof templateCode === 'string' ? JSON.parse(templateCode) : templateCode;
	console.log("template :: ", template, template?.type === 'doc' &&
		Array.isArray(template?.content) &&
		template.content.length === 1 &&
		template.content[0]?.type === 'paragraph' &&
		template.content[0]?.attrs?.textAlign === null &&
		!template.content[0]?.content);
	return (
		template?.type === 'doc' &&
		Array.isArray(template?.content) &&
		template.content.length === 1 &&
		template.content[0]?.type === 'paragraph' &&
		template.content[0]?.attrs?.textAlign === null &&
		!template.content[0]?.content // Check if there's no content in the paragraph
	);
}

export const IntegrationType = Object.freeze({
	SendX: 1,
	WooCommerce: 2,
	SamCart: 3,
	Stripe: 4,
	Paypal: 5,
	InstaPage: 6,
	PipeDrive: 7,
	SalesForce: 8,
	CloseIo: 9,
	Demio: 10,
	Facebook: 11,
	Shopify: 12,
	Twilio: 15,
});

export const ShopifyCouponType = Object.freeze({
	DiscountPercentageOff: 0,
	DiscountFixedAmount: 1,
	DiscountFreeShipping: 2,
});

export const ShopifyCouponAppliesTo = Object.freeze({
	EntireOrder: 0,
	SpecificCollections: 1,
});

export const ShopifyCouponMinRequirements = Object.freeze({
	None: 0,
	PurchaseAmount: 1,
	PurchaseQuantity: 2,
});

export const ShopifyCouponUsageLimit = Object.freeze({
	NTimes: 0,
	OncePerUser: 1,
});

// {
//   workflow: {
//     name :
//     status :
//     evaluateExisting : false
//     excludeContacts : false
//     goal : "{}"
//     goalEnabled : false
//   },
//   nodes: [],
//   edges: []
// }

export const WORKFLOW_TEMPLATES = [
	{
		workflow: {
			name: "Simple welcome email",
			status: false,
			evaluateExisting: false,
			excludeContacts: false,
			goal: "{}",
			goalEnabled: false,
			description: "Use this easy workflow to welcome your new contacts.",
		},
		nodes: [
			{
				id: "1",
				type: "enrollment_trigger",
				dimensions: {
					width: 300,
					height: 82,
				},
				computedPosition: {
					x: 150,
					y: 116,
					z: 1000,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: true,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 150,
					y: 116,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "2",
				type: "exit_node",
				dimensions: {
					width: 300,
					height: 16,
				},
				computedPosition: {
					x: 150,
					y: 800,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 150,
					y: 800,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "16827215-618e-49f3-a0f5-134118416569",
				type: "email_node",
				dimensions: {
					width: 300,
					height: 193,
				},
				computedPosition: {
					x: 150,
					y: 453.5,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 150,
					y: 453.5,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
		],
		edges: [
			{
				id: "63462c6c-0070-4b06-a562-539c1baed3aa",
				type: "step",
				source: "1",
				target: "16827215-618e-49f3-a0f5-134118416569",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "1",
					type: "enrollment_trigger",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 150,
						y: 116,
						z: 1000,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: true,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 116,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "16827215-618e-49f3-a0f5-134118416569",
					type: "email_node",
					dimensions: {
						width: 300,
						height: 193,
					},
					computedPosition: {
						x: 150,
						y: 453.5,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 453.5,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 300,
				sourceY: 198,
				targetX: 300,
				targetY: 453.5,
			},
			{
				id: "c59e2de7-0a0e-4040-bd45-b831787b686c",
				type: "step",
				source: "16827215-618e-49f3-a0f5-134118416569",
				target: "2",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "16827215-618e-49f3-a0f5-134118416569",
					type: "email_node",
					dimensions: {
						width: 300,
						height: 193,
					},
					computedPosition: {
						x: 150,
						y: 453.5,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 453.5,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "2",
					type: "exit_node",
					dimensions: {
						width: 300,
						height: 16,
					},
					computedPosition: {
						x: 150,
						y: 800,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 800,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 300,
				sourceY: 646.5,
				targetX: 300,
				targetY: 800,
			},
		],
		tags: ["Welcome"],
	},
	{
		workflow: {
			name: "Win back inactive contacts",
			status: false,
			evaluateExisting: false,
			excludeContacts: false,
			goal: "{}",
			goalEnabled: false,
			description:
				"Win back unengaged contacts and unsubscribe inactive ones.",
		},
		nodes: [
			{
				id: "1",
				type: "enrollment_trigger",
				dimensions: {
					width: 300,
					height: 82,
				},
				computedPosition: {
					x: 950,
					y: 116,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 950,
					y: 116,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "2",
				type: "exit_node",
				dimensions: {
					width: 300,
					height: 16,
				},
				computedPosition: {
					x: 950,
					y: 4403,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 950,
					y: 4403,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "1b4c122a-f380-487b-b6cd-37bbe4c7f936",
				type: "email_node",
				dimensions: {
					width: 300,
					height: 193,
				},
				computedPosition: {
					x: 950,
					y: 453.5,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 950,
					y: 453.5,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "8973c2fe-9611-4d1b-b7af-9c3593f8dc20",
				type: "delay_node",
				dimensions: {
					width: 300,
					height: 82,
				},
				computedPosition: {
					x: 950,
					y: 791,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 950,
					y: 791,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "19384019-91cb-47fd-9381-61cbcf243666",
				type: "decision_node",
				dimensions: {
					width: 300,
					height: 82,
				},
				computedPosition: {
					x: 950,
					y: 1073,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 950,
					y: 1073,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "1a849f54-dcb7-46f0-a89a-cf8fe004dd77-19384019-91cb-47fd-9381-61cbcf243666",
				type: "A",
				dimensions: {
					width: 300,
					height: 20,
				},
				computedPosition: {
					x: 150,
					y: 1373,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 150,
					y: 1373,
				},
				data: {
					metadata:
						'{"style":{"backgroundColor":"#3B82F6"},"label":"Yes"}',
				},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "decision_node-A-da1ed922-de25-4879-8996-e44e2affa2a2-19384019-91cb-47fd-9381-61cbcf243666",
				type: "garbage_node",
				dimensions: {
					width: 300,
					height: 20,
				},
				computedPosition: {
					x: 150,
					y: 3803,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 150,
					y: 3803,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "05ece20f-36e9-443f-a55c-908701c7dbd9-19384019-91cb-47fd-9381-61cbcf243666",
				type: "B",
				dimensions: {
					width: 300,
					height: 20,
				},
				computedPosition: {
					x: 1350,
					y: 1373,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 1350,
					y: 1373,
				},
				data: {
					metadata: '{"style":{"backgroundColor":"#6B7280"},"label":"No"}',
				},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "decision_node-B-770028ba-b1bf-437a-bfc3-1e8bc47be7ea-19384019-91cb-47fd-9381-61cbcf243666",
				type: "garbage_node",
				dimensions: {
					width: 300,
					height: 20,
				},
				computedPosition: {
					x: 1350,
					y: 3803,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 1350,
					y: 3803,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "decision_node-d928eb03-bf79-4190-9752-08ec368008eb-19384019-91cb-47fd-9381-61cbcf243666",
				type: "dot",
				dimensions: {
					width: 300,
					height: 10,
				},
				computedPosition: {
					x: 950,
					y: 4103,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 950,
					y: 4103,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "88049262-7fe8-41f7-a783-b857c213ca8b",
				type: "action_node",
				dimensions: {
					width: 300,
					height: 82,
				},
				computedPosition: {
					x: 150,
					y: 3503,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 150,
					y: 3503,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "dfa1cfd1-2206-4168-9de7-fb587a06b0b5",
				type: "email_node",
				dimensions: {
					width: 300,
					height: 193,
				},
				computedPosition: {
					x: 1350,
					y: 1710.5,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 1350,
					y: 1710.5,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "b74c5d17-94ac-4461-8b05-8c7b653e558a",
				type: "delay_node",
				dimensions: {
					width: 300,
					height: 82,
				},
				computedPosition: {
					x: 1350,
					y: 2048,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 1350,
					y: 2048,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "ce184de6-fbb0-4e16-96de-4b2727055f7f",
				type: "decision_node",
				dimensions: {
					width: 300,
					height: 82,
				},
				computedPosition: {
					x: 1350,
					y: 2330,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 1350,
					y: 2330,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "bcc68953-5cea-4c22-b5ed-16e68e9d2ea2-ce184de6-fbb0-4e16-96de-4b2727055f7f",
				type: "A",
				dimensions: {
					width: 300,
					height: 20,
				},
				computedPosition: {
					x: 950,
					y: 2630,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 950,
					y: 2630,
				},
				data: {
					metadata:
						'{"style":{"backgroundColor":"#3B82F6"},"label":"Yes"}',
				},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "decision_node-A-ba7c11aa-b1b3-413e-9336-807e2dc6b0f2-ce184de6-fbb0-4e16-96de-4b2727055f7f",
				type: "garbage_node",
				dimensions: {
					width: 300,
					height: 20,
				},
				computedPosition: {
					x: 950,
					y: 3203,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 950,
					y: 3203,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "89eb354f-b605-482e-9129-71b6149396dd-ce184de6-fbb0-4e16-96de-4b2727055f7f",
				type: "B",
				dimensions: {
					width: 300,
					height: 20,
				},
				computedPosition: {
					x: 1750,
					y: 2630,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 1750,
					y: 2630,
				},
				data: {
					metadata: '{"style":{"backgroundColor":"#6B7280"},"label":"No"}',
				},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "decision_node-B-97b3a14c-6fa5-4b95-b4df-629688e89f16-ce184de6-fbb0-4e16-96de-4b2727055f7f",
				type: "garbage_node",
				dimensions: {
					width: 300,
					height: 20,
				},
				computedPosition: {
					x: 1750,
					y: 3203,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 1750,
					y: 3203,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "decision_node-6c79c599-8112-4e2f-974c-c47f9b831127-ce184de6-fbb0-4e16-96de-4b2727055f7f",
				type: "dot",
				dimensions: {
					width: 300,
					height: 10,
				},
				computedPosition: {
					x: 1350,
					y: 3503,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 1350,
					y: 3503,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "65534443-df03-4487-a83d-1ff15edd532f",
				type: "action_node",
				dimensions: {
					width: 300,
					height: 82,
				},
				computedPosition: {
					x: 1750,
					y: 2912,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 1750,
					y: 2912,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "ab827726-0ac3-4009-b095-e6847ad79296",
				type: "action_node",
				dimensions: {
					width: 300,
					height: 82,
				},
				computedPosition: {
					x: 950,
					y: 2912,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 950,
					y: 2912,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
		],
		edges: [
			{
				id: "a1c6a2dd-3116-4aa2-b163-40b7e2e4f9ad",
				type: "step",
				source: "1",
				target: "1b4c122a-f380-487b-b6cd-37bbe4c7f936",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "1",
					type: "enrollment_trigger",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 950,
						y: 116,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 116,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "1b4c122a-f380-487b-b6cd-37bbe4c7f936",
					type: "email_node",
					dimensions: {
						width: 300,
						height: 193,
					},
					computedPosition: {
						x: 950,
						y: 453.5,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 453.5,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1100,
				sourceY: 198,
				targetX: 1100,
				targetY: 453.5,
			},
			{
				id: "3756cbfd-7157-48ad-abf3-12fca4b99450",
				type: "step",
				source: "1b4c122a-f380-487b-b6cd-37bbe4c7f936",
				target: "8973c2fe-9611-4d1b-b7af-9c3593f8dc20",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "1b4c122a-f380-487b-b6cd-37bbe4c7f936",
					type: "email_node",
					dimensions: {
						width: 300,
						height: 193,
					},
					computedPosition: {
						x: 950,
						y: 453.5,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 453.5,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "8973c2fe-9611-4d1b-b7af-9c3593f8dc20",
					type: "delay_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 950,
						y: 791,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 791,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1100,
				sourceY: 646.5,
				targetX: 1100,
				targetY: 791,
			},
			{
				id: "0c3877d7-4139-4fae-9b3e-e05bad91fb12",
				type: "default",
				source: "8973c2fe-9611-4d1b-b7af-9c3593f8dc20",
				target: "19384019-91cb-47fd-9381-61cbcf243666",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "8973c2fe-9611-4d1b-b7af-9c3593f8dc20",
					type: "delay_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 950,
						y: 791,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 791,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "19384019-91cb-47fd-9381-61cbcf243666",
					type: "decision_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 950,
						y: 1073,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 1073,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1100,
				sourceY: 873,
				targetX: 1100,
				targetY: 1073,
			},
			{
				id: "1c8959e4-e04f-4a01-bc10-3e6efdf49a9e",
				type: "step",
				source: "19384019-91cb-47fd-9381-61cbcf243666",
				target:
					"1a849f54-dcb7-46f0-a89a-cf8fe004dd77-19384019-91cb-47fd-9381-61cbcf243666",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "19384019-91cb-47fd-9381-61cbcf243666",
					type: "decision_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 950,
						y: 1073,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 1073,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "1a849f54-dcb7-46f0-a89a-cf8fe004dd77-19384019-91cb-47fd-9381-61cbcf243666",
					type: "A",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 150,
						y: 1373,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 1373,
					},
					data: {
						metadata:
							'{"style":{"backgroundColor":"#3B82F6"},"label":"Yes"}',
					},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1100,
				sourceY: 1155,
				targetX: 300,
				targetY: 1373,
			},
			{
				id: "7fa83659-2033-46b6-8f73-8a493c734bc2",
				type: "step",
				source: "19384019-91cb-47fd-9381-61cbcf243666",
				target:
					"05ece20f-36e9-443f-a55c-908701c7dbd9-19384019-91cb-47fd-9381-61cbcf243666",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "19384019-91cb-47fd-9381-61cbcf243666",
					type: "decision_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 950,
						y: 1073,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 1073,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "05ece20f-36e9-443f-a55c-908701c7dbd9-19384019-91cb-47fd-9381-61cbcf243666",
					type: "B",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 1350,
						y: 1373,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1350,
						y: 1373,
					},
					data: {
						metadata:
							'{"style":{"backgroundColor":"#6B7280"},"label":"No"}',
					},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1100,
				sourceY: 1155,
				targetX: 1500,
				targetY: 1373,
			},
			{
				id: "143e5b9a-57dc-4092-adeb-bda0e62fe5cb",
				type: "step",
				source:
					"decision_node-A-da1ed922-de25-4879-8996-e44e2affa2a2-19384019-91cb-47fd-9381-61cbcf243666",
				target:
					"decision_node-d928eb03-bf79-4190-9752-08ec368008eb-19384019-91cb-47fd-9381-61cbcf243666",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "decision_node-A-da1ed922-de25-4879-8996-e44e2affa2a2-19384019-91cb-47fd-9381-61cbcf243666",
					type: "garbage_node",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 150,
						y: 3803,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 3803,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "decision_node-d928eb03-bf79-4190-9752-08ec368008eb-19384019-91cb-47fd-9381-61cbcf243666",
					type: "dot",
					dimensions: {
						width: 300,
						height: 10,
					},
					computedPosition: {
						x: 950,
						y: 4103,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 4103,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 300,
				sourceY: 3823,
				targetX: 1100,
				targetY: 4103,
			},
			{
				id: "f6437931-92ed-46b7-9168-c8fdd8a7cfe2",
				type: "step",
				source:
					"decision_node-B-770028ba-b1bf-437a-bfc3-1e8bc47be7ea-19384019-91cb-47fd-9381-61cbcf243666",
				target:
					"decision_node-d928eb03-bf79-4190-9752-08ec368008eb-19384019-91cb-47fd-9381-61cbcf243666",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "decision_node-B-770028ba-b1bf-437a-bfc3-1e8bc47be7ea-19384019-91cb-47fd-9381-61cbcf243666",
					type: "garbage_node",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 1350,
						y: 3803,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1350,
						y: 3803,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "decision_node-d928eb03-bf79-4190-9752-08ec368008eb-19384019-91cb-47fd-9381-61cbcf243666",
					type: "dot",
					dimensions: {
						width: 300,
						height: 10,
					},
					computedPosition: {
						x: 950,
						y: 4103,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 4103,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1500,
				sourceY: 3823,
				targetX: 1100,
				targetY: 4103,
			},
			{
				id: "f9dafb90-0c1d-4db4-bf4f-09fd98be6592",
				type: "step",
				source:
					"decision_node-d928eb03-bf79-4190-9752-08ec368008eb-19384019-91cb-47fd-9381-61cbcf243666",
				target: "2",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "decision_node-d928eb03-bf79-4190-9752-08ec368008eb-19384019-91cb-47fd-9381-61cbcf243666",
					type: "dot",
					dimensions: {
						width: 300,
						height: 10,
					},
					computedPosition: {
						x: 950,
						y: 4103,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 4103,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "2",
					type: "exit_node",
					dimensions: {
						width: 300,
						height: 16,
					},
					computedPosition: {
						x: 950,
						y: 4403,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 4403,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1100,
				sourceY: 4113,
				targetX: 1100,
				targetY: 4403,
			},
			{
				id: "eb260b4a-e298-4622-ae6c-ac73fc91b9ce",
				type: "step",
				source:
					"1a849f54-dcb7-46f0-a89a-cf8fe004dd77-19384019-91cb-47fd-9381-61cbcf243666",
				target: "88049262-7fe8-41f7-a783-b857c213ca8b",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "1a849f54-dcb7-46f0-a89a-cf8fe004dd77-19384019-91cb-47fd-9381-61cbcf243666",
					type: "A",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 150,
						y: 1373,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 1373,
					},
					data: {
						metadata:
							'{"style":{"backgroundColor":"#3B82F6"},"label":"Yes"}',
					},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "88049262-7fe8-41f7-a783-b857c213ca8b",
					type: "action_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 150,
						y: 3503,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 3503,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 300,
				sourceY: 1393,
				targetX: 300,
				targetY: 3503,
			},
			{
				id: "b86b47a5-4f4b-42bb-84ad-cb99c03eb2fb",
				type: "step",
				source: "88049262-7fe8-41f7-a783-b857c213ca8b",
				target:
					"decision_node-A-da1ed922-de25-4879-8996-e44e2affa2a2-19384019-91cb-47fd-9381-61cbcf243666",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "88049262-7fe8-41f7-a783-b857c213ca8b",
					type: "action_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 150,
						y: 3503,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 3503,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "decision_node-A-da1ed922-de25-4879-8996-e44e2affa2a2-19384019-91cb-47fd-9381-61cbcf243666",
					type: "garbage_node",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 150,
						y: 3803,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 3803,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 300,
				sourceY: 3585,
				targetX: 300,
				targetY: 3803,
			},
			{
				id: "be5f5667-abc9-45d8-8a83-261a4de99cf2",
				type: "step",
				source:
					"05ece20f-36e9-443f-a55c-908701c7dbd9-19384019-91cb-47fd-9381-61cbcf243666",
				target: "dfa1cfd1-2206-4168-9de7-fb587a06b0b5",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "05ece20f-36e9-443f-a55c-908701c7dbd9-19384019-91cb-47fd-9381-61cbcf243666",
					type: "B",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 1350,
						y: 1373,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1350,
						y: 1373,
					},
					data: {
						metadata:
							'{"style":{"backgroundColor":"#6B7280"},"label":"No"}',
					},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "dfa1cfd1-2206-4168-9de7-fb587a06b0b5",
					type: "email_node",
					dimensions: {
						width: 300,
						height: 193,
					},
					computedPosition: {
						x: 1350,
						y: 1710.5,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1350,
						y: 1710.5,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1500,
				sourceY: 1393,
				targetX: 1500,
				targetY: 1710.5,
			},
			{
				id: "087c5326-1511-4223-ae3e-bd44e220c387",
				type: "step",
				source: "dfa1cfd1-2206-4168-9de7-fb587a06b0b5",
				target: "b74c5d17-94ac-4461-8b05-8c7b653e558a",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "dfa1cfd1-2206-4168-9de7-fb587a06b0b5",
					type: "email_node",
					dimensions: {
						width: 300,
						height: 193,
					},
					computedPosition: {
						x: 1350,
						y: 1710.5,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1350,
						y: 1710.5,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "b74c5d17-94ac-4461-8b05-8c7b653e558a",
					type: "delay_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 1350,
						y: 2048,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1350,
						y: 2048,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1500,
				sourceY: 1903.5,
				targetX: 1500,
				targetY: 2048,
			},
			{
				id: "f8cc4d12-9afe-4cba-a84d-fe169b86d5cf",
				type: "default",
				source: "b74c5d17-94ac-4461-8b05-8c7b653e558a",
				target: "ce184de6-fbb0-4e16-96de-4b2727055f7f",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "b74c5d17-94ac-4461-8b05-8c7b653e558a",
					type: "delay_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 1350,
						y: 2048,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1350,
						y: 2048,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "ce184de6-fbb0-4e16-96de-4b2727055f7f",
					type: "decision_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 1350,
						y: 2330,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1350,
						y: 2330,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1500,
				sourceY: 2130,
				targetX: 1500,
				targetY: 2330,
			},
			{
				id: "fb22c147-8135-417d-a7a6-88ebb296cbaa",
				type: "step",
				source: "ce184de6-fbb0-4e16-96de-4b2727055f7f",
				target:
					"bcc68953-5cea-4c22-b5ed-16e68e9d2ea2-ce184de6-fbb0-4e16-96de-4b2727055f7f",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "ce184de6-fbb0-4e16-96de-4b2727055f7f",
					type: "decision_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 1350,
						y: 2330,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1350,
						y: 2330,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "bcc68953-5cea-4c22-b5ed-16e68e9d2ea2-ce184de6-fbb0-4e16-96de-4b2727055f7f",
					type: "A",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 950,
						y: 2630,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 2630,
					},
					data: {
						metadata:
							'{"style":{"backgroundColor":"#3B82F6"},"label":"Yes"}',
					},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1500,
				sourceY: 2412,
				targetX: 1100,
				targetY: 2630,
			},
			{
				id: "9e6cd66d-0843-4a5d-add5-31281b3b63c8",
				type: "step",
				source: "ce184de6-fbb0-4e16-96de-4b2727055f7f",
				target:
					"89eb354f-b605-482e-9129-71b6149396dd-ce184de6-fbb0-4e16-96de-4b2727055f7f",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "ce184de6-fbb0-4e16-96de-4b2727055f7f",
					type: "decision_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 1350,
						y: 2330,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1350,
						y: 2330,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "89eb354f-b605-482e-9129-71b6149396dd-ce184de6-fbb0-4e16-96de-4b2727055f7f",
					type: "B",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 1750,
						y: 2630,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1750,
						y: 2630,
					},
					data: {
						metadata:
							'{"style":{"backgroundColor":"#6B7280"},"label":"No"}',
					},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1500,
				sourceY: 2412,
				targetX: 1900,
				targetY: 2630,
			},
			{
				id: "ead40ea5-9959-4e50-b448-3b624c408ea7",
				type: "step",
				source:
					"decision_node-A-ba7c11aa-b1b3-413e-9336-807e2dc6b0f2-ce184de6-fbb0-4e16-96de-4b2727055f7f",
				target:
					"decision_node-6c79c599-8112-4e2f-974c-c47f9b831127-ce184de6-fbb0-4e16-96de-4b2727055f7f",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "decision_node-A-ba7c11aa-b1b3-413e-9336-807e2dc6b0f2-ce184de6-fbb0-4e16-96de-4b2727055f7f",
					type: "garbage_node",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 950,
						y: 3203,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 3203,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "decision_node-6c79c599-8112-4e2f-974c-c47f9b831127-ce184de6-fbb0-4e16-96de-4b2727055f7f",
					type: "dot",
					dimensions: {
						width: 300,
						height: 10,
					},
					computedPosition: {
						x: 1350,
						y: 3503,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1350,
						y: 3503,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1100,
				sourceY: 3223,
				targetX: 1500,
				targetY: 3503,
			},
			{
				id: "66d1bcb0-6388-49b0-876a-0b7f41c2a09b",
				type: "step",
				source:
					"decision_node-B-97b3a14c-6fa5-4b95-b4df-629688e89f16-ce184de6-fbb0-4e16-96de-4b2727055f7f",
				target:
					"decision_node-6c79c599-8112-4e2f-974c-c47f9b831127-ce184de6-fbb0-4e16-96de-4b2727055f7f",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "decision_node-B-97b3a14c-6fa5-4b95-b4df-629688e89f16-ce184de6-fbb0-4e16-96de-4b2727055f7f",
					type: "garbage_node",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 1750,
						y: 3203,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1750,
						y: 3203,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "decision_node-6c79c599-8112-4e2f-974c-c47f9b831127-ce184de6-fbb0-4e16-96de-4b2727055f7f",
					type: "dot",
					dimensions: {
						width: 300,
						height: 10,
					},
					computedPosition: {
						x: 1350,
						y: 3503,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1350,
						y: 3503,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1900,
				sourceY: 3223,
				targetX: 1500,
				targetY: 3503,
			},
			{
				id: "38ea9d56-32d6-4349-92b4-1bc38fbf191e",
				type: "step",
				source:
					"decision_node-6c79c599-8112-4e2f-974c-c47f9b831127-ce184de6-fbb0-4e16-96de-4b2727055f7f",
				target:
					"decision_node-B-770028ba-b1bf-437a-bfc3-1e8bc47be7ea-19384019-91cb-47fd-9381-61cbcf243666",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "decision_node-6c79c599-8112-4e2f-974c-c47f9b831127-ce184de6-fbb0-4e16-96de-4b2727055f7f",
					type: "dot",
					dimensions: {
						width: 300,
						height: 10,
					},
					computedPosition: {
						x: 1350,
						y: 3503,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1350,
						y: 3503,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "decision_node-B-770028ba-b1bf-437a-bfc3-1e8bc47be7ea-19384019-91cb-47fd-9381-61cbcf243666",
					type: "garbage_node",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 1350,
						y: 3803,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1350,
						y: 3803,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1500,
				sourceY: 3513,
				targetX: 1500,
				targetY: 3803,
			},
			{
				id: "d66b06be-2f0a-4421-8c1d-521f8135f5a7",
				type: "step",
				source:
					"89eb354f-b605-482e-9129-71b6149396dd-ce184de6-fbb0-4e16-96de-4b2727055f7f",
				target: "65534443-df03-4487-a83d-1ff15edd532f",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "89eb354f-b605-482e-9129-71b6149396dd-ce184de6-fbb0-4e16-96de-4b2727055f7f",
					type: "B",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 1750,
						y: 2630,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1750,
						y: 2630,
					},
					data: {
						metadata:
							'{"style":{"backgroundColor":"#6B7280"},"label":"No"}',
					},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "65534443-df03-4487-a83d-1ff15edd532f",
					type: "action_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 1750,
						y: 2912,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1750,
						y: 2912,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1900,
				sourceY: 2650,
				targetX: 1900,
				targetY: 2912,
			},
			{
				id: "529995b3-e265-425f-b43f-066b036c3d00",
				type: "step",
				source: "65534443-df03-4487-a83d-1ff15edd532f",
				target:
					"decision_node-B-97b3a14c-6fa5-4b95-b4df-629688e89f16-ce184de6-fbb0-4e16-96de-4b2727055f7f",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "65534443-df03-4487-a83d-1ff15edd532f",
					type: "action_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 1750,
						y: 2912,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1750,
						y: 2912,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "decision_node-B-97b3a14c-6fa5-4b95-b4df-629688e89f16-ce184de6-fbb0-4e16-96de-4b2727055f7f",
					type: "garbage_node",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 1750,
						y: 3203,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1750,
						y: 3203,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1900,
				sourceY: 2994,
				targetX: 1900,
				targetY: 3203,
			},
			{
				id: "a5103229-f6f6-4d3e-874c-efb68d4352e1",
				type: "step",
				source:
					"bcc68953-5cea-4c22-b5ed-16e68e9d2ea2-ce184de6-fbb0-4e16-96de-4b2727055f7f",
				target: "ab827726-0ac3-4009-b095-e6847ad79296",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "bcc68953-5cea-4c22-b5ed-16e68e9d2ea2-ce184de6-fbb0-4e16-96de-4b2727055f7f",
					type: "A",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 950,
						y: 2630,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 2630,
					},
					data: {
						metadata:
							'{"style":{"backgroundColor":"#3B82F6"},"label":"Yes"}',
					},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "ab827726-0ac3-4009-b095-e6847ad79296",
					type: "action_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 950,
						y: 2912,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 2912,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1100,
				sourceY: 2650,
				targetX: 1100,
				targetY: 2912,
			},
			{
				id: "883cc7aa-7c80-4021-947b-bc7075009848",
				type: "step",
				source: "ab827726-0ac3-4009-b095-e6847ad79296",
				target:
					"decision_node-A-ba7c11aa-b1b3-413e-9336-807e2dc6b0f2-ce184de6-fbb0-4e16-96de-4b2727055f7f",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "ab827726-0ac3-4009-b095-e6847ad79296",
					type: "action_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 950,
						y: 2912,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 2912,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "decision_node-A-ba7c11aa-b1b3-413e-9336-807e2dc6b0f2-ce184de6-fbb0-4e16-96de-4b2727055f7f",
					type: "garbage_node",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 950,
						y: 3203,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 3203,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1100,
				sourceY: 2994,
				targetX: 1100,
				targetY: 3203,
			},
		],
		tags: ["Promotion"],
	},
	{
		workflow: {
			name: "Retarget contacts",
			status: false,
			evaluateExisting: false,
			excludeContacts: false,
			goal: "{}",
			goalEnabled: false,
			description:
				"Send your contacts a new offer based on their interests.",
		},
		nodes: [
			{
				id: "1",
				type: "enrollment_trigger",
				dimensions: {
					width: 300,
					height: 82,
				},
				computedPosition: {
					x: 550,
					y: 116,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 550,
					y: 116,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "2",
				type: "exit_node",
				dimensions: {
					width: 300,
					height: 16,
				},
				computedPosition: {
					x: 550,
					y: 3614,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 550,
					y: 3614,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "36edc332-908a-4cb5-97f3-c3b7f36dcffa",
				type: "email_node",
				dimensions: {
					width: 300,
					height: 193,
				},
				computedPosition: {
					x: 550,
					y: 453.5,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 550,
					y: 453.5,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "7c90bba3-0f9f-448b-b7e3-121e233bdc0f",
				type: "delay_node",
				dimensions: {
					width: 300,
					height: 82,
				},
				computedPosition: {
					x: 550,
					y: 791,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 550,
					y: 791,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
				type: "decision_node",
				dimensions: {
					width: 300,
					height: 82,
				},
				computedPosition: {
					x: 550,
					y: 1073,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 550,
					y: 1073,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "e27a6f73-12ea-417e-8ab1-814fc1585801-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
				type: "A",
				dimensions: {
					width: 300,
					height: 20,
				},
				computedPosition: {
					x: 150,
					y: 1373,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 150,
					y: 1373,
				},
				data: {
					metadata:
						'{"style":{"backgroundColor":"#3B82F6"},"label":"Yes"}',
				},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "decision_node-A-bd1688e6-cdea-4dee-8bca-ad90a1322a26-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
				type: "garbage_node",
				dimensions: {
					width: 300,
					height: 20,
				},
				computedPosition: {
					x: 150,
					y: 3014,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 150,
					y: 3014,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "d7f50c15-8c3d-4879-bb12-1de9268a425e-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
				type: "B",
				dimensions: {
					width: 300,
					height: 20,
				},
				computedPosition: {
					x: 950,
					y: 1373,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 950,
					y: 1373,
				},
				data: {
					metadata: '{"style":{"backgroundColor":"#6B7280"},"label":"No"}',
				},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "decision_node-B-4e9b2928-71ca-4c53-9aea-b1124bb57ac5-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
				type: "garbage_node",
				dimensions: {
					width: 300,
					height: 20,
				},
				computedPosition: {
					x: 950,
					y: 3014,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 950,
					y: 3014,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "decision_node-b3ed51d4-8f82-402b-9aa2-386a53ef2245-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
				type: "dot",
				dimensions: {
					width: 300,
					height: 10,
				},
				computedPosition: {
					x: 550,
					y: 3314,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 550,
					y: 3314,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "814fdfea-1fc3-4d07-a5b1-b7c791afcdab",
				type: "action_node",
				dimensions: {
					width: 300,
					height: 82,
				},
				computedPosition: {
					x: 150,
					y: 1655,
					z: 1000,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: true,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 150,
					y: 1655,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "68bcf5f0-874d-4880-8ce4-2dcfe6e3ad7f",
				type: "email_node",
				dimensions: {
					width: 300,
					height: 193,
				},
				computedPosition: {
					x: 150,
					y: 1992.5,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 150,
					y: 1992.5,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "1a42a5e8-f5b1-42ff-a3ae-b3bd7f8a92d5",
				type: "delay_node",
				dimensions: {
					width: 300,
					height: 82,
				},
				computedPosition: {
					x: 150,
					y: 2330,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 150,
					y: 2330,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "4e4060b3-50eb-4954-91f2-2cf45fabfa4b",
				type: "email_node",
				dimensions: {
					width: 300,
					height: 193,
				},
				computedPosition: {
					x: 150,
					y: 2667.5,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 150,
					y: 2667.5,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
		],
		edges: [
			{
				id: "deb192e0-2ad8-4567-b493-c77a65027d67",
				type: "step",
				source: "1",
				target: "36edc332-908a-4cb5-97f3-c3b7f36dcffa",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "1",
					type: "enrollment_trigger",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 550,
						y: 116,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 550,
						y: 116,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "36edc332-908a-4cb5-97f3-c3b7f36dcffa",
					type: "email_node",
					dimensions: {
						width: 300,
						height: 193,
					},
					computedPosition: {
						x: 550,
						y: 453.5,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 550,
						y: 453.5,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 700,
				sourceY: 198,
				targetX: 700,
				targetY: 453.5,
			},
			{
				id: "66f34a8c-2d87-4ee1-92c2-96ad3716fab6",
				type: "step",
				source: "36edc332-908a-4cb5-97f3-c3b7f36dcffa",
				target: "7c90bba3-0f9f-448b-b7e3-121e233bdc0f",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "36edc332-908a-4cb5-97f3-c3b7f36dcffa",
					type: "email_node",
					dimensions: {
						width: 300,
						height: 193,
					},
					computedPosition: {
						x: 550,
						y: 453.5,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 550,
						y: 453.5,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "7c90bba3-0f9f-448b-b7e3-121e233bdc0f",
					type: "delay_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 550,
						y: 791,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 550,
						y: 791,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 700,
				sourceY: 646.5,
				targetX: 700,
				targetY: 791,
			},
			{
				id: "21137b1c-90c8-43e0-9d2f-301da7b4257f",
				type: "default",
				source: "7c90bba3-0f9f-448b-b7e3-121e233bdc0f",
				target: "e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "7c90bba3-0f9f-448b-b7e3-121e233bdc0f",
					type: "delay_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 550,
						y: 791,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 550,
						y: 791,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
					type: "decision_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 550,
						y: 1073,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 550,
						y: 1073,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 700,
				sourceY: 873,
				targetX: 700,
				targetY: 1073,
			},
			{
				id: "098f50d4-8619-4681-9553-660eaf0f3ec3",
				type: "step",
				source: "e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
				target:
					"e27a6f73-12ea-417e-8ab1-814fc1585801-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
					type: "decision_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 550,
						y: 1073,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 550,
						y: 1073,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "e27a6f73-12ea-417e-8ab1-814fc1585801-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
					type: "A",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 150,
						y: 1373,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 1373,
					},
					data: {
						metadata:
							'{"style":{"backgroundColor":"#3B82F6"},"label":"Yes"}',
					},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 700,
				sourceY: 1155,
				targetX: 300,
				targetY: 1373,
			},
			{
				id: "406c5f2e-624b-499e-ac5d-1717c5984bbf",
				type: "step",
				source: "e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
				target:
					"d7f50c15-8c3d-4879-bb12-1de9268a425e-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
					type: "decision_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 550,
						y: 1073,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 550,
						y: 1073,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "d7f50c15-8c3d-4879-bb12-1de9268a425e-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
					type: "B",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 950,
						y: 1373,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 1373,
					},
					data: {
						metadata:
							'{"style":{"backgroundColor":"#6B7280"},"label":"No"}',
					},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 700,
				sourceY: 1155,
				targetX: 1100,
				targetY: 1373,
			},
			{
				id: "2ed573ff-b5eb-4790-b124-0c74f3a7a341",
				type: "step",
				source:
					"d7f50c15-8c3d-4879-bb12-1de9268a425e-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
				target:
					"decision_node-B-4e9b2928-71ca-4c53-9aea-b1124bb57ac5-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "d7f50c15-8c3d-4879-bb12-1de9268a425e-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
					type: "B",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 950,
						y: 1373,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 1373,
					},
					data: {
						metadata:
							'{"style":{"backgroundColor":"#6B7280"},"label":"No"}',
					},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "decision_node-B-4e9b2928-71ca-4c53-9aea-b1124bb57ac5-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
					type: "garbage_node",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 950,
						y: 3014,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 3014,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1100,
				sourceY: 1393,
				targetX: 1100,
				targetY: 3014,
			},
			{
				id: "e1cf6344-1627-4dcf-9b56-5550d708066e",
				type: "step",
				source:
					"decision_node-A-bd1688e6-cdea-4dee-8bca-ad90a1322a26-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
				target:
					"decision_node-b3ed51d4-8f82-402b-9aa2-386a53ef2245-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "decision_node-A-bd1688e6-cdea-4dee-8bca-ad90a1322a26-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
					type: "garbage_node",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 150,
						y: 3014,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 3014,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "decision_node-b3ed51d4-8f82-402b-9aa2-386a53ef2245-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
					type: "dot",
					dimensions: {
						width: 300,
						height: 10,
					},
					computedPosition: {
						x: 550,
						y: 3314,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 550,
						y: 3314,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 300,
				sourceY: 3034,
				targetX: 700,
				targetY: 3314,
			},
			{
				id: "4f4f6b60-5c95-4406-9b0a-6a257a651903",
				type: "step",
				source:
					"decision_node-B-4e9b2928-71ca-4c53-9aea-b1124bb57ac5-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
				target:
					"decision_node-b3ed51d4-8f82-402b-9aa2-386a53ef2245-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "decision_node-B-4e9b2928-71ca-4c53-9aea-b1124bb57ac5-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
					type: "garbage_node",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 950,
						y: 3014,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 3014,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "decision_node-b3ed51d4-8f82-402b-9aa2-386a53ef2245-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
					type: "dot",
					dimensions: {
						width: 300,
						height: 10,
					},
					computedPosition: {
						x: 550,
						y: 3314,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 550,
						y: 3314,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1100,
				sourceY: 3034,
				targetX: 700,
				targetY: 3314,
			},
			{
				id: "668159c7-4d9b-4204-9c51-f9bbab034180",
				type: "step",
				source:
					"decision_node-b3ed51d4-8f82-402b-9aa2-386a53ef2245-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
				target: "2",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "decision_node-b3ed51d4-8f82-402b-9aa2-386a53ef2245-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
					type: "dot",
					dimensions: {
						width: 300,
						height: 10,
					},
					computedPosition: {
						x: 550,
						y: 3314,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 550,
						y: 3314,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "2",
					type: "exit_node",
					dimensions: {
						width: 300,
						height: 16,
					},
					computedPosition: {
						x: 550,
						y: 3614,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 550,
						y: 3614,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 700,
				sourceY: 3324,
				targetX: 700,
				targetY: 3614,
			},
			{
				id: "214aa778-f930-4ce7-9c1d-20b95eb3903f",
				type: "step",
				source:
					"e27a6f73-12ea-417e-8ab1-814fc1585801-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
				target: "814fdfea-1fc3-4d07-a5b1-b7c791afcdab",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "e27a6f73-12ea-417e-8ab1-814fc1585801-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
					type: "A",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 150,
						y: 1373,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 1373,
					},
					data: {
						metadata:
							'{"style":{"backgroundColor":"#3B82F6"},"label":"Yes"}',
					},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "814fdfea-1fc3-4d07-a5b1-b7c791afcdab",
					type: "action_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 150,
						y: 1655,
						z: 1000,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: true,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 1655,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 300,
				sourceY: 1393,
				targetX: 300,
				targetY: 1655,
			},
			{
				id: "28dbc483-5b4a-4f6e-9276-bc75f55b4248",
				type: "step",
				source: "814fdfea-1fc3-4d07-a5b1-b7c791afcdab",
				target: "68bcf5f0-874d-4880-8ce4-2dcfe6e3ad7f",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "814fdfea-1fc3-4d07-a5b1-b7c791afcdab",
					type: "action_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 150,
						y: 1655,
						z: 1000,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: true,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 1655,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "68bcf5f0-874d-4880-8ce4-2dcfe6e3ad7f",
					type: "email_node",
					dimensions: {
						width: 300,
						height: 193,
					},
					computedPosition: {
						x: 150,
						y: 1992.5,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 1992.5,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 300,
				sourceY: 1737,
				targetX: 300,
				targetY: 1992.5,
			},
			{
				id: "4da5e5d4-e4ae-4b89-a648-fbc0c99dd316",
				type: "step",
				source: "68bcf5f0-874d-4880-8ce4-2dcfe6e3ad7f",
				target: "1a42a5e8-f5b1-42ff-a3ae-b3bd7f8a92d5",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "68bcf5f0-874d-4880-8ce4-2dcfe6e3ad7f",
					type: "email_node",
					dimensions: {
						width: 300,
						height: 193,
					},
					computedPosition: {
						x: 150,
						y: 1992.5,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 1992.5,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "1a42a5e8-f5b1-42ff-a3ae-b3bd7f8a92d5",
					type: "delay_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 150,
						y: 2330,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 2330,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 300,
				sourceY: 2185.5,
				targetX: 300,
				targetY: 2330,
			},
			{
				id: "71ed7710-0517-489d-848b-6f4822df93e8",
				type: "step",
				source: "1a42a5e8-f5b1-42ff-a3ae-b3bd7f8a92d5",
				target: "4e4060b3-50eb-4954-91f2-2cf45fabfa4b",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "1a42a5e8-f5b1-42ff-a3ae-b3bd7f8a92d5",
					type: "delay_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 150,
						y: 2330,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 2330,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "4e4060b3-50eb-4954-91f2-2cf45fabfa4b",
					type: "email_node",
					dimensions: {
						width: 300,
						height: 193,
					},
					computedPosition: {
						x: 150,
						y: 2667.5,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 2667.5,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 300,
				sourceY: 2412,
				targetX: 300,
				targetY: 2667.5,
			},
			{
				id: "a4e5058f-de53-442e-bb0c-30b1742f0ad3",
				type: "step",
				source: "4e4060b3-50eb-4954-91f2-2cf45fabfa4b",
				target:
					"decision_node-A-bd1688e6-cdea-4dee-8bca-ad90a1322a26-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "4e4060b3-50eb-4954-91f2-2cf45fabfa4b",
					type: "email_node",
					dimensions: {
						width: 300,
						height: 193,
					},
					computedPosition: {
						x: 150,
						y: 2667.5,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 2667.5,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "decision_node-A-bd1688e6-cdea-4dee-8bca-ad90a1322a26-e41a2912-b54f-4a76-b2e3-b9143c5c8db7",
					type: "garbage_node",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 150,
						y: 3014,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 3014,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 300,
				sourceY: 2860.5,
				targetX: 300,
				targetY: 3014,
			},
		],
		tags: ["Promotion"],
	},
	{
		workflow: {
			name: "New promotion",
			status: false,
			evaluateExisting: false,
			excludeContacts: false,
			goal: "{}",
			goalEnabled: false,
			description:
				"Send contacts new promotions and update custom fields based on their interaction with the campaigns.",
		},
		nodes: [
			{
				id: "1",
				type: "enrollment_trigger",
				dimensions: {
					width: 300,
					height: 82,
				},
				computedPosition: {
					x: 1350,
					y: 116,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 1350,
					y: 116,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "2",
				type: "exit_node",
				dimensions: {
					width: 300,
					height: 16,
				},
				computedPosition: {
					x: 1350,
					y: 4403,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 1350,
					y: 4403,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "2583e971-c147-41e3-8ae9-e5175422a8e6",
				type: "email_node",
				dimensions: {
					width: 300,
					height: 193,
				},
				computedPosition: {
					x: 1350,
					y: 453.5,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 1350,
					y: 453.5,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "5ce10fff-2689-4fd4-9322-fc417e8fd4f4",
				type: "delay_node",
				dimensions: {
					width: 300,
					height: 82,
				},
				computedPosition: {
					x: 1350,
					y: 791,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 1350,
					y: 791,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "52c6cf6b-e43f-4549-b177-8979e640d1c8",
				type: "decision_node",
				dimensions: {
					width: 300,
					height: 82,
				},
				computedPosition: {
					x: 1350,
					y: 1073,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 1350,
					y: 1073,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "73924e6c-d84d-49a9-919f-2684da4a6b33-52c6cf6b-e43f-4549-b177-8979e640d1c8",
				type: "A",
				dimensions: {
					width: 300,
					height: 20,
				},
				computedPosition: {
					x: 550,
					y: 1373,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 550,
					y: 1373,
				},
				data: {
					metadata:
						'{"style":{"backgroundColor":"#3B82F6"},"label":"Yes"}',
				},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "decision_node-A-054daaff-cf9f-49ee-8362-d48dc6f27426-52c6cf6b-e43f-4549-b177-8979e640d1c8",
				type: "garbage_node",
				dimensions: {
					width: 300,
					height: 20,
				},
				computedPosition: {
					x: 550,
					y: 3803,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 550,
					y: 3803,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "bfa5e239-4117-4ba1-a2dd-6e392b4be5c1-52c6cf6b-e43f-4549-b177-8979e640d1c8",
				type: "B",
				dimensions: {
					width: 300,
					height: 20,
				},
				computedPosition: {
					x: 2150,
					y: 1373,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 2150,
					y: 1373,
				},
				data: {
					metadata: '{"style":{"backgroundColor":"#6B7280"},"label":"No"}',
				},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "decision_node-B-6ac221a6-0002-4237-b13c-1583f7c80b6d-52c6cf6b-e43f-4549-b177-8979e640d1c8",
				type: "garbage_node",
				dimensions: {
					width: 300,
					height: 20,
				},
				computedPosition: {
					x: 2150,
					y: 3803,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 2150,
					y: 3803,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "decision_node-766d7987-49fd-4243-a25a-8d7919085b4c-52c6cf6b-e43f-4549-b177-8979e640d1c8",
				type: "dot",
				dimensions: {
					width: 300,
					height: 10,
				},
				computedPosition: {
					x: 1350,
					y: 4103,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 1350,
					y: 4103,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "b2576772-a2e0-4951-89b6-df834be69bf3",
				type: "email_node",
				dimensions: {
					width: 300,
					height: 193,
				},
				computedPosition: {
					x: 550,
					y: 1710.5,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 550,
					y: 1710.5,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "08f21502-7cb4-4b73-b6e7-048193d837f2",
				type: "delay_node",
				dimensions: {
					width: 300,
					height: 82,
				},
				computedPosition: {
					x: 550,
					y: 2048,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 550,
					y: 2048,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "e7ecf3a3-e699-48d7-8d2c-74c18670e494",
				type: "decision_node",
				dimensions: {
					width: 300,
					height: 82,
				},
				computedPosition: {
					x: 550,
					y: 2330,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 550,
					y: 2330,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "622a7acc-85b0-405c-8d77-cce3fb0990cd-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
				type: "A",
				dimensions: {
					width: 300,
					height: 20,
				},
				computedPosition: {
					x: 150,
					y: 2630,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 150,
					y: 2630,
				},
				data: {
					metadata:
						'{"style":{"backgroundColor":"#3B82F6"},"label":"Yes"}',
				},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "decision_node-A-0e1f776e-bbaa-4f3c-bcfa-d0a022a8305f-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
				type: "garbage_node",
				dimensions: {
					width: 300,
					height: 20,
				},
				computedPosition: {
					x: 150,
					y: 3203,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 150,
					y: 3203,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "4777707c-47d9-4425-95b0-2ced3bb644a6-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
				type: "B",
				dimensions: {
					width: 300,
					height: 20,
				},
				computedPosition: {
					x: 950,
					y: 2630,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 950,
					y: 2630,
				},
				data: {
					metadata: '{"style":{"backgroundColor":"#6B7280"},"label":"No"}',
				},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "decision_node-B-beefada9-28b4-4da8-8a01-abcc8c1b209f-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
				type: "garbage_node",
				dimensions: {
					width: 300,
					height: 20,
				},
				computedPosition: {
					x: 950,
					y: 3203,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 950,
					y: 3203,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "decision_node-c035effc-349a-44bb-9f95-381cd03b3419-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
				type: "dot",
				dimensions: {
					width: 300,
					height: 10,
				},
				computedPosition: {
					x: 550,
					y: 3503,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 550,
					y: 3503,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "85e358c6-a6b0-4e5a-b336-e0fd7b1de477",
				type: "action_node",
				dimensions: {
					width: 300,
					height: 82,
				},
				computedPosition: {
					x: 150,
					y: 2912,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 150,
					y: 2912,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "07db5eee-bc8d-4b0a-a9e0-16a201149eaf",
				type: "action_node",
				dimensions: {
					width: 300,
					height: 82,
				},
				computedPosition: {
					x: 950,
					y: 2912,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 950,
					y: 2912,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "b7dfd730-d8c9-40bf-bd9a-ba3687c25855",
				type: "email_node",
				dimensions: {
					width: 300,
					height: 193,
				},
				computedPosition: {
					x: 2150,
					y: 1710.5,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 2150,
					y: 1710.5,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "7546943c-1dec-48ad-90a8-4143dd9e4d9b",
				type: "delay_node",
				dimensions: {
					width: 300,
					height: 82,
				},
				computedPosition: {
					x: 2150,
					y: 2048,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 2150,
					y: 2048,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "3a365ed3-7e39-45ed-87d8-bd49fa87d011",
				type: "decision_node",
				dimensions: {
					width: 300,
					height: 82,
				},
				computedPosition: {
					x: 2150,
					y: 2330,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 2150,
					y: 2330,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "d3e76a07-25d1-44f6-b484-62678577ad10-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
				type: "A",
				dimensions: {
					width: 300,
					height: 20,
				},
				computedPosition: {
					x: 1750,
					y: 2630,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 1750,
					y: 2630,
				},
				data: {
					metadata:
						'{"style":{"backgroundColor":"#3B82F6"},"label":"Yes"}',
				},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "decision_node-A-765e3f51-f4db-4c3a-8391-358e2c11a2c3-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
				type: "garbage_node",
				dimensions: {
					width: 300,
					height: 20,
				},
				computedPosition: {
					x: 1750,
					y: 3203,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 1750,
					y: 3203,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "70394dbb-4dfe-4b86-a06f-377b91285181-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
				type: "B",
				dimensions: {
					width: 300,
					height: 20,
				},
				computedPosition: {
					x: 2550,
					y: 2630,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 2550,
					y: 2630,
				},
				data: {
					metadata: '{"style":{"backgroundColor":"#6B7280"},"label":"No"}',
				},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "decision_node-B-5d895ac4-e33a-442c-9f2d-b2cf81437ec2-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
				type: "garbage_node",
				dimensions: {
					width: 300,
					height: 20,
				},
				computedPosition: {
					x: 2550,
					y: 3203,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 2550,
					y: 3203,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "decision_node-16ecd7cd-b5a8-4e91-bd21-7c6bc9d90cce-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
				type: "dot",
				dimensions: {
					width: 300,
					height: 10,
				},
				computedPosition: {
					x: 2150,
					y: 3503,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 2150,
					y: 3503,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "59145a02-891b-428e-b37f-a46d2e2a1e15",
				type: "action_node",
				dimensions: {
					width: 300,
					height: 82,
				},
				computedPosition: {
					x: 1750,
					y: 2912,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 1750,
					y: 2912,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
			{
				id: "682e6c0f-2c0e-46e3-ac2f-3d0b90f2ecc9",
				type: "action_node",
				dimensions: {
					width: 300,
					height: 82,
				},
				computedPosition: {
					x: 2550,
					y: 2912,
					z: 0,
				},
				handleBounds: {
					source: [],
					target: [],
				},
				selected: false,
				dragging: false,
				resizing: false,
				initialized: false,
				isParent: false,
				position: {
					x: 2550,
					y: 2912,
				},
				data: {},
				events: {},
				targetPosition: "top",
				sourcePosition: "bottom",
			},
		],
		edges: [
			{
				id: "894e3e03-ca5c-49a0-9249-cbfc83cf2a3e",
				type: "step",
				source: "1",
				target: "2583e971-c147-41e3-8ae9-e5175422a8e6",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "1",
					type: "enrollment_trigger",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 1350,
						y: 116,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1350,
						y: 116,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "2583e971-c147-41e3-8ae9-e5175422a8e6",
					type: "email_node",
					dimensions: {
						width: 300,
						height: 193,
					},
					computedPosition: {
						x: 1350,
						y: 453.5,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1350,
						y: 453.5,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1500,
				sourceY: 198,
				targetX: 1500,
				targetY: 453.5,
			},
			{
				id: "f75a988b-8e98-46e6-b64e-725d25062794",
				type: "step",
				source: "2583e971-c147-41e3-8ae9-e5175422a8e6",
				target: "5ce10fff-2689-4fd4-9322-fc417e8fd4f4",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "2583e971-c147-41e3-8ae9-e5175422a8e6",
					type: "email_node",
					dimensions: {
						width: 300,
						height: 193,
					},
					computedPosition: {
						x: 1350,
						y: 453.5,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1350,
						y: 453.5,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "5ce10fff-2689-4fd4-9322-fc417e8fd4f4",
					type: "delay_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 1350,
						y: 791,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1350,
						y: 791,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1500,
				sourceY: 646.5,
				targetX: 1500,
				targetY: 791,
			},
			{
				id: "8de4882e-6210-4614-8bd3-0075a30d8956",
				type: "default",
				source: "5ce10fff-2689-4fd4-9322-fc417e8fd4f4",
				target: "52c6cf6b-e43f-4549-b177-8979e640d1c8",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "5ce10fff-2689-4fd4-9322-fc417e8fd4f4",
					type: "delay_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 1350,
						y: 791,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1350,
						y: 791,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "52c6cf6b-e43f-4549-b177-8979e640d1c8",
					type: "decision_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 1350,
						y: 1073,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1350,
						y: 1073,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1500,
				sourceY: 873,
				targetX: 1500,
				targetY: 1073,
			},
			{
				id: "31e7541b-83f4-4d0a-8431-40b95d78d250",
				type: "step",
				source: "52c6cf6b-e43f-4549-b177-8979e640d1c8",
				target:
					"73924e6c-d84d-49a9-919f-2684da4a6b33-52c6cf6b-e43f-4549-b177-8979e640d1c8",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "52c6cf6b-e43f-4549-b177-8979e640d1c8",
					type: "decision_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 1350,
						y: 1073,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1350,
						y: 1073,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "73924e6c-d84d-49a9-919f-2684da4a6b33-52c6cf6b-e43f-4549-b177-8979e640d1c8",
					type: "A",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 550,
						y: 1373,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 550,
						y: 1373,
					},
					data: {
						metadata:
							'{"style":{"backgroundColor":"#3B82F6"},"label":"Yes"}',
					},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1500,
				sourceY: 1155,
				targetX: 700,
				targetY: 1373,
			},
			{
				id: "9e6e1cb6-7cea-42d6-a85e-6b13a7c5c90f",
				type: "step",
				source: "52c6cf6b-e43f-4549-b177-8979e640d1c8",
				target:
					"bfa5e239-4117-4ba1-a2dd-6e392b4be5c1-52c6cf6b-e43f-4549-b177-8979e640d1c8",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "52c6cf6b-e43f-4549-b177-8979e640d1c8",
					type: "decision_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 1350,
						y: 1073,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1350,
						y: 1073,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "bfa5e239-4117-4ba1-a2dd-6e392b4be5c1-52c6cf6b-e43f-4549-b177-8979e640d1c8",
					type: "B",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 2150,
						y: 1373,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 2150,
						y: 1373,
					},
					data: {
						metadata:
							'{"style":{"backgroundColor":"#6B7280"},"label":"No"}',
					},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1500,
				sourceY: 1155,
				targetX: 2300,
				targetY: 1373,
			},
			{
				id: "d60e39b8-a3d5-44aa-95b2-4243f7ca1641",
				type: "step",
				source:
					"decision_node-A-054daaff-cf9f-49ee-8362-d48dc6f27426-52c6cf6b-e43f-4549-b177-8979e640d1c8",
				target:
					"decision_node-766d7987-49fd-4243-a25a-8d7919085b4c-52c6cf6b-e43f-4549-b177-8979e640d1c8",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "decision_node-A-054daaff-cf9f-49ee-8362-d48dc6f27426-52c6cf6b-e43f-4549-b177-8979e640d1c8",
					type: "garbage_node",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 550,
						y: 3803,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 550,
						y: 3803,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "decision_node-766d7987-49fd-4243-a25a-8d7919085b4c-52c6cf6b-e43f-4549-b177-8979e640d1c8",
					type: "dot",
					dimensions: {
						width: 300,
						height: 10,
					},
					computedPosition: {
						x: 1350,
						y: 4103,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1350,
						y: 4103,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 700,
				sourceY: 3823,
				targetX: 1500,
				targetY: 4103,
			},
			{
				id: "1691394c-ae08-447f-9638-227ef2367c51",
				type: "step",
				source:
					"decision_node-B-6ac221a6-0002-4237-b13c-1583f7c80b6d-52c6cf6b-e43f-4549-b177-8979e640d1c8",
				target:
					"decision_node-766d7987-49fd-4243-a25a-8d7919085b4c-52c6cf6b-e43f-4549-b177-8979e640d1c8",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "decision_node-B-6ac221a6-0002-4237-b13c-1583f7c80b6d-52c6cf6b-e43f-4549-b177-8979e640d1c8",
					type: "garbage_node",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 2150,
						y: 3803,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 2150,
						y: 3803,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "decision_node-766d7987-49fd-4243-a25a-8d7919085b4c-52c6cf6b-e43f-4549-b177-8979e640d1c8",
					type: "dot",
					dimensions: {
						width: 300,
						height: 10,
					},
					computedPosition: {
						x: 1350,
						y: 4103,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1350,
						y: 4103,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 2300,
				sourceY: 3823,
				targetX: 1500,
				targetY: 4103,
			},
			{
				id: "ef252760-54eb-4a8c-b654-1e6990674942",
				type: "step",
				source:
					"decision_node-766d7987-49fd-4243-a25a-8d7919085b4c-52c6cf6b-e43f-4549-b177-8979e640d1c8",
				target: "2",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "decision_node-766d7987-49fd-4243-a25a-8d7919085b4c-52c6cf6b-e43f-4549-b177-8979e640d1c8",
					type: "dot",
					dimensions: {
						width: 300,
						height: 10,
					},
					computedPosition: {
						x: 1350,
						y: 4103,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1350,
						y: 4103,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "2",
					type: "exit_node",
					dimensions: {
						width: 300,
						height: 16,
					},
					computedPosition: {
						x: 1350,
						y: 4403,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1350,
						y: 4403,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1500,
				sourceY: 4113,
				targetX: 1500,
				targetY: 4403,
			},
			{
				id: "5b673654-88e8-4319-a815-ec9c623f25d4",
				type: "step",
				source:
					"73924e6c-d84d-49a9-919f-2684da4a6b33-52c6cf6b-e43f-4549-b177-8979e640d1c8",
				target: "b2576772-a2e0-4951-89b6-df834be69bf3",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "73924e6c-d84d-49a9-919f-2684da4a6b33-52c6cf6b-e43f-4549-b177-8979e640d1c8",
					type: "A",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 550,
						y: 1373,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 550,
						y: 1373,
					},
					data: {
						metadata:
							'{"style":{"backgroundColor":"#3B82F6"},"label":"Yes"}',
					},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "b2576772-a2e0-4951-89b6-df834be69bf3",
					type: "email_node",
					dimensions: {
						width: 300,
						height: 193,
					},
					computedPosition: {
						x: 550,
						y: 1710.5,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 550,
						y: 1710.5,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 700,
				sourceY: 1393,
				targetX: 700,
				targetY: 1710.5,
			},
			{
				id: "2fda84fc-8fd3-46da-9d74-2adf5369d359",
				type: "step",
				source: "b2576772-a2e0-4951-89b6-df834be69bf3",
				target: "08f21502-7cb4-4b73-b6e7-048193d837f2",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "b2576772-a2e0-4951-89b6-df834be69bf3",
					type: "email_node",
					dimensions: {
						width: 300,
						height: 193,
					},
					computedPosition: {
						x: 550,
						y: 1710.5,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 550,
						y: 1710.5,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "08f21502-7cb4-4b73-b6e7-048193d837f2",
					type: "delay_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 550,
						y: 2048,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 550,
						y: 2048,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 700,
				sourceY: 1903.5,
				targetX: 700,
				targetY: 2048,
			},
			{
				id: "d28fd655-91ef-466d-9f13-3416c64bddc4",
				type: "default",
				source: "08f21502-7cb4-4b73-b6e7-048193d837f2",
				target: "e7ecf3a3-e699-48d7-8d2c-74c18670e494",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "08f21502-7cb4-4b73-b6e7-048193d837f2",
					type: "delay_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 550,
						y: 2048,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 550,
						y: 2048,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "e7ecf3a3-e699-48d7-8d2c-74c18670e494",
					type: "decision_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 550,
						y: 2330,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 550,
						y: 2330,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 700,
				sourceY: 2130,
				targetX: 700,
				targetY: 2330,
			},
			{
				id: "f03a724f-53ab-47a9-bbd3-a96ba39a2f00",
				type: "step",
				source: "e7ecf3a3-e699-48d7-8d2c-74c18670e494",
				target:
					"622a7acc-85b0-405c-8d77-cce3fb0990cd-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "e7ecf3a3-e699-48d7-8d2c-74c18670e494",
					type: "decision_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 550,
						y: 2330,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 550,
						y: 2330,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "622a7acc-85b0-405c-8d77-cce3fb0990cd-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
					type: "A",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 150,
						y: 2630,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 2630,
					},
					data: {
						metadata:
							'{"style":{"backgroundColor":"#3B82F6"},"label":"Yes"}',
					},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 700,
				sourceY: 2412,
				targetX: 300,
				targetY: 2630,
			},
			{
				id: "751349e4-c48c-4548-9395-480b7a9a1b81",
				type: "step",
				source: "e7ecf3a3-e699-48d7-8d2c-74c18670e494",
				target:
					"4777707c-47d9-4425-95b0-2ced3bb644a6-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "e7ecf3a3-e699-48d7-8d2c-74c18670e494",
					type: "decision_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 550,
						y: 2330,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 550,
						y: 2330,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "4777707c-47d9-4425-95b0-2ced3bb644a6-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
					type: "B",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 950,
						y: 2630,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 2630,
					},
					data: {
						metadata:
							'{"style":{"backgroundColor":"#6B7280"},"label":"No"}',
					},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 700,
				sourceY: 2412,
				targetX: 1100,
				targetY: 2630,
			},
			{
				id: "467b93e8-9cf0-45a8-91ba-f71e53821f55",
				type: "step",
				source:
					"decision_node-A-0e1f776e-bbaa-4f3c-bcfa-d0a022a8305f-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
				target:
					"decision_node-c035effc-349a-44bb-9f95-381cd03b3419-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "decision_node-A-0e1f776e-bbaa-4f3c-bcfa-d0a022a8305f-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
					type: "garbage_node",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 150,
						y: 3203,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 3203,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "decision_node-c035effc-349a-44bb-9f95-381cd03b3419-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
					type: "dot",
					dimensions: {
						width: 300,
						height: 10,
					},
					computedPosition: {
						x: 550,
						y: 3503,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 550,
						y: 3503,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 300,
				sourceY: 3223,
				targetX: 700,
				targetY: 3503,
			},
			{
				id: "e6a43daf-d04f-4ebd-9a5a-c210cb4c2412",
				type: "step",
				source:
					"decision_node-B-beefada9-28b4-4da8-8a01-abcc8c1b209f-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
				target:
					"decision_node-c035effc-349a-44bb-9f95-381cd03b3419-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "decision_node-B-beefada9-28b4-4da8-8a01-abcc8c1b209f-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
					type: "garbage_node",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 950,
						y: 3203,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 3203,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "decision_node-c035effc-349a-44bb-9f95-381cd03b3419-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
					type: "dot",
					dimensions: {
						width: 300,
						height: 10,
					},
					computedPosition: {
						x: 550,
						y: 3503,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 550,
						y: 3503,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1100,
				sourceY: 3223,
				targetX: 700,
				targetY: 3503,
			},
			{
				id: "e84047ba-3fd6-4851-9a1c-e72478db4913",
				type: "step",
				source:
					"decision_node-c035effc-349a-44bb-9f95-381cd03b3419-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
				target:
					"decision_node-A-054daaff-cf9f-49ee-8362-d48dc6f27426-52c6cf6b-e43f-4549-b177-8979e640d1c8",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "decision_node-c035effc-349a-44bb-9f95-381cd03b3419-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
					type: "dot",
					dimensions: {
						width: 300,
						height: 10,
					},
					computedPosition: {
						x: 550,
						y: 3503,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 550,
						y: 3503,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "decision_node-A-054daaff-cf9f-49ee-8362-d48dc6f27426-52c6cf6b-e43f-4549-b177-8979e640d1c8",
					type: "garbage_node",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 550,
						y: 3803,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 550,
						y: 3803,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 700,
				sourceY: 3513,
				targetX: 700,
				targetY: 3803,
			},
			{
				id: "d542b259-6869-4856-9705-11e4a5a5af98",
				type: "step",
				source:
					"622a7acc-85b0-405c-8d77-cce3fb0990cd-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
				target: "85e358c6-a6b0-4e5a-b336-e0fd7b1de477",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "622a7acc-85b0-405c-8d77-cce3fb0990cd-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
					type: "A",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 150,
						y: 2630,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 2630,
					},
					data: {
						metadata:
							'{"style":{"backgroundColor":"#3B82F6"},"label":"Yes"}',
					},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "85e358c6-a6b0-4e5a-b336-e0fd7b1de477",
					type: "action_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 150,
						y: 2912,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 2912,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 300,
				sourceY: 2650,
				targetX: 300,
				targetY: 2912,
			},
			{
				id: "c0343de5-2fd7-4818-ab36-9a5dea9ac715",
				type: "step",
				source: "85e358c6-a6b0-4e5a-b336-e0fd7b1de477",
				target:
					"decision_node-A-0e1f776e-bbaa-4f3c-bcfa-d0a022a8305f-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "85e358c6-a6b0-4e5a-b336-e0fd7b1de477",
					type: "action_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 150,
						y: 2912,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 2912,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "decision_node-A-0e1f776e-bbaa-4f3c-bcfa-d0a022a8305f-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
					type: "garbage_node",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 150,
						y: 3203,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 150,
						y: 3203,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 300,
				sourceY: 2994,
				targetX: 300,
				targetY: 3203,
			},
			{
				id: "a34943c1-eab5-4706-bd78-8a3f2b93922d",
				type: "step",
				source:
					"4777707c-47d9-4425-95b0-2ced3bb644a6-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
				target: "07db5eee-bc8d-4b0a-a9e0-16a201149eaf",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "4777707c-47d9-4425-95b0-2ced3bb644a6-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
					type: "B",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 950,
						y: 2630,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 2630,
					},
					data: {
						metadata:
							'{"style":{"backgroundColor":"#6B7280"},"label":"No"}',
					},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "07db5eee-bc8d-4b0a-a9e0-16a201149eaf",
					type: "action_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 950,
						y: 2912,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 2912,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1100,
				sourceY: 2650,
				targetX: 1100,
				targetY: 2912,
			},
			{
				id: "880013ad-53d3-4441-9371-96d44c8f752e",
				type: "step",
				source: "07db5eee-bc8d-4b0a-a9e0-16a201149eaf",
				target:
					"decision_node-B-beefada9-28b4-4da8-8a01-abcc8c1b209f-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "07db5eee-bc8d-4b0a-a9e0-16a201149eaf",
					type: "action_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 950,
						y: 2912,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 2912,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "decision_node-B-beefada9-28b4-4da8-8a01-abcc8c1b209f-e7ecf3a3-e699-48d7-8d2c-74c18670e494",
					type: "garbage_node",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 950,
						y: 3203,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 950,
						y: 3203,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1100,
				sourceY: 2994,
				targetX: 1100,
				targetY: 3203,
			},
			{
				id: "182c6779-ba89-4f9f-95f4-4f721d3ba9d6",
				type: "step",
				source:
					"bfa5e239-4117-4ba1-a2dd-6e392b4be5c1-52c6cf6b-e43f-4549-b177-8979e640d1c8",
				target: "b7dfd730-d8c9-40bf-bd9a-ba3687c25855",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "bfa5e239-4117-4ba1-a2dd-6e392b4be5c1-52c6cf6b-e43f-4549-b177-8979e640d1c8",
					type: "B",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 2150,
						y: 1373,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 2150,
						y: 1373,
					},
					data: {
						metadata:
							'{"style":{"backgroundColor":"#6B7280"},"label":"No"}',
					},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "b7dfd730-d8c9-40bf-bd9a-ba3687c25855",
					type: "email_node",
					dimensions: {
						width: 300,
						height: 193,
					},
					computedPosition: {
						x: 2150,
						y: 1710.5,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 2150,
						y: 1710.5,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 2300,
				sourceY: 1393,
				targetX: 2300,
				targetY: 1710.5,
			},
			{
				id: "92df6c24-6907-4ad1-87e5-800ebf137322",
				type: "step",
				source: "b7dfd730-d8c9-40bf-bd9a-ba3687c25855",
				target: "7546943c-1dec-48ad-90a8-4143dd9e4d9b",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "b7dfd730-d8c9-40bf-bd9a-ba3687c25855",
					type: "email_node",
					dimensions: {
						width: 300,
						height: 193,
					},
					computedPosition: {
						x: 2150,
						y: 1710.5,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 2150,
						y: 1710.5,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "7546943c-1dec-48ad-90a8-4143dd9e4d9b",
					type: "delay_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 2150,
						y: 2048,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 2150,
						y: 2048,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 2300,
				sourceY: 1903.5,
				targetX: 2300,
				targetY: 2048,
			},
			{
				id: "a9600b2e-e2ac-4944-83ff-1497a5c818ab",
				type: "default",
				source: "7546943c-1dec-48ad-90a8-4143dd9e4d9b",
				target: "3a365ed3-7e39-45ed-87d8-bd49fa87d011",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "7546943c-1dec-48ad-90a8-4143dd9e4d9b",
					type: "delay_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 2150,
						y: 2048,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 2150,
						y: 2048,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "3a365ed3-7e39-45ed-87d8-bd49fa87d011",
					type: "decision_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 2150,
						y: 2330,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 2150,
						y: 2330,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 2300,
				sourceY: 2130,
				targetX: 2300,
				targetY: 2330,
			},
			{
				id: "12782e12-9617-47c6-afbe-007cac6b0649",
				type: "step",
				source: "3a365ed3-7e39-45ed-87d8-bd49fa87d011",
				target:
					"d3e76a07-25d1-44f6-b484-62678577ad10-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "3a365ed3-7e39-45ed-87d8-bd49fa87d011",
					type: "decision_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 2150,
						y: 2330,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 2150,
						y: 2330,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "d3e76a07-25d1-44f6-b484-62678577ad10-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
					type: "A",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 1750,
						y: 2630,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1750,
						y: 2630,
					},
					data: {
						metadata:
							'{"style":{"backgroundColor":"#3B82F6"},"label":"Yes"}',
					},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 2300,
				sourceY: 2412,
				targetX: 1900,
				targetY: 2630,
			},
			{
				id: "0afc3e8d-4e80-4783-8ccc-0ee06ded6c02",
				type: "step",
				source: "3a365ed3-7e39-45ed-87d8-bd49fa87d011",
				target:
					"70394dbb-4dfe-4b86-a06f-377b91285181-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "3a365ed3-7e39-45ed-87d8-bd49fa87d011",
					type: "decision_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 2150,
						y: 2330,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 2150,
						y: 2330,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "70394dbb-4dfe-4b86-a06f-377b91285181-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
					type: "B",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 2550,
						y: 2630,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 2550,
						y: 2630,
					},
					data: {
						metadata:
							'{"style":{"backgroundColor":"#6B7280"},"label":"No"}',
					},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 2300,
				sourceY: 2412,
				targetX: 2700,
				targetY: 2630,
			},
			{
				id: "8e220883-2850-4d1e-9f00-8888770ce93d",
				type: "step",
				source:
					"decision_node-A-765e3f51-f4db-4c3a-8391-358e2c11a2c3-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
				target:
					"decision_node-16ecd7cd-b5a8-4e91-bd21-7c6bc9d90cce-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "decision_node-A-765e3f51-f4db-4c3a-8391-358e2c11a2c3-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
					type: "garbage_node",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 1750,
						y: 3203,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1750,
						y: 3203,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "decision_node-16ecd7cd-b5a8-4e91-bd21-7c6bc9d90cce-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
					type: "dot",
					dimensions: {
						width: 300,
						height: 10,
					},
					computedPosition: {
						x: 2150,
						y: 3503,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 2150,
						y: 3503,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1900,
				sourceY: 3223,
				targetX: 2300,
				targetY: 3503,
			},
			{
				id: "9ec450d8-58e1-4cec-9861-20e464abdd1e",
				type: "step",
				source:
					"decision_node-B-5d895ac4-e33a-442c-9f2d-b2cf81437ec2-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
				target:
					"decision_node-16ecd7cd-b5a8-4e91-bd21-7c6bc9d90cce-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "decision_node-B-5d895ac4-e33a-442c-9f2d-b2cf81437ec2-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
					type: "garbage_node",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 2550,
						y: 3203,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 2550,
						y: 3203,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "decision_node-16ecd7cd-b5a8-4e91-bd21-7c6bc9d90cce-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
					type: "dot",
					dimensions: {
						width: 300,
						height: 10,
					},
					computedPosition: {
						x: 2150,
						y: 3503,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 2150,
						y: 3503,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 2700,
				sourceY: 3223,
				targetX: 2300,
				targetY: 3503,
			},
			{
				id: "f0913565-5864-4435-9311-74992e8c79e4",
				type: "step",
				source:
					"decision_node-16ecd7cd-b5a8-4e91-bd21-7c6bc9d90cce-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
				target:
					"decision_node-B-6ac221a6-0002-4237-b13c-1583f7c80b6d-52c6cf6b-e43f-4549-b177-8979e640d1c8",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "decision_node-16ecd7cd-b5a8-4e91-bd21-7c6bc9d90cce-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
					type: "dot",
					dimensions: {
						width: 300,
						height: 10,
					},
					computedPosition: {
						x: 2150,
						y: 3503,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 2150,
						y: 3503,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "decision_node-B-6ac221a6-0002-4237-b13c-1583f7c80b6d-52c6cf6b-e43f-4549-b177-8979e640d1c8",
					type: "garbage_node",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 2150,
						y: 3803,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 2150,
						y: 3803,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 2300,
				sourceY: 3513,
				targetX: 2300,
				targetY: 3803,
			},
			{
				id: "2406db07-2e06-41b2-aaf6-49c65efb1a11",
				type: "step",
				source:
					"d3e76a07-25d1-44f6-b484-62678577ad10-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
				target: "59145a02-891b-428e-b37f-a46d2e2a1e15",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "d3e76a07-25d1-44f6-b484-62678577ad10-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
					type: "A",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 1750,
						y: 2630,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1750,
						y: 2630,
					},
					data: {
						metadata:
							'{"style":{"backgroundColor":"#3B82F6"},"label":"Yes"}',
					},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "59145a02-891b-428e-b37f-a46d2e2a1e15",
					type: "action_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 1750,
						y: 2912,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1750,
						y: 2912,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1900,
				sourceY: 2650,
				targetX: 1900,
				targetY: 2912,
			},
			{
				id: "fbe72ff4-cb68-42d8-a1d7-37262c8b1d76",
				type: "step",
				source: "59145a02-891b-428e-b37f-a46d2e2a1e15",
				target:
					"decision_node-A-765e3f51-f4db-4c3a-8391-358e2c11a2c3-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "59145a02-891b-428e-b37f-a46d2e2a1e15",
					type: "action_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 1750,
						y: 2912,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1750,
						y: 2912,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "decision_node-A-765e3f51-f4db-4c3a-8391-358e2c11a2c3-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
					type: "garbage_node",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 1750,
						y: 3203,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 1750,
						y: 3203,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 1900,
				sourceY: 2994,
				targetX: 1900,
				targetY: 3203,
			},
			{
				id: "acad134c-0d16-4766-9290-d9bf7fcc5522",
				type: "step",
				source:
					"70394dbb-4dfe-4b86-a06f-377b91285181-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
				target: "682e6c0f-2c0e-46e3-ac2f-3d0b90f2ecc9",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "70394dbb-4dfe-4b86-a06f-377b91285181-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
					type: "B",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 2550,
						y: 2630,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 2550,
						y: 2630,
					},
					data: {
						metadata:
							'{"style":{"backgroundColor":"#6B7280"},"label":"No"}',
					},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "682e6c0f-2c0e-46e3-ac2f-3d0b90f2ecc9",
					type: "action_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 2550,
						y: 2912,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 2550,
						y: 2912,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 2700,
				sourceY: 2650,
				targetX: 2700,
				targetY: 2912,
			},
			{
				id: "380582e1-b120-4a74-ae88-c913d686d332",
				type: "step",
				source: "682e6c0f-2c0e-46e3-ac2f-3d0b90f2ecc9",
				target:
					"decision_node-B-5d895ac4-e33a-442c-9f2d-b2cf81437ec2-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
				data: {},
				events: {},
				label: "",
				sourceNode: {
					id: "682e6c0f-2c0e-46e3-ac2f-3d0b90f2ecc9",
					type: "action_node",
					dimensions: {
						width: 300,
						height: 82,
					},
					computedPosition: {
						x: 2550,
						y: 2912,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 2550,
						y: 2912,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				targetNode: {
					id: "decision_node-B-5d895ac4-e33a-442c-9f2d-b2cf81437ec2-3a365ed3-7e39-45ed-87d8-bd49fa87d011",
					type: "garbage_node",
					dimensions: {
						width: 300,
						height: 20,
					},
					computedPosition: {
						x: 2550,
						y: 3203,
						z: 0,
					},
					handleBounds: {
						source: [],
						target: [],
					},
					selected: false,
					dragging: false,
					resizing: false,
					initialized: false,
					isParent: false,
					position: {
						x: 2550,
						y: 3203,
					},
					data: {},
					events: {},
					targetPosition: "top",
					sourcePosition: "bottom",
				},
				sourceX: 2700,
				sourceY: 2994,
				targetX: 2700,
				targetY: 3203,
			},
		],
		tags: ["Promotion"],
	},
];

export const SegmentOptions = Object.freeze([
	{
		label: "Contacts",
		items: [
			{
				id: "unsubscribed",
				label: "Unsubscribed from all email communication",
				conditions: [
					{
						label: "equal",
						value: "equal",
					},
				],
				input: Segment.Input.RADIO,
				type: Segment.Type.INTEGER,
			},
			{
				id: "bounced",
				label: "Email address bounced",
				conditions: [
					{
						label: "equal",
						value: "equal",
					},
				],
				input: Segment.Input.RADIO,
				type: Segment.Type.INTEGER,
			},
			{
				id: "marked-spam",
				label: "Marked spam",
				conditions: [
					{
						label: "equal",
						value: "equal",
					},
				],
				input: Segment.Input.RADIO,
				type: Segment.Type.INTEGER,
			},

			{
				id: "lists",
				label: "Lists",
				conditions: [
					{ label: "Any of", value: "in" },
					{ label: "None of", value: "not_in" },
				],
				input: Segment.Input.CHECKBOX,
				type: Segment.Type.INTEGER,
				options: Segment.Option.LISTS,
			},
			{
				id: "tags",
				label: "Tags",
				conditions: [
					{ label: "Any of", value: "in" },
					{ label: "None of", value: "not_in" },
				],
				input: Segment.Input.CHECKBOX,
				type: Segment.Type.INTEGER,
				options: Segment.Option.TAGS,
			},

      {
        id: "email",
        label: "Email",
        conditions: [
          { label: "contains", value: "contains" },
          { label: "doesn't contain", value: "not_contains" },
          { label: "equal", value: "equal" },
          { label: "not equal", value: "not_equal" },
          { label: "begins with", value: "begins_with" },
          { label: "ends with", value: "ends_with" },
        ],
        input: Segment.Input.TEXT,
        type: Segment.Type.STRING,
      },
      {
        id: "first-name",
        label: "First name",
        conditions: [
          { label: "is empty", value: "is_empty" },
          { label: "is not empty", value: "is_not_empty" },
          { label: "contains", value: "contains" },
          { label: "doesn't contain", value: "not_contains" },
          { label: "equal", value: "equal" },
          { label: "not equal", value: "not_equal" },
          { label: "begins with", value: "begins_with" },
          { label: "ends with", value: "ends_with" },
        ],
        input: Segment.Input.TEXT,
        type: Segment.Type.STRING,
      },
      {
        id: "last-name",
        label: "Last name",
        conditions: [
          { label: "is empty", value: "is_empty" },
          { label: "is not empty", value: "is_not_empty" },
          { label: "contains", value: "contains" },
          { label: "doesn't contain", value: "not_contains" },
          { label: "equal", value: "equal" },
          { label: "not equal", value: "not_equal" },
          { label: "begins with", value: "begins_with" },
          { label: "ends with", value: "ends_with" },
        ],
        input: Segment.Input.TEXT,
        type: Segment.Type.STRING,
      },
      {
        id: "company",
        label: "Company",
        conditions: [
          { label: "is empty", value: "is_empty" },
          { label: "is not empty", value: "is_not_empty" },
          { label: "contains", value: "contains" },
          { label: "doesn't contain", value: "not_contains" },
          { label: "equal", value: "equal" },
          { label: "not equal", value: "not_equal" },
          { label: "begins with", value: "begins_with" },
          { label: "ends with", value: "ends_with" },
        ],
        input: Segment.Input.TEXT,
        type: Segment.Type.STRING,
      },
      {
        id: "active",
        label: "Last email opened or submitted form (in days)",
        conditions: [
          { label: "less", value: "less" },
          { label: "greater", value: "greater" },
        ],
        input: Segment.Input.TEXT,
        type: Segment.Type.INTEGER,
      },
      {
        id: "email-opened",
        label : "Last email opened (in days)",
        conditions: [
          {label : "less", value: "less"},
          {label : "greater", value: "greater"},
        ],
        input: Segment.Input.TEXT,
        type: Segment.Type.INTEGER,
      },
      {
        id: "email-clicked",
        label : "Last email clicked (in days)",
        conditions: [
          {label : "less", value: "less"},
          {label : "greater", value: "greater"},
        ],
        input: Segment.Input.TEXT,
        type: Segment.Type.INTEGER,
      },
      {
        id: "email-sent",
        label : "Last email sent (in days)",
        conditions: [
          {label : "less", value: "less"},
          {label : "greater", value: "greater"},
        ],
        input: Segment.Input.TEXT,
        type: Segment.Type.INTEGER,
      },
      {
        id: "not-email-opened",
        label: "Email not opened (in days)",
        conditions: [
          {label: "less", value: "less"},
          {label: "greater", value: "greater"},
        ],
        input: Segment.Input.TEXT,
        type: Segment.Type.INTEGER,
      },
      {
        id: "not-email-clicked",
        label: "Email not clicked (in days)",
        conditions: [
          {label: "less", value: "less"},
          {label: "greater", value: "greater"},
        ],
        input: Segment.Input.TEXT,
        type: Segment.Type.INTEGER,
      },
      {
        id: "location",
        label: "Location",
        conditions: [
          { label: "equal", value: "equal" },
          { label: "not equal", value: "not_equal" },
        ],
        input: Segment.Input.SELECT,
        type: Segment.Type.STRING,
      },
      {
        id: "ltv",
        label: "Lifetime value",
        conditions: [{ label: "between", value: "between" }],
        input: Segment.Input.TEXT,
        type: Segment.Type.INTEGER,
      },
      {
        id: "contact-source",
        label: "Contact added via source",
        conditions: [{ label: "equal", value: "equal" }],
        input: Segment.Input.SELECT,
        type: Segment.Type.INTEGER,
      },
      {
        id: "contact-created",
        label: "Contact created",
        conditions: [
          { label: "equal", value: "equal" },
          { label: "less", value: "less" },
          { label: "greater", value: "greater" },
        ],
        input: Segment.Input.TEXT,
        type: Segment.Type.DATE,
      },
      {
        id: "contact-created-within-days",
        label: "Contact created within (in days)",
        conditions: [
          { label: "less", value: "less" },
          { label: "greater", value: "greater" },
        ],
        input: Segment.Input.TEXT,
        type: Segment.Type.INTEGER,
      },
      {
        id: "contact-updated",
        label: "Contact updated",
        conditions: [
          { label: "equal", value: "equal" },
          { label: "less", value: "less" },
          { label: "greater", value: "greater" },
        ],
        input: Segment.Input.TEXT,
        type: Segment.Type.DATE,
      },
      {
        id: "contact-updated-within-days",
        label: "Contact updated within (in days)",
        conditions: [
          { label: "less", value: "less" },
          { label: "greater", value: "greater" },
        ],
        input: Segment.Input.TEXT,
        type: Segment.Type.INTEGER,
      },
      {
        id: "sent-x-emails-in-y-days",
        label: "Sent X emails in Y days",
        conditions: [
          { label: "atleast", value: "less" },
        ],
        input: Segment.Input.TEXT,
        type: Segment.Type.INTEGER,
      }
    ],
  },
  {
    label: "Lists",
    items: [
      {
        id: "lists-confirmed",
        label: "Subscribed and confirmed to lists",
        conditions: [{ label: "Any of", value: "in" }],
        input: Segment.Input.CHECKBOX,
        type: Segment.Type.INTEGER,
        options: Segment.Option.LISTS,
      },
      {
        id: "lists-notconfirmed",
        label: "Subscribed and not confirmed to lists",
        type: "DP with list option",
        conditions: [{ label: "None of", value: "not_in" }],
        input: Segment.Input.CHECKBOX,
        type: Segment.Type.INTEGER,
        options: Segment.Option.LISTS,
      },
    ],
  },
  {
    label: "Newsletter or Auto-Trigger Campaigns",
    items: [
      {
        id: "campaigns",
        label: "Sent these campaigns",
        conditions: [
          { label: "Any of", value: "in" },
          { label: "None of", value: "not_in" },
        ],
        options: Segment.Option.CAMPAIGNS,
        input: Segment.Input.CHECKBOX,
        type: Segment.Type.INTEGER,
      },
      {
        id: "campaigns-opened",
        label: "Campaigns sent and opened them",
        conditions: [{ label: "Any of", value: "in" }],
        options: Segment.Option.CAMPAIGNS,
        input: Segment.Input.CHECKBOX,
        type: Segment.Type.INTEGER,
      },
      {
        id: "campaigns-unopened",
        label: "Campaigns sent but didn't open them",
        conditions: [{ label: "Any of", value: "not_in" }],
        options: Segment.Option.CAMPAIGNS,
        input: Segment.Input.CHECKBOX,
        type: Segment.Type.INTEGER,
      },
      {
        id: "campaigns-clicked",
        label: "Campaigns sent and clicked links in them",
        conditions: [{ label: "Any of", value: "in" }],
        options: Segment.Option.CAMPAIGNS,
        input: Segment.Input.CHECKBOX,
        type: Segment.Type.INTEGER,
      },
      {
        id: "campaigns-link-clicked",
        label: "Clicked this link in campaign",
        conditions: [
          { label: "contains", value: "contains" },
          { label: "equal", value: "equal" },
        ],
        input: Segment.Input.TEXT,
        type: Segment.Type.STRING,
      },
      {
        id: "campaigns-unclicked",
        label: "Campaigns sent but didn't click links in them",
        // type: Segment.Type."DP with campaigns options",
        conditions: [{ label: "Any of", value: "not_in" }],
        options: Segment.Option.CAMPAIGNS,
        input: Segment.Input.CHECKBOX,
        type: Segment.Type.INTEGER,
      },
    ],
  },
  {
    label: "Drip Campaigns",
    items: [
      {
        id: "drip-steps-sent",
        label: "Added to drip campaigns and the below drip steps are already sent.",
        conditions: [
          { label: "Any of", value: "in" },
        ],
        options: Segment.Option.DRIPSTEP,
        input: Segment.Input.CHECKBOX,
        type: Segment.Type.INTEGER,
      },
      {
        id: "drip-steps-notsent",
        label: "Added to drip campaigns but the below drip steps are not sent",
        conditions: [
          { label: "None of", value: "not_in" },
        ],
        options: Segment.Option.DRIPSTEP,
        input: Segment.Input.CHECKBOX,
        type: Segment.Type.INTEGER,
      },
      {
        id: "drip-steps-opened",
        label: "Drip steps sent and opened",
        conditions: [
          { label: "Any of", value: "in" },
        ],
        options: Segment.Option.DRIPSTEP,
        input: Segment.Input.CHECKBOX,
        type: Segment.Type.INTEGER,
      },
      {
        id: "drip-steps-unopened",
        label: "Drip steps sent but not opened",
        conditions: [
          { label: "None of", value: "not_in" },
        ],
        options: Segment.Option.DRIPSTEP,
        input: Segment.Input.CHECKBOX,
        type: Segment.Type.INTEGER,
      },
      {
        id: "drip-steps-clicked",
        label: "Drip steps sent and links clicked",
        conditions: [
          { label: "Any of", value: "in" },
        ],
        options: Segment.Option.DRIPSTEP,
        input: Segment.Input.CHECKBOX,
        type: Segment.Type.INTEGER,
      },
      {
        id: "drip-steps-link-clicked",
        label: "Clicked this link in drip steps",
        conditions: [
          { label: "contains", value: "contains" },
          { label: "equal", value: "equal" },
        ],
        input: Segment.Input.TEXT,
        type: Segment.Type.STRING,
      },
      {
        id: "drip-steps-unclicked",
        label: "Drip steps sent but links not clicked",
        conditions: [
          { label: "None of", value: "not_in" },
        ],
        options: Segment.Option.DRIPSTEP,
        input: Segment.Input.CHECKBOX,
        type: Segment.Type.INTEGER,
      },
      //{
      //  id: "drip-sequences-replied",
      //  label: "Replied to drip campaigns",
      //  conditions: [
      //    { label: "Any of", value: "in" },
      //  ],
      //  options: Segment.Option.DRIPSTEP,
      //  input: Segment.Input.CHECKBOX,
      //  type: Segment.Type.INTEGER,
      //},
      //{
      //  id: "drip-sequences-unreplied",
      //  label: "Did not reply to drip campaigns",
      //  conditions: [
      //    { label: "None of", value: "not_in" },
      //  ],
      //  options: Segment.Option.DRIPSTEP,
      //  input: Segment.Input.CHECKBOX,
      //  type: Segment.Type.INTEGER,
      //},
      {
        id: "drip_sequences_started",
        label: "Drip started but not completed",
        conditions: [
          { label: "None of", value: "not_in" },
        ],
        options: Segment.Option.DRIP,
        input: Segment.Input.CHECKBOX,
        type: Segment.Type.INTEGER,
      },
      {
        id: "drip_sequences_completed",
        label: "Drip completed",
        conditions: [
          { label: "Any of", value: "in" },
        ],
        options: Segment.Option.DRIP,
        input: Segment.Input.CHECKBOX,
        type: Segment.Type.INTEGER,
      },
    ]
    
  },
  {
    label: "Custom Fields",
    items: [],
  },
  {
    label: "Custom Events",
    items: [],
  },
  {
    label: "Workflows",
    items: [
      {
        id: "workflows",
        label: "Added to these workflows",
        conditions: [
          { label: "Any of", value: "in" },
          { label: "None of", value: "not_in" },
        ],
        options: Segment.Option.WORKFLOWS,
        input: Segment.Input.CHECKBOX,
        type: Segment.Type.INTEGER,
      },
      {
        id: "workflows-email",
        label: "Added to workflows and email sent",
        conditions: [
          { label: "Any of", value: "in" },
          { label: "None of", value: "not_in" },
        ],
        options: Segment.Option.WORKFLOWS,
        input: Segment.Input.CHECKBOX,
        type: Segment.Type.INTEGER,
      },
      {
        id: "workflows-email-opened",
        label: "Added to workflows and email opened",
        conditions: [{ label: "Any of", value: "in" }],
        options: Segment.Option.WORKFLOWS,
        input: Segment.Input.CHECKBOX,
        type: Segment.Type.INTEGER,
      },
      {
        id: "workflows-email-unopened",
        label: "Added to workflows and email not opened",
        conditions: [{ label: "Any of", value: "not_in" }],
        options: Segment.Option.WORKFLOWS,
        input: Segment.Input.CHECKBOX,
        type: Segment.Type.INTEGER,
      },
      {
        id: "workflows-email-clicked",
        label: "Added to workflows and email links clicked",
        conditions: [{ label: "Any of", value: "in" }],
        options: Segment.Option.WORKFLOWS,
        input: Segment.Input.CHECKBOX,
        type: Segment.Type.INTEGER,
      },
      {
        id: "workflows-email-link-clicked",
        label: "Added to workflows and specific email link clicked",
        conditions: [
          { label: "contains", value: "contains" },
          { label: "equal", value: "equal" },
        ],
        input: Segment.Input.TEXT,
        type: Segment.Type.STRING,
      },
      {
        id: "workflows-email-unclicked",
        label: "Added to workflows and email links not clicked",
        conditions: [{ label: "Any of", value: "not_in" }],
        options: Segment.Option.WORKFLOWS,
        input: Segment.Input.CHECKBOX,
        type: Segment.Type.INTEGER,
      },
    ],
  },
])

export const ShopifySegmentOptions = Object.freeze([
	{
		label: "Shopify",
		items: [
			{
				id: "shopify-order-placed",
				label: "Last order placed (in days)",
				conditions: [
					{ label: "less", value: "less" },
					{ label: "greater", value: "greater" },
				],
				input: Segment.Input.TEXT,
				type: Segment.Type.INTEGER,
			},
			{
				id: "shopify-product-purchased",
				label: "Product purchased",
				conditions: [{ label: "Any of", value: "in" }],
				options: Segment.Option.SHOPIFY_PRODUCT,
				input: Segment.Input.CHECKBOX,
				type: Segment.Type.INTEGER,
			},
			{
				id: "shopify-started-checkout",
				label: "Last checkout started (in days)",
				conditions: [
					{ label: "less", value: "less" },
					{ label: "greater", value: "greater" },
				],
				input: Segment.Input.TEXT,
				type: Segment.Type.INTEGER,
			},
			{
				id: "shopify-order-not-placed",
				label: "Order not placed (in days)",
				conditions: [
					{ label: "less", value: "less" },
					{ label: "greater", value: "greater" },
				],
				input: Segment.Input.TEXT,
				type: Segment.Type.INTEGER,
			},
			{
				id: "shopify-product-purchased-collection",
				label: "Order purchased from smart collection",
				conditions: [{ label: "Any of", value: "in" }],
				options: Segment.Option.SHOPIFY_SMART_COLLECTION,
				input: Segment.Input.CHECKBOX,
				type: Segment.Type.INTEGER,
			},
			{
				id: "shopify-product-purchased-collection",
				label: "Order purchased from custom collection",
				conditions: [{ label: "Any of", value: "in" }],
				options: Segment.Option.SHOPIFY_CUSTOM_COLLECTION,
				input: Segment.Input.CHECKBOX,
				type: Segment.Type.INTEGER,
			},
			//{
			//   id: "shopify-coupon-used",
			//   label: "Coupon used (in days)",
			//   conditions: [
			//     {label : "less", value: "less"},
			//     {label : "greater", value: "greater"},
			//   ],
			//   options: Segment.Option.SHOPIFY_COUPON,
			//   input: Segment.Input.CHECKBOX,
			//   type: Segment.Type.INTEGER,
			// }
		],
	},
]);

export const CustomEventPropertyOptions = Object.freeze([
	{
		type: "string",
		conditions: [
			{ label: "contains", value: "contains" },
			{ label: "is empty", value: "is_empty" },
			{ label: "is not empty", value: "is_not_empty" },
			{ label: "equal", value: "equal" },
			{ label: "not equal", value: "not_equal" },
		],
	},
	{
		type: "number",
		conditions: [
			{ label: "equal", value: "equal" },
			{ label: "not equal", value: "not_equal" },
			{ label: "less", value: "less" },
			{ label: "greater", value: "greater" },
		],
	},
	{
		type: "date",
		conditions: [
			{ label: "equal", value: "equal" },
			{ label: "not equal", value: "not_equal" },
			{ label: "less", value: "less" },
			{ label: "greater", value: "greater" },
		],
	},
	{
		type: "boolean",
		conditions: [{ label: "equal", value: "equal" }],
	},
]);

export const CMD = "⌘";
export const CTRL = "⌃";

export const DEFAULT_SHORTCUTS = Object.freeze([
	{
		keys: ["Meta", "/"],
		title: "Open Shortcut Menu",
		action: () => handleShortcutOpen(),
	},
	{ keys: ["b", "b"], title: "Go Back", action: () => handleBack() },
	{ keys: ["Meta", "s"], title: "Open Search", action: () => showSearch() },
	{
		keys: ["Meta", "k"],
		title: "Open Video Search",
		action: () => showVideoSearch(),
	},
	{
		keys: ["n", "n"],
		title: "New Newsletter Campaign",
		action: () => navigateTo(Routes.Campaign.Newsletter.New.Sender),
	},
	{
		keys: ["n", "a", "b"],
		title: "New A/B Test Campaign",
		action: () => navigateTo(Routes.Campaign.ABTest.New.Sender),
	},
	{
		keys: ["n", "a", "t"],
		title: "New Auto Trigger Campaign",
		action: () => navigateTo(Routes.Campaign.AutoTrigger.New.Sender),
	},
	{
		keys: ["n", "h", "t"],
		title: "New Ticket",
		action: () => navigateTo(Routes.Tickets.New),
	},
	{
		keys: ["n", "d"],
		title: "New Drip Campaign",
		action: () => navigateTo(Routes.Campaign.Drip.New.Sender),
	},
	{
		keys: ["n", "r"],
		title: "New RSS Campaign",
		action: () => navigateTo(Routes.Campaign.RSS.New.Basic),
	},
	{
		keys: ["n", "w"],
		title: "New Workflow",
		action: () => navigateTo(Routes.Automate.Workflow.New.Edit),
	},
	{
		keys: ["n", "f"],
		title: "New Form",
		action: () => navigateTo(Routes.Form.New.Type),
	},
	{
		keys: ["n", "a", "r"],
		title: "New Automation",
		action: () => navigateTo(Routes.Automate.Automation.New.Name),
	},

	{
		keys: ["g", "n"],
		title: "Go to Newsletter Campaigns",
		action: () => navigateTo(Routes.Campaign.Newsletter.Home),
	},
	{
		keys: ["g", "w"],
		title: "Go to Workflows",
		action: () => navigateTo(Routes.Automate.Workflow.Home),
	},
	{
		keys: ["g", "a", "r"],
		title: "Go to Automations",
		action: () => navigateTo(Routes.Automate.Automation.Home),
	},
	{
		keys: ["g", "a", "b"],
		title: "Go to A/B Test Campaigns",
		action: () => navigateTo(Routes.Campaign.ABTest.Home),
	},
	{
		keys: ["g", "a", "t"],
		title: "Go to Auto Trigger Campaigns",
		action: () => navigateTo(Routes.Campaign.AutoTrigger.Home),
	},
	{
		keys: ["g", "a", "d"],
		title: "Go to Drip Campaigns",
		action: () => navigateTo(Routes.Campaign.Drip.Home),
	},
	{
		keys: ["g", "r"],
		title: "Go to RSS Campaigns",
		action: () => navigateTo(Routes.Campaign.RSS.Home),
	},
	{
		keys: ["g", "l"],
		title: "Go to Audience Lists",
		action: () => navigateTo(Routes.Audience.List.Home),
	},
	{
		keys: ["g", "t"],
		title: "Go to Audience Tags",
		action: () => navigateTo(Routes.Audience.Tag.Home),
	},
	{
		keys: ["g", "f"],
		title: "Go to Form Popup",
		action: () => navigateTo(Routes.Form.Popup),
	},
	{
		keys: ["g", "s"],
		title: "Go to Settings",
		action: () => navigateTo(Routes.Setting.Setup.DomainWhitelisting),
	},
	{
		keys: ["g", "a", "s"],
		title: "Go to Audience Segments",
		action: () => navigateTo(Routes.Audience.Segment.Home),
	},
	{
		keys: ["g", "c"],
		title: "Go to Contacts",
		action: () => navigateTo(Routes.Audience.Contact.Home),
	},
	{
		keys: ["g", "h", "t"],
		title: "Go to Tickets",
		action: () => navigateTo(Routes.Tickets.Home),
	},
	{
		keys: ["g", "d"],
		title: "Go to Dashboard",
		action: () => navigateTo(Routes.Dashboard),
	},

	// Special shortcut
	{
		keys: ["s", "t"],
		title: "Switch Team",
		action: () => switchTeamShortcut(),
	},
]);

export const submissionScript = `<script type="text/javascript">var _lpData={popupEnabled:false};var _scq=_scq||[],_scs=_scs||{};_scs.teamId="{{.TeamEncryptedId}}";(function(){var dc=document.createElement('script');dc.type="text/javascript",dc.async=!0,dc.src="//cdn.sendx.io/{{.Environment}}/{{.TeamEncryptedId}}.js";var s=document.getElementsByTagName("script")[0];s.parentNode.insertBefore(dc,s)})();document.addEventListener("DOMContentLoaded",function(){document.querySelectorAll(".sendx-subscribe-submit").forEach(button=>{button.addEventListener("click",function(){var emailInput=this.closest("div").querySelector(".sendx-email-input"),email=emailInput.value.trim(),emailRegex=/^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$/;if(!email||!emailRegex.test(email)){emailInput.closest("div").style.display="none";emailInput.closest(".parent-container").style.backgroundColor="#F47983";emailInput.closest(".parent-container").querySelector(".success-message").innerHTML="Please enter a valid email address."}else{_scq.push(["identify",{email:email,tags:["via_newsletter_share_page"],success:function(){emailInput.closest("div").style.display="none";emailInput.closest(".parent-container").style.backgroundColor="#1F3A8A";emailInput.closest(".parent-container").querySelector(".success-message").innerHTML="You have been subscribed successfully!"},failure:function(){emailInput.closest("div").style.display="none";emailInput.closest(".parent-container").style.backgroundColor="#F47983";emailInput.closest(".parent-container").querySelector(".success-message").innerHTML="Some error occurred while trying to subscribe you :("}}])}})})});</script>`;